{
  "anchors.json": {
    "AnchorInfo": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "urlFragment": {
          "type": "string",
          "maxLength": 60
        }
      },
      "isTopLevelDataNode": true
    }
  },
  "atomicScopes.json": {
    "AtomicScope": {
      "type": "object",
      "isPermanentDataNode": true,
      "isTopLevelDataNode": true
    }
  },
  "behaviors.json": {
    "ObsoleteBehaviorsList": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "items": {
          "type": [
            "string"
          ]
        }
      }
    }
  },
  "classnames.json": {
    "Classnames": {
      "type": "object",
      "properties": {
        "classnames": {
          "type": "array",
          "items": {
            "type": "string",
            "pattern": "^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$",
            "maxLength": 200
          },
          "default": [],
          "maxItems": 20
        }
      },
      "required": [
        "classnames"
      ],
      "isTopLevelDataNode": true
    }
  },
  "commonSchemas.json": {
    "RefArray": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": [
            "array"
          ],
          "items": {
            "type": "string"
          },
          "pseudoType": [
            "refList"
          ],
          "default": []
        }
      }
    },
    "VariantRelation": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "variants": {
          "type": "array",
          "items": {
            "type": "string",
            "pseudoType": [
              "weakRef"
            ],
            "shouldValidate": true,
            "isRefOwner": false,
            "shouldCollect": true,
            "referencedMap": "variants_data",
            "refTypes": [
              "Hover",
              "Mobile",
              "State",
              "Selected",
              "Trigger",
              "Preset",
              "RepeaterPattern",
              "BreakpointRange"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": "string",
            "pseudoType": [
              "weakRef"
            ],
            "shouldValidate": false,
            "isRefOwner": false,
            "shouldCollect": false,
            "referencedMap": "variants_data"
          }
        },
        "from": {
          "type": [
            "string"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": false,
          "shouldCollect": false,
          "referencedMap": "components"
        },
        "to": {
          "type": [
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    },
    "MinimalUnitSize": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "percentage"
          ]
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "UnitSize": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "fr",
            "percentage",
            "vh",
            "vw",
            "spx",
            "siteWidthPercentage"
          ]
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "SPXReferenceDefinition": {
      "type": "object",
      "properties": {
        "refWidth": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "resolverType": {
          "type": "string",
          "enum": [
            "scale",
            "fixed"
          ]
        }
      },
      "required": [
        "refWidth",
        "resolverType"
      ],
      "isTopLevelDataNode": false
    },
    "UnitLength": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "UnitLengthPercentage": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "percentage",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "UnitAngle": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "deg",
            "percentage"
          ]
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "UnitSizeArea": {
      "type": "object",
      "properties": {
        "width": {
          "$ref": "UnitLengthPercentage"
        },
        "height": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "isTopLevelDataNode": false
    },
    "UnitSizePoint": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "UnitLengthPercentage"
        },
        "y": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "isTopLevelDataNode": false
    },
    "NumberThatCanConnectToAVariable": {
      "type": "number"
    },
    "LinkReference": {
      "type": [
        "null",
        "string"
      ],
      "pattern": "^$|^#",
      "pseudoType": [
        "ref"
      ],
      "refTypes": [
        "ExternalLink",
        "EmailLink",
        "PhoneLink",
        "WhatsAppLink",
        "PageLink",
        "AddressLink",
        "AnchorLink",
        "DynamicPageLink",
        "TpaPageLink",
        "DocumentLink",
        "FormSubmitButtonLink",
        "LoginToWixLink"
      ],
      "isTopLevelDataNode": false
    },
    "Common_Image": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100,
          "description": "Title or caption for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Name identifier for the image."
        },
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
          "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
          "description": "Represents the URI or path to the image."
        },
        "description": {
          "type": "string",
          "maxLength": 1200,
          "description": "Textual description or details about the image."
        },
        "height": {
          "type": "number",
          "default": 200,
          "description": "Height dimension of the image."
        },
        "width": {
          "type": "number",
          "default": 200,
          "description": "Width dimension of the image."
        },
        "borderSize": {
          "type": "string",
          "description": "Size of the border around the image."
        },
        "alt": {
          "type": "string",
          "default": "",
          "description": "Alternative text for the image (for accessibility purposes)."
        },
        "decorative": {
          "type": "boolean"
        },
        "hasAnimation": {
          "type": "boolean",
          "description": "Indicates whether the image has animation valid for images in webP format"
        },
        "originalImageDataRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "description": "Original Image before edit",
          "refTypes": [
            "Image"
          ]
        },
        "opacity": {
          "type": "number",
          "description": "Opacity level of the image."
        },
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 4,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                }
              }
            }
          ],
          "description": "Defines cropping boundaries and additional transformations for the image."
        },
        "upscaleMethod": {
          "type": "string",
          "description": "used for upscaling method when building an image url , expected values default|super"
        },
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 2,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              }
            }
          ],
          "description": "Specifies the focal point within the image."
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "description": "Information about the artist of the image."
        }
      },
      "isTopLevelDataNode": true
    },
    "Common_SVGItem": {
      "type": "object",
      "properties": {
        "svgId": {
          "type": "string",
          "maxLength": 100
        }
      },
      "isTopLevelDataNode": true
    },
    "ColorLayers": {
      "type": [
        "null",
        "array"
      ],
      "pseudoType": [
        "refList"
      ],
      "shouldCollect": true,
      "shouldValidate": true,
      "refTypes": [
        "GradientLinearLayer",
        "GradientCircleLayer",
        "GradientEllipseLayer",
        "GradientConicLayer",
        "GradientMeshLayer",
        "SolidColorLayer"
      ]
    },
    "GradientLinearLayer": {
      "type": "object",
      "properties": {
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "$ref": "GradientLinear"
        }
      },
      "isTopLevelDataNode": true
    },
    "GradientCircleLayer": {
      "type": "object",
      "properties": {
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "$ref": "GradientCircle"
        }
      },
      "isTopLevelDataNode": true
    },
    "GradientEllipseLayer": {
      "type": "object",
      "properties": {
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "$ref": "GradientEllipse"
        }
      },
      "isTopLevelDataNode": true
    },
    "GradientMeshLayer": {
      "type": "object",
      "properties": {
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "$ref": "GradientCircle"
              }
            }
          },
          "isTopLevelDataNode": false
        }
      },
      "isTopLevelDataNode": true
    },
    "GradientConicLayer": {
      "type": "object",
      "properties": {
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "$ref": "GradientConic"
        }
      },
      "isTopLevelDataNode": true
    },
    "SolidColorLayer": {
      "type": "object",
      "properties": {
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "$ref": "SolidColor"
        }
      },
      "isTopLevelDataNode": true
    },
    "GradientLinear": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientLinear"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "BlendMode"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "GradientColorStop"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "GradientCircleSize": {
      "type": "object",
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "oneOf": [
        {
          "required": [
            "value",
            "type"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        },
        {
          "required": [],
          "maxProperties": 0
        }
      ],
      "isTopLevelDataNode": false
    },
    "GradientCircle": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientCircle"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "BlendMode"
        },
        "size": {
          "$ref": "GradientCircleSize"
        },
        "position": {
          "$ref": "UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "GradientColorStop"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "GradientEllipseSize": {
      "type": "object",
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "width": {
          "$ref": "UnitLengthPercentage"
        },
        "height": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "oneOf": [
        {
          "required": [
            "width",
            "height"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        }
      ],
      "isTopLevelDataNode": false
    },
    "GradientEllipse": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientEllipse"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "BlendMode"
        },
        "size": {
          "$ref": "GradientEllipseSize"
        },
        "position": {
          "$ref": "UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "GradientColorStop"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "GradientConic": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientConic"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "$ref": "BlendMode"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "position": {
          "$ref": "UnitSizePoint"
        },
        "colorStops": {
          "type": "array",
          "items": {
            "$ref": "GradientAngularColorStop"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "SolidColor": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SolidColor"
          ]
        },
        "color": {
          "type": "string",
          "format": "color"
        }
      },
      "isTopLevelDataNode": false
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ],
      "isTopLevelDataNode": false
    },
    "GradientColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "$ref": "UnitLengthPercentage"
        },
        "color": {
          "type": "string",
          "format": "color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "isTopLevelDataNode": false
    },
    "GradientAngularColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "$ref": "UnitAngle"
        },
        "color": {
          "type": "string",
          "format": "color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "isTopLevelDataNode": false
    }
  },
  "componentsDefinitionsMap.json": {
    "core.components.Image": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Image",
        ""
      ],
      "styles": {},
      "nickname": "image"
    },
    "core.components.MenuButton": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Link",
        "Page",
        "",
        "AppPage",
        "Text",
        "BasicMenuItem"
      ],
      "styles": {},
      "nickname": "componentLabelMenuButton"
    },
    "mobile.core.components.Page": {
      "type": "Page",
      "aliases": [
        "core.components.Page"
      ],
      "skins": [
        "wysiwyg.viewer.skins.page.TransparentPageSkin",
        "wysiwyg.viewer.skins.page.SloopyPageSkin",
        "wysiwyg.viewer.skins.page.BasicPageSkin",
        "wysiwyg.viewer.skins.page.ThreeDeePageSkin",
        "wysiwyg.viewer.skins.page.InnerShadowPageSkin",
        "wysiwyg.viewer.skins.page.LiftedBottomPageSkin",
        "wysiwyg.viewer.skins.page.LiftedTopPageSkin",
        "wysiwyg.viewer.skins.page.BorderPageSkin",
        "wysiwyg.viewer.skins.page.LiftedShadowPageSkin",
        "wysiwyg.viewer.skins.page.ShinyIPageSkin",
        "wysiwyg.viewer.skins.page.NoMarginPageSkin"
      ],
      "dataTypes": [
        "Page"
      ],
      "styles": {
        "p1": "wysiwyg.viewer.skins.page.TransparentPageSkin",
        "p2": "wysiwyg.viewer.skins.page.SloopyPageSkin",
        "p3": "wysiwyg.viewer.skins.page.BasicPageSkin",
        "p4": "wysiwyg.viewer.skins.page.FullWidthPageSkin"
      },
      "nickname": "page",
      "designDataTypes": [
        "",
        "MediaContainerDesignData"
      ],
      "propertyTypes": [
        "",
        "PageProperties"
      ]
    },
    "mobile.core.components.MasterPage": {
      "type": "Document",
      "skins": [],
      "dataTypes": [
        "Document"
      ],
      "styles": {},
      "nickname": "masterPage"
    },
    "wixapps.integration.components.AppPage": {
      "type": "Page",
      "skins": [
        "wysiwyg.viewer.skins.page.TransparentPageSkin",
        "wysiwyg.viewer.skins.page.SloopyPageSkin",
        "wysiwyg.viewer.skins.page.BasicPageSkin",
        "wysiwyg.viewer.skins.page.ThreeDeePageSkin",
        "wysiwyg.viewer.skins.page.InnerShadowPageSkin",
        "wysiwyg.viewer.skins.page.LiftedBottomPageSkin",
        "wysiwyg.viewer.skins.page.LiftedTopPageSkin",
        "wysiwyg.viewer.skins.page.BorderPageSkin",
        "wysiwyg.viewer.skins.page.LiftedShadowPageSkin",
        "wysiwyg.viewer.skins.page.ShinyIPageSkin",
        "wysiwyg.viewer.skins.page.NoMarginPageSkin"
      ],
      "dataTypes": [
        "AppPage"
      ],
      "styles": {
        "p1": "wysiwyg.viewer.skins.page.TransparentPageSkin",
        "p2": "wysiwyg.viewer.skins.page.SloopyPageSkin",
        "p3": "wysiwyg.viewer.skins.page.BasicPageSkin"
      },
      "nickname": "page",
      "propertyTypes": [
        "",
        "PageProperties"
      ]
    },
    "wixapps.integration.components.AppPart": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.AppPartSkin"
      ],
      "dataTypes": [
        "AppPart"
      ],
      "styles": {
        "blog_4de5abc5-6da2-4f97-acc3-94bb74285072_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_f72fe377-8abc-40f2-8656-89cfe00f3a22_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_c7f57b50-8940-4ff1-83c6-6756d6f0a1f4_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_56ab6fa4-95ac-4391-9337-6702b8a77011_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_e000b4bf-9ff1-4e66-a0d3-d4b365ba3af5_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_31c0cede-09db-4ec7-b760-d375d62101e6_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_33a9f5e0-b083-4ccc-b55d-3ca5d241a6eb_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_1b8c501f-ccc2-47e7-952a-47e264752614_1": "wysiwyg.viewer.skins.AppPartSkin",
        "blog_4656a63c-b316-4315-ab16-e2003f5935ca_1": "wysiwyg.viewer.skins.AppPartSkin"
      },
      "nickname": "blog",
      "propertyTypes": [
        "AppPartProperties"
      ]
    },
    "wixapps.integration.components.AppPart2": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.AppPartSkin"
      ],
      "dataTypes": [
        "AppBuilderComponent"
      ],
      "styles": {
        "app1": "wysiwyg.viewer.skins.AppPartSkin"
      },
      "nickname": "list"
    },
    "wysiwyg.viewer.components.inputs.TextInput": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.appinputs.AppsTextInputSkin"
      ],
      "dataTypes": [
        "TextInput"
      ],
      "styles": {
        "wa_ti1": "wysiwyg.viewer.skins.appinputs.AppsTextInputSkin"
      },
      "nickname": "input",
      "propertyTypes": [
        "TextInputProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.menus.DropDownMenu": {
      "type": "Component",
      "externalizable": true,
      "responsiveSkins": [],
      "skins": [
        "wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonBgFixSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.TextSeparatorsMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SolidColorMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIIButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.OverlineMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateBasicMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIIMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.LinesMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateLinesMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.PointerMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.RibbonsMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.VerticalRibbonsMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.IndentedMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateIndentedMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.SloppyBorderMenuButtonSkin",
        "wysiwyg.common.components.dropdownmenu.viewer.skins.OverlineMenuButtonHorizontalMenuAdaptationSkin"
      ],
      "dataTypes": [
        "CustomMenuDataRef"
      ],
      "styles": {
        "ddm1": "wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonSkin",
        "ddm2": "wysiwyg.common.components.dropdownmenu.viewer.skins.SolidColorMenuButtonSkin",
        "ddm3": "wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIButtonSkin"
      },
      "nickname": "horizontalMenu",
      "propertyTypes": [
        "HorizontalMenuProperties"
      ]
    },
    "wixapps.integration.components.Icon": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Icon"
      ],
      "styles": {
        "skin": "wixapps.integration.skins.IconSkin"
      },
      "nickname": "icon"
    },
    "wixapps.integration.components.ImageButton": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "ImageButton"
      ],
      "styles": {
        "ImageButton_1": "wysiwyg.common.components.imagebutton.viewer.skins.ImageButtonSkin"
      },
      "nickname": "iconButton",
      "propertyTypes": [
        "ImageButtonProperties"
      ]
    },
    "wysiwyg.common.components.rssbutton.viewer.RSSButton": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "RssButton"
      ],
      "styles": {
        "RSSButton_1": "wysiwyg.common.components.rssbutton.viewer.skins.RSSButtonSkin"
      },
      "nickname": "rssButton",
      "propertyTypes": [
        "RssButtonProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.anchor.viewer.Anchor": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.anchor.viewer.skins.AnchorSkin",
        "AutoWidthAnchorSkin"
      ],
      "dataTypes": [
        "Anchor"
      ],
      "styles": {
        "Anchor_1": "wysiwyg.common.components.anchor.viewer.skins.AnchorSkin",
        "Anchor_2": "AutoWidthAnchorSkin"
      },
      "nickname": "anchor"
    },
    "wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolSkin",
        "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuTextSkin",
        "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithTextSkin",
        "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithHiddenTextSkin",
        "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuLinkedNoTextSkin"
      ],
      "dataTypes": [
        "VerticalAnchorsMenu"
      ],
      "styles": {
        "VerticalAnchors_1": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithHiddenTextSkin",
        "VerticalAnchors_2": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithTextSkin",
        "VerticalAnchors_3": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolSkin",
        "VerticalAnchors_4": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuTextSkin",
        "VerticalAnchors_5": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuLinkedNoTextSkin"
      },
      "nickname": "anchorMenu",
      "propertyTypes": [
        "VerticalAnchorsMenuProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.facebooklikebox.viewer.FacebookLikeBox": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.facebooklikebox.viewer.skins.FacebookLikeBoxSkin"
      ],
      "dataTypes": [
        "FacebookLikeBox"
      ],
      "styles": {
        "FacebookLikeBox_1": "wysiwyg.common.components.facebooklikebox.viewer.skins.FacebookLikeBoxSkin"
      },
      "nickname": "facebookPageLike",
      "propertyTypes": [
        "FacebookLikeBoxProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.imagebutton.viewer.ImageButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.imagebutton.viewer.skins.ImageButtonSkin"
      ],
      "dataTypes": [
        "ImageButton"
      ],
      "styles": {
        "ImageButton_1": "wysiwyg.common.components.imagebutton.viewer.skins.ImageButtonSkin"
      },
      "nickname": "iconButton",
      "propertyTypes": [
        "ImageButtonProperties"
      ]
    },
    "wysiwyg.common.components.inputs.OptionsListInput": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "SelectableList"
      ],
      "styles": {},
      "nickname": "optionsListInput"
    },
    "wysiwyg.common.components.inputs.SelectOptionsList": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "SelectableList"
      ],
      "styles": {},
      "nickname": "selectOptionsList"
    },
    "wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.pinitpinwidget.viewer.skins.PinItPinWidgetSkin"
      ],
      "dataTypes": [
        "PinItPinWidget"
      ],
      "styles": {
        "PinItPinWidget_1": "wysiwyg.common.components.pinitpinwidget.viewer.skins.PinItPinWidgetSkin"
      },
      "nickname": "shareFromPinterest",
      "externalizable": true
    },
    "wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.pinterestpinit.viewer.skins.PinterestPinItSkin"
      ],
      "dataTypes": [
        "PinterestPinIt"
      ],
      "styles": {
        "PinterestPinIt_1": "wysiwyg.common.components.pinterestpinit.viewer.skins.PinterestPinItSkin"
      },
      "nickname": "pinToPinterest",
      "propertyTypes": [
        "PinterestPinItProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.singleaudioplayer.viewer.skins.SingleAudioPlayerSkin",
        "wysiwyg.common.components.singleaudioplayer.viewer.skins.EPlayerRoundPlay",
        "wysiwyg.common.components.singleaudioplayer.viewer.skins.EPlayerFramedPlay",
        "wysiwyg.common.components.singleaudioplayer.viewer.skins.EPlayerLargePlay"
      ],
      "dataTypes": [
        "SingleAudioPlayer"
      ],
      "styles": {
        "SingleAudioPlayer_1": "wysiwyg.common.components.singleaudioplayer.viewer.skins.SingleAudioPlayerSkin"
      },
      "nickname": "trackPlayer",
      "propertyTypes": [
        "SingleAudioPlayerProperties"
      ]
    },
    "wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.skypecallbutton.viewer.skins.SkypeCallButtonSkin"
      ],
      "dataTypes": [
        "SkypeCallButton"
      ],
      "styles": {
        "SkypeCallButton_1": "wysiwyg.common.components.skypecallbutton.viewer.skins.SkypeCallButtonSkin"
      },
      "nickname": "skypeCall",
      "propertyTypes": [
        "SkypeCallButtonProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.spotifyfollow.viewer.skins.SpotifyFollowSkin"
      ],
      "dataTypes": [
        "SpotifyFollow"
      ],
      "styles": {
        "SpotifyFollow_1": "wysiwyg.common.components.spotifyfollow.viewer.skins.SpotifyFollowSkin"
      },
      "nickname": "spotifyFollow",
      "propertyTypes": [
        "SpotifyFollowProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.spotifyplayer.viewer.skins.SpotifyPlayerSkin"
      ],
      "dataTypes": [
        "SpotifyPlayer"
      ],
      "styles": {
        "SpotifyPlayer_1": "wysiwyg.common.components.spotifyplayer.viewer.skins.SpotifyPlayerSkin"
      },
      "nickname": "spotifyPlayer",
      "propertyTypes": [
        "SpotifyPlayerProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.subscribeform.viewer.SubscribeForm": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormPlaceholderSkin",
        "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutEnvelope",
        "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutFlat",
        "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutFlat",
        "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutTransparentWithIcon",
        "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutShiny"
      ],
      "dataTypes": [
        "SubscribeForm"
      ],
      "styles": {
        "SubscribeForm_1": "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutFlat"
      },
      "nickname": "subscribeForm",
      "propertyTypes": [
        "SubscribeFormProperties"
      ]
    },
    "wysiwyg.common.components.verticalmenu.viewer.VerticalMenu": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSolidColorSkin",
        "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSeparatedButtonFixedWidthSkin",
        "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuTextSkin",
        "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSeparatedButtonSkin",
        "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuTextWithSeparatorsSkin"
      ],
      "dataTypes": [
        "CustomMenuDataRef"
      ],
      "styles": {
        "VerticalMenu_1": "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSolidColorSkin"
      },
      "nickname": "verticalMenu",
      "propertyTypes": [
        "VerticalMenuProperties"
      ]
    },
    "wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.youtubesubscribebutton.viewer.skins.YouTubeSubscribeButtonSkin"
      ],
      "dataTypes": [
        "YouTubeSubscribeButton"
      ],
      "styles": {
        "YouTubeSubscribeButton_1": "wysiwyg.common.components.youtubesubscribebutton.viewer.skins.YouTubeSubscribeButtonSkin"
      },
      "nickname": "youTubeSubscribe",
      "propertyTypes": [
        "YouTubeSubscribeButtonProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.AdminLoginButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.button.AdminLoginButtonSkin"
      ],
      "dataTypes": [
        "LinkableButton"
      ],
      "styles": {
        "admb0": "wysiwyg.viewer.skins.button.AdminLoginButtonSkin"
      },
      "nickname": "webmasterLogin",
      "propertyTypes": [
        "ButtonProperties"
      ]
    },
    "wysiwyg.viewer.components.AudioPlayer": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.audioplayer.Audio3DPlayer",
        "wysiwyg.viewer.skins.audioplayer.ShinyPlayer",
        "wysiwyg.viewer.skins.audioplayer.SimplePlayer",
        "wysiwyg.viewer.skins.audioplayer.BoldPlayer"
      ],
      "dataTypes": [
        "AudioPlayer"
      ],
      "styles": {
        "ap1": "wysiwyg.viewer.skins.audioplayer.SimplePlayer",
        "ap2": "wysiwyg.viewer.skins.audioplayer.ShinyPlayer"
      },
      "nickname": "miniPlayer"
    },
    "wysiwyg.viewer.components.BgImageStrip": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "skins.viewer.bgimagestrip.BgImageStripSkin",
        "skins.viewer.bgimagestrip.BevelScreenSkin",
        "skins.viewer.bgimagestrip.IronScreenSkin",
        "skins.viewer.bgimagestrip.DoubleBorderScreenSkin"
      ],
      "dataTypes": [
        "Image",
        ""
      ],
      "styles": {
        "bgis1": "skins.viewer.bgimagestrip.BgImageStripSkin",
        "bgis2": "skins.viewer.bgimagestrip.BevelScreenSkin",
        "bgis3": "skins.viewer.bgimagestrip.IronScreenSkin",
        "bgis4": "skins.viewer.bgimagestrip.DoubleBorderScreenSkin"
      },
      "nickname": "strip",
      "propertyTypes": [
        "BgImageStripUnifiedProperties"
      ]
    },
    "wysiwyg.viewer.components.ClipArt": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.photo.NoSkinPhoto"
      ],
      "dataTypes": [
        "Image"
      ],
      "styles": {
        "ca1": "wysiwyg.viewer.skins.photo.NoSkinPhoto"
      },
      "nickname": "clipArt",
      "propertyTypes": [
        "WPhotoProperties"
      ]
    },
    "wysiwyg.viewer.components.ContactForm": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.contactform.DefaultContactForm",
        "wysiwyg.viewer.skins.contactform.BasicContactFormSkin",
        "wysiwyg.viewer.skins.contactform.VerticalFormLabelsLeft",
        "wysiwyg.viewer.skins.contactform.VerticalForm",
        "contactform.OverlappingButtonSkin",
        "contactform.FullWidthButtonSkin",
        "contactform.LineOnlySkin",
        "contactform.FieldAnimationSkin"
      ],
      "dataTypes": [
        "ContactForm"
      ],
      "styles": {
        "cf1": "wysiwyg.viewer.skins.contactform.DefaultContactForm",
        "cf2": "wysiwyg.viewer.skins.contactform.BasicContactFormSkin"
      },
      "nickname": "contactForm",
      "propertyTypes": [
        "ContactFormProperties"
      ]
    },
    "wysiwyg.viewer.components.DynamicContactForm": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.contactform.DefaultContactForm",
        "wysiwyg.viewer.skins.contactform.BasicContactFormSkin",
        "wysiwyg.viewer.skins.contactform.VerticalFormLabelsLeft",
        "wysiwyg.viewer.skins.contactform.VerticalForm",
        "contactform.OverlappingButtonSkin",
        "contactform.FullWidthButtonSkin",
        "contactform.LineOnlySkin",
        "contactform.FieldAnimationSkin",
        "wysiwyg.viewer.skins.contactform.HorizontalContactFormSkin"
      ],
      "dataTypes": [
        "DynamicContactForm"
      ],
      "styles": {
        "cf1": "wysiwyg.viewer.skins.contactform.DefaultContactForm",
        "cf2": "wysiwyg.viewer.skins.contactform.BasicContactFormSkin"
      },
      "nickname": "contactForm"
    },
    "wysiwyg.viewer.components.Displayer": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Image"
      ],
      "styles": {},
      "nickname": "displayer"
    },
    "wysiwyg.viewer.components.documentmedia.DocumentMedia": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "skins.viewer.documentmedia.DocumentMediaSkin"
      ],
      "dataTypes": [
        "Image"
      ],
      "styles": {
        "dm1": "skins.viewer.documentmedia.DocumentMediaSkin"
      },
      "nickname": "document",
      "propertyTypes": [
        "DocumentMediaProperties"
      ]
    },
    "wysiwyg.viewer.components.EbayItemsBySeller": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.EbayItemsBySellerSkin"
      ],
      "dataTypes": [
        "EbayItemsBySeller"
      ],
      "styles": {
        "eib1": "wysiwyg.viewer.skins.EbayItemsBySellerSkin"
      },
      "nickname": "eBay",
      "propertyTypes": [
        "EbayItemsBySellerProperties"
      ]
    },
    "wysiwyg.viewer.components.FacebookShare": {
      "type": "Component",
      "skins": [
        "skins.viewer.facebookshare.FacebookShareSkin"
      ],
      "dataTypes": [
        "FacebookShareButton"
      ],
      "styles": {
        "fs1": "skins.viewer.facebookshare.FacebookShareSkin"
      },
      "nickname": "facebookShare",
      "externalizable": true
    },
    "wysiwyg.viewer.components.FlashComponent": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.FlashComponentSkin"
      ],
      "dataTypes": [
        "LinkableFlashComponent"
      ],
      "styles": {
        "swf1": "wysiwyg.viewer.skins.FlashComponentSkin"
      },
      "nickname": "flash",
      "propertyTypes": [
        "FlashComponentProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.FlickrBadgeWidget": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.FlickrBadgeWidgetSkin"
      ],
      "dataTypes": [
        "FlickrBadgeWidget"
      ],
      "styles": {
        "fk1": "wysiwyg.viewer.skins.FlickrBadgeWidgetSkin"
      },
      "nickname": "flickrGallery",
      "externalizable": true
    },
    "wysiwyg.viewer.components.GoogleMap": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.GoogleMapSkin",
        "wysiwyg.viewer.skins.map.GoogleMapDefault",
        "wysiwyg.viewer.skins.map.GoogleMapSloppy",
        "wysiwyg.viewer.skins.map.GoogleMapLiftedShadow"
      ],
      "dataTypes": [
        "GeoMap"
      ],
      "styles": {
        "gm1": "wysiwyg.viewer.skins.GoogleMapSkin"
      },
      "nickname": "googleMaps",
      "propertyTypes": [
        "GoogleMapProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.HtmlComponent": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.HtmlComponentSkin"
      ],
      "dataTypes": [
        "HtmlComponent"
      ],
      "styles": {
        "htco1": "wysiwyg.viewer.skins.HtmlComponentSkin"
      },
      "nickname": "html"
    },
    "wysiwyg.viewer.components.ItunesButton": {
      "type": "Component",
      "skins": [
        "skins.viewer.itunesbutton.ItunesButtonSkin"
      ],
      "dataTypes": [
        "ItunesButton"
      ],
      "styles": {
        "ib1": "skins.viewer.itunesbutton.ItunesButtonSkin"
      },
      "nickname": "iTunesButton",
      "propertyTypes": [
        "ItunesButtonProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.LinkBar": {
      "type": "Component",
      "externalizable": true,
      "responsiveSkins": [],
      "skins": [
        "wysiwyg.viewer.skins.LinkBarNoBGSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "lb1": "wysiwyg.viewer.skins.LinkBarNoBGSkin"
      },
      "nickname": "socialBar",
      "propertyTypes": [
        "LinkBarProperties"
      ]
    },
    "wysiwyg.viewer.components.LinkBarItem": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Image"
      ],
      "styles": {},
      "nickname": "linkBarItem"
    },
    "wysiwyg.viewer.components.LoginButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.button.LoginButtonSkin"
      ],
      "dataTypes": [
        "LoginButton",
        ""
      ],
      "styles": {
        "lgn0": "wysiwyg.viewer.skins.button.LoginButtonSkin"
      },
      "nickname": "memberLoginButton"
    },
    "wysiwyg.viewer.components.LoginSocialBar": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.LoginSocialBarSkin"
      ],
      "dataTypes": [
        "LoginSocialBar"
      ],
      "styles": {
        "lsb0": "wysiwyg.viewer.skins.LoginSocialBarSkin"
      },
      "nickname": "accountNavBar",
      "propertyTypes": [
        "LoginSocialBarProperties"
      ]
    },
    "wysiwyg.viewer.components.MatrixGallery": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryDefaultSkin",
        "wysiwyg.viewer.skins.gallerymatrix.TextBottomCustomHeightSkin",
        "wysiwyg.viewer.skins.gallerymatrix.PolaroidCustomHeightSkin",
        "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryLiftedShadow",
        "wysiwyg.viewer.skins.gallerymatrix.MatrixGallerySloopy",
        "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryCircleSkin",
        "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryTextSlideUpSkin",
        "skins.viewer.gallerymatrix.MatrixGalleryIronSkin",
        "skins.viewer.gallerymatrix.MatrixGalleryScotchTapeSkin",
        "wysiwyg.common.components.matrixgallery.viewer.skins.MatrixGalleryTextOnCenterSkin",
        "wysiwyg.common.components.matrixgallery.viewer.skins.MatrixGallerySeparateTextBoxSkin",
        "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryTransparentSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "mg1": "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryDefaultSkin",
        "mg2": "wysiwyg.viewer.skins.gallerymatrix.TextBottomCustomHeightSkin",
        "mg3": "wysiwyg.viewer.skins.gallerymatrix.PolaroidCustomHeightSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "MatrixGalleryProperties"
      ]
    },
    "wysiwyg.viewer.components.MediaRichText": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "MediaRichText",
        "StyledText"
      ],
      "styles": {},
      "nickname": "text"
    },
    "wysiwyg.viewer.components.PayPalButton": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.PayPalButtonSkin"
      ],
      "dataTypes": [
        "PayPalButton"
      ],
      "styles": {
        "ppb0": "wysiwyg.viewer.skins.PayPalButtonSkin"
      },
      "nickname": "paypalButton",
      "propertyTypes": [
        "PayPalButtonProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.PinterestFollow": {
      "type": "Component",
      "skins": [
        "skins.viewer.pinterestfollow.PinterestFollowSkin"
      ],
      "dataTypes": [
        "PinterestFollow"
      ],
      "styles": {
        "pf1": "skins.viewer.pinterestfollow.PinterestFollowSkin"
      },
      "nickname": "pinterestFollow",
      "externalizable": true
    },
    "wysiwyg.viewer.components.SiteButton": {
      "type": "Component",
      "responsiveSkins": [
        "wysiwyg.viewer.skins.button.WrappingButton"
      ],
      "skins": [
        "wysiwyg.viewer.skins.button.BasicButton",
        "wysiwyg.viewer.skins.button.ButtonThreeD",
        "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
        "wysiwyg.viewer.skins.button.ShinyButtonInverted",
        "wysiwyg.viewer.skins.button.ButtonArrow",
        "wysiwyg.viewer.skins.button.ButtonArrowLeft",
        "wysiwyg.viewer.skins.button.ButtonInnerShadow",
        "wysiwyg.viewer.skins.button.ButtonShadowRight",
        "wysiwyg.viewer.skins.button.ButtonShadowLeft",
        "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
        "wysiwyg.viewer.skins.button.ShinyButtonISkin",
        "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
        "wysiwyg.viewer.skins.button.RibbonButton",
        "wysiwyg.viewer.skins.button.CircleButton",
        "wysiwyg.viewer.skins.button.SloopyButton",
        "wysiwyg.viewer.skins.button.IronButton",
        "wysiwyg.viewer.skins.button.GamingButton",
        "wysiwyg.viewer.skins.button.ScotchTapeButton"
      ],
      "dataTypes": [
        "LinkableButton",
        "SiteButtonData"
      ],
      "styles": {
        "b1": "wysiwyg.viewer.skins.button.BasicButton",
        "b2": "wysiwyg.viewer.skins.button.ButtonThreeD",
        "b3": "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
        "b4": "wysiwyg.viewer.skins.button.ShinyButtonInverted"
      },
      "nickname": "button",
      "propertyTypes": [
        "ButtonProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.SliderGallery": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.galleryslider.SliderGalleryDefaultSkin",
        "wysiwyg.viewer.skins.galleryslider.SliderGalleryCircleSkin",
        "wysiwyg.viewer.skins.galleryslider.SliderGalleryNoArrow",
        "wysiwyg.viewer.skins.galleryslider.SliderGalleryIronSkin",
        "wysiwyg.viewer.skins.galleryslider.SliderGalleryScotchTapeSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "sg1": "wysiwyg.viewer.skins.galleryslider.SliderGalleryDefaultSkin",
        "sg2": "wysiwyg.viewer.skins.galleryslider.SliderGalleryCircleSkin",
        "sg3": "wysiwyg.viewer.skins.galleryslider.SliderGalleryNoArrow"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "SliderGalleryProperties"
      ]
    },
    "wysiwyg.viewer.components.SlideShowGallery": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.gallery.SlideShowTextOverlay",
        "wysiwyg.viewer.skins.gallery.SlideShowTextFloating",
        "wysiwyg.viewer.skins.gallery.SlideShowTextRight",
        "wysiwyg.viewer.skins.gallery.SlideShowPolaroid",
        "wysiwyg.viewer.skins.gallery.SlideShowTextBottom",
        "wysiwyg.viewer.skins.gallery.SlideShowGallerySloopy",
        "wysiwyg.viewer.skins.gallery.SlideShowGalleryLiftedShadowSkin",
        "skins.viewer.gallery.SlideShowIron",
        "skins.viewer.gallery.SlideShowCleanAndSimple2",
        "skins.viewer.gallery.SlideShowScotchTape",
        "skins.viewer.gallery.SlideShowCleanAndSimple"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "ssg1": "wysiwyg.viewer.skins.gallery.SlideShowTextOverlay",
        "ssg2": "wysiwyg.viewer.skins.gallery.SlideShowTextFloating",
        "ssg3": "wysiwyg.viewer.skins.gallery.SlideShowTextRight"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "SlideShowGalleryProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.SoundCloudWidget": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.SoundCloudWidgetSkin"
      ],
      "dataTypes": [
        "SoundCloudWidget"
      ],
      "styles": {
        "scw1": "wysiwyg.viewer.skins.SoundCloudWidgetSkin"
      },
      "nickname": "soundcloud",
      "externalizable": true
    },
    "wysiwyg.viewer.components.TwitterFeed": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TwitterFeedSkin"
      ],
      "dataTypes": [
        "TwitterFollow"
      ],
      "styles": {
        "twf1": "wysiwyg.viewer.skins.TwitterFeedSkin"
      },
      "nickname": "twitterFeed",
      "propertyTypes": [
        "TwitterFeedProperties"
      ]
    },
    "wysiwyg.viewer.components.VerticalRepeater": {
      "type": "RepeaterContainer",
      "skins": [
        "wysiwyg.viewer.skins.VerticalRepeaterEmptySkin",
        "wysiwyg.viewer.skins.VerticalRepeaterSkin"
      ],
      "dataTypes": [
        "",
        "ImageList"
      ],
      "styles": {
        "vr1": "wysiwyg.viewer.skins.VerticalRepeaterEmptySkin",
        "vr2": "wysiwyg.viewer.skins.VerticalRepeaterSkin",
        "vr3": "wysiwyg.viewer.skins.VerticalRepeaterSkin",
        "vr4": "wysiwyg.viewer.skins.VerticalRepeaterSkin"
      },
      "nickname": "verticalRepeater"
    },
    "wysiwyg.viewer.components.Video": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.VideoSkin",
        "wysiwyg.viewer.skins.video.VideoDefault",
        "wysiwyg.viewer.skins.video.VideoSloppy",
        "wysiwyg.viewer.skins.video.VideoLiftedShadow"
      ],
      "dataTypes": [
        "Video"
      ],
      "styles": {
        "v1": "wysiwyg.viewer.skins.VideoSkin",
        "v2": "wysiwyg.viewer.skins.video.VideoDefault"
      },
      "nickname": "video",
      "propertyTypes": [
        "VideoProperties"
      ]
    },
    "wysiwyg.viewer.components.VKShareButton": {
      "type": "Component",
      "skins": [
        "skins.viewer.vkshare.VKShareSkin"
      ],
      "dataTypes": [
        "VKShareButton"
      ],
      "styles": {
        "vks1": "skins.viewer.vkshare.VKShareSkin"
      },
      "nickname": "vkShare",
      "propertyTypes": [
        "VKShareProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.WPhoto": {
      "type": "Component",
      "externalizable": true,
      "responsiveSkins": [
        "wysiwyg.viewer.skins.photo.NoSkinPhoto"
      ],
      "skins": [
        "wysiwyg.viewer.skins.photo.NoSkinPhoto",
        "wysiwyg.viewer.skins.photo.MouseOverPhoto",
        "wysiwyg.viewer.skins.photo.RoundPhoto",
        "wysiwyg.viewer.skins.photo.LiftedShadowPhoto",
        "wysiwyg.viewer.skins.photo.LiftedTopPhoto",
        "wysiwyg.viewer.skins.photo.PolaroidPhoto",
        "wysiwyg.viewer.skins.photo.CirclePhoto",
        "wysiwyg.viewer.skins.photo.SloppyPhoto",
        "wysiwyg.viewer.skins.photo.DoubleBorderPhoto",
        "wysiwyg.viewer.skins.photo.ScotchDoubleHorizontal",
        "wysiwyg.viewer.skins.photo.ScotchDoubleVertical",
        "wysiwyg.viewer.skins.photo.ScotchTopPhoto",
        "wysiwyg.viewer.skins.photo.IronPhoto",
        "wysiwyg.viewer.skins.photo.GlowLinePhoto",
        "wysiwyg.viewer.skins.photo.NewPolaroidPhoto"
      ],
      "dataTypes": [
        "Image"
      ],
      "styles": {
        "ca1": "wysiwyg.viewer.skins.photo.NoSkinPhoto",
        "wp1": "wysiwyg.viewer.skins.photo.NoSkinPhoto",
        "wp2": "wysiwyg.viewer.skins.photo.MouseOverPhoto",
        "wp3": "wysiwyg.viewer.skins.photo.RoundPhoto",
        "wp4": "wysiwyg.viewer.skins.photo.LiftedShadowPhoto"
      },
      "nickname": "image",
      "propertyTypes": [
        "WPhotoProperties"
      ]
    },
    "wysiwyg.viewer.components.WRichText": {
      "type": "Component",
      "externalizable": true,
      "responsiveSkins": [
        "wysiwyg.viewer.skins.WRichTextNewSkin"
      ],
      "skins": [
        "wysiwyg.viewer.skins.WRichTextSkin",
        "wysiwyg.viewer.skins.WRichTextNewSkin",
        "wysiwyg.viewer.skins.WRichTextThemeSkin"
      ],
      "dataTypes": [
        "RichText",
        "StyledText"
      ],
      "styles": {
        "txtNew": "wysiwyg.viewer.skins.WRichTextNewSkin",
        "txt1": "wysiwyg.viewer.skins.WRichTextSkin",
        "txtTheme": "wysiwyg.viewer.skins.WRichTextThemeSkin"
      },
      "nickname": "text",
      "propertyTypes": [
        "",
        "WRichTextProperties"
      ]
    },
    "wysiwyg.viewer.components.WTwitterFollow": {
      "type": "Component",
      "skins": [
        "mobile.core.skins.TwitterFollowSkin",
        "skins.core.TwitterFollowSkin"
      ],
      "dataTypes": [
        "TwitterFollow"
      ],
      "styles": {
        "tf1": "skins.core.TwitterFollowSkin"
      },
      "nickname": "twitterFollow",
      "propertyTypes": [
        "WTwitterFollowProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.WTwitterTweet": {
      "type": "Component",
      "skins": [
        "skins.core.TwitterTweetSkin"
      ],
      "dataTypes": [
        "TwitterTweet"
      ],
      "styles": {
        "twt1": "skins.core.TwitterTweetSkin"
      },
      "nickname": "twitterTweet",
      "propertyTypes": [
        "WTwitterTweetProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.inputs.ComboBoxInput": {
      "type": "Component",
      "skins": [
        "ComboBoxInputSkin",
        "wysiwyg.viewer.skins.input.ComboBoxInputSkin",
        "wysiwyg.viewer.skins.input.ComboBoxInputSkinNoValidation",
        "wysiwyg.viewer.skins.appinputs.AppsComboBoxInputSkin",
        "wysiwyg.viewer.skins.appinputs.AppsComboBoxInputSkinNoValidation"
      ],
      "dataTypes": [
        "SelectableList",
        "ComboBoxInputData"
      ],
      "styles": {
        "wa_cb1": "wysiwyg.viewer.skins.input.ComboBoxInputSkin",
        "wa_cb2": "wysiwyg.viewer.skins.input.ComboBoxInputSkinNoValidation",
        "wa_cb3": "wysiwyg.viewer.skins.appinputs.AppsComboBoxInputSkin"
      },
      "nickname": "dropdown",
      "propertyTypes": [
        "ComboBoxInputProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.inputs.TextOption": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "SelectOption"
      ],
      "styles": {},
      "nickname": "textOption"
    },
    "ecommerce.integration.components.MobileTextOption": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "SelectOption"
      ],
      "styles": {},
      "nickname": "mobileTextOption"
    },
    "wysiwyg.viewer.components.inputs.ColorOption": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "SelectOption"
      ],
      "styles": {},
      "nickname": "colorOption"
    },
    "ecommerce.integration.components.MobileColorOption": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "SelectOption"
      ],
      "styles": {},
      "nickname": "mobileColorOption"
    },
    "wysiwyg.viewer.components.mobile.TinyMenu": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin",
        "wysiwyg.viewer.skins.mobile.TinyMenuPullFromLeftSkin",
        "wysiwyg.viewer.skins.mobile.TinyMenuPullFromRightSkin"
      ],
      "dataTypes": [
        "",
        "TinyMenu"
      ],
      "styles": {
        "tm1": "wysiwyg.viewer.skins.mobile.TinyMenuSkin",
        "tm2": "wysiwyg.viewer.skins.mobile.TinyMenuSkin",
        "tmFull1": "wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin",
        "tmFull2": "wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin"
      },
      "nickname": "mobileMenu",
      "propertyTypes": [
        "",
        "TinyMenuProperties"
      ]
    },
    "wysiwyg.viewer.components.ExpandableMenu": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.ExpandableMenuSkin"
      ],
      "dataTypes": [
        "CustomMenuDataRef"
      ],
      "styles": {
        "ExpandableMenu_1": "wysiwyg.viewer.skins.ExpandableMenuSkin"
      },
      "nickname": "expandableMenu",
      "propertyTypes": [
        "ExpandableMenuProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.QuickActionBar": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.quickActionBar.anchoredSkin",
        "wysiwyg.viewer.skins.quickActionBar.floatingSkin",
        "wysiwyg.viewer.skins.quickActionBar.ovalSkin",
        "wysiwyg.viewer.skins.quickActionBar.rectSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "anchored": "wysiwyg.viewer.skins.quickActionBar.anchoredSkin",
        "floating": "wysiwyg.viewer.skins.quickActionBar.floatingSkin",
        "oval": "wysiwyg.viewer.skins.quickActionBar.ovalSkin",
        "rect": "wysiwyg.viewer.skins.quickActionBar.rectSkin"
      },
      "nickname": "quickActionBar",
      "propertyTypes": [
        "QuickActionBarProperties"
      ]
    },
    "wysiwyg.viewer.components.QuickActionBarItem": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        "QuickActionBarItem"
      ],
      "styles": {},
      "nickname": "quickActionBarItem"
    },
    "tpa.viewer.components.Collage": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPACollageSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpacol1": "wysiwyg.viewer.skins.TPACollageSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "CollageProperties"
      ]
    },
    "tpa.viewer.components.Freestyle": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAFreestyleSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpafs1": "wysiwyg.viewer.skins.TPAFreestyleSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "FreestyleProperties"
      ]
    },
    "wysiwyg.viewer.components.TouchMediaZoom": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TouchMediaZoom"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tmZoomSlideshow1": "wysiwyg.viewer.skins.TouchMediaZoom"
      },
      "nickname": "touchMediaZoom"
    },
    "wysiwyg.viewer.components.TouchMediaZoomItem": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.TouchMediaZoomItem"
      ],
      "dataTypes": [
        "Image"
      ],
      "styles": {
        "touchMediaZoomItem1": "wysiwyg.viewer.skins.TouchMediaZoomItem"
      },
      "nickname": "touchMediaZoomItem"
    },
    "tpa.viewer.components.Honeycomb": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAHoneycombSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpahc1": "wysiwyg.viewer.skins.TPAHoneycombSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "HoneycombProperties"
      ]
    },
    "tpa.viewer.components.Masonry": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAMasonrySkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpms1": "wysiwyg.viewer.skins.TPAMasonrySkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "MasonryProperties"
      ]
    },
    "wysiwyg.viewer.components.tpapps.TPA3DCarousel": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPA3DCarouselSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tfc1": "wysiwyg.viewer.skins.TPA3DCarouselSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "SlideShowGalleryProperties"
      ]
    },
    "wysiwyg.viewer.components.tpapps.TPA3DGallery": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPA3DGallerySkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tfg1": "wysiwyg.viewer.skins.TPA3DGallerySkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "SlideShowGalleryProperties"
      ]
    },
    "tpa.viewer.components.StripShowcase": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAStripShowcaseSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpasc1": "wysiwyg.viewer.skins.TPAStripShowcaseSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "StripShowcaseProperties"
      ]
    },
    "tpa.viewer.components.StripSlideshow": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAStripSlideshowSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpastr1": "wysiwyg.viewer.skins.TPAStripSlideshowSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "StripSlideshowProperties"
      ]
    },
    "tpa.viewer.components.Thumbnails": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAThumbnailsSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "thmb1": "wysiwyg.viewer.skins.TPAThumbnailsSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "ThumbnailsProperties"
      ]
    },
    "tpa.viewer.components.Accordion": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAAccordionSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpaacc1": "wysiwyg.viewer.skins.TPAAccordionSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "AccordionProperties"
      ]
    },
    "tpa.viewer.components.Impress": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.TPAImpressSkin"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "tpaimprs": "wysiwyg.viewer.skins.TPAImpressSkin"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "ImpressProperties"
      ]
    },
    "wysiwyg.common.components.exitmobilemode.viewer.ExitMobileMode": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.exitmobilemode.viewer.skins.ExitMobileModeSkin"
      ],
      "dataTypes": [
        "LinkableButton"
      ],
      "styles": {
        "emb1": "wysiwyg.common.components.exitmobilemode.viewer.skins.ExitMobileModeSkin"
      },
      "nickname": "backToDesktopButton",
      "propertyTypes": [
        "ButtonProperties"
      ]
    },
    "wysiwyg.common.components.NumericStepper": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.numericstepper.viewer.skins.NumericStepperSimpleSkin"
      ],
      "dataTypes": [
        "NumericStepper"
      ],
      "styles": {
        "NumericStepper_1": "wysiwyg.common.components.numericstepper.viewer.skins.NumericStepperSimpleSkin"
      },
      "nickname": "numericStepper",
      "propertyTypes": [
        "NumericStepperProperties"
      ]
    },
    "wysiwyg.viewer.components.FiveGridLine": {
      "type": "Component",
      "externalizable": true,
      "responsiveSkins": [
        "wysiwyg.viewer.skins.line.SolidLineStudio",
        "wysiwyg.viewer.skins.line.DashedLineStudio",
        "wysiwyg.viewer.skins.line.DottedLineStudio"
      ],
      "skins": [
        "wysiwyg.viewer.skins.line.SolidLine",
        "wysiwyg.viewer.skins.line.FadeLine",
        "wysiwyg.viewer.skins.line.FadeNotchTopLine",
        "wysiwyg.viewer.skins.line.FadeNotchBottomLine",
        "wysiwyg.viewer.skins.line.NotchDashedLine",
        "wysiwyg.viewer.skins.line.DashedLine",
        "wysiwyg.viewer.skins.line.DottedLine",
        "wysiwyg.viewer.skins.line.DoubleLine",
        "wysiwyg.viewer.skins.line.NotchLine",
        "wysiwyg.viewer.skins.line.ShadowTopLine",
        "wysiwyg.viewer.skins.line.ShadowBottomLine",
        "wysiwyg.viewer.skins.line.ArrowRightLine",
        "wysiwyg.viewer.skins.line.ArrowLine",
        "wysiwyg.viewer.skins.line.SloppyLine",
        "wysiwyg.viewer.skins.line.IronLine",
        "wysiwyg.viewer.skins.line.ZigzagLineSkin",
        "wysiwyg.viewer.skins.line.ZigzagLineFlipSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "hl1": "wysiwyg.viewer.skins.line.SolidLine",
        "hl2": "wysiwyg.viewer.skins.line.FadeLine",
        "hl3": "wysiwyg.viewer.skins.line.FadeNotchTopLine",
        "hl4": "wysiwyg.viewer.skins.line.FadeNotchBottomLine"
      },
      "nickname": "line",
      "propertyTypes": [
        "",
        "FiveGridLineProperties"
      ]
    },
    "wysiwyg.viewer.components.PageGroup": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.PageGroupSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "pageGroup",
      "propertyTypes": [
        "PageGroupProperties"
      ]
    },
    "wysiwyg.viewer.components.PaginatedGridGallery": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridDefaultSkin",
        "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridArrowsOutside",
        "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridOverlay",
        "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridRibbonArrows",
        "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridTextBottom"
      ],
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "pagg1": "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridOverlay",
        "pagg2": "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridArrowsOutside",
        "pagg3": "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridRibbonArrows"
      },
      "nickname": "gallery",
      "propertyTypes": [
        "PaginatedGridGalleryProperties"
      ]
    },
    "wysiwyg.viewer.components.WFacebookComment": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "mobile.core.skins.FacebookCommentSkin",
        "skins.core.FacebookCommentSkin"
      ],
      "dataTypes": [
        "",
        "WFacebookComment"
      ],
      "styles": {
        "fbc1": "skins.core.FacebookCommentSkin"
      },
      "nickname": "facebookComments",
      "propertyTypes": [
        "WFacebookCommentProperties"
      ]
    },
    "wysiwyg.common.components.disquscomments.viewer.DisqusComments": {
      "type": "Component",
      "skins": [
        "wysiwyg.common.components.disquscomments.viewer.skins.DisqusCommentsSkin"
      ],
      "dataTypes": [
        "DisqusComments"
      ],
      "styles": {
        "disq2": "wysiwyg.common.components.disquscomments.viewer.skins.DisqusCommentsSkin"
      },
      "nickname": "disqusComments",
      "externalizable": true
    },
    "wysiwyg.viewer.components.WFacebookLike": {
      "type": "Component",
      "skins": [
        "skins.core.FacebookLikeSkin"
      ],
      "dataTypes": [
        "",
        "WFacebookLike"
      ],
      "styles": {
        "fbl1": "skins.core.FacebookLikeSkin"
      },
      "nickname": "facebookLike",
      "propertyTypes": [
        "WFacebookLikeProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.WGooglePlusOne": {
      "type": "Component",
      "skins": [
        "mobile.core.skins.GooglePlusOneSkin",
        "skins.core.GooglePlusOneSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "gp1": "skins.core.GooglePlusOneSkin"
      },
      "nickname": "google1",
      "propertyTypes": [
        "WGooglePlusOneProperties"
      ]
    },
    "wysiwyg.viewer.components.svgshape.SvgShape": {
      "type": "Component",
      "skins": [
        "skins.viewer.svgshape.SvgShapeDefaultSkin"
      ],
      "dataTypes": [
        "SvgShape",
        ""
      ],
      "styles": {
        "assh": "skins.viewer.svgshape.SvgShapeDefaultSkin"
      },
      "nickname": "shape",
      "propertyTypes": [
        "SvgShapeProperties"
      ]
    },
    "wysiwyg.viewer.components.VectorImage": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "skins.viewer.VectorImageSkin"
      ],
      "dataTypes": [
        "VectorImage"
      ],
      "styles": {
        "vi1": "skins.viewer.VectorImageSkin"
      },
      "nickname": "vectorImage",
      "designDataTypes": [
        "VectorImageDesignData"
      ],
      "propertyTypes": [
        "VectorImageProperties"
      ]
    },
    "wysiwyg.viewer.components.svgPrimitive.SvgPrimitive": {
      "type": "Component",
      "skins": [],
      "dataTypes": [],
      "styles": {
        "svgp1": "skins.viewer.svgPrimitive.SvgShapeDefaultSkin"
      },
      "nickname": "svgPrimitive"
    },
    "wysiwyg.viewer.components.SiteRegionContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "sirc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      },
      "nickname": "container"
    },
    "mobile.core.components.Container": {
      "type": "Container",
      "externalizable": true,
      "aliases": [
        "core.components.ContainerOBC",
        "core.components.Container"
      ],
      "responsiveSkins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin",
        "wysiwyg.viewer.skins.area.RectangleArea",
        "wysiwyg.viewer.skins.area.AppleArea",
        "wysiwyg.viewer.skins.area.CircleArea",
        "wysiwyg.viewer.skins.area.BubbleArea",
        "wysiwyg.viewer.skins.area.BubbleLeftArea",
        "wysiwyg.viewer.skins.area.RibbonAreaSkin",
        "wysiwyg.viewer.skins.area.ThreeDeeAreaSkin",
        "wysiwyg.viewer.skins.area.LiftedShadowArea",
        "wysiwyg.viewer.skins.area.LiftedTopAreaSkin",
        "wysiwyg.viewer.skins.area.LiftedBottomAreaSkin",
        "wysiwyg.viewer.skins.area.InnerShadowAreaSkin",
        "wysiwyg.viewer.skins.area.SloopyArea",
        "wysiwyg.viewer.skins.area.BorderDashDefaultAreaSkin",
        "wysiwyg.viewer.skins.area.ForkedRibbonArea",
        "wysiwyg.viewer.skins.area.VerticalRibbonArea",
        "wysiwyg.viewer.skins.area.CenterRibbon",
        "wysiwyg.viewer.skins.area.ArrowRightRibbon",
        "wysiwyg.viewer.skins.area.VerticalArrowArea",
        "wysiwyg.viewer.skins.area.SandClockArea",
        "wysiwyg.viewer.skins.area.DBDefaultAreaSkin",
        "wysiwyg.viewer.skins.area.BubbleAreaLeft",
        "wysiwyg.viewer.skins.area.LeftTriangleArea",
        "wysiwyg.viewer.skins.area.RightTriangleArea",
        "wysiwyg.viewer.skins.area.BubbleAreaRight",
        "wysiwyg.viewer.skins.area.IronBox",
        "wysiwyg.viewer.skins.area.PhotoArea",
        "skins.viewer.area.ScotchTopArea",
        "skins.viewer.area.ScotchDoubleHorizontalArea",
        "skins.viewer.area.ScotchDoubleVerticalArea"
      ],
      "dataTypes": [
        "ContainerData",
        ""
      ],
      "styles": {
        "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin",
        "c2": "wysiwyg.viewer.skins.area.RectangleArea",
        "c3": "wysiwyg.viewer.skins.area.AppleArea",
        "c4": "wysiwyg.viewer.skins.area.CircleArea"
      },
      "nickname": "box"
    },
    "wixui.SlotsPlaceholder": {
      "type": "Container",
      "externalizable": true,
      "styles": {},
      "slotsDataType": "PlaceholderSlot",
      "dataTypes": [
        "SlotsPlaceholderData",
        ""
      ],
      "nickname": "slotsPlaceholder"
    },
    "wysiwyg.viewer.components.MediaBox": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer",
        "wysiwyg.viewer.skins.mediaContainer.MediaBox"
      ],
      "dataTypes": [
        "MediaBoxData",
        ""
      ],
      "styles": {
        "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer",
        "mb1": "wysiwyg.viewer.skins.mediaContainer.MediaBox"
      },
      "nickname": "mediaBox",
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "propertyTypes": [
        "",
        "MediaBoxProperties"
      ]
    },
    "wysiwyg.viewer.components.HoverBox": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      },
      "nickname": "hoverBox",
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "propertyTypes": [
        "HoverBoxProperties"
      ]
    },
    "wysiwyg.viewer.components.PopupContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
      ],
      "dataTypes": [
        "LightboxContainer",
        ""
      ],
      "styles": {
        "strc1": "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
      },
      "nickname": "lightbox",
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "propertyTypes": [
        "PopupContainerProperties"
      ]
    },
    "wysiwyg.viewer.components.PopupCloseTextButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.button.BasicButton",
        "wysiwyg.viewer.skins.button.ButtonThreeD",
        "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
        "wysiwyg.viewer.skins.button.ShinyButtonInverted",
        "wysiwyg.viewer.skins.button.ButtonArrow",
        "wysiwyg.viewer.skins.button.ButtonArrowLeft",
        "wysiwyg.viewer.skins.button.ButtonInnerShadow",
        "wysiwyg.viewer.skins.button.ButtonShadowRight",
        "wysiwyg.viewer.skins.button.ButtonShadowLeft",
        "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
        "wysiwyg.viewer.skins.button.ShinyButtonISkin",
        "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
        "wysiwyg.viewer.skins.button.RibbonButton",
        "wysiwyg.viewer.skins.button.CircleButton",
        "wysiwyg.viewer.skins.button.SloopyButton",
        "wysiwyg.viewer.skins.button.IronButton",
        "wysiwyg.viewer.skins.button.GamingButton",
        "wysiwyg.viewer.skins.button.ScotchTapeButton"
      ],
      "dataTypes": [
        "LinkableButton"
      ],
      "styles": {
        "b1": "wysiwyg.viewer.skins.button.BasicButton",
        "b2": "wysiwyg.viewer.skins.button.ButtonThreeD",
        "b3": "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
        "b4": "wysiwyg.viewer.skins.button.ShinyButtonInverted"
      },
      "nickname": "button",
      "propertyTypes": [
        "ButtonProperties"
      ]
    },
    "wysiwyg.viewer.components.PopupCloseIconButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        "SvgShape",
        ""
      ],
      "styles": {
        "assh": "skins.viewer.svgshape.SvgShapeDefaultSkin"
      },
      "nickname": "button",
      "propertyTypes": [
        "SvgShapeProperties"
      ]
    },
    "wysiwyg.viewer.components.Group": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.components.GroupSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "group"
    },
    "wysiwyg.viewer.components.FormContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.FormContainerSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "form"
    },
    "wysiwyg.viewer.components.WSiteStructure": {
      "type": "Document",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "site"
    },
    "wysiwyg.viewer.components.HeaderContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.screenwidthcontainer.AfterScroll",
        "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.DefaultWithFillLayers",
        "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.ThreeDeeScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.LiftedTopScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.LiftedBottomScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.ShadowBottomScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "hc1": "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
        "hc2": "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
        "hc3": "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen"
      },
      "nickname": "header",
      "designDataTypes": [
        "MediaContainerWithDividers",
        ""
      ]
    },
    "wysiwyg.viewer.components.FooterContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.DefaultWithFillLayers",
        "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.ThreeDeeScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.LiftedTopScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.LiftedBottomScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.ShadowTopScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "fc1": "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
        "fc2": "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
        "fc3": "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen"
      },
      "nickname": "footer",
      "designDataTypes": [
        "MediaContainerWithDividers",
        ""
      ]
    },
    "wysiwyg.viewer.components.PagesContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "pc1": "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen",
        "pc2": "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen"
      },
      "nickname": "pagesContainer"
    },
    "wysiwyg.viewer.components.StripContainer": {
      "type": "Container",
      "skins": [
        "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
      ],
      "dataTypes": [
        "StripContainer"
      ],
      "styles": {
        "strc1": "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
      },
      "nickname": "strip"
    },
    "wysiwyg.viewer.components.StripColumnsContainer": {
      "type": "Container",
      "dataTypes": [
        "StripColumnsContainer",
        ""
      ],
      "skins": [
        "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer",
        "wysiwyg.viewer.skins.stripContainer.DesignedStrip"
      ],
      "styles": {
        "strc1": "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
      },
      "requiredChildType": "wysiwyg.viewer.components.Column",
      "nickname": "columnStrip",
      "designDataTypes": [
        "MediaContainerDesignData",
        "MediaContainerWithDividers"
      ],
      "propertyTypes": [
        "StripColumnsContainerProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.ClassicSection": {
      "type": "Container",
      "externalizable": true,
      "dataTypes": [
        "ClassicSection",
        ""
      ],
      "nickname": "section",
      "designDataTypes": [
        "MediaContainerDesignData",
        "MediaContainerWithDividers"
      ],
      "propertyTypes": [
        "ClassicSectionProperties"
      ]
    },
    "wysiwyg.viewer.components.Column": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      },
      "nickname": "column",
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "propertyTypes": [
        "ColumnProperties"
      ]
    },
    "wysiwyg.viewer.components.MediaPlayer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mediaPlayerSkin"
      ],
      "dataTypes": [
        ""
      ],
      "designDataTypes": [
        "MediaPlayerDesignData"
      ],
      "styles": {
        "mp1": "wysiwyg.viewer.skins.mediaPlayerSkin"
      },
      "nickname": "videoBox",
      "propertyTypes": [
        "MediaPlayerProperties"
      ]
    },
    "wysiwyg.viewer.components.MediaOverlayControls": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "skins.viewer.mediaOverlayControlsDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "designDataTypes": [
        "MediaControlsDesignData"
      ],
      "styles": {
        "mocntDefault": "skins.viewer.mediaOverlayControlsDefaultSkin"
      },
      "nickname": "videoBoxBigPlay",
      "propertyTypes": [
        "MediaOverlayControlsProperties"
      ]
    },
    "wysiwyg.viewer.components.MediaControls": {
      "type": "Component",
      "skins": [
        "skins.viewer.mediaControlsDarkSkin",
        "skins.viewer.mediaControlsLightSkin",
        "skins.viewer.mediaControlsNoControlsSkin"
      ],
      "dataTypes": [
        ""
      ],
      "designDataTypes": [
        "MediaControlsDesignData"
      ],
      "styles": {
        "mcntDefault": "skins.viewer.mediaControlsNoControlsSkin",
        "mcntLight": "skins.viewer.mediaControlsLightSkin",
        "mcntDark": "skins.viewer.mediaControlsDarkSkin"
      },
      "nickname": "videoBoxMute",
      "propertyTypes": [
        "MediaControlsProperties"
      ]
    },
    "wysiwyg.viewer.components.MediaControlPlay": {
      "type": "Component",
      "skins": [
        "skins.viewer.mediaControlPlayDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mcp1": "skins.viewer.mediaControlPlayDefaultSkin"
      },
      "nickname": "mediaControlPlay"
    },
    "wysiwyg.viewer.components.MediaControlVolume": {
      "type": "Component",
      "skins": [
        "skins.viewer.mediaControlVolumeDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mcv1": "skins.viewer.mediaControlVolumeDefaultSkin"
      },
      "nickname": "mediaControlVolume"
    },
    "wysiwyg.viewer.components.MediaControlFullscreen": {
      "type": "Component",
      "skins": [
        "skins.viewer.mediaControlFullscreenDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mcf1": "skins.viewer.mediaControlFullscreenDefaultSkin"
      },
      "nickname": "mediaControlFullscreen"
    },
    "wysiwyg.viewer.components.MediaControlProgress": {
      "type": "Component",
      "skins": [
        "skins.viewer.mediaControlProgressDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mcfpr1": "skins.viewer.mediaControlProgressDefaultSkin"
      },
      "nickname": "mediaControlProgress"
    },
    "wysiwyg.viewer.components.MediaControlTime": {
      "type": "Component",
      "skins": [
        "skins.viewer.mediaControlTimeDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mct1": "skins.viewer.mediaControlTimeDefaultSkin"
      },
      "nickname": "mediaControlTime"
    },
    "wysiwyg.viewer.components.MediaControlStoryboard": {
      "type": "Component",
      "skins": [
        "skins.viewer.MediaControlStoryboardDefaultSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mcsb1": "skins.viewer.mediaControlStoryboardDefaultSkin",
        "mcsb2": "skins.viewer.mediaControlStoryboardMinimalSkin"
      },
      "nickname": "mediaControlStoryboard"
    },
    "wysiwyg.viewer.components.ScreenWidthContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
        "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "sc1": "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
        "sc2": "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
        "sc3": "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
        "sc4": "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
      },
      "nickname": "strip"
    },
    "wysiwyg.viewer.components.VerticalLine": {
      "type": "Component",
      "externalizable": true,
      "responsiveSkins": [
        "wysiwyg.viewer.skins.line.VerticalSolidLine",
        "wysiwyg.viewer.skins.line.VerticalNotchDashedLine",
        "wysiwyg.viewer.skins.line.VerticalDottedLine"
      ],
      "skins": [
        "wysiwyg.viewer.skins.line.VerticalSolidLine",
        "wysiwyg.viewer.skins.line.VerticalFadeNotchLeftLine",
        "wysiwyg.viewer.skins.line.VerticalFadeNotchRightLine",
        "wysiwyg.viewer.skins.line.VerticalNotchDashedLine",
        "wysiwyg.viewer.skins.line.VerticalShadowLeftLine",
        "wysiwyg.viewer.skins.line.VerticalShadowRightLine",
        "wysiwyg.viewer.skins.line.VerticalDoubleLine",
        "wysiwyg.viewer.skins.line.VerticalDashedLine",
        "wysiwyg.viewer.skins.line.VerticalDottedLine",
        "wysiwyg.viewer.skins.line.VerticalNotchLine",
        "wysiwyg.viewer.skins.line.VerticalSloopyLine",
        "wysiwyg.viewer.skins.line.VerticalArrowLineTop",
        "wysiwyg.viewer.skins.line.VerticalArrowLine",
        "wysiwyg.viewer.skins.line.VerticalIronLine"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "vl1": "wyiwyg.viewer.skins.line.VerticalSolidLine",
        "vl2": "wysiwyg.viewer.skins.line.VerticalFadeNotchLeftLine",
        "vl3": "wysiwyg.viewer.skins.line.VerticalFadeNotchRightLine",
        "vl4": "wysiwyg.viewer.skins.line.VerticalNotchDashedLine"
      },
      "nickname": "line"
    },
    "wysiwyg.viewer.components.tpapps.TPAGluedWidget": {
      "type": "Container",
      "aliases": [
        "tpa.viewer.components.tpapps.TPAGluedWidget"
      ],
      "skins": [
        "wysiwyg.viewer.skins.TPAWidgetSkin"
      ],
      "dataTypes": [
        "TPAWidget"
      ],
      "slotsDataType": "DynamicSlots",
      "styles": {
        "tpagw0": "wysiwyg.viewer.skins.TPAWidgetSkin"
      },
      "nickname": "gluedApp",
      "propertyTypes": [
        "TPAGluedProperties"
      ]
    },
    "wysiwyg.viewer.components.tpapps.TPAWidget": {
      "type": "Container",
      "aliases": [
        "tpa.viewer.components.tpapps.TPAWidget"
      ],
      "skins": [
        "wysiwyg.viewer.skins.TPAWidgetSkin"
      ],
      "dataTypes": [
        "TPAWidget"
      ],
      "slotsDataType": "DynamicSlots",
      "styles": {
        "tpaw0": "wysiwyg.viewer.skins.TPAWidgetSkin"
      },
      "nickname": "widget"
    },
    "wysiwyg.viewer.components.tpapps.TPASection": {
      "type": "Container",
      "aliases": [
        "tpa.viewer.components.tpapps.TPASection"
      ],
      "skins": [
        "wysiwyg.viewer.skins.TPASectionSkin"
      ],
      "dataTypes": [
        "TPA"
      ],
      "slotsDataType": "DynamicSlots",
      "styles": {
        "tpas0": "wysiwyg.viewer.skins.TPASectionSkin"
      },
      "nickname": "pageApp"
    },
    "wysiwyg.viewer.components.tpapps.TPAMultiSection": {
      "type": "Container",
      "aliases": [
        "tpa.viewer.components.tpapps.TPAMultiSection"
      ],
      "skins": [
        "wysiwyg.viewer.skins.TPASectionSkin"
      ],
      "dataTypes": [
        "TPAMultiSection"
      ],
      "slotsDataType": "DynamicSlots",
      "styles": {
        "tpas0": "wysiwyg.viewer.skins.TPASectionSkin"
      },
      "nickname": "pageApp"
    },
    "wysiwyg.common.components.backtotopbutton.viewer.BackToTopButton": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.backtotopbutton.BackToTopButtonSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "BackToTopButton_1": "wysiwyg.viewer.skins.backtotopbutton.BackToTopButtonSkin"
      },
      "nickname": "backToTop"
    },
    "wysiwyg.viewer.components.BackToTopButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "skins.viewer.VectorImageSkin"
      ],
      "dataTypes": [
        "VectorImage"
      ],
      "styles": {
        "vi1": "skins.viewer.VectorImageSkin"
      },
      "nickname": "backToTop",
      "designDataTypes": [
        "VectorImageDesignData"
      ],
      "propertyTypes": [
        "VectorImageProperties"
      ]
    },
    "wysiwyg.viewer.components.SiteBackground": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        "BackgroundMedia"
      ],
      "styles": {
        "siteBackground": "wysiwyg.viewer.skins.siteBackgroundSkin"
      },
      "nickname": "siteBackground"
    },
    "wysiwyg.viewer.components.dialogs.EnterPasswordDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "enterPasswordDialog"
    },
    "wysiwyg.viewer.components.dialogs.NotificationDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "notificationDialog"
    },
    "wysiwyg.viewer.components.dialogs.siteMemberDialogs.SignUpDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "signUpDialog"
    },
    "wysiwyg.viewer.components.dialogs.siteMemberDialogs.MemberLoginDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "memberLoginDialog"
    },
    "wysiwyg.viewer.components.dialogs.siteMemberDialogs.RequestPasswordResetDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "requestPasswordResetDialog"
    },
    "wysiwyg.viewer.components.dialogs.siteMemberDialogs.ResetPasswordDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "resetPasswordDialog"
    },
    "ecommerce.viewer.dialogs.EcomCheckoutMessageDialog": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "ecomCheckoutMessageDialog"
    },
    "core.components.ZoomedImage": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        "Image"
      ],
      "styles": {},
      "nickname": "zoomedImage"
    },
    "wysiwyg.components.imageZoom": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        "Image"
      ],
      "styles": {},
      "nickname": "imageZoom"
    },
    "wysiwyg.components.ImageZoomDisplayer": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Image"
      ],
      "styles": {},
      "nickname": "imageZoomDisplayer"
    },
    "wixapps.integration.components.AppPartZoom": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "PermaLink"
      ],
      "styles": {},
      "nickname": "appPartZoom"
    },
    "wysiwyg.viewer.components.MediaZoom": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "mediaZoom"
    },
    "wysiwyg.viewer.components.MobileMediaZoom": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "mobileMediaZoom"
    },
    "wysiwyg.viewer.components.inputs.ErasableTextInput": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.appinputs.EcomErasableTextInputSkin"
      ],
      "dataTypes": [
        "TextInput"
      ],
      "styles": {
        "ecom_eti1": "wysiwyg.viewer.skins.appinputs.EcomErasableTextInputSkin"
      },
      "nickname": "textInput",
      "propertyTypes": [
        "TextInputProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.common.components.InfoTip": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "infoTip"
    },
    "wysiwyg.components.viewer.inputs.InputWithValidation": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "input"
    },
    "wysiwyg.viewer.components.MessageView": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "messageView"
    },
    "wixapps.integration.components.Area": {
      "type": "Container",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "area"
    },
    "wysiwyg.viewer.components.inputs.TextAreaInput": {
      "type": "Component",
      "skins": [
        "TextAreaDefaultSkin",
        "wysiwyg.viewer.skins.input.TextAreaInputSkin",
        "wysiwyg.viewer.skins.appinputs.AppsTextAreaInputSkin",
        "wysiwyg.viewer.skins.appinputs.AppsTextAreaInputSkinNoValidation"
      ],
      "dataTypes": [
        "TextAreaInput"
      ],
      "styles": {},
      "nickname": "textBox",
      "propertyTypes": [
        "TextAreaInputProperties"
      ],
      "externalizable": true
    },
    "wixapps.integration.components.inputs.TextArea": {
      "type": "Component",
      "externalizable": true,
      "skins": [],
      "dataTypes": [
        "TextAreaInput"
      ],
      "styles": {},
      "nickname": "textArea",
      "propertyTypes": [
        "TextAreaInputProperties"
      ]
    },
    "wixapps.integration.components.Toggle": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "toggle"
    },
    "wysiwyg.viewer.components.MobileActionsMenu": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mobile.MobileActionsMenuSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "actionMenu"
    },
    "wysiwyg.viewer.components.Table": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "table"
    },
    "wysiwyg.viewer.components.tpapps.TPAModal": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "tpaModal"
    },
    "wysiwyg.viewer.components.tpapps.TPAPopup": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "tpaPopup"
    },
    "wysiwyg.viewer.components.tpapps.TPAPreloaderOverlay": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "preloaderOverly"
    },
    "wysiwyg.viewer.components.tpapps.TPAUnavailableMessageOverlay": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "unavailableMessageOverlay"
    },
    "tpa.viewer.classes.TPAWorker": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "tpaWorker"
    },
    "wysiwyg.viewer.components.tpapps.TPAPlaceholder": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "tpaPlaceholder"
    },
    "wysiwyg.viewer.components.cloud.CloudGluedWidget": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "cloudWidget"
    },
    "wysiwyg.viewer.components.cloud.CloudWidget": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "cloudWidget"
    },
    "wysiwyg.viewer.components.background.bgMedia": {
      "type": "Component",
      "skins": [],
      "dataTypes": [],
      "styles": {
        "bgMedia": "skins.viewer.bgMedia.bgMediaSkin"
      },
      "nickname": "bgMedia"
    },
    "wysiwyg.viewer.components.background.bgImage": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "Image"
      ],
      "styles": {
        "bgImage": "skins.viewer.bgImage.bgImageSkin"
      },
      "nickname": "bgImage"
    },
    "wysiwyg.viewer.components.background.html5Video": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "WixVideo"
      ],
      "styles": {
        "bgVideo": "skins.viewer.bgVideo.html5VideoSkin"
      },
      "nickname": "html5Video"
    },
    "wysiwyg.viewer.components.background.webglMedia": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "WixVideo"
      ],
      "styles": {
        "webgl": "skins.viewer.bgVideo.webglMediaSkin"
      },
      "nickname": "webglMedia"
    },
    "wysiwyg.viewer.components.background.iframeVideo": {
      "type": "Component",
      "skins": [],
      "dataTypes": [
        "WixVideo"
      ],
      "styles": {
        "iframeVideo": "skins.viewer.bgVideo.iframeVideoSkin"
      },
      "nickname": "iframeVideo"
    },
    "wysiwyg.viewer.components.background.bgOverlay": {
      "type": "Component",
      "skins": [],
      "dataTypes": [],
      "styles": {
        "bgOverlay": "skins.viewer.bgOverlay.bgOverlaySkin"
      },
      "nickname": "bgOverlay"
    },
    "wysiwyg.viewer.components.BoxSlideShow": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
        "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsSkin",
        "wysiwyg.common.components.boxSlideShow.viewer.skins.squareButtonsSkin",
        "wysiwyg.common.components.boxSlideShow.viewer.skins.longArrowsLargeSelectedCircleSkin"
      ],
      "dataTypes": [
        "",
        "BoxSlideShow"
      ],
      "styles": {
        "boxSlide1": "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
        "boxSlide2": "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsSkin",
        "boxSlide3": "wysiwyg.common.components.boxSlideShow.viewer.skins.squareButtonsSkin",
        "boxSlide4": "wysiwyg.common.components.boxSlideShow.viewer.skins.longArrowsLargeSelectedCircleSkin"
      },
      "requiredChildType": "wysiwyg.viewer.components.BoxSlideShowSlide",
      "nickname": "slideshow",
      "propertyTypes": [
        "BoxSlideShowProperties"
      ]
    },
    "wysiwyg.viewer.components.StateBox": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.statebox.viewer.skins.StateBoxSkin"
      ],
      "dataTypes": [
        "",
        "StateBox"
      ],
      "styles": {
        "stateBox1": "wysiwyg.common.components.statebox.viewer.skins.StateBoxSkin"
      },
      "requiredChildType": "wysiwyg.viewer.components.StateBoxState",
      "nickname": "statebox",
      "propertyTypes": [
        "StateBoxProperties"
      ]
    },
    "wysiwyg.viewer.components.StateStrip": {
      "type": "Container",
      "skins": [
        "wysiwyg.common.components.statebox.viewer.skins.StateStripSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "stateStrip1": "wysiwyg.common.components.statebox.viewer.skins.StateStripSkin"
      },
      "requiredChildType": "wysiwyg.viewer.components.StateStripState",
      "nickname": "stateStrip",
      "propertyTypes": [
        "StateBoxProperties"
      ]
    },
    "wysiwyg.viewer.components.StateBoxState": {
      "type": "Container",
      "skins": [],
      "dataTypes": [
        "",
        "StateBoxState"
      ],
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "styles": {
        "stateBoxState1": "wysiwyg.common.components.boxSlideShowSlide.viewer.skins.boxSlideShowSlideSkin"
      },
      "nickname": "state",
      "propertyTypes": [
        "",
        "BoxSlideShowSlideProperties"
      ]
    },
    "wysiwyg.viewer.components.StateBoxFormState": {
      "type": "Container",
      "skins": [
        "wysiwyg.common.components.statebox.viewer.skins.StateBoxStateFormSkin"
      ],
      "dataTypes": [
        ""
      ],
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "styles": {
        "stateBoxFormState1": "wysiwyg.common.components.statebox.viewer.skins.StateBoxStateFormSkin"
      },
      "nickname": "stateboxFormState",
      "propertyTypes": [
        "",
        "BoxSlideShowSlideProperties"
      ]
    },
    "wysiwyg.viewer.components.StateStripState": {
      "type": "Container",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "styles": {
        "stateStripState1": "wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin"
      },
      "nickname": "stateStripState",
      "propertyTypes": [
        "",
        "StateBoxStateProperties"
      ]
    },
    "wysiwyg.viewer.components.StripContainerSlideShow": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
        "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsSkin",
        "wysiwyg.common.components.stripSlideShow.viewer.skins.squareButtonsSkin",
        "wysiwyg.common.components.stripSlideShow.viewer.skins.longArrowsLargeSelectedCircleSkin"
      ],
      "dataTypes": [
        "",
        "StripContainerSlideShow"
      ],
      "styles": {
        "stripSlide1": "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
        "stripSlide2": "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsSkin",
        "stripSlide3": "wysiwyg.common.components.stripSlideShow.viewer.skins.squareButtonsSkin",
        "stripSlide4": "wysiwyg.common.components.stripSlideShow.viewer.skins.bottomArrowsLargeSelectedCircleSkin"
      },
      "requiredChildType": "wysiwyg.viewer.components.StripContainerSlideShowSlide",
      "nickname": "fullWidthSlides",
      "propertyTypes": [
        "StripContainerSlideShowProperties"
      ]
    },
    "wysiwyg.viewer.components.BoxSlideShowSlide": {
      "type": "Container",
      "skins": [],
      "dataTypes": [
        "BoxSlideShowSlide"
      ],
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "styles": {
        "boxSlideShowSlide1": "wysiwyg.common.components.boxSlideShowSlide.viewer.skins.boxSlideShowSlideSkin"
      },
      "nickname": "slideshowSlide",
      "propertyTypes": [
        "",
        "BoxSlideShowSlideProperties"
      ]
    },
    "wysiwyg.viewer.components.StripContainerSlideShowSlide": {
      "type": "Container",
      "skins": [
        "wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin"
      ],
      "dataTypes": [
        "StripContainerSlideShowSlide"
      ],
      "designDataTypes": [
        "MediaContainerDesignData"
      ],
      "styles": {
        "stripSlideShowSlide1": "wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin"
      },
      "nickname": "slide",
      "propertyTypes": [
        "",
        "StripContainerSlideShowSlideProperties"
      ]
    },
    "wysiwyg.viewer.components.inputs.Checkbox": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.input.CheckboxBasicSkin"
      ],
      "dataTypes": [
        "CheckboxInput"
      ],
      "nickname": "checkbox",
      "styles": {},
      "propertyTypes": [
        "CheckboxProperties"
      ]
    },
    "wysiwyg.viewer.components.inputs.RadioButton": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.common.components.radio.viewer.skins.RadioButtonDefaultSkin"
      ],
      "dataTypes": [
        "RadioButton"
      ],
      "styles": {},
      "nickname": "radioButton",
      "propertyTypes": [
        "RadioButtonProperties"
      ]
    },
    "wysiwyg.viewer.components.inputs.RadioGroup": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "skins.input.RadioGroupDefaultSkin"
      ],
      "dataTypes": [
        "RadioGroup"
      ],
      "styles": {
        "rg1": "skins.input.RadioGroupDefaultSkin"
      },
      "nickname": "radioGroup",
      "propertyTypes": [
        "RadioGroupProperties"
      ]
    },
    "wysiwyg.viewer.components.inputs.CheckboxGroup": {
      "type": "Component",
      "skins": [
        "skins.input.CheckboxGroupDefaultSkin"
      ],
      "dataTypes": [
        "CheckboxGroup"
      ],
      "styles": {
        "cg1": "skins.input.CheckboxGroupDefaultSkin"
      },
      "nickname": "checkboxGroup",
      "propertyTypes": [
        "CheckboxGroupProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.inputs.FileUploader": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.FileUploaderDefaultSkin"
      ],
      "dataTypes": [
        "FileUploader"
      ],
      "styles": {
        "fu1": "wysiwyg.viewer.skins.FileUploaderDefaultSkin"
      },
      "nickname": "uploadButton",
      "propertyTypes": [
        "FileUploaderProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.inputs.uploadName": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.UploadNameDefaultSkin"
      ],
      "dataTypes": [
        "UploadName"
      ],
      "styles": {
        "un1": "wysiwyg.viewer.skins.UploadNameDefaultSkin"
      },
      "nickname": "uploadName",
      "propertyTypes": [
        "UploadNameProperties"
      ]
    },
    "wysiwyg.viewer.components.inputs.DatePicker": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.input.DatePickerDefaultSkin",
        "wysiwyg.viewer.skins.input.DatePickerTextBetweenNavSkin",
        "wysiwyg.viewer.skins.input.DatePickerTextYearNavSkin"
      ],
      "dataTypes": [
        "DatePicker"
      ],
      "styles": {},
      "nickname": "datePicker",
      "propertyTypes": [
        "DatePickerProperties"
      ]
    },
    "wysiwyg.viewer.components.ImageButtonWithText": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.IconLeftImageButtonWithText"
      ],
      "dataTypes": [
        "ImageButtonWithText"
      ],
      "styles": {
        "imgBtnWTxt1": "wysiwyg.viewer.skins.IconLeftImageButtonWithText"
      },
      "nickname": "button"
    },
    "wysiwyg.viewer.components.Grid": {
      "type": "Component",
      "skins": [
        "wixui.skins.Skinless"
      ],
      "dataTypes": [
        "Grid"
      ],
      "styles": {
        "Grid1": "wixui.skins.Skinless"
      },
      "nickname": "table",
      "propertyTypes": [
        "GridProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.Repeater": {
      "type": "RepeaterContainer",
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "dataTypes": [
        "Repeater"
      ],
      "styles": {
        "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "nickname": "repeater",
      "propertyTypes": [
        "CardsLayoutProperties",
        "VerticalLayoutProperties"
      ]
    },
    "wysiwyg.viewer.components.MediaContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
      },
      "nickname": "container",
      "designDataTypes": [
        "MediaContainerDesignData"
      ]
    },
    "wysiwyg.viewer.components.InlinePopup": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "dip1": "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
      },
      "nickname": "inlinePopup"
    },
    "wysiwyg.viewer.components.MenuContainer": {
      "type": "Container",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "mcdip1": "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
      },
      "nickname": "menuContainer",
      "designDataTypes": [
        "MediaContainerDesignData",
        ""
      ]
    },
    "wysiwyg.viewer.components.InlinePopupToggle": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
      ],
      "styles": {
        "inlinePopupToggleSkin12": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
        "inlinePopupToggleSkin10": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
        "inlinePopupToggleSkin11": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
        "inlinePopupToggleSkin5": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
        "inlinePopupToggleSkin9": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
        "inlinePopupToggleSkin1": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
        "inlinePopupToggleSkin4": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
        "inlinePopupToggleSkin8": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
        "inlinePopupToggleSkin6": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
        "inlinePopupToggleSkin2": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
        "inlinePopupToggleSkin3": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
        "inlinePopupToggleSkin7": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
        "inlinePopupToggleSkin14": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
        "inlinePopupToggleSkin16": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
        "inlinePopupToggleSkin15": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
        "inlinePopupToggleSkin13": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
      },
      "nickname": "inlinePopupToggle"
    },
    "wysiwyg.viewer.components.MenuToggle": {
      "type": "Component",
      "externalizable": true,
      "skins": [
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
        "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
      ],
      "styles": {
        "inlinePopupToggleSkin12": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
        "inlinePopupToggleSkin10": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
        "inlinePopupToggleSkin11": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
        "inlinePopupToggleSkin5": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
        "inlinePopupToggleSkin9": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
        "inlinePopupToggleSkin1": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
        "inlinePopupToggleSkin4": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
        "inlinePopupToggleSkin8": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
        "inlinePopupToggleSkin6": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
        "inlinePopupToggleSkin2": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
        "inlinePopupToggleSkin3": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
        "inlinePopupToggleSkin7": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
        "inlinePopupToggleSkin14": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
        "inlinePopupToggleSkin16": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
        "inlinePopupToggleSkin15": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
        "inlinePopupToggleSkin13": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
      },
      "nickname": "menuToggle"
    },
    "platform.components.AppController": {
      "type": "Component",
      "skins": [
        "platform.components.skins.controllerSkin",
        "platform.components.skins.controllerIconAndNameSkin"
      ],
      "dataTypes": [
        "AppController"
      ],
      "styles": {
        "controller1": "platform.components.skins.controllerSkin"
      },
      "nickname": "controller"
    },
    "platform.components.AppWidget": {
      "type": "Container",
      "skins": [],
      "dataTypes": [
        "AppController"
      ],
      "styles": {
        "appWidget1": "platform.components.skins.AppWidgetSkin",
        "appWidget2": "platform.components.skins.AppWidgetLoaderSkin"
      },
      "nickname": "appWidget"
    },
    "wysiwyg.viewer.components.LanguageSelector": {
      "type": "Component",
      "skins": [
        "wysiwyg.viewer.skins.LanguageSelectorSkin"
      ],
      "dataTypes": [
        "LanguageSelector",
        ""
      ],
      "styles": {},
      "nickname": "languageSelector",
      "propertyTypes": [
        "LanguageSelectorProperties"
      ],
      "externalizable": true
    },
    "wysiwyg.viewer.components.Popover": {
      "type": "Container",
      "skins": [],
      "dataTypes": [
        ""
      ],
      "styles": {
        "pop1": "wysiwyg.viewer.skins.popover.PopoverSkin"
      },
      "nickname": "popover",
      "propertyTypes": [
        "PopoverProperties"
      ]
    },
    "wysiwyg.viewer.components.RefComponent": {
      "type": "RefComponent",
      "dataTypes": [
        "WidgetRef",
        "InternalRef",
        "InternalBlocksRef"
      ],
      "propertyTypes": [
        "",
        "RefComponentProperties"
      ],
      "styles": {
        "ref1": "skins.core.InlineSkin"
      },
      "nickname": "refComponent"
    },
    "responsive.components.Section": {
      "type": "Container",
      "responsiveSkins": [],
      "dataTypes": [
        "Section",
        ""
      ],
      "skins": [
        "skins.core.InlineSkin",
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "designDataTypes": [
        "",
        "MediaContainerDesignData",
        "MediaContainerWithDividers"
      ],
      "styles": {
        "sec1": "skins.core.InlineSkin"
      },
      "nickname": "section",
      "externalizable": true
    },
    "responsive.components.HeaderSection": {
      "type": "Container",
      "externalizable": true,
      "responsiveSkins": [],
      "skins": [
        "skins.core.InlineSkin",
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "designDataTypes": [
        "",
        "MediaContainerDesignData",
        "MediaContainerWithDividers"
      ],
      "styles": {
        "sec1": "skins.core.InlineSkin"
      },
      "nickname": "section"
    },
    "responsive.components.FooterSection": {
      "type": "Container",
      "externalizable": true,
      "responsiveSkins": [],
      "skins": [
        "skins.core.InlineSkin",
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "designDataTypes": [
        "",
        "MediaContainerDesignData",
        "MediaContainerWithDividers"
      ],
      "styles": {
        "sec1": "skins.core.InlineSkin"
      },
      "nickname": "section"
    },
    "responsive.components.MembersAreaSection": {
      "type": "Container",
      "responsiveSkins": [],
      "skins": [
        "skins.core.InlineSkin"
      ],
      "dataTypes": [
        ""
      ],
      "styles": {
        "sec1": "skins.core.InlineSkin"
      },
      "nickname": "section"
    },
    "wixui.MultiStateBox": {
      "type": "Container",
      "dataTypes": [
        "MultiStateBoxData"
      ],
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "styles": {
        "MultiStateBox_1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "nickname": "multiStateBox",
      "externalizable": true
    },
    "mobui.MobuiButton": {
      "dataTypes": [
        "mobui.MobuiButton"
      ],
      "styles": {},
      "nickname": "Button",
      "labelDisplayName": "mobui_compDisplayName_MobuiButton",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiDatePicker": {
      "dataTypes": [
        "mobui.MobuiDatePicker"
      ],
      "styles": {},
      "nickname": "DatePicker",
      "labelDisplayName": "mobui_compDisplayName_MobuiDatePicker",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiImage": {
      "dataTypes": [
        "mobui.MobuiImage"
      ],
      "styles": {},
      "nickname": "Image",
      "labelDisplayName": "mobui_compDisplayName_MobuiImage",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiPicker": {
      "dataTypes": [
        "mobui.MobuiPicker"
      ],
      "propertyType": "mobui.MobuiPickerProperties",
      "styles": {},
      "nickname": "Picker",
      "labelDisplayName": "mobui_compDisplayName_MobuiPicker",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiSwitch": {
      "dataTypes": [
        "mobui.MobuiSwitch"
      ],
      "styles": {},
      "nickname": "Switch",
      "labelDisplayName": "mobui_compDisplayName_MobuiSwitch",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiText": {
      "dataTypes": [
        "mobui.MobuiText"
      ],
      "styles": {},
      "nickname": "Text",
      "labelDisplayName": "mobui_compDisplayName_MobuiText",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiTextInput": {
      "dataTypes": [
        "mobui.MobuiTextInput"
      ],
      "propertyType": "mobui.MobuiTextInputProperties",
      "styles": {},
      "nickname": "Input",
      "labelDisplayName": "mobui_compDisplayName_MobuiTextInput",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiVideoPlayer": {
      "dataTypes": [
        "mobui.MobuiVideoPlayer"
      ],
      "styles": {},
      "nickname": "VideoPlayer",
      "labelDisplayName": "mobui_compDisplayName_MobuiVideoPlayer",
      "type": "Component",
      "externalizable": true
    },
    "mobui.MobuiContainer": {
      "dataTypes": [
        ""
      ],
      "styles": {},
      "nickname": "Container",
      "labelDisplayName": "mobui_compDisplayName_MobuiContainer",
      "type": "Container",
      "externalizable": true
    },
    "mobui.MobuiMultiStateBox": {
      "dataTypes": [
        "mobui.MobuiMultiStateBoxData"
      ],
      "styles": {},
      "nickname": "MobuiMultiStateBox",
      "labelDisplayName": "mobui_compDisplayName_MobuiMultiStateBox",
      "type": "Container",
      "externalizable": true
    },
    "wixui.Logo": {
      "dataTypes": [
        "wixui.Logo"
      ],
      "styles": {},
      "nickname": "Logo",
      "labelDisplayName": "wixui_compDisplayName_Logo",
      "type": "Component",
      "externalizable": true
    },
    "wixui.ShareButtons": {
      "dataTypes": [
        "wixui.ShareButtons"
      ],
      "styles": {
        "ShareButtons1": "wixui.skins.Skinless"
      },
      "nickname": "ShareButtons",
      "labelDisplayName": "wixui_compDisplayName_ShareButtons",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.AccordionContainer": {
      "type": "Container",
      "dataTypes": [
        "AccordionContainerData"
      ],
      "propertyType": "AccordionContainerProperties",
      "slotsDataType": "DynamicSlots",
      "styles": {
        "accordionContainer1": "wixui.skins.Skinless"
      },
      "nickname": "accordion",
      "isStylableComp": true,
      "verticalCenterDockDisabled": true,
      "verticalDockDisabled": true,
      "externalizable": true
    },
    "wixui.AccordionItem": {
      "type": "Container",
      "dataTypes": [
        "AccordionItemData"
      ],
      "propertyTypes": [
        "DefaultProperties",
        "AccordionItemProperties"
      ],
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "styles": {
        "AccordionItem1": "wixui.skins.Skinless"
      },
      "nickname": "accordionItem",
      "isStylableComp": true,
      "externalizable": true
    },
    "wixui.AddressInput": {
      "skins": [
        "wixui.skins.AddressInput"
      ],
      "dataTypes": [
        "AddressInput"
      ],
      "propertyType": "AddressInputProperties",
      "nickname": "addressInput",
      "styles": {
        "ai1": "wixui.skins.AddressInput"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.BoltComponent": {
      "dataTypes": [
        "BoltComponentData"
      ],
      "styles": {
        "boltComponent1": "wixui.skins.Skinless"
      },
      "nickname": "boltComponent",
      "labelDisplayName": "component_label_bolt_component",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.Breadcrumbs": {
      "dataTypes": [
        "BreadcrumbsData"
      ],
      "propertyType": "BreadcrumbsProperties",
      "styles": {
        "breadcrumbs1": "wixui.skins.Skinless"
      },
      "nickname": "breadcrumbs",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.Captcha": {
      "skins": [
        "wixui.skins.Captcha"
      ],
      "dataTypes": [
        "Captcha"
      ],
      "propertyType": "CaptchaProperties",
      "nickname": "captcha",
      "styles": {
        "captcha1": "wixui.skins.Captcha"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.CollapsibleText": {
      "dataTypes": [
        "CollapsibleTextData"
      ],
      "propertyType": "CollapsibleTextProperties",
      "styles": {
        "CollapsibleText1": "wixui.skins.Skinless",
        "CollapsibleTextSkin1": "wixui.skins.CollapsibleText"
      },
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.CollapsibleText"
      ],
      "nickname": "CollapsibleText",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.CustomElementComponent": {
      "dataTypes": [
        "CustomElement"
      ],
      "styles": {},
      "nickname": "CustomElement",
      "labelDisplayName": "component_label_custom_element",
      "skins": [
        "wixui.skins.CustomElement",
        "wixui.skins.Default"
      ],
      "type": "Component",
      "externalizable": true
    },
    "wixui.DynamicRepeater": {
      "type": "RepeaterContainer",
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "dataTypes": [
        "Repeater"
      ],
      "styles": {
        "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "nickname": "repeater",
      "propertyTypes": [
        "CardsLayoutProperties",
        "VerticalLayoutProperties"
      ],
      "externalizable": true
    },
    "wixui.ExternalComponent": {
      "dataTypes": [
        "wixui.ExternalComponent"
      ],
      "styles": {},
      "nickname": "ReactComponent",
      "labelDisplayName": "wixui_compDisplayName_ExternalComponent",
      "type": "Component",
      "externalizable": true
    },
    "wixui.FastGallery": {
      "type": "Container",
      "dataTypes": [
        "wixui.FastGallery"
      ],
      "styles": {
        "FastGallery1": "wixui.skins.FastGallery"
      },
      "nickname": "FastGallery",
      "labelDisplayName": "wixui_compDisplayName_FastGallery",
      "externalizable": true
    },
    "wixui.HamburgerCloseButton": {
      "propertyTypes": [
        "HamburgerCloseButtonProperties"
      ],
      "dataTypes": [
        "StylableButton"
      ],
      "styles": {
        "HamburgerCloseButton1": "wixui.skins.Skinless",
        "HamburgerCloseButtonSkin1": "wixui.skins.HamburgerCloseButton"
      },
      "nickname": "hamburgerCloseButton",
      "labelDisplayName": "wixui_compDisplayName_HamburgerCloseButton",
      "isStylableComp": true,
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.HamburgerCloseButton"
      ],
      "type": "Component",
      "externalizable": true
    },
    "wixui.HamburgerMenuContainer": {
      "type": "Container",
      "dataTypes": [
        "wixui.HamburgerMenuContainer"
      ],
      "propertyTypes": [
        "HamburgerMenuContainerProperties",
        "DefaultProperties"
      ],
      "styles": {},
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.HamburgerMenuContainer"
      ],
      "nickname": "hamburgerMenuContainer",
      "labelDisplayName": "wixui_compDisplayName_HamburgerMenuContainer",
      "isStylableComp": true,
      "externalizable": true
    },
    "wixui.HamburgerMenuContent": {
      "type": "Container",
      "nickname": "hamburgerMenuContent",
      "skins": [
        "wixui.skins.HamburgerMenuContent"
      ],
      "styles": {},
      "externalizable": true
    },
    "wixui.HamburgerMenuRoot": {
      "dataTypes": [
        "wixui.HamburgerMenuRoot"
      ],
      "type": "Container",
      "styles": {},
      "nickname": "hamburgerOpenButton",
      "labelDisplayName": "wixui_compDisplayName_HamburgerMenuRoot",
      "externalizable": true
    },
    "wixui.HamburgerOpenButton": {
      "propertyTypes": [
        "HamburgerOpenButtonProperties"
      ],
      "dataTypes": [
        "StylableButton"
      ],
      "styles": {
        "HamburgerOpenButton1": "wixui.skins.Skinless",
        "HamburgerOpenButtonSkin1": "wixui.skins.HamburgerOpenButton"
      },
      "nickname": "hamburgerOpenButtonHidden",
      "labelDisplayName": "wixui_compDisplayName_HamburgerOpenButton",
      "isStylableComp": true,
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.HamburgerOpenButton"
      ],
      "type": "Component",
      "externalizable": true
    },
    "wixui.HamburgerOverlay": {
      "type": "Container",
      "dataTypes": [
        "wixui.HamburgerOverlay"
      ],
      "styles": {},
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.HamburgerOverlay"
      ],
      "nickname": "hamburgerOverlay",
      "labelDisplayName": "wixui_compDisplayName_HamburgerOverlay",
      "isStylableComp": true,
      "externalizable": true
    },
    "wixui.ImageX": {
      "skins": [
        "wixui.skins.ImageX"
      ],
      "dataTypes": [
        "ImageX"
      ],
      "nickname": "imageX",
      "labelDisplayName": "component_label_WPhoto",
      "styles": {
        "ImageX_1": "wixui.skins.ImageX"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.LineShareButton": {
      "skins": [
        "wixui.skins.LineShareButton"
      ],
      "propertyType": "LineShareButtonProperties",
      "nickname": "lineShareButton",
      "labelDisplayName": "component_label_line_share",
      "styles": {
        "lsb1": "wixui.skins.LineShareButton"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.LottieEmbed": {
      "dataTypes": [
        "wixui.LottieEmbed"
      ],
      "styles": {},
      "nickname": "LottieEmbed",
      "labelDisplayName": "LottieFiles_component_label",
      "type": "Component",
      "externalizable": true
    },
    "wixui.MegaMenuContainerItem": {
      "type": "Container",
      "dataTypes": [
        "wixui.MegaMenuContainerItem"
      ],
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin",
        "wixui.skins.Dropdown"
      ],
      "styles": {},
      "nickname": "dropdownContainer",
      "labelDisplayName": "megaMenuContainerItem_definition_label_display_name",
      "externalizable": true
    },
    "wixui.Menu": {
      "type": "Container",
      "labelDisplayName": "menu_definition_label_display_name",
      "dataTypes": [
        "MenuData"
      ],
      "slotsDataType": "DynamicSlots",
      "nickname": "menu",
      "skins": [
        "wixui.skins.Menu"
      ],
      "styles": {},
      "externalizable": true
    },
    "wixui.MenuList": {
      "type": "Container",
      "dataTypes": [
        "wixui.MenuList"
      ],
      "styles": {
        "MenuList1": "wixui.skins.MenuList"
      },
      "nickname": "MenuList",
      "labelDisplayName": "wixui_compDisplayName_MenuList",
      "externalizable": true
    },
    "wixui.MusicPlayer": {
      "skins": [
        "wixui.skins.MusicPlayer"
      ],
      "dataTypes": [
        "MusicPlayerData"
      ],
      "propertyType": "MusicPlayerProperties",
      "nickname": "audioPlayer",
      "styles": {
        "MusicPlayer_1": "wixui.skins.MusicPlayer"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.OldBlogDeprecation": {
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "nickname": "oldBlogDeprecation",
      "labelDisplayName": "component_label_old_blog_deprecation",
      "styles": {
        "OldBlogDeprecation_1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.OldHoverBoxDeprecation": {
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "nickname": "oldHoverBoxDeprecation",
      "labelDisplayName": "component_label_old_hoverbox_deprecation",
      "styles": {
        "OldHoverBoxDeprecation_1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.Pagination": {
      "skins": [
        "wixui.skins.Pagination",
        "wixui.skins.ResponsivePagination"
      ],
      "dataTypes": [
        "Pagination"
      ],
      "propertyType": "PaginationProperties",
      "nickname": "pagination",
      "styles": {
        "pag1": "wixui.skins.Pagination"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.ProductSpecification": {
      "dataTypes": [
        "wixui.ProductSpecification"
      ],
      "styles": {
        "ProductSpecification1": "wixui.skins.ProductSpecification"
      },
      "skins": [
        "wixui.skins.ProductSpecification"
      ],
      "nickname": "ProductSpecification",
      "labelDisplayName": "wixui_compDisplayName_ProductSpecification",
      "type": "Component",
      "externalizable": true
    },
    "wixui.ProGallery": {
      "dataTypes": [
        "ImageList"
      ],
      "styles": {
        "ProGallery1": "wixui.skins.Skinless"
      },
      "nickname": "ProGallery",
      "propertyType": "ProGalleryProperties",
      "isStylableComp": true,
      "translatedLabelDisplayName": "Pro Gallery",
      "type": "Component",
      "externalizable": true
    },
    "wixui.ProgressBar": {
      "skins": [
        "wixui.skins.ProgressBar"
      ],
      "dataTypes": [
        "ProgressBar"
      ],
      "propertyType": "ProgressBarProperties",
      "nickname": "progressBar",
      "labelDisplayName": "component_label_progressBar",
      "styles": {
        "pb1": "wixui.skins.ProgressBar"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.RangeSlider": {
      "dataTypes": [
        "wixui.RangeSlider"
      ],
      "propertyType": "RangeSliderProperties",
      "styles": {},
      "nickname": "RangeSlider",
      "translatedLabelDisplayName": "RangeSlider",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.RatingsDisplay": {
      "skins": [
        "wixui.skins.Rating"
      ],
      "dataTypes": [
        "RatingsDisplay"
      ],
      "propertyType": "RatingsDisplayProperties",
      "nickname": "ratingsDisplay",
      "styles": {
        "rd1": "wixui.skins.Rating"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.RatingsInput": {
      "skins": [
        "wixui.skins.Rating"
      ],
      "dataTypes": [
        "RatingsInput"
      ],
      "propertyType": "RatingsInputProperties",
      "nickname": "ratingsInput",
      "styles": {
        "ri1": "wixui.skins.Rating"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.RichContentViewer": {
      "dataTypes": [
        "wixui.RichContentViewer"
      ],
      "styles": {
        "RichContentViewer_1": "wixui.skins.RichContentViewer"
      },
      "skins": [
        "wixui.skins.RichContentViewer"
      ],
      "nickname": "RichContentViewer",
      "labelDisplayName": "wixui_compDisplayName_RichContentViewer",
      "type": "Component",
      "externalizable": true
    },
    "wixui.RichTextBox": {
      "skins": [
        "wixui.skins.RichTextBox"
      ],
      "dataTypes": [
        "RichTextBox"
      ],
      "propertyType": "RichTextBoxProperties",
      "nickname": "richTextBox",
      "styles": {
        "richtextbox1": "wixui.skins.RichTextBox"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.Rive": {
      "styles": {
        "Rive1": "wixui.skins.Rive"
      },
      "type": "Component",
      "nickname": "Rive",
      "dataTypes": [
        "wixui.Rive"
      ],
      "externalizable": true
    },
    "wixui.SearchBox": {
      "skins": [
        "wixui.skins.SearchBox"
      ],
      "dataTypes": [
        "SearchBox"
      ],
      "propertyType": "SearchBoxProperties",
      "nickname": "searchBox",
      "styles": {
        "SearchBox_1": "wixui.skins.SearchBox"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.SearchButton": {
      "propertyTypes": [
        "SearchButtonProperties"
      ],
      "dataTypes": [
        "StylableButton"
      ],
      "styles": {
        "SearchButton1": "wixui.skins.SearchButton"
      },
      "skins": [
        "wixui.skins.SearchButton"
      ],
      "nickname": "searchButton",
      "labelDisplayName": "component_label_stylable_button",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.SelectableContainer": {
      "type": "Container",
      "nickname": "SelectableContainer",
      "dataTypes": [
        "wixui.SelectableContainer"
      ],
      "styles": {
        "SelectableContainer1": "wixui.skins.Skinless",
        "SelectableContainer2": "wixui.skins.SelectableContainer"
      },
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.SelectableContainer"
      ],
      "labelDisplayName": "component_label_SelectableContainer",
      "isStylableComp": true,
      "externalizable": true
    },
    "wixui.SelectableContainerInput": {
      "dataTypes": [
        "wixui.SelectableContainerInput"
      ],
      "styles": {
        "SelectableContainerInput1": "wixui.skins.Skinless",
        "SelectableContainerInputSkin1": "wixui.skins.SelectableContainerInput"
      },
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.SelectableContainerInput"
      ],
      "nickname": "SelectableContainerInput",
      "labelDisplayName": "wixui_compDisplayName_SelectableContainerInput",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.SelectionTagsList": {
      "skins": [
        "wixui.skins.SelectionTagsList"
      ],
      "dataTypes": [
        "SelectionTagsList"
      ],
      "propertyType": "SelectionTagsListProperties",
      "nickname": "selectionTags",
      "labelDisplayName": "component_label_selection_tags",
      "styles": {
        "SelectionTagsList_1": "wixui.skins.SelectionTagsList"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.SignatureInput": {
      "skins": [
        "wixui.skins.SignatureInput",
        "wixui.skins.TypeOrDrawSignatureInput"
      ],
      "dataTypes": [
        "SignatureInput"
      ],
      "propertyType": "SignatureInputProperties",
      "nickname": "signatureInput",
      "styles": {
        "SignatureInput_1": "wixui.skins.SignatureInput"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.SingleTab": {
      "type": "Container",
      "dataTypes": [
        "wixui.SingleTab"
      ],
      "propertyTypes": [
        "DefaultProperties",
        "SingleTabProperties"
      ],
      "nickname": "singleTab",
      "styles": {},
      "externalizable": true
    },
    "wixui.Slider": {
      "skins": [
        "wixui.skins.Slider"
      ],
      "dataTypes": [
        "Slider"
      ],
      "propertyType": "SliderProperties",
      "nickname": "slider",
      "styles": {
        "slider1": "wixui.skins.Slider"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.Slideshow": {
      "type": "Container",
      "propertyType": "SlideshowProperties",
      "dataTypes": [
        "",
        "wixui.Slideshow"
      ],
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "styles": {},
      "nickname": "slideshow",
      "isStylableComp": false,
      "externalizable": true
    },
    "wixui.SlideshowButton": {
      "propertyTypes": [
        "SlideshowButtonProperties"
      ],
      "dataTypes": [
        "StylableButton"
      ],
      "styles": {
        "SlideshowButton1": "wixui.skins.Skinless"
      },
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.SlideshowButton"
      ],
      "nickname": "slideshowButton",
      "labelDisplayName": "component_label_stylable_button",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.SlideshowItem": {
      "type": "Container",
      "externalizable": true,
      "aliases": [
        "core.components.ContainerOBC",
        "core.components.Container"
      ],
      "responsiveSkins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "skins": [
        "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      ],
      "dataTypes": [
        "ContainerData"
      ],
      "styles": {
        "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "nickname": "slideshowItem"
    },
    "wixui.SocialAuth": {
      "skins": [
        "wixui.skins.Skinless"
      ],
      "dataTypes": [
        "SocialAuth"
      ],
      "propertyType": "SocialAuthProperties",
      "nickname": "socialAuth",
      "styles": {
        "SocialAuth_1": "wixui.skins.Skinless"
      },
      "isStylableComp": true,
      "labelDisplayName": "component_label_social_auth",
      "type": "Component",
      "externalizable": true
    },
    "wixui.StretchedContainer": {
      "styles": {},
      "type": "Container",
      "nickname": "StretchedContainer",
      "dataTypes": [
        ""
      ],
      "labelDisplayName": "wixui_compDisplayName_StretchedContainer",
      "externalizable": true
    },
    "wixui.StylableButton": {
      "propertyTypes": [
        "StylableButtonProperties",
        ""
      ],
      "dataTypes": [
        "StylableButton"
      ],
      "styles": {
        "stButton1": "wixui.skins.Skinless",
        "stButton2": "wixui.skins.Skinless",
        "stButton3": "wixui.skins.Skinless",
        "stButton4": "wixui.skins.Skinless",
        "stButton5": "wixui.skins.StylableButton",
        "stButton6": "wixui.skins.StylableButton",
        "stButton7": "wixui.skins.StylableButton",
        "stButton8": "wixui.skins.StylableButton"
      },
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.StylableButton",
        "wixui.skins.Button"
      ],
      "nickname": "button",
      "labelDisplayName": "component_label_stylable_button",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.StylableHorizontalMenu": {
      "type": "Container",
      "labelDisplayName": "component_label_stylable_horizontal_menu",
      "dataTypes": [
        "CustomMenuDataRef"
      ],
      "slotsDataType": "DynamicSlots",
      "propertyType": "StylableHorizontalMenuProperties",
      "nickname": "horizontalMenu",
      "isStylableComp": true,
      "styles": {
        "stMenu1": "wixui.skins.Skinless",
        "stMenu2": "wixui.skins.Skinless",
        "stMenu3": "wixui.skins.Skinless"
      },
      "externalizable": true
    },
    "wixui.Submenu": {
      "type": "Component",
      "dataTypes": [
        "Submenu"
      ],
      "styles": {},
      "nickname": "dropdownmenu",
      "isStylableComp": false,
      "externalizable": true
    },
    "wixui.SvgImage": {
      "type": "Component",
      "dataTypes": [
        "SvgImage"
      ],
      "skins": [
        "wixui.skins.SvgImage"
      ],
      "responsiveSkins": [
        "wixui.skins.SvgImage"
      ],
      "styles": {},
      "nickname": "svgImage",
      "isStylableComp": false,
      "externalizable": true
    },
    "wixui.Tabs": {
      "type": "Container",
      "dataTypes": [
        "wixui.Tabs"
      ],
      "propertyType": "TabsProperties",
      "styles": {
        "Tabs1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
      },
      "nickname": "tabs",
      "isStylableComp": true,
      "labelDisplayName": "tabs_component_label",
      "externalizable": true
    },
    "wixui.TestComp": {
      "styles": {
        "TestComp1": "wixui.skins.Skinless"
      },
      "nickname": "TestComp",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "wixui.TextEffects3d": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffects3d"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsBauhaus": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsBauhaus"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsGlass": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsGlass"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsGlitch": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsGlitch"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsLetterPress": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsLetterPress"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsMatrix": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsMatrix"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsNeonSign": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsNeonSign"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsNoisy": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsNoisy"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsOutlineOut": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsOutlineOut"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsRetro": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsRetro"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsShared": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsShared"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsShook": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsShook"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsSticker": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsSticker"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextEffectsStriped": {
      "type": "Component",
      "dataTypes": [
        "TextEffectsSharedData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextEffectsStriped"
      ],
      "nickname": "textEffects",
      "externalizable": true
    },
    "wixui.TextMarquee": {
      "type": "Component",
      "dataTypes": [
        "TextMarqueeData"
      ],
      "skins": [
        "wixui.skins.TextMarquee"
      ],
      "responsiveSkins": [
        "wixui.skins.TextMarquee"
      ],
      "styles": {},
      "nickname": "textMarquee",
      "isStylableComp": false,
      "externalizable": true
    },
    "wixui.TextMask": {
      "dataTypes": [
        "TextFxData"
      ],
      "designDataTypes": [
        "TextFxMask"
      ],
      "styles": {
        "TextMask1": "wixui.skins.Skinless"
      },
      "nickname": "textMask",
      "isStylableComp": false,
      "type": "Component",
      "externalizable": true
    },
    "wixui.TextOnPath": {
      "type": "Component",
      "dataTypes": [
        "TextOnPathData"
      ],
      "skins": [
        "wixui.skins.TextOnPath"
      ],
      "responsiveSkins": [
        "wixui.skins.TextOnPath"
      ],
      "styles": {},
      "nickname": "textOnPath",
      "isStylableComp": false,
      "allowConnectToDB": true,
      "externalizable": true
    },
    "wixui.TextParticles": {
      "type": "Component",
      "dataTypes": [
        "TextParticlesData"
      ],
      "styles": {},
      "responsiveSkins": [
        "wixui.skins.TextParticles"
      ],
      "nickname": "textParticles",
      "labelDisplayName": "wixui_compDisplayName_TextParticles",
      "externalizable": true
    },
    "wixui.TimePicker": {
      "skins": [
        "wixui.skins.TimePicker"
      ],
      "dataTypes": [
        "TimePickerData"
      ],
      "propertyType": "TimePickerProperties",
      "nickname": "timePicker",
      "styles": {
        "tp1": "wixui.skins.TimePicker"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.ToggleSwitch": {
      "skins": [
        "wixui.skins.ToggleSwitch"
      ],
      "dataTypes": [
        "ToggleSwitch"
      ],
      "propertyType": "ToggleSwitchProperties",
      "nickname": "switch",
      "styles": {
        "ts1": "wixui.skins.ToggleSwitch"
      },
      "type": "Component",
      "externalizable": true
    },
    "wixui.UnsupportedComponent": {
      "dataTypes": [
        "UnsupportedComponentData"
      ],
      "styles": {
        "UnsupportedComponent1": "wixui.skins.Skinless"
      },
      "nickname": "UnsupportedComponent",
      "isStylableComp": false,
      "type": "Component",
      "externalizable": true
    },
    "wixui.VideoPlayer": {
      "skins": [
        "wixui.skins.VideoPlayer"
      ],
      "dataTypes": [
        "VideoPlayer"
      ],
      "propertyType": "VideoPlayerProperties",
      "nickname": "videoPlayer",
      "styles": {
        "vp1": "wixui.skins.VideoPlayer"
      },
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.ControlTypes": {
      "dataTypes": [
        "dsgnsys.ControlTypes"
      ],
      "styles": {},
      "nickname": "ControlTypes",
      "labelDisplayName": "dsgnsys_compDisplayName_ControlTypes",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WutRadioButton": {
      "dataTypes": [
        "dsgnsys.WutRadioButton"
      ],
      "styles": {},
      "nickname": "WutRadioButton",
      "labelDisplayName": "dsgnsys_compDisplayName_WutRadioButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardButton": {
      "dataTypes": [
        "dsgnsys.DashboardButton"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardButton1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardButton",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardHeading": {
      "dataTypes": [
        "dsgnsys.DashboardHeading"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardHeading1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardHeading",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardHeading",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardIconButton": {
      "dataTypes": [
        "dsgnsys.DashboardIconButton"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardIconButton1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardIconButton",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardIconButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardInfoIcon": {
      "dataTypes": [
        "dsgnsys.DashboardInfoIcon"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardInfoIcon1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardInfoIcon",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardInfoIcon",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardInput": {
      "dataTypes": [
        "dsgnsys.DashboardInput"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardInput1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardInput",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardInput",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardNumberInput": {
      "dataTypes": [
        "dsgnsys.DashboardNumberInput"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardNumberInput1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardNumberInput",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardNumberInput",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardText": {
      "dataTypes": [
        "dsgnsys.DashboardText"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardText1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardText",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardText",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardTextButton": {
      "dataTypes": [
        "dsgnsys.DashboardTextButton"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardTextButton1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardTextButton",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardTextButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.DashboardToggleSwitch": {
      "dataTypes": [
        "dsgnsys.DashboardToggleSwitch"
      ],
      "skins": [
        "wixui.skins.Skinless"
      ],
      "styles": {
        "DashboardToggleSwitch1": "wixui.skins.Skinless"
      },
      "nickname": "DashboardToggleSwitch",
      "labelDisplayName": "dsgnsys_compDisplayName_DashboardToggleSwitch",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.SettingsPanelContainer": {
      "dataTypes": [
        "dsgnsys.SettingsPanelContainer"
      ],
      "styles": {},
      "nickname": "SettingsPanelContainer",
      "translatedLabelDisplayName": "SettingsPanelContainer",
      "type": "Container",
      "externalizable": true
    },
    "dsgnsys.WbuAccordion": {
      "dataTypes": [
        "dsgnsys.WbuAccordion"
      ],
      "styles": {},
      "nickname": "PanelAccordion",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuAccordion",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuBackButton": {
      "dataTypes": [
        "dsgnsys.WbuBackButton"
      ],
      "styles": {},
      "nickname": "PanelBackButton",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuBackButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuButton": {
      "dataTypes": [
        "dsgnsys.WbuButton"
      ],
      "styles": {},
      "nickname": "PanelButton",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuCheckboxGroup": {
      "dataTypes": [
        "dsgnsys.WbuCheckboxGroup"
      ],
      "styles": {},
      "nickname": "PanelCheckboxGroup",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuCheckboxGroup",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuColorPicker": {
      "dataTypes": [
        "dsgnsys.WbuColorPicker"
      ],
      "styles": {},
      "nickname": "PanelColorPicker",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuColorPicker",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuColorSelector": {
      "dataTypes": [
        "dsgnsys.WbuColorSelector"
      ],
      "styles": {},
      "nickname": "PanelColorPicker",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuColorSelector",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuColumnControllerControl": {
      "dataTypes": [
        "dsgnsys.WbuColumnControllerControl"
      ],
      "styles": {},
      "nickname": "panelColumnControl",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuColumnControllerControl",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuDatePicker": {
      "dataTypes": [
        "dsgnsys.WbuDatePicker"
      ],
      "styles": {},
      "nickname": "PanelDatePicker",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuDatePicker",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuDrillDown": {
      "dataTypes": [
        "dsgnsys.WbuDrillDown"
      ],
      "styles": {},
      "nickname": "PanelDrillDown",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuDrillDown",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuDropdown": {
      "dataTypes": [
        "dsgnsys.WbuDropdown"
      ],
      "styles": {},
      "nickname": "PanelDropdown",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuDropdown",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuEmptyState": {
      "dataTypes": [
        "dsgnsys.WbuEmptyState"
      ],
      "styles": {},
      "nickname": "PanelEmptyState",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuEmptyState",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "dataTypes": [
        "dsgnsys.WbuFontAndColorPicker"
      ],
      "styles": {},
      "nickname": "PanelFontAndColorPicker",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuFontAndColorPicker",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuHorizontalTabs": {
      "dataTypes": [
        "dsgnsys.WbuHorizontalTabs"
      ],
      "styles": {},
      "nickname": "PanelHorizontalTabs",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuHorizontalTabs",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuLeftTextButton": {
      "dataTypes": [
        "dsgnsys.WbuLeftTextButton"
      ],
      "styles": {},
      "nickname": "PanelLeftTextButton",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuLeftTextButton",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuMultilineTextInput": {
      "dataTypes": [
        "dsgnsys.WbuMultilineTextInput"
      ],
      "styles": {},
      "nickname": "PanelMultilineTextInput",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuMultilineTextInput",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuNotificationBanner": {
      "dataTypes": [
        "dsgnsys.WbuNotificationBanner"
      ],
      "styles": {},
      "nickname": "PanelNotificationBanner",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuNotificationBanner",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuNumericInput": {
      "dataTypes": [
        "dsgnsys.WbuNumericInput"
      ],
      "styles": {},
      "nickname": "PanelNumericInput",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuNumericInput",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "dataTypes": [
        "dsgnsys.WbuRadioButtonGroup"
      ],
      "styles": {},
      "nickname": "PanelRadioButtonGroup",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuRadioButtonGroup",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuRichText": {
      "dataTypes": [
        "dsgnsys.WbuRichText"
      ],
      "styles": {},
      "nickname": "PanelRichText",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuRichText",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuSectionDivider": {
      "dataTypes": [
        "dsgnsys.WbuSectionDivider"
      ],
      "styles": {},
      "nickname": "PanelSectionDivider",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuSectionDivider",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuSlider": {
      "dataTypes": [
        "dsgnsys.WbuSlider"
      ],
      "styles": {},
      "nickname": "PanelSlider",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuSlider",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuTextInput": {
      "dataTypes": [
        "dsgnsys.WbuTextInput"
      ],
      "styles": {},
      "nickname": "PanelTextInput",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuTextInput",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuThumbnails": {
      "dataTypes": [
        "dsgnsys.WbuThumbnails"
      ],
      "styles": {},
      "nickname": "PanelThumbnails",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuThumbnails",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WbuToggleSwitch": {
      "dataTypes": [
        "dsgnsys.WbuToggleSwitch"
      ],
      "styles": {},
      "nickname": "PanelToggleSwitch",
      "labelDisplayName": "dsgnsys_compDisplayName_WbuToggleSwitch",
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WutAvatar": {
      "dataTypes": [
        "dsgnsys.WutAvatar"
      ],
      "styles": {},
      "nickname": "Avatar",
      "labelDisplayName": "dsgnsys_compDisplayName_WutAvatar",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WutAvatarGroup": {
      "dataTypes": [
        "dsgnsys.WutAvatarGroup"
      ],
      "styles": {},
      "nickname": "avatarGroup",
      "labelDisplayName": "dsgnsys_WutAvatarGroup_component_label",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    },
    "dsgnsys.WutBadge": {
      "dataTypes": [
        "dsgnsys.WutBadge"
      ],
      "styles": {
        "WutBadge1": "wixui.skins.Skinless",
        "WutBadgeSkin1": "wixui.skins.WutBadge"
      },
      "nickname": "Badge",
      "skins": [
        "wixui.skins.Skinless",
        "wixui.skins.WutBadge"
      ],
      "labelDisplayName": "dsgnsys_compDisplayName_WutBadge",
      "isStylableComp": true,
      "type": "Component",
      "externalizable": true
    }
  },
  "connections.json": {
    "ConnectionList": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "anyOf": [
              {
                "$ref": "ConnectionItem"
              },
              {
                "$ref": "WixCodeConnectionItem"
              }
            ]
          }
        }
      }
    },
    "ConnectionItem": {
      "type": "object",
      "properties": {
        "controllerId": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": true,
          "referencedMap": "document_data",
          "refTypes": [
            "AppController",
            "TPAWidget",
            "TPA",
            "TPAMultiSection"
          ]
        },
        "isPrimary": {
          "type": "boolean"
        },
        "config": {
          "type": "string",
          "maxLength": 2000,
          "pseudoType": [
            "stringifyObject"
          ]
        },
        "subRole": {
          "type": "string",
          "maxLength": 100
        },
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "ConnectionItem"
          ]
        }
      },
      "required": [
        "controllerId"
      ],
      "isTopLevelDataNode": false
    },
    "WixCodeConnectionItem": {
      "type": "object",
      "properties": {
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "WixCodeConnectionItem"
          ]
        }
      },
      "isTopLevelDataNode": false
    }
  },
  "contentRole.json": {
    "ContainerRole": {
      "isTopLevelDataNode": true,
      "type": "object",
      "required": [
        "contentRole",
        "complexity"
      ],
      "properties": {
        "contentRole": {
          "type": "string",
          "maxLength": 50
        },
        "fieldRole": {
          "type": "string",
          "maxLength": 50
        },
        "listRole": {
          "type": "string",
          "maxLength": 30
        },
        "complexity": {
          "type": "string",
          "maxLength": 30
        },
        "allowedFlows": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      }
    },
    "Field": {
      "isTopLevelDataNode": true,
      "type": "object",
      "required": [
        "fieldRole"
      ],
      "properties": {
        "fieldRole": {
          "type": "string",
          "maxLength": 50
        },
        "listItemId": {
          "type": "number",
          "minimum": 0,
          "maximum": 128
        },
        "allowedFlows": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      }
    }
  },
  "controllers.json": {
    "ControllerList": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "controllers": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "document_data",
          "refTypes": [
            "AppController",
            "TPAWidget",
            "TPA",
            "TPAMultiSection"
          ]
        }
      }
    }
  },
  "css-value-definitions.schema.json": {
    "title": "CSS Value Definitions",
    "description": "Individual JSON Schema definitions for CSS value types, suitable for format registration",
    "definitions": {
      "<positive-value>": {
        "type": "string",
        "pattern": "^[^-]",
        "description": "CSS positive value"
      },
      "<length>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
          }
        ],
        "description": "CSS numeric length with all valid units"
      },
      "<positive-length>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS positive numeric length with all valid units"
      },
      "<percentage>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc()>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+%$"
          }
        ],
        "description": "Number followed by %"
      },
      "<positive-percentage>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Positive number followed by %"
      },
      "<length-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Accepts both <length> and <percentage>"
      },
      "<positive-length-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          }
        ],
        "description": "Accepts both <positive-length> and <positive-percentage>"
      },
      "<auto>": {
        "type": "string",
        "enum": [
          "auto"
        ],
        "description": "CSS auto keyword"
      },
      "<length-percentage-auto>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          },
          {
            "$ref": "#/definitions/<auto>"
          }
        ],
        "description": "CSS length, percentage, or auto"
      },
      "<positive-length-percentage-auto>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          },
          {
            "$ref": "#/definitions/<auto>"
          }
        ],
        "description": "CSS positive length, positive percentage, or auto"
      },
      "<number>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc-without-percentage>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+$"
          }
        ],
        "description": "Decimal or integer number"
      },
      "<positive-number>": {
        "allOf": [
          {
            "$ref": "#/definitions/<positive-value>"
          },
          {
            "$ref": "#/definitions/<number>"
          }
        ],
        "description": "Positive decimal or integer number"
      },
      "<integer>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc()>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d+$"
          }
        ],
        "description": "Whole numbers only"
      },
      "height": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content"
            ]
          }
        ],
        "description": "CSS height value"
      },
      "<angle>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc()>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
          }
        ],
        "description": "Used in rotation, direction, etc."
      },
      "<time>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc()>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
          }
        ],
        "description": "CSS durations (s, ms)"
      },
      "<resolution>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+(dpi|dpcm|dppx|x)$",
        "description": "Screen density/resolution units"
      },
      "<frequency>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<calc()>"
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(Hz|kHz)$"
          }
        ],
        "description": "Used in aural CSS or media queries"
      },
      "<dimension>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+[a-zA-Z]+$",
        "description": "Generic dimension (unit required)"
      },
      "<percentage-or-number>": {
        "oneOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "Matches numbers or percentages"
      },
      "<custom-ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "CSS identifiers (excluding keywords)"
      },
      "<ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "Same as <custom-ident>"
      },
      "<string>": {
        "type": "string",
        "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
        "description": "Quoted strings with escapes"
      },
      "<url>": {
        "type": "string",
        "pattern": "^url\\((['\"]?).*?\\1\\)$",
        "description": "Matches url(...) with optional quotes"
      },
      "<hex-color>": {
        "type": "string",
        "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
        "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
      },
      "<rgb-color>": {
        "type": "string",
        "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
      },
      "<hsl-color>": {
        "type": "string",
        "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
      },
      "<named-color>": {
        "type": "string",
        "enum": [
          "transparent",
          "currentColor",
          "aliceblue",
          "antiquewhite",
          "aqua",
          "aquamarine",
          "azure",
          "beige",
          "bisque",
          "black",
          "blanchedalmond",
          "blue",
          "blueviolet",
          "brown",
          "burlywood",
          "cadetblue",
          "chartreuse",
          "chocolate",
          "coral",
          "cornflowerblue",
          "cornsilk",
          "crimson",
          "cyan",
          "darkblue",
          "darkcyan",
          "darkgoldenrod",
          "darkgray",
          "darkgrey",
          "darkgreen",
          "darkkhaki",
          "darkmagenta",
          "darkolivegreen",
          "darkorange",
          "darkorchid",
          "darkred",
          "darksalmon",
          "darkseagreen",
          "darkslateblue",
          "darkslategray",
          "darkslategrey",
          "darkturquoise",
          "darkviolet",
          "deeppink",
          "deepskyblue",
          "dimgray",
          "dimgrey",
          "dodgerblue",
          "firebrick",
          "floralwhite",
          "forestgreen",
          "fuchsia",
          "gainsboro",
          "ghostwhite",
          "gold",
          "goldenrod",
          "gray",
          "grey",
          "green",
          "greenyellow",
          "honeydew",
          "hotpink",
          "indianred",
          "indigo",
          "ivory",
          "khaki",
          "lavender",
          "lavenderblush",
          "lawngreen",
          "lemonchiffon",
          "lightblue",
          "lightcoral",
          "lightcyan",
          "lightgoldenrodyellow",
          "lightgray",
          "lightgrey",
          "lightgreen",
          "lightpink",
          "lightsalmon",
          "lightseagreen",
          "lightskyblue",
          "lightslategray",
          "lightslategrey",
          "lightsteelblue",
          "lightyellow",
          "lime",
          "limegreen",
          "linen",
          "magenta",
          "maroon",
          "mediumaquamarine",
          "mediumblue",
          "mediumorchid",
          "mediumpurple",
          "mediumseagreen",
          "mediumslateblue",
          "mediumspringgreen",
          "mediumturquoise",
          "mediumvioletred",
          "midnightblue",
          "mintcream",
          "mistyrose",
          "moccasin",
          "navajowhite",
          "navy",
          "oldlace",
          "olive",
          "olivedrab",
          "orange",
          "orangered",
          "orchid",
          "palegoldenrod",
          "palegreen",
          "paleturquoise",
          "palevioletred",
          "papayawhip",
          "peachpuff",
          "peru",
          "pink",
          "plum",
          "powderblue",
          "purple",
          "rebeccapurple",
          "red",
          "rosybrown",
          "royalblue",
          "saddlebrown",
          "salmon",
          "sandybrown",
          "seagreen",
          "seashell",
          "sienna",
          "silver",
          "skyblue",
          "slateblue",
          "slategray",
          "slategrey",
          "snow",
          "springgreen",
          "steelblue",
          "tan",
          "teal",
          "thistle",
          "tomato",
          "turquoise",
          "violet",
          "wheat",
          "white",
          "whitesmoke",
          "yellow",
          "yellowgreen"
        ],
        "description": "CSS named colors including transparent and currentColor"
      },
      "<color>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<hex-color>"
          },
          {
            "$ref": "#/definitions/<rgb-color>"
          },
          {
            "$ref": "#/definitions/<hsl-color>"
          },
          {
            "$ref": "#/definitions/<named-color>"
          }
        ],
        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
      },
      "<image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "type": "string",
            "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
            "description": "Gradient functions - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^image\\(.*\\)$",
            "description": "Image function - arguments cannot be fully validated with regex"
          }
        ],
        "description": "CSS image values including URLs, gradients, and image() functions"
      },
      "<position>": {
        "type": "string",
        "pattern": "^(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%))(\\s+(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%)))*$",
        "description": "Single position value. Full position syntax with multiple values and combinations requires complex parsing that cannot be fully validated with regex."
      },
      "<transform-function>": {
        "type": "string",
        "pattern": "^(matrix|matrix3d|perspective|rotate|rotate3d|rotateX|rotateY|rotateZ|scale|scale3d|scaleX|scaleY|scaleZ|skew|skewX|skewY|translate|translate3d|translateX|translateY|translateZ)\\(.*\\)$",
        "description": "Transform functions like rotate(), translate(), scale(). Function arguments cannot be fully validated with regex as they require parsing of nested expressions."
      },
      "<var()>": {
        "type": "string",
        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
        "description": "CSS var() function- resolving a variable value from the variable"
      },
      "<calc()>": {
        "type": "string",
        "pattern": "calc\\((?!.*\\/\\s*0\\b)[^(),]+\\)",
        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units. Division by zero is rejected."
      },
      "<calc-without-percentage>": {
        "type": "string",
        "pattern": "^calc\\((?!.*\\/\\s*0\\b)[^(),%]+\\)$",
        "description": "CSS calc() function without percentages or division by zero."
      },
      "<calc-with-percentage>": {
        "allOf": [
          {
            "$ref": "#/definitions/<calc()>"
          },
          {
            "type": "string",
            "pattern": "calc\\([^()]*%[^()]*\\)"
          }
        ]
      },
      "<attr()>": {
        "type": "string",
        "pattern": "^attr\\(.*\\)$",
        "description": "CSS attr() function. Cannot fully validate fallback values and type hints with regex."
      },
      "<image-set()>": {
        "type": "string",
        "pattern": "^image-set\\(.*\\)$",
        "description": "CSS image-set() function. Cannot parse comma-separated URLs and resolution descriptors with regex."
      },
      "<basic-shape>": {
        "type": "string",
        "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
        "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
      },
      "<filter-function>": {
        "type": "string",
        "pattern": "^(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\)$",
        "description": "CSS filter functions. Function arguments cannot be fully validated with regex."
      },
      "<filter-value-list>": {
        "type": "string",
        "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
        "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
      },
      "<filter>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<filter-value-list>"
          }
        ],
        "description": "CSS filter value"
      },
      "<line-width>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "type": "string",
            "enum": [
              "thin",
              "medium",
              "thick"
            ]
          }
        ],
        "description": "CSS line width: length values or predefined keywords"
      },
      "<line-style>": {
        "type": "string",
        "enum": [
          "none",
          "hidden",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS line style keywords"
      },
      "<global-values>": {
        "type": "string",
        "enum": [
          "inherit",
          "initial",
          "unset",
          "revert",
          "revert-layer"
        ],
        "description": "Global values available for any CSS property"
      },
      "<flex>": {
        "type": "string",
        "pattern": "^\\d*\\.?\\d+fr$",
        "description": "CSS flex unit for grid and flexbox"
      },
      "<none>": {
        "type": "string",
        "enum": [
          "none"
        ],
        "description": "CSS none keyword"
      },
      "<normal>": {
        "type": "string",
        "enum": [
          "normal"
        ],
        "description": "CSS normal keyword"
      },
      "<shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "pattern": "^(inset\\s+)?(-?\\d+\\w*\\s+){2,4}(#[a-fA-F0-9]{3,8}|rgba?\\(.*\\)|hsla?\\(.*\\)|[a-zA-Z]+)?$"
          }
        ],
        "description": "CSS shadow value (box-shadow, text-shadow). Complex syntax with optional inset, multiple length values, and color cannot be fully validated with regex."
      },
      "<font-family>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<family-name>"
          },
          {
            "$ref": "#/definitions/<generic-family>"
          },
          {
            "type": "string",
            "pattern": "^['\"]?([^\\d][\\p{L}\\s\\-\\d]*)['\"]?(,\\s*['\"]?([^\\d][\\p{L}\\s\\-\\d]*)['\"]?)*$",
            "description": "Complex family name with multiple family names separated by commas"
          }
        ],
        "description": "CSS font family: generic families, quoted family names, or unquoted family names"
      },
      "<font-weight>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold",
              "bolder",
              "lighter"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900)$"
          }
        ],
        "description": "CSS font weight: keywords or numeric values"
      },
      "<font-style>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "italic",
              "oblique"
            ]
          },
          {
            "type": "string",
            "pattern": "^oblique\\s+\\d+deg$"
          }
        ],
        "description": "CSS font style: keywords or oblique with angle"
      },
      "<font-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<absolute-size>"
          },
          {
            "$ref": "#/definitions/<relative-size>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "math"
            ]
          }
        ],
        "description": "CSS font size: length, percentage, or keyword values"
      },
      "<display>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "table-row-group",
              "table-header-group",
              "table-footer-group",
              "table-row",
              "table-cell",
              "table-column-group",
              "table-column",
              "table-caption",
              "ruby-base",
              "ruby-text",
              "ruby-base-container",
              "ruby-text-container",
              "contents",
              "none",
              "inline-block",
              "inline-table",
              "inline-flex",
              "inline-grid"
            ]
          },
          {
            "type": "string",
            "description": "complex display value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS display property values"
      },
      "<overflow-block>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "clip",
          "scroll",
          "auto"
        ],
        "description": "CSS overflow-x and overflow-y property values"
      },
      "<overflow>": {
        "type": "string",
        "pattern": "^(visible|hidden|scroll|auto|clip)(\\s+(visible|hidden|scroll|auto|clip))?$",
        "description": "CSS overflow property values"
      },
      "<text-align>": {
        "type": "string",
        "enum": [
          "left",
          "right",
          "center",
          "justify",
          "start",
          "end",
          "match-parent"
        ],
        "description": "CSS text-align property values"
      },
      "<align-items>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "type": "string",
            "enum": [
              "stretch"
            ]
          },
          {
            "$ref": "#/definitions/<baseline-position>"
          },
          {
            "type": "string",
            "pattern": "^((safe|unsafe)\\s+)?(center|start|end|self-start|self-end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS align-items values"
      },
      "<vertical-align>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "baseline",
              "sub",
              "super",
              "text-top",
              "text-bottom",
              "middle",
              "top",
              "bottom"
            ]
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS vertical-align: keywords, length, or percentage"
      },
      "<border-radius>": {
        "type": "string",
        "pattern": "^(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3}(\\s*/\\s*(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3})?$",
        "description": "CSS border-radius shorthand. Complex syntax combining multiple radius values cannot be fully validated with regex."
      },
      "<border-top-left-radius>": {
        "type": "string",
        "pattern": "^(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
        "description": "CSS border-top-left-radius shorthand"
      },
      "<border-style>": {
        "type": "string",
        "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$",
        "description": "CSS border-style shorthand"
      },
      "<border-width>": {
        "type": "string",
        "pattern": "^(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$",
        "description": "CSS border-width shorthand"
      },
      "<border>": {
        "type": "string",
        "pattern": "^(?!.*\\/\\s*0).*$",
        "description": "CSS border shorthand with division by zero rejection in calc expressions. Detailed syntax validation handled by css-tree."
      },
      "<background>": {
        "type": "string",
        "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
      },
      "<transition>": {
        "type": "string",
        "description": "CSS transition shorthand. Complex syntax combining property, duration, timing-function, and delay cannot be fully validated with regex."
      },
      "<animation>": {
        "type": "string",
        "description": "CSS animation shorthand. Complex syntax combining name, duration, timing-function, delay, iteration-count, direction, fill-mode, and play-state cannot be fully validated with regex."
      },
      "<grid-template>": {
        "type": "string",
        "description": "CSS grid template properties. Complex syntax with track sizes, line names, and repeat functions cannot be fully validated with regex."
      },
      "<flex-shorthand>": {
        "type": "string",
        "description": "CSS flex shorthand combining flex-grow, flex-shrink, and flex-basis. Complex parsing required to validate the various combinations."
      },
      "<blend-mode>": {
        "type": "string",
        "enum": [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity"
        ],
        "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
      },
      "<mix-blend-mode>": {
        "$ref": "#/definitions/<blend-mode>",
        "description": "CSS mix-blend-mode property values"
      },
      "<background-blend-mode>": {
        "$ref": "#/definitions/<blend-mode>",
        "description": "CSS background-blend-mode property values"
      },
      "<timing-function>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "ease",
              "ease-in",
              "ease-out",
              "ease-in-out",
              "linear",
              "step-start",
              "step-end"
            ]
          },
          {
            "type": "string",
            "pattern": "^cubic-bezier\\(\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*\\)$"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end)\\s*)?\\)$"
          }
        ],
        "description": "CSS timing function: keywords, cubic-bezier(), or steps()"
      },
      "<repeat-style>": {
        "type": "string",
        "enum": [
          "repeat",
          "repeat-x",
          "repeat-y",
          "no-repeat",
          "space",
          "round"
        ],
        "description": "CSS background-repeat values"
      },
      "<attachment>": {
        "type": "string",
        "enum": [
          "scroll",
          "fixed",
          "local"
        ],
        "description": "CSS background-attachment values"
      },
      "<origin>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box"
        ],
        "description": "CSS background-origin values"
      },
      "<clip>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box",
          "text"
        ],
        "description": "CSS background-clip values"
      },
      "<sizing>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS background-size values"
      },
      "<cursor>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "default",
              "none",
              "context-menu",
              "help",
              "pointer",
              "progress",
              "wait",
              "cell",
              "crosshair",
              "text",
              "vertical-text",
              "alias",
              "copy",
              "move",
              "no-drop",
              "not-allowed",
              "grab",
              "grabbing",
              "all-scroll",
              "col-resize",
              "row-resize",
              "n-resize",
              "e-resize",
              "s-resize",
              "w-resize",
              "ne-resize",
              "nw-resize",
              "se-resize",
              "sw-resize",
              "ew-resize",
              "ns-resize",
              "nesw-resize",
              "nwse-resize",
              "zoom-in",
              "zoom-out"
            ]
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS cursor: keywords or custom cursor URLs"
      },
      "<list-style-type>": {
        "type": "string",
        "enum": [
          "disc",
          "circle",
          "square",
          "decimal",
          "decimal-leading-zero",
          "lower-roman",
          "upper-roman",
          "lower-greek",
          "lower-latin",
          "upper-latin",
          "armenian",
          "georgian",
          "lower-alpha",
          "upper-alpha",
          "none"
        ],
        "description": "CSS list-style-type values"
      },
      "<z-index>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<integer>"
          }
        ],
        "description": "CSS z-index: auto or integer"
      },
      "<opacity>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS opacity: number (0-1) or percentage"
      },
      "<visibility>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "collapse"
        ],
        "description": "CSS visibility values"
      },
      "<white-space>": {
        "type": "string",
        "enum": [
          "normal",
          "nowrap",
          "pre",
          "pre-wrap",
          "pre-line",
          "break-spaces"
        ],
        "description": "CSS white-space values"
      },
      "<text-decoration-line>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "underline",
              "overline",
              "line-through",
              "blink"
            ],
            "description": "single value text decoration line"
          },
          {
            "type": "string",
            "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
            "description": "multiple values text decoration line that cannot be fully validated with regex"
          }
        ],
        "description": "CSS text-decoration-line values"
      },
      "<text-decoration-style>": {
        "type": "string",
        "enum": [
          "solid",
          "double",
          "dotted",
          "dashed",
          "wavy"
        ],
        "description": "CSS text-decoration-style values"
      },
      "<text-transform>": {
        "type": "string",
        "enum": [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
          "full-width",
          "full-size-kana"
        ],
        "description": "CSS text-transform values"
      },
      "<word-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS word-wrap/overflow-wrap values"
      },
      "<user-select>": {
        "type": "string",
        "enum": [
          "auto",
          "text",
          "none",
          "contain",
          "all"
        ],
        "description": "CSS user-select values"
      },
      "<pointer-events>": {
        "type": "string",
        "enum": [
          "auto",
          "bounding-box",
          "none",
          "visiblePainted",
          "visibleFill",
          "visibleStroke",
          "visible",
          "painted",
          "fill",
          "stroke",
          "all"
        ],
        "description": "CSS pointer-events values"
      },
      "<box-sizing>": {
        "type": "string",
        "enum": [
          "content-box",
          "border-box"
        ],
        "description": "CSS box-sizing values"
      },
      "<resize>": {
        "type": "string",
        "enum": [
          "none",
          "both",
          "horizontal",
          "vertical",
          "block",
          "inline"
        ],
        "description": "CSS resize values"
      },
      "<outline>": {
        "type": "string",
        "description": "CSS outline shorthand. Complex syntax combining outline-width, outline-style, and outline-color cannot be fully validated with regex."
      },
      "<quotes>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "auto"
            ]
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS quotes: none, auto, or quoted string pairs"
      },
      "<content>": {
        "type": "string",
        "description": "CSS content property. Complex syntax with strings, counters, attr(), and url() cannot be fully validated with regex."
      },
      "<will-change>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "type": "string",
            "enum": [
              "scroll-position",
              "contents"
            ]
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS will-change: auto or property names"
      },
      "<contain>": {
        "type": "string",
        "enum": [
          "none",
          "strict",
          "content",
          "size",
          "inline-size",
          "layout",
          "style",
          "paint"
        ],
        "description": "CSS contain values"
      },
      "<isolation>": {
        "type": "string",
        "enum": [
          "auto",
          "isolate"
        ],
        "description": "CSS isolation values"
      },
      "<writing-mode>": {
        "type": "string",
        "enum": [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
          "sideways-rl",
          "sideways-lr"
        ],
        "description": "CSS writing-mode values"
      },
      "<direction>": {
        "type": "string",
        "enum": [
          "ltr",
          "rtl"
        ],
        "description": "CSS direction values"
      },
      "<unicode-bidi>": {
        "type": "string",
        "enum": [
          "normal",
          "embed",
          "isolate",
          "bidi-override",
          "isolate-override",
          "plaintext"
        ],
        "description": "CSS unicode-bidi values"
      },
      "<object-fit>": {
        "type": "string",
        "enum": [
          "fill",
          "contain",
          "cover",
          "none",
          "scale-down"
        ],
        "description": "CSS object-fit values"
      },
      "<object-position>": {
        "$ref": "#/definitions/<position>",
        "description": "CSS object-position: similar to position."
      },
      "<scroll-behavior>": {
        "type": "string",
        "enum": [
          "auto",
          "smooth"
        ],
        "description": "CSS scroll-behavior values"
      },
      "<appearance>": {
        "type": "string",
        "enum": [
          "none",
          "auto",
          "base-select",
          "textfield",
          "searchfield",
          "textarea",
          "checkbox",
          "radio",
          "menulist",
          "menulist-button",
          "listbox",
          "meter",
          "progress-bar",
          "button"
        ],
        "description": "CSS appearance values"
      },
      "<outline-offset>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS outline-offset: length values"
      },
      "<tab-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<integer>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS tab-size: integer or length"
      },
      "<hyphens>": {
        "type": "string",
        "enum": [
          "none",
          "manual",
          "auto"
        ],
        "description": "CSS hyphens values"
      },
      "<word-break>": {
        "type": "string",
        "enum": [
          "normal",
          "break-all",
          "keep-all",
          "break-word"
        ],
        "description": "CSS word-break values"
      },
      "<line-break>": {
        "type": "string",
        "enum": [
          "auto",
          "loose",
          "normal",
          "strict",
          "anywhere"
        ],
        "description": "CSS line-break values"
      },
      "<letter-spacing>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS letter-spacing: normal or length"
      },
      "<word-spacing>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<length>"
          }
        ],
        "description": "CSS word-spacing: normal, length, or percentage"
      },
      "<line-height>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<positive-number>"
          },
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          }
        ],
        "description": "CSS line-height: normal, number, length, or percentage"
      },
      "<text-indent>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "pattern": "(?:^(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(?=(?:\\shanging|\\seach-line){0,2}$))|(?:^(?:hanging\\s?|each-line\\s?){1,2}\\s(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s?(?:hanging|each-line)?$)",
            "description": "css text-indent string"
          }
        ],
        "description": "CSS text-indent: length or percentage, with optional 'hanging' or 'each-line' keywords"
      },
      "<text-overflow>": {
        "type": "string",
        "enum": [
          "clip",
          "ellipsis"
        ],
        "description": "CSS text-overflow values"
      },
      "<text-decoration>": {
        "type": "string",
        "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
      },
      "<text-shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "not": {
              "$ref": "#/definitions/<calc-with-percentage>"
            }
          }
        ],
        "description": "CSS text-shadow: complex shadow value cannot be fully validated with regex"
      },
      "<box-shadow>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "not": {
              "$ref": "#/definitions/<calc-with-percentage>"
            },
            "description": "complex shadow value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS box-shadow: none or shadow values (h-offset v-offset take <length>, no percentages allowed)"
      },
      "<list-style>": {
        "type": "string",
        "description": "CSS list-style shorthand. Complex syntax combining list-style-type, list-style-position, and list-style-image cannot be fully validated with regex."
      },
      "<list-style-position>": {
        "type": "string",
        "enum": [
          "inside",
          "outside"
        ],
        "description": "CSS list-style-position values"
      },
      "<list-style-image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          }
        ],
        "description": "CSS list-style-image: none or URL"
      },
      "<alpha-value>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS alpha value for colors: number (0-1) or percentage"
      },
      "<absolute-size>": {
        "type": "string",
        "enum": [
          "xx-small",
          "x-small",
          "small",
          "medium",
          "large",
          "x-large",
          "xx-large",
          "xxx-large"
        ],
        "description": "CSS absolute font sizes"
      },
      "<relative-size>": {
        "type": "string",
        "enum": [
          "larger",
          "smaller"
        ],
        "description": "CSS relative font sizes"
      },
      "<angle-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<angle>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS angle or percentage"
      },
      "<number-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS number or percentage"
      },
      "<time-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<time>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS time or percentage"
      },
      "<frequency-percentage>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<frequency>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS frequency or percentage"
      },
      "<baseline-position>": {
        "type": "string",
        "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
        "description": "CSS baseline position: baseline, first baseline, or last baseline"
      },
      "<content-distribution>": {
        "type": "string",
        "enum": [
          "space-between",
          "space-around",
          "space-evenly",
          "stretch"
        ],
        "description": "CSS content distribution values for alignment"
      },
      "<content-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS content position values for alignment"
      },
      "<self-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "self-start",
          "self-end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS self position values for alignment"
      },
      "<overflow-position>": {
        "type": "string",
        "enum": [
          "unsafe",
          "safe"
        ],
        "description": "CSS overflow position modifiers"
      },
      "<justify-content>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<normal>"
          },
          {
            "$ref": "#/definitions/<content-distribution>"
          },
          {
            "$ref": "#/definitions/<content-position>"
          },
          {
            "type": "string",
            "enum": [
              "left",
              "right"
            ]
          },
          {
            "type": "string",
            "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS justify-content values"
      },
      "<visual-box>": {
        "type": "string",
        "enum": [
          "content-box",
          "padding-box",
          "border-box"
        ],
        "description": "CSS visual box types"
      },
      "<shape-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "margin-box"
            ]
          }
        ],
        "description": "CSS shape box types"
      },
      "<geometry-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<shape-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS geometry box types including visual box and additional geometry boxes"
      },
      "<paint-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box"
            ]
          }
        ],
        "description": "CSS paint box types"
      },
      "<coord-box>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<paint-box>"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS coordinate box types"
      },
      "<generic-family>": {
        "type": "string",
        "enum": [
          "serif",
          "sans-serif",
          "monospace",
          "cursive",
          "fantasy",
          "system-ui",
          "ui-serif",
          "ui-sans-serif",
          "ui-monospace",
          "ui-rounded",
          "math",
          "emoji",
          "fangsong"
        ],
        "description": "CSS generic font families"
      },
      "<family-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<string>"
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS font family name: quoted string or unquoted identifier"
      },
      "<system-family-name>": {
        "type": "string",
        "enum": [
          "caption",
          "icon",
          "menu",
          "message-box",
          "small-caption",
          "status-bar"
        ],
        "description": "CSS system font family names"
      },
      "<font-stretch-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "ultra-condensed",
              "extra-condensed",
              "condensed",
              "semi-condensed",
              "semi-expanded",
              "expanded",
              "extra-expanded",
              "ultra-expanded"
            ]
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS font stretch absolute values"
      },
      "<font-weight-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900|[1-9][0-9]{0,2})$"
          }
        ],
        "description": "CSS font weight absolute values: normal, bold, or number 1-1000"
      },
      "<grid-line>": {
        "type": "string",
        "description": "CSS grid line: auto, custom identifier, integer with optional identifier, or span notation. Complex syntax cannot be fully validated with regex."
      },
      "<track-breadth>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "$ref": "#/definitions/<flex>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS grid track breadth"
      },
      "<inflexible-breadth>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS inflexible breadth (track breadth without flex)"
      },
      "<track-size>": {
        "type": "string",
        "description": "CSS grid track size: track-breadth, minmax(), or fit-content(). Complex syntax cannot be fully validated with regex."
      },
      "<easing-function>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<timing-function>"
          },
          {
            "type": "string",
            "pattern": "^linear\\(.*\\)$",
            "description": "Linear easing function - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end|jump-start|jump-end|jump-none|jump-both)\\s*)?\\)$"
          }
        ],
        "description": "CSS easing functions including cubic-bezier, steps, and linear"
      },
      "<single-animation-direction>": {
        "type": "string",
        "enum": [
          "normal",
          "reverse",
          "alternate",
          "alternate-reverse"
        ],
        "description": "CSS animation direction values"
      },
      "<single-animation-fill-mode>": {
        "type": "string",
        "enum": [
          "none",
          "forwards",
          "backwards",
          "both"
        ],
        "description": "CSS animation fill mode values"
      },
      "<single-animation-play-state>": {
        "type": "string",
        "enum": [
          "running",
          "paused"
        ],
        "description": "CSS animation play state values"
      },
      "<single-animation-iteration-count>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "type": "string",
            "enum": [
              "infinite"
            ]
          }
        ],
        "description": "CSS animation iteration count: number or infinite"
      },
      "<keyframes-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS keyframes name: identifier or string"
      },
      "<single-transition-property>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "all"
            ]
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS transition property: all or property name"
      },
      "<quote>": {
        "type": "string",
        "enum": [
          "open-quote",
          "close-quote",
          "no-open-quote",
          "no-close-quote"
        ],
        "description": "CSS quote values for generated content"
      },
      "<counter-style-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "type": "string",
            "enum": [
              "decimal",
              "decimal-leading-zero",
              "lower-roman",
              "upper-roman",
              "lower-greek",
              "lower-latin",
              "upper-latin",
              "armenian",
              "georgian",
              "lower-alpha",
              "upper-alpha",
              "disc",
              "circle",
              "square",
              "none"
            ]
          }
        ],
        "description": "CSS counter style: predefined or custom identifier"
      },
      "<ratio>": {
        "type": "string",
        "pattern": "^\\d+(\\.\\d+)?\\s*/\\s*\\d+(\\.\\d+)?$",
        "description": "CSS ratio: number/number"
      },
      "<dasharray>": {
        "type": "string",
        "description": "CSS dash array for stroke-dasharray. Complex syntax with multiple length/percentage/number values cannot be fully validated with regex."
      },
      "<paint>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<color>"
          },
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "type": "string",
            "enum": [
              "context-stroke"
            ]
          }
        ],
        "description": "CSS paint values for SVG: none, color, URL, or context keywords"
      },
      "<overflow-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS overflow-wrap values (same as word-wrap)"
      },
      "<text-decoration-thickness>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<positive-length>"
          },
          {
            "$ref": "#/definitions/<positive-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "from-font"
            ]
          }
        ],
        "description": "CSS text decoration thickness"
      },
      "<text-underline-offset>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<auto>"
          },
          {
            "$ref": "#/definitions/<length>"
          },
          {
            "$ref": "#/definitions/<percentage>"
          }
        ],
        "description": "CSS text underline offset"
      },
      "<text-emphasis-style>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "type": "string",
            "enum": [
              "filled",
              "open",
              "dot",
              "circle",
              "double-circle",
              "triangle",
              "sesame"
            ]
          },
          {
            "$ref": "#/definitions/<string>"
          }
        ],
        "description": "CSS text emphasis style"
      },
      "<mask-composite>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS mask composite operation values"
      },
      "<mask-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS mask mode values"
      },
      "<clip-path>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<url>"
          },
          {
            "$ref": "#/definitions/<basic-shape>"
          }
        ],
        "description": "CSS clip-path: none, URL, or basic shape"
      },
      "<shape-outside>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<basic-shape>"
          }
        ],
        "description": "CSS shape-outside: none, image, or basic shape"
      },
      "<intrinsic-size-keyword>": {
        "type": "string",
        "enum": [
          "auto",
          "min-content",
          "max-content",
          "fit-content"
        ],
        "description": "CSS intrinsic sizing keywords"
      },
      "<step-position>": {
        "type": "string",
        "enum": [
          "jump-start",
          "jump-end",
          "jump-none",
          "jump-both",
          "start",
          "end"
        ],
        "description": "CSS step position for steps() timing function"
      },
      "<system-color>": {
        "type": "string",
        "enum": [
          "AccentColor",
          "AccentColorText",
          "ActiveText",
          "ButtonBorder",
          "ButtonFace",
          "ButtonText",
          "Canvas",
          "CanvasText",
          "Field",
          "FieldText",
          "GrayText",
          "Highlight",
          "HighlightText",
          "LinkText",
          "Mark",
          "MarkText",
          "SelectedItem",
          "SelectedItemText",
          "VisitedText"
        ],
        "description": "CSS system colors"
      },
      "<deprecated-system-color>": {
        "type": "string",
        "enum": [
          "ActiveBorder",
          "ActiveCaption",
          "AppWorkspace",
          "Background",
          "ButtonHighlight",
          "ButtonShadow",
          "CaptionText",
          "InactiveBorder",
          "InactiveCaption",
          "InactiveCaptionText",
          "InfoBackground",
          "InfoText",
          "Menu",
          "MenuText",
          "Scrollbar",
          "ThreeDDarkShadow",
          "ThreeDFace",
          "ThreeDHighlight",
          "ThreeDLightShadow",
          "ThreeDShadow",
          "Window",
          "WindowFrame",
          "WindowText"
        ],
        "description": "CSS deprecated system colors"
      },
      "<bg-size>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<positive-length-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "type": "string",
            "pattern": "^(auto|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(auto|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))?)$",
            "description": "complex syntax with multiple values that cannot be fully validated with regex"
          }
        ],
        "description": "CSS background-size values"
      },
      "<bg-position>": {
        "type": "string",
        "description": "CSS background-position values. Complex syntax with multiple position values and combinations cannot be fully validated with regex."
      },
      "<bg-clip>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<visual-box>"
          },
          {
            "type": "string",
            "enum": [
              "border-area",
              "text"
            ]
          }
        ],
        "description": "CSS background-clip values"
      },
      "<bg-image>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          }
        ],
        "description": "CSS background-image values"
      },
      "<hue>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<number>"
          },
          {
            "$ref": "#/definitions/<angle>"
          }
        ],
        "description": "CSS hue value: number or angle"
      },
      "<radial-shape>": {
        "type": "string",
        "enum": [
          "circle",
          "ellipse"
        ],
        "description": "CSS radial gradient shape"
      },
      "<radial-extent>": {
        "type": "string",
        "enum": [
          "closest-corner",
          "closest-side",
          "farthest-corner",
          "farthest-side"
        ],
        "description": "CSS radial gradient extent"
      },
      "<side-or-corner>": {
        "type": "string",
        "pattern": "^(left|right|top|bottom)$|^(left|right)\\s+(top|bottom)$|^(top|bottom)\\s+(left|right)$",
        "description": "CSS gradient side or corner direction"
      },
      "<color-stop-length>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<length-percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?%\\s+\\d+(\\.\\d+)?%$"
          }
        ],
        "description": "CSS color stop length: single or double length-percentage"
      },
      "<color-stop-angle>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<angle-percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?deg\\s+\\d+(\\.\\d+)?deg$"
          }
        ],
        "description": "CSS color stop angle: single or double angle-percentage"
      },
      "<masking-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS masking mode values"
      },
      "<mask-reference>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<none>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<url>"
          }
        ],
        "description": "CSS mask reference values"
      },
      "<outline-line-style>": {
        "type": "string",
        "enum": [
          "none",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS outline line style values"
      },
      "<counter-name>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<custom-ident>"
          },
          {
            "type": "string",
            "enum": [
              "list-item"
            ]
          }
        ],
        "description": "CSS counter name: custom identifier or list-item"
      },
      "<symbol>": {
        "anyOf": [
          {
            "$ref": "#/definitions/<string>"
          },
          {
            "$ref": "#/definitions/<image>"
          },
          {
            "$ref": "#/definitions/<custom-ident>"
          }
        ],
        "description": "CSS symbol values for counters"
      },
      "<symbols-type>": {
        "type": "string",
        "enum": [
          "cyclic",
          "numeric",
          "alphabetic",
          "symbolic",
          "fixed"
        ],
        "description": "CSS symbols() function type"
      },
      "<feature-tag-value>": {
        "type": "string",
        "description": "CSS font feature tag value. Complex syntax with string and optional integer/keyword cannot be fully validated with regex."
      },
      "<east-asian-variant-values>": {
        "type": "string",
        "enum": [
          "jis78",
          "jis83",
          "jis90",
          "jis04",
          "simplified",
          "traditional"
        ],
        "description": "CSS East Asian variant values"
      },
      "<east-asian-width-values>": {
        "type": "string",
        "enum": [
          "full-width",
          "proportional-width"
        ],
        "description": "CSS East Asian width values"
      },
      "<numeric-figure-values>": {
        "type": "string",
        "enum": [
          "lining-nums",
          "oldstyle-nums"
        ],
        "description": "CSS numeric figure values"
      },
      "<numeric-fraction-values>": {
        "type": "string",
        "enum": [
          "diagonal-fractions",
          "stacked-fractions"
        ],
        "description": "CSS numeric fraction values"
      },
      "<numeric-spacing-values>": {
        "type": "string",
        "enum": [
          "proportional-nums",
          "tabular-nums"
        ],
        "description": "CSS numeric spacing values"
      },
      "<common-lig-values>": {
        "type": "string",
        "enum": [
          "common-ligatures",
          "no-common-ligatures"
        ],
        "description": "CSS common ligature values"
      },
      "<discretionary-lig-values>": {
        "type": "string",
        "enum": [
          "discretionary-ligatures",
          "no-discretionary-ligatures"
        ],
        "description": "CSS discretionary ligature values"
      },
      "<historical-lig-values>": {
        "type": "string",
        "enum": [
          "historical-ligatures",
          "no-historical-ligatures"
        ],
        "description": "CSS historical ligature values"
      },
      "<contextual-alt-values>": {
        "type": "string",
        "enum": [
          "contextual",
          "no-contextual"
        ],
        "description": "CSS contextual alternates values"
      },
      "<composite-style>": {
        "type": "string",
        "enum": [
          "clear",
          "copy",
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "xor"
        ],
        "description": "CSS composite style values"
      },
      "<compositing-operator>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS compositing operator values"
      },
      "<axis>": {
        "type": "string",
        "enum": [
          "block",
          "inline",
          "x",
          "y"
        ],
        "description": "CSS axis values"
      },
      "<scroller>": {
        "type": "string",
        "enum": [
          "root",
          "nearest",
          "self"
        ],
        "description": "CSS scroller values"
      },
      "<try-size>": {
        "type": "string",
        "enum": [
          "most-width",
          "most-height",
          "most-block-size",
          "most-inline-size"
        ],
        "description": "CSS try size values"
      },
      "<try-tactic>": {
        "type": "string",
        "enum": [
          "flip-block",
          "flip-inline",
          "flip-start"
        ],
        "description": "CSS try tactic values"
      },
      "<font>": {
        "type": "string",
        "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
      },
      "<font-variant>": {
        "type": "string",
        "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
      },
      "<flex-direction>": {
        "type": "string",
        "enum": [
          "row",
          "row-reverse",
          "column",
          "column-reverse"
        ],
        "description": "CSS flex-direction values"
      },
      "<gap>": {
        "type": "string",
        "pattern": "^(normal|0|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
        "description": "CSS gap values"
      },
      "<padding>": {
        "type": "string",
        "pattern": "^(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))(\\s+(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))){0,3}$",
        "description": "CSS padding values"
      },
      "<padding-top>": {
        "$ref": "#/definitions/<positive-length-percentage>",
        "description": "CSS padding-top values"
      }
    }
  },
  "cssPropertySchemas.json": {
    "title": "CSS Property Schemas",
    "description": "Individual JSON Schema definitions for CSS property value types used within Wix",
    "definitions": {
      "CSS.Color": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
                "format": "css-color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<blend-mode>",
                "format": "css-blend-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Angle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<angle>",
                "format": "css-angle"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
                "format": "css-length-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
                "format": "css-length-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Length": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length>",
                "format": "css-length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLength": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length>",
                "format": "css-length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Number": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<number>",
                "format": "css-number"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveNumber": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-number>",
                "format": "css-number"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Percentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<percentage>",
                "format": "css-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositivePercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-percentage>",
                "format": "css-percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.String": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<string>",
                "format": "css-string"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Time": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<time>",
                "format": "css-time"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-style>",
                "format": "css-border-top-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-width>",
                "format": "css-border-top-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-width>",
                "format": "css-border-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-style>",
                "format": "css-border-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderColor": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
                "format": "css-border-color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Border": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border>",
                "format": "css-border"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-radius>",
                "description": "border radius shorthand syntax",
                "format": "css-border-radius"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopLeftRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-top-left-radius>",
                "format": "css-border-top-left-radius"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Font": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font>",
                "format": "css-font"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontFamily": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.String"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-family>",
                "format": "css-font-family"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-size>",
                "format": "css-font-size"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStretch": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-stretch-absolute>",
                "format": "css-font-stretch"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-style>",
                "format": "css-font-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontVariant": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-variant>",
                "format": "css-font-variant"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontWeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-weight>",
                "format": "css-font-weight"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LineHeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveNumber"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-height>",
                "format": "css-line-height"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LetterSpacing": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<letter-spacing>",
                "format": "css-letter-spacing"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextAlign": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-align>",
                "format": "css-text-align"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextTransform": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-transform>",
                "format": "css-text-transform"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-shadow>",
                "format": "css-text-shadow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecoration": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration>",
                "format": "css-text-decoration"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationLine": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-line>",
                "format": "css-text-decoration-line"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-style>",
                "format": "css-text-decoration-style"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationThickness": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-thickness>",
                "format": "css-text-decoration-thickness"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextOverflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-overflow>",
                "format": "css-text-overflow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextIndent": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-indent>",
                "format": "css-text-indent"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Padding": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding>",
                "format": "css-padding",
                "description": "padding shorthand syntax"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PaddingTop": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding-top>",
                "format": "css-padding-top"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Margin": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "description": "margin shorthand syntax",
                "format": "css-margin"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.MarginTop": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage-auto>",
                "format": "css-margin-top"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BoxShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<box-shadow>",
                "format": "css-box-shadow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Opacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<opacity>",
                "format": "css-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Background": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<background>",
                "format": "css-background"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-size>",
                "format": "css-background-size"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundImage": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-image>",
                "format": "css-background-image"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignSelf": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<self-position>",
                "format": "css-align-self"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.HeightOrWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage-auto>",
                "format": "css-height-or-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundClip": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-clip>",
                "format": "css-background-clip"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundOrigin": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<origin>",
                "format": "css-background-origin"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-position>",
                "format": "css-background-position"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundRepeat": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<repeat-style>",
                "format": "css-background-repeat"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BackgroundAttachment": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<attachment>",
                "format": "css-background-attachment"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Overflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow>",
                "format": "css-overflow"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowX": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
                "format": "css-overflow-x"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowY": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
                "format": "css-overflow-y"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignItems": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<align-items>",
                "format": "css-align-items"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FlexDirection": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<flex-direction>",
                "format": "css-flex-direction"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Gap": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<gap>",
                "format": "css-gap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.SingleValueGap": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
                "format": "css-single-value-gap"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.JustifyContent": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<justify-content>",
                "format": "css-justify-content"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillWithURL": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
                "format": "css-fill-with-url"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Isolation": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<isolation>",
                "format": "css-isolation"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.MixBlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BlendMode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mix-blend-mode>",
                "format": "css-mix-blend-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectFit": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-fit>",
                "format": "css-object-fit"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-position>",
                "format": "css-object-position"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
                "format": "css-fill-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Stroke": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
                "format": "css-stroke"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
                "format": "css-stroke-width"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
              },
              {
                "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
                "format": "css-stroke-opacity"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Display": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<display>",
                "format": "css-display"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Filter": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<filter>",
                "format": "css-filter"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.WritingMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
              },
              {
                "type": "string",
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<writing-mode>",
                "format": "css-writing-mode"
              },
              {
                "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      }
    }
  },
  "cursor.json": {
    "Cursor": {
      "type": "object",
      "properties": {
        "media": {
          "type": "string",
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "Image",
            "SVGItem"
          ],
          "shouldCollect": true,
          "shouldValidate": true
        },
        "offsetX": {
          "type": "number",
          "default": 0,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        },
        "offsetY": {
          "type": "number",
          "default": 0,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        },
        "width": {
          "type": "number",
          "default": 32,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        },
        "height": {
          "type": "number",
          "default": 32,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        }
      },
      "isTopLevelDataNode": true
    },
    "Image": {
      "$ref": "Common_Image",
      "isTopLevelDataNode": true
    },
    "SVGItem": {
      "$ref": "Common_SVGItem",
      "isTopLevelDataNode": true
    }
  },
  "data.json": {
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ],
      "isTopLevelDataNode": false
    },
    "AppVars": {
      "type": "object",
      "properties": {
        "vars": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "value": {
                "type": "string",
                "maxLength": 100
              },
              "type": {
                "type": "string",
                "enum": [
                  "AppPartParam"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "appDefId": {
          "type": "string",
          "maxLength": 100
        }
      },
      "isPermanentDataNode": true,
      "isTopLevelDataNode": true
    },
    "SVGItem": {
      "$ref": "Common_SVGItem",
      "isTopLevelDataNode": true
    },
    "SVGReference": {
      "type": [
        "null",
        "string"
      ],
      "pseudoType": [
        "ref"
      ],
      "refTypes": [
        "SVGItem"
      ],
      "isTopLevelDataNode": false
    },
    "BackgroundImage": {
      "type": "object",
      "properties": {
        "url": {
          "type": "string"
        },
        "positionx": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "center"
        },
        "imagesizew": {
          "$ref": "urn:dm:schemas:common.json#/JavaInt"
        },
        "imagesizeh": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "positiony": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ],
          "default": "center"
        },
        "width": {
          "type": "string"
        },
        "repeatx": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ],
          "default": "repeat"
        },
        "repeaty": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ],
          "default": "repeat"
        },
        "attachment": {
          "type": "string",
          "enum": [
            "scroll",
            "fixed",
            "inherit",
            "local"
          ],
          "default": "inherit"
        },
        "color": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "BackgroundMedia": {
      "type": "object",
      "properties": {
        "mediaRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image",
            "WixVideo"
          ]
        },
        "color": {
          "type": "string"
        },
        "colorOpacity": {
          "type": "number"
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "imageOverlay": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "colorOverlay": {
          "type": "string"
        },
        "colorOverlayOpacity": {
          "type": "number"
        }
      },
      "isTopLevelDataNode": true
    },
    "WixVideo": {
      "type": "object",
      "allOf": [
        {
          "$ref": "WixVideoData"
        },
        {
          "properties": {
            "loop": {
              "type": "boolean"
            },
            "autoplay": {
              "type": "boolean"
            },
            "playbackSpeed": {
              "type": "number"
            },
            "preload": {
              "type": "string",
              "enum": [
                "auto",
                "metadata",
                "none"
              ]
            },
            "controls": {
              "type": "string",
              "enum": [
                "none",
                "full"
              ]
            },
            "mute": {
              "type": "boolean",
              "description": "deprecated, moved to properties"
            },
            "opacity": {
              "type": "number"
            },
            "mediaFeatures": {
              "type": "array",
              "items": {
                "type": "string",
                "enum": [
                  "alpha"
                ]
              }
            },
            "mask": {
              "anyOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "ImageMask"
                }
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "WixVideoData": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            }
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            }
          }
        },
        "posterImageRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "duration": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "Document": {
      "type": "object",
      "isPermanentDataNode": true,
      "properties": {
        "siteName": {
          "type": "string",
          "maxLength": 1000
        },
        "usedFonts": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 1000
          }
        },
        "characterSets": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "renderModifiers": {
          "type": "object",
          "properties": {
            "siteWidth": {
              "type": "number",
              "minimum": 0
            },
            "pageAutoShrink": {
              "type": "boolean"
            }
          }
        },
        "name": {
          "type": "string"
        },
        "mainPage": {
          "type": [
            "string",
            "null"
          ],
          "isRefOwner": false,
          "shouldCollect": false,
          "shouldValidate": true,
          "refTypes": [
            "Page",
            "AppPage"
          ],
          "referencedMap": "#",
          "pseudoType": [
            "ref"
          ]
        },
        "mainPageId": {
          "type": "string"
        },
        "smSettings": {
          "type": "object",
          "allOf": [
            {
              "$ref": "SiteMembersData"
            }
          ]
        },
        "styleSettings": {
          "$ref": "StyleSettings"
        },
        "accessibilitySettings": {
          "$ref": "AccessibilitySettings"
        },
        "mobileSettings": {
          "$ref": "MobileSettings"
        },
        "layoutSettings": {
          "$ref": "LayoutSettings"
        },
        "appStudioData": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "AppStudioData"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean"
          ]
        },
        "anchorLockThreshold": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "supportMobile": {
          "type": "boolean"
        },
        "autoDomReorder": {
          "type": "boolean"
        },
        "appsInstallState": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "AppsInstallState"
          ]
        },
        "usesNewAnimations": {
          "type": "boolean"
        }
      },
      "isTopLevelDataNode": true
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "skipToContent": {
          "default": true,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isRtlSupportEnabled": {
          "default": false,
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      }
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "pagesToFooterGap": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      }
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      }
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "LinkReference"
            }
          }
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "LinkReference"
            }
          }
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "$ref": "LinkReference"
            }
          }
        },
        "smFirstDialogLogin": {
          "$ref": "urn:dm:schemas:common.json#/NullableBool"
        }
      },
      "isTopLevelDataNode": false
    },
    "AppStudioData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "widgets": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "WidgetDescriptor"
          ]
        },
        "codePackages": {
          "type": [
            "null",
            "array"
          ],
          "maxItems": 1,
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "CodePackagesDescriptor"
          ]
        },
        "panels": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "PanelDescriptor"
          ]
        },
        "dependencies": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "appDefId": {
                "type": "string",
                "maxLength": 100
              },
              "dependencyData": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "PROVISION_ONLY_INSTALLATION",
                    "NOTIFY_USER_ON_DEPENDENCY",
                    "IS_BUNDLE"
                  ]
                }
              }
            },
            "additionalProperties": false,
            "required": [
              "appDefId"
            ]
          }
        },
        "dashboards": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "DashboardDescriptor"
          ]
        },
        "customDefinitions": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "CustomDefinitionDescriptor"
          ]
        },
        "ssrCache": {
          "type": "boolean"
        }
      }
    },
    "CodePackagesDescriptor": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "displayName": {
          "type": "string",
          "maxLength": 30,
          "minLength": 1
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "minLength": 3
        },
        "description": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "WidgetPropertyDefinition": {
      "type": "object",
      "properties": {
        "allOf": {
          "type": "array",
          "items": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "$ref": {
                    "type": "string"
                  }
                },
                "required": [
                  "$ref"
                ]
              },
              {
                "type": "object",
                "properties": {
                  "title": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "array",
                      "string",
                      "number",
                      "boolean",
                      "object"
                    ]
                  },
                  "default": {},
                  "minimum": {
                    "type": "number"
                  },
                  "maximum": {
                    "type": "number"
                  },
                  "multipleOf": {
                    "type": "number"
                  },
                  "minLength": {
                    "type": "number"
                  },
                  "maxLength": {
                    "type": "number"
                  },
                  "items": {
                    "$ref": "WidgetPropertyDefinition"
                  }
                },
                "additionalProperties": false,
                "required": [
                  "title",
                  "description"
                ]
              }
            ]
          }
        }
      },
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "CustomDefinitionDescriptor": {
      "type": "object",
      "properties": {
        "structure": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "$id": {
                "type": "string"
              },
              "type": {
                "type": "string",
                "default": "object"
              },
              "title": {
                "type": "string"
              },
              "description": {
                "type": "string"
              },
              "properties": {
                "type": "object",
                "additionalProperties": {
                  "$ref": "WidgetPropertyDefinition"
                }
              },
              "default": {
                "type": "object",
                "default": {}
              },
              "propertiesOrder": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "default": []
              }
            },
            "additionalProperties": false,
            "required": [
              "$id",
              "title",
              "description",
              "default",
              "propertiesOrder"
            ]
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "WidgetDescriptor": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string"
        },
        "devCenterWidgetId": {
          "type": [
            "string",
            "null"
          ]
        },
        "devCenterEditorReactComponentId": {
          "type": [
            "string",
            "null"
          ]
        },
        "kind": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "container",
            "section"
          ]
        },
        "panels": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "PanelDescriptor"
          ]
        },
        "defaultSize": {
          "type": [
            "object",
            "null"
          ],
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            }
          }
        },
        "rootCompId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": false,
          "shouldCollect": false,
          "referencedMap": "components"
        },
        "variations": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "VariationDescriptor"
          ]
        },
        "presets": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "PresetDescriptor"
          ]
        },
        "plugin": {
          "type": "object",
          "properties": {
            "placements": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "appDefinitionId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "widgetId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "slotId": {
                    "type": "string",
                    "maxLength": 100
                  }
                }
              }
            }
          }
        },
        "containedWidgets": {
          "type": "array",
          "items": {
            "type": "string",
            "pseudoType": [
              "weakRef"
            ],
            "shouldCollect": false,
            "shouldValidate": true,
            "referencedMap": "#"
          },
          "default": []
        },
        "widgetApi": {
          "type": "object",
          "default": {},
          "properties": {
            "functions": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "params": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "name": {
                          "type": "string"
                        },
                        "description": {
                          "type": [
                            "string",
                            "null"
                          ]
                        }
                      }
                    }
                  },
                  "returnsDescription": {
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "required": [
                  "name"
                ]
              }
            },
            "propertiesSchemas": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "properties": {
                  "structure": {
                    "type": "object",
                    "additionalProperties": {
                      "$ref": "WidgetPropertyDefinition"
                    },
                    "default": {}
                  }
                }
              }
            },
            "events": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "args": {
                    "type": "array",
                    "items": {
                      "properties": {
                        "name": {
                          "type": "string"
                        }
                      }
                    }
                  }
                },
                "required": [
                  "name"
                ]
              }
            }
          }
        },
        "structureRef": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "rootCompId": {
              "type": "string"
            }
          }
        },
        "compType": {
          "type": "string"
        }
      }
    },
    "DashboardDescriptor": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "rootCompId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": false,
          "shouldCollect": false,
          "referencedMap": "components"
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "routePath": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideInSidebar": {
          "type": "boolean"
        },
        "activeSidebarPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "isRoutePathConnectedToTitle": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "PanelDescriptor": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "devCenterPanelId": {
          "type": [
            "string",
            "null"
          ]
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "kind": {
          "type": "string",
          "enum": [
            "settings"
          ]
        },
        "helpId": {
          "type": "string",
          "maxLength": 100
        },
        "pageUrl": {
          "type": "string",
          "minLength": 1,
          "maxLength": 2048
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "defaultSize": {
          "type": "object",
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            }
          }
        },
        "rootCompId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": false,
          "shouldCollect": false,
          "referencedMap": "components"
        }
      }
    },
    "VariationDescriptor": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string"
        },
        "rootCompId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": false,
          "shouldCollect": false,
          "referencedMap": "components"
        }
      }
    },
    "PresetDescriptor": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "presetId": {
          "type": "string",
          "maxLength": 100
        },
        "name": {
          "type": "string",
          "maxLength": 100
        },
        "defaultSize": {
          "type": "object",
          "minProperties": 1,
          "properties": {
            "width": {
              "$ref": "UnitSize"
            },
            "height": {
              "$ref": "UnitSize"
            }
          }
        }
      }
    },
    "FlatTheme": {
      "type": "object",
      "isPermanentDataNode": true,
      "properties": {
        "THEME_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "BG_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "CONTACT_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "NETWORKS_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "PAGES_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "WEB_THEME_DIRECTORY": {
          "type": "string",
          "format": "webThemeUrl",
          "default": "base"
        },
        "BASE_THEME_DIRECTORY": {
          "type": "string",
          "format": "webThemeUrl",
          "default": "base"
        },
        "font": {
          "type": "string",
          "format": "font-family",
          "default": "Arial,sans-serif"
        },
        "bgId": {
          "type": "string",
          "default": "BG_USES_THEME_IMAGE"
        },
        "bgSize": {
          "type": "string",
          "default": ","
        },
        "bgType": {
          "type": "string",
          "default": "BG_USES_THEME_IMAGE"
        },
        "siteBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "mobileBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "siteBgColor": {
          "type": "string",
          "format": "color",
          "default": "0,0,0,1"
        },
        "headerTextColor": {
          "type": "string",
          "format": "color",
          "default": "255,255,255,1"
        },
        "headerBgColor": {
          "type": "string",
          "format": "color",
          "default": "0,0,0,0"
        },
        "textColor": {
          "type": "string",
          "format": "color",
          "default": "255,255,255,1"
        },
        "areaBgColor": {
          "type": "string",
          "format": "color",
          "default": "130,81,13,1"
        },
        "iconBgColor": {
          "type": "string",
          "format": "color",
          "default": "255,255,255,1"
        },
        "borderColor": {
          "type": "string",
          "format": "color",
          "default": "255,255,255,1"
        },
        "fontHeader": {
          "type": "string",
          "format": "font",
          "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}"
        },
        "fontTitle": {
          "type": "string",
          "format": "font",
          "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}"
        },
        "fontSubTitle": {
          "type": "string",
          "format": "font",
          "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}"
        },
        "fontButton": {
          "type": "string",
          "format": "font",
          "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}"
        },
        "fontText": {
          "type": "string",
          "format": "font",
          "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}"
        },
        "fontSmallText": {
          "type": "string",
          "format": "font",
          "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}"
        },
        "borderContainer": {
          "type": "string",
          "format": "border",
          "default": "0.15em solid [borderColor]"
        },
        "borderThumb": {
          "type": "string",
          "format": "border",
          "default": "0.15em solid [borderColor]"
        },
        "borderButton": {
          "type": "string",
          "format": "border",
          "default": "0.15em solid [borderColor]"
        },
        "borderIcon": {
          "type": "string",
          "format": "border",
          "default": "0.15em solid [borderColor]"
        },
        "radiusContainer": {
          "type": "string",
          "format": "radius",
          "default": "0.6em 0.6em 0.6em 0.6em"
        },
        "radiusThumb": {
          "type": "string",
          "format": "radius",
          "default": "0.6em 0.6em 0.6em 0.6em"
        },
        "radiusButton": {
          "type": "string",
          "format": "radius",
          "default": "0.6em 0.6em 0.6em 0.6em"
        },
        "radiusIcon": {
          "type": "string",
          "format": "radius",
          "default": "0.6em 0.0em 0.0em 0.6em"
        },
        "padding1": {
          "type": "string",
          "format": "padding",
          "default": "1em 1em 1em 1em"
        },
        "padding2": {
          "type": "string",
          "format": "padding",
          "default": "0.0em 0.5em 0.0em 0.5em"
        },
        "padding3": {
          "type": "string",
          "format": "padding",
          "default": "1.0em 0.0em 1.0em 0.0em"
        },
        "iconSize": {
          "format": "cssMeasure",
          "default": "3.2"
        },
        "bulletSize": {
          "format": "cssMeasure",
          "default": "1.5"
        },
        "headerSpacing": {
          "format": "cssMeasure",
          "default": "0em"
        },
        "componentSpacing": {
          "format": "cssMeasure",
          "default": "0.45em"
        },
        "itemSpacing": {
          "format": "cssMeasure",
          "default": "0.75em"
        },
        "thumbSpacing": {
          "format": "cssMeasure",
          "default": "0.23em"
        },
        "iconSpacing": {
          "format": "cssMeasure",
          "default": "0.75em"
        }
      },
      "isTopLevelDataNode": true
    },
    "Image": {
      "allOf": [
        {
          "$ref": "Common_Image"
        },
        {
          "type": "object",
          "properties": {
            "a11y": {
              "type": [
                "null",
                "string"
              ],
              "pseudoType": [
                "ref"
              ],
              "refTypes": [
                "ImageA11y"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "ImageA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ImageReference": {
      "type": [
        "null",
        "string"
      ],
      "pseudoType": [
        "ref"
      ],
      "refTypes": [
        "Image"
      ],
      "isTopLevelDataNode": false
    },
    "GlobalImageQuality": {
      "isPermanentDataNode": true,
      "$ref": "ImageQuality",
      "isTopLevelDataNode": true
    },
    "ImageQuality": {
      "type": "object",
      "properties": {
        "quality": {
          "$ref": "urn:dm:schemas:common.json#/Int",
          "minimum": 0,
          "maximum": 100
        },
        "unsharpMask": {
          "type": "object",
          "minProperties": 3,
          "additionalProperties": false,
          "properties": {
            "radius": {
              "type": "number",
              "minimum": 0,
              "maximum": 500
            },
            "amount": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "threshold": {
              "type": "number",
              "minimum": 0,
              "maximum": 255
            }
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "ClassicSectionA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": {
          "type": "number"
        }
      }
    },
    "StripColumnsContainerA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": {
          "$ref": "urn:dm:schemas:common.json#/JavaInt"
        }
      }
    },
    "StripColumnsContainer": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "StripColumnsContainerA11y"
          ]
        },
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      },
      "isTopLevelDataNode": true
    },
    "ClassicSection": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ClassicSectionA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "StripContainer": {
      "type": "object",
      "properties": {
        "background": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "ImageList": {
      "type": "object",
      "properties": {
        "items": {
          "type": [
            "null",
            "array"
          ],
          "default": [],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "direction": {
          "$ref": "Direction",
          "description": "direction of the component"
        }
      },
      "isTopLevelDataNode": true
    },
    "Link": {
      "type": "object",
      "properties": {
        "linkType": {
          "$ref": "LinkType"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "TextLink": {
      "type": "object",
      "isPermanentDataNode": true,
      "isTopLevelDataNode": true,
      "properties": {
        "linkType": {
          "$ref": "LinkType"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        }
      }
    },
    "AnchorLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "anchorName": {
          "type": "string"
        },
        "anchorDataId": {
          "anyOf": [
            {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "weakRef",
                "string"
              ],
              "shouldCollect": false,
              "shouldValidate": false,
              "referencedMap": "#"
            },
            {
              "enum": [
                "SCROLL_TO_TOP"
              ]
            }
          ]
        },
        "pageId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": false,
          "referencedMap": "#"
        },
        "rel": {
          "$ref": "LinkRelAttribute"
        }
      }
    },
    "DocumentLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "docId": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "indexable": {
          "type": "boolean"
        }
      }
    },
    "PhoneLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "phoneNumber": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "WhatsAppLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "phoneNumber": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "AddressLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "address": {
          "type": "string",
          "maxLength": 200
        }
      }
    },
    "EmailLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "recipient": {
          "type": "string",
          "description": "Email address of the recipient."
        },
        "subject": {
          "type": "string",
          "description": "Subject of the email."
        },
        "body": {
          "type": "string",
          "description": "Body or content of the email."
        }
      }
    },
    "FormSubmitButtonLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "ExternalLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "url": {
          "allOf": [
            {
              "type": "string"
            },
            {
              "not": {
                "type": "string",
                "pattern": ".*script://.*"
              }
            }
          ],
          "description": "URL of the external link."
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_blank",
          "description": "Specifies where to open the linked document."
        },
        "rel": {
          "$ref": "LinkRelAttribute",
          "default": [
            "noreferrer",
            "noopener"
          ],
          "description": "Specifies the relationship between the current document and the linked document."
        }
      }
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": [],
      "isTopLevelDataNode": false
    },
    "DynamicPageLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "routerId": {
          "type": "string"
        },
        "innerRoute": {
          "type": "string"
        },
        "anchorDataId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": false,
          "referencedMap": "#"
        },
        "isTpaRoute": {
          "type": "boolean"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self"
        },
        "rel": {
          "$ref": "LinkRelAttribute"
        }
      }
    },
    "TpaPageLink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "itemTypeIdentifier": {
          "type": "string"
        },
        "itemId": {
          "type": "string"
        },
        "pageId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": false,
          "referencedMap": "#"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "path": {
          "type": "string"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self"
        },
        "rel": {
          "$ref": "LinkRelAttribute"
        }
      },
      "required": [
        "itemTypeIdentifier",
        "itemId",
        "pageId",
        "appDefinitionId",
        "path"
      ]
    },
    "LoginToWixLink": {
      "type": "object",
      "properties": {
        "postLoginUrl": {
          "type": "string"
        },
        "postSignupUrl": {
          "type": "string"
        },
        "dialog": {
          "type": "string",
          "enum": [
            "createUser",
            "login",
            "showLogin"
          ],
          "default": "login"
        },
        "sendMail": {
          "type": "boolean",
          "default": true
        },
        "mailTemplate": {
          "type": "string"
        },
        "userColor": {
          "type": "string"
        },
        "loginCompName": {
          "type": "string",
          "default": ""
        }
      },
      "isTopLevelDataNode": true
    },
    "PageLink": {
      "type": "object",
      "properties": {
        "pageId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": false,
          "referencedMap": "#",
          "description": "Page ID of the page to link to."
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self",
          "description": "Specifies where to open the linked document."
        },
        "rel": {
          "$ref": "LinkRelAttribute",
          "description": "Specifies the relationship between the current document and the linked document."
        }
      },
      "isTopLevelDataNode": true
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "MediaRichText": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 120000
        },
        "stylesMapId": {
          "type": "string"
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "pseudoType": [
            "refList"
          ]
        },
        "componentDataList": {
          "type": [
            "array",
            "null"
          ],
          "pseudoType": [
            "refList"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "Page": {
      "type": "object",
      "dataClassRef": "core.datatypes.PageDataClass",
      "properties": {
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideTitle": {
          "type": "boolean"
        },
        "icon": {
          "type": "string"
        },
        "windowTitle": {
          "type": "string",
          "minLength": 1,
          "maxLength": 512
        },
        "descriptionSEO": {
          "type": "string",
          "maxLength": 1024
        },
        "advancedSeoData": {
          "type": "string",
          "maxLength": 10000
        },
        "metaKeywordsSEO": {
          "type": "string",
          "maxLength": 512
        },
        "pageTitleSEO": {
          "type": "string"
        },
        "pageUriSEO": {
          "type": "string"
        },
        "hidePage": {
          "type": "boolean"
        },
        "underConstruction": {
          "type": "boolean"
        },
        "tpaApplicationId": {
          "type": "number"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "managingAppDefId": {
          "type": [
            "string",
            "null"
          ]
        },
        "tpaPageId": {
          "type": "string"
        },
        "parentPageId": {
          "type": [
            "string",
            "null"
          ],
          "isRefOwner": false,
          "shouldCollect": false,
          "shouldValidate": true,
          "refTypes": [
            "Page",
            "AppPage"
          ],
          "referencedMap": "#",
          "pseudoType": [
            "weakRef"
          ]
        },
        "pageSecurity": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "requireLogin": {
              "type": "boolean"
            },
            "passwordDigest": {
              "type": "string"
            },
            "dialogLanguage": {
              "type": "string"
            }
          },
          "default": {
            "requireLogin": false,
            "passwordDigest": "",
            "dialogLanguage": ""
          }
        },
        "indexable": {
          "type": "boolean",
          "default": true
        },
        "mobileHidePage": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "pseudoType": [
                    "ref"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              }
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ],
                  "default": "viewport"
                },
                "ref": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "pseudoType": [
                    "ref"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              }
            }
          }
        },
        "isLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isMobileLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isPopup": {
          "type": "boolean",
          "default": false
        },
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": {
              "type": "boolean",
              "default": false
            }
          }
        },
        "ogImage": {
          "type": [
            "string",
            "null"
          ]
        },
        "ogImageRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        }
      },
      "isTopLevelDataNode": true
    },
    "Text": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 4000
        }
      },
      "isTopLevelDataNode": true
    },
    "RichText": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 120000,
          "default": ""
        },
        "defaultStyle": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "RichTextImage": {
      "type": "object",
      "properties": {
        "text": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "image": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BaseInput": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      },
      "isTopLevelDataNode": true
    },
    "BaseTextInput": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "value": {
              "type": "string",
              "default": "",
              "maxLength": 4000
            }
          }
        },
        {
          "$ref": "BaseInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TextInputA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "invalid": {
          "type": "boolean"
        },
        "multiline": {
          "type": "boolean"
        },
        "autocomplete": {
          "type": "boolean"
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": {
          "type": "boolean"
        }
      }
    },
    "TextInput": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "errorDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "textType": {
              "type": "string",
              "default": "text",
              "enum": [
                "text",
                "email",
                "url",
                "number",
                "tel",
                "password"
              ],
              "description": "input data type"
            },
            "maxLength": {
              "type": [
                "number",
                "null"
              ],
              "description": "maximum number of characters allowed"
            },
            "min": {
              "type": [
                "number",
                "null"
              ],
              "minimum": -2147483648,
              "maximum": 2147483647,
              "description": "minimum allowed value for a numeric type field"
            },
            "max": {
              "type": [
                "number",
                "null"
              ],
              "minimum": -2147483648,
              "maximum": 2147483647,
              "description": "maximum allowed value for a numeric type field"
            },
            "pattern": {
              "type": [
                "string",
                "null"
              ],
              "description": "specifies a regular expression against which the control's value will be validate",
              "maxLength": 500
            },
            "phoneFormat": {
              "type": [
                "string",
                "null"
              ],
              "description": "specifies a phone number format against which the control's value will be validated",
              "pattern": "^#*(((#+-)*)#+$)",
              "maxLength": 100
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "placeholder": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 4000,
              "description": "the placeholder option in case nothing is selected"
            },
            "a11y": {
              "type": [
                "null",
                "string"
              ],
              "pseudoType": [
                "ref"
              ],
              "refTypes": [
                "TextInputA11y"
              ]
            },
            "prefix": {
              "type": [
                "null",
                "string"
              ],
              "maxLength": 10
            },
            "step": {
              "type": "number"
            },
            "autoComplete": {
              "type": [
                "null",
                "string"
              ],
              "maxLength": 400
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ],
      "not": {
        "required": [
          "pattern",
          "phoneFormat"
        ]
      }
    },
    "TextAreaInput": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "errorDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "maxLength": {
              "type": [
                "number"
              ],
              "description": "maximum number of characters allowed"
            },
            "label": {
              "type": [
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "placeholder": {
              "type": [
                "string"
              ],
              "maxLength": 4000,
              "description": "the placeholder option in case nothing is selected"
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ]
    },
    "CheckboxInput": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "checked": {
              "$ref": "urn:dm:schemas:common.json#/JavaBool",
              "description": "The checked status of the input"
            },
            "linkLabel": {
              "type": "string",
              "default": "",
              "maxLength": 1000
            },
            "link": {
              "$ref": "LinkReference"
            },
            "label": {
              "type": "string",
              "default": "",
              "maxLength": 4000
            },
            "indeterminate": {
              "$ref": "urn:dm:schemas:common.json#/JavaBool",
              "description": "Used for three state check box"
            },
            "direction": {
              "$ref": "Direction",
              "description": "direction of the component"
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "DateItem": {
      "type": "string",
      "format": "date-time",
      "isTopLevelDataNode": false
    },
    "DateString": {
      "type": "string",
      "format": "date",
      "isTopLevelDataNode": false
    },
    "DateRange": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "startDate": {
          "$ref": "DateString"
        },
        "endDate": {
          "$ref": "DateString"
        }
      },
      "required": [
        "startDate",
        "endDate"
      ],
      "isTopLevelDataNode": false
    },
    "DateRanges": {
      "type": "array",
      "default": [],
      "items": {
        "$ref": "DateRange"
      },
      "isTopLevelDataNode": false
    },
    "DatePicker": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "disabledDates": {
              "type": "array",
              "items": {
                "$ref": "DateItem"
              },
              "default": [],
              "description": "array of disabled dates"
            },
            "disabledDaysOfWeek": {
              "type": "array",
              "items": {
                "type": [
                  "number"
                ],
                "enum": [
                  0,
                  1,
                  2,
                  3,
                  4,
                  5,
                  6
                ]
              },
              "default": [],
              "description": "array of disabled days"
            },
            "minDate": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "DateItem"
                }
              ],
              "description": "date input minimum date value"
            },
            "maxDate": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "DateItem"
                }
              ],
              "description": "date input maximum date value"
            },
            "allowPastDates": {
              "type": "boolean",
              "default": true,
              "description": "if true all past days are enabled, false otherwise"
            },
            "allowFutureDates": {
              "type": "boolean",
              "default": true,
              "description": "if true all future days are enabled, false otherwise"
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "placeholder": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 200,
              "description": "the placeholder option in case nothing is selected"
            },
            "enabledDateRanges": {
              "$ref": "DateRanges",
              "description": "array of enabled dates. each date in the format YYYY/MM/DD"
            },
            "disabledDateRanges": {
              "$ref": "DateRanges",
              "description": "array of disabled dates. each date in the format YYYY/MM/DD"
            }
          }
        },
        {
          "$ref": "BaseInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "Theme": {
      "type": [
        "object",
        "null"
      ],
      "isPermanentDataNode": true,
      "properties": {
        "properties": {
          "type": [
            "object",
            "null"
          ],
          "additionalProperties": true,
          "default": {}
        }
      },
      "isTopLevelDataNode": true
    },
    "TwitterFollow": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "accountToFollow": {
          "type": "string",
          "default": "wix"
        }
      }
    },
    "TwitterTweet": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "defaultText": {
          "type": "string"
        },
        "accountToFollow": {
          "type": "string"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "$ref": "UrlFormat"
        }
      }
    },
    "MobileMetaData": {
      "type": "object",
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      },
      "required": [
        "adaptiveMobileOn"
      ],
      "isTopLevelDataNode": false
    },
    "Preloader": {
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      },
      "required": [
        "enabled",
        "uri"
      ],
      "isTopLevelDataNode": false
    },
    "ContactInfo": {
      "type": "object",
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      },
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "isTopLevelDataNode": false
    },
    "SocialLink": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      },
      "required": [
        "id",
        "url"
      ],
      "isTopLevelDataNode": false
    },
    "QuickActions": {
      "type": "object",
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          }
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "$ref": "SocialLink"
          },
          "default": []
        }
      },
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "isTopLevelDataNode": false
    },
    "QuickActionBarItem": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "itemType": {
          "maxLength": 50,
          "type": "string"
        },
        "text": {
          "maxLength": 40,
          "type": "string",
          "default": ""
        },
        "icon": {
          "maxLength": 200,
          "type": "string",
          "default": ""
        }
      },
      "required": [
        "itemType"
      ],
      "isTopLevelDataNode": true
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      },
      "isTopLevelDataNode": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      },
      "isTopLevelDataNode": false
    },
    "Anchor": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "compId": {
          "type": "string"
        },
        "urlFragment": {
          "type": "string",
          "maxLength": 60
        }
      },
      "isTopLevelDataNode": true
    },
    "BasicMenuItem": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "items": {
          "type": [
            "array",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldCollect": true,
          "shouldValidate": true,
          "isRefOwner": true,
          "referencedMap": "#",
          "refTypes": [
            "BasicMenuItem"
          ]
        },
        "slot": {
          "type": "string"
        },
        "label": {
          "type": "string"
        },
        "isVisible": {
          "type": "boolean",
          "default": true
        },
        "isVisibleMobile": {
          "type": "boolean",
          "default": true
        },
        "displayCount": {
          "$ref": "urn:dm:schemas:common.json#/NullableInt"
        },
        "iconRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "VectorImage"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "CustomMenu": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string"
        },
        "menuType": {
          "type": "string",
          "maxLength": 100
        },
        "syncWithPages": {
          "type": "boolean",
          "default": false
        },
        "appId": {
          "$ref": "urn:dm:schemas:common.json#/JavaInt"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "items": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "BasicMenuItem"
          ]
        }
      }
    },
    "CustomMenusCollection": {
      "type": "object",
      "isPermanentDataNode": true,
      "properties": {
        "menus": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "CustomMenu",
            "Builder.MenuItems"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "CustomMenuDataRef": {
      "type": "object",
      "properties": {
        "menuRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "default": "#CUSTOM_MAIN_MENU",
          "shouldCollect": false,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "CustomMenu"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "CustomMenuDataRefA11y"
          ]
        },
        "direction": {
          "$ref": "Direction",
          "description": "direction of the component"
        },
        "itemDirection": {
          "$ref": "Direction",
          "description": "direction of the 1st (top) level menu items"
        },
        "submenuDirection": {
          "$ref": "Direction",
          "description": "direction of the 2nd level menu item (submenu)"
        },
        "submenuSubItemDirection": {
          "$ref": "Direction",
          "description": "direction of the 3rd level menu item (submenuSubItem)"
        }
      },
      "isTopLevelDataNode": true
    },
    "CustomMenuDataRefA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "Menu": {
      "type": "object",
      "isPermanentDataNode": true,
      "properties": {
        "items": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": []
        }
      },
      "isTopLevelDataNode": true
    },
    "FacebookLikeBox": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "facebookPageId": {
          "type": "string",
          "default": "wix",
          "description": "Facebook page id"
        },
        "showFaces": {
          "type": "boolean",
          "default": true,
          "description": "Show profile photos in the plugin"
        },
        "colorScheme": {
          "type": "string",
          "default": "light",
          "enum": [
            "light",
            "dark"
          ],
          "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
        },
        "showStream": {
          "type": "boolean",
          "default": true,
          "description": "Show the profile stream for the public profile"
        },
        "showBorder": {
          "type": "boolean",
          "default": true,
          "description": "Show a border around the plugin"
        },
        "showHeader": {
          "type": "boolean",
          "default": true,
          "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
        }
      }
    },
    "ImageButtonA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ImageButton": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "alt": {
          "type": "string"
        },
        "a11y": {
          "referencedMap": "#",
          "shouldCollect": true,
          "shouldValidate": true,
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ImageButtonA11y"
          ]
        },
        "defaultImage": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "hoverImage": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "activeImage": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "NumericStepper": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "default": "1"
        }
      },
      "isTopLevelDataNode": true
    },
    "PinItPinWidget": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "pinId": {
          "type": "string",
          "default": "http://www.pinterest.com/pin/204421270560540859/"
        }
      }
    },
    "PinterestPinIt": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "uri": {
          "type": "string",
          "default": ""
        },
        "description": {
          "type": "string",
          "default": "Check it out!"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "$ref": "UrlFormat"
        }
      }
    },
    "SingleAudioPlayer": {
      "type": "object",
      "properties": {
        "uri": {
          "type": "string",
          "default": "",
          "description": "MP3 uri"
        },
        "originalFileName": {
          "type": "string",
          "default": "",
          "description": "Original MP3 file name"
        },
        "artist": {
          "type": "string",
          "default": "Unknown Artist",
          "description": "Artist Name"
        },
        "track": {
          "type": "string",
          "default": "Unknown Track",
          "description": "Track Name"
        }
      },
      "isTopLevelDataNode": true
    },
    "SkypeCallButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "skypeName": {
          "type": "string"
        },
        "buttonType": {
          "type": "string",
          "enum": [
            "call",
            "chat"
          ],
          "default": "call"
        }
      }
    },
    "SpotifyFollow": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "uri": {
          "type": "string",
          "default": ""
        }
      }
    },
    "SpotifyPlayer": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "uri": {
          "type": "string",
          "default": "",
          "description": "Spotify URI"
        }
      }
    },
    "SubscribeForm": {
      "type": "object",
      "properties": {
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "firstNameFieldLabel": {
          "type": "string",
          "default": "First Name"
        },
        "lastNameFieldLabel": {
          "type": "string",
          "default": "Last Name"
        },
        "emailFieldLabel": {
          "type": "string",
          "default": "Email"
        },
        "phoneFieldLabel": {
          "type": "string",
          "default": "Mobile number"
        },
        "subscribeFormTitle": {
          "type": "string",
          "default": "Subscribe for Updates"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Subscribe Now"
        },
        "successMessage": {
          "type": "string",
          "default": "Congrats! You’re subscribed"
        },
        "errorMessage": {
          "type": "string",
          "default": "Forgot your email? Try again."
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "To subscribe please fill in all the required info"
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "$ref": "LinkReference"
        }
      },
      "isTopLevelDataNode": true
    },
    "YouTubeSubscribeButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "youtubeChannelId": {
          "type": "string",
          "default": "wix",
          "description": "youtube channel id"
        }
      }
    },
    "AudioPlayer": {
      "type": "object",
      "properties": {
        "uri": {
          "type": "string",
          "default": ""
        },
        "autoPlay": {
          "type": "boolean",
          "default": false
        },
        "loop": {
          "type": "boolean",
          "default": false
        },
        "visible": {
          "type": "boolean",
          "default": true
        },
        "volume": {
          "type": "number",
          "default": 100
        },
        "title": {
          "type": "string",
          "default": ""
        },
        "description": {
          "type": "string",
          "default": ""
        },
        "icon_uri": {
          "type": "string",
          "default": ""
        },
        "originalFileName": {
          "type": "string",
          "default": ""
        },
        "showToolTip": {
          "$ref": "urn:dm:schemas:common.json#/JavaBool"
        }
      },
      "isTopLevelDataNode": true
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      },
      "isTopLevelDataNode": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      },
      "isTopLevelDataNode": false
    },
    "Grid": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "dataSource": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "static",
                "dynamic"
              ]
            },
            "revision": {
              "type": "number",
              "multipleOf": 1
            }
          }
        },
        "rows": {
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "rowsCount": {
          "type": "number"
        },
        "revision": {
          "type": "number"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ContactForm": {
      "type": "object",
      "properties": {
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "nameFieldLabel": {
          "type": "string",
          "default": "Name"
        },
        "emailFieldLabel": {
          "type": "string",
          "default": "Email"
        },
        "phoneFieldLabel": {
          "type": "string",
          "default": "Phone"
        },
        "addressFieldLabel": {
          "type": "string",
          "default": "Address"
        },
        "subjectFieldLabel": {
          "type": "string",
          "default": "Subject"
        },
        "messageFieldLabel": {
          "type": "string",
          "default": "Message"
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Send"
        },
        "successMessage": {
          "type": "string",
          "default": "Your details were sent successfully!"
        },
        "errorMessage": {
          "type": "string",
          "default": "Please provide a valid email"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "Please fill in all required fields."
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "$ref": "LinkReference"
        }
      },
      "isTopLevelDataNode": true
    },
    "DynamicContactForm": {
      "type": "object",
      "properties": {
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Send"
        },
        "successMessage": {
          "type": "string",
          "default": "Your details were sent successfully!"
        },
        "errorMessage": {
          "type": "string",
          "default": "Please provide a valid email"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "Please fill in all required fields."
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "$ref": "LinkReference"
        },
        "formName": {
          "type": "string",
          "default": ""
        },
        "dynamicFields": {
          "type": "array",
          "default": [
            {
              "name": "email",
              "inputType": "email",
              "displayLabel": "Email",
              "required": true
            },
            {
              "name": "name",
              "inputType": "text",
              "displayLabel": "Name",
              "required": true
            },
            {
              "name": "subject",
              "inputType": "text",
              "displayLabel": "Subject",
              "required": false
            },
            {
              "name": "message",
              "inputType": "text",
              "displayLabel": "Message",
              "required": false
            }
          ],
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string",
                "maxLength": 50
              },
              "inputType": {
                "type": "string",
                "maxLength": 50
              },
              "displayLabel": {
                "type": "string",
                "maxLength": 200
              },
              "required": {
                "$ref": "urn:dm:schemas:common.json#/JavaBool"
              },
              "displayed": {
                "$ref": "urn:dm:schemas:common.json#/JavaBool"
              }
            }
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "EbayItemsBySeller": {
      "type": "object",
      "properties": {
        "sellerId": {
          "type": "string"
        },
        "registrationSite": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "FacebookShareButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "urlChoice": {
          "type": "string",
          "enum": [
            "Current page",
            "Site"
          ],
          "default": "Current page",
          "description": "Share: current/site url"
        },
        "label": {
          "type": "string",
          "default": "Share",
          "description": ""
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "$ref": "UrlFormat"
        }
      }
    },
    "FlashComponent": {
      "type": "object",
      "properties": {
        "linkType": {
          "$ref": "LinkType"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "uri": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "maxLength": 1000
        },
        "height": {
          "type": "number",
          "default": 0
        },
        "width": {
          "type": "number",
          "default": 0
        },
        "placeHolderImage": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FlickrBadgeWidget": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "userId": {
          "type": "string",
          "default": "74009459@N07"
        },
        "userName": {
          "type": "string"
        },
        "tag": {
          "type": "string"
        },
        "imageCount": {
          "type": [
            "string",
            "number"
          ],
          "default": 3
        },
        "whichImages": {
          "type": "string",
          "default": "latest"
        },
        "imageSize": {
          "type": "string",
          "default": "t"
        },
        "layoutOrientation": {
          "type": "string",
          "default": "v"
        }
      }
    },
    "GeoMapLocation": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "address": {
          "type": "string",
          "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
          "maxLength": 1000
        },
        "latitude": {
          "type": "number",
          "default": 37.77065
        },
        "longitude": {
          "type": "number",
          "default": -122.387301
        },
        "title": {
          "type": "string",
          "default": "Wix Office",
          "maxLength": 10000
        },
        "description": {
          "type": "string",
          "default": "Wix HQ",
          "maxLength": 350
        },
        "link": {
          "$ref": "LinkReference"
        },
        "linkTitle": {
          "type": "string",
          "default": "Visit Wix's Site",
          "maxLength": 140
        },
        "pinIcon": {
          "type": "string",
          "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
          "maxLength": 1000
        },
        "pinColor": {
          "type": "string",
          "default": "#2A3688",
          "maxLength": 20
        }
      }
    },
    "GeoMap": {
      "type": "object",
      "properties": {
        "language": {
          "type": "string",
          "enum": [
            "af",
            "sq",
            "am",
            "ar",
            "hy",
            "az",
            "eu",
            "be",
            "bn",
            "bs",
            "bg",
            "my",
            "ca",
            "zh",
            "zh-CN",
            "zh-HK",
            "zh-TW",
            "hr",
            "cs",
            "da",
            "nl",
            "en",
            "en-AU",
            "en-GB",
            "et",
            "fa",
            "fi",
            "fil",
            "fr",
            "fr-CA",
            "gl",
            "ka",
            "de",
            "el",
            "gu",
            "iw",
            "hi",
            "hu",
            "is",
            "id",
            "it",
            "ja",
            "kn",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "lv",
            "lt",
            "mk",
            "ms",
            "ml",
            "mr",
            "mn",
            "ne",
            "no",
            "pl",
            "pt",
            "pt-BR",
            "pt-PT",
            "pa",
            "ro",
            "ru",
            "sr",
            "si",
            "sk",
            "sl",
            "es",
            "es-419",
            "sw",
            "sv",
            "ta",
            "te",
            "th",
            "tr",
            "uk",
            "ur",
            "uz",
            "vi",
            "zu"
          ]
        },
        "locations": {
          "type": [
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "minItems": 0,
          "refTypes": [
            "GeoMapLocation"
          ]
        },
        "address": {
          "type": "string",
          "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
        },
        "latitude": {
          "type": "number",
          "default": 37.77065
        },
        "longitude": {
          "type": "number",
          "default": -122.387301
        },
        "addressInfo": {
          "type": "string",
          "default": "Wix Office"
        },
        "defaultLocation": {
          "type": "number",
          "default": 0
        },
        "mapStyle": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "elementType": {
                "type": "string",
                "enum": [
                  "all",
                  "geometry",
                  "geometry.fill",
                  "geometry.stroke",
                  "labels",
                  "labels.icon",
                  "labels.text",
                  "labels.text.fill",
                  "labels.text.stroke"
                ],
                "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
              },
              "featureType": {
                "type": "string",
                "enum": [
                  "administrative",
                  "administrative.country",
                  "administrative.land_parcel",
                  "administrative.locality",
                  "administrative.neighborhood",
                  "administrative.province",
                  "all",
                  "landscape",
                  "landscape.man_made",
                  "landscape.natural",
                  "landscape.natural.landcover",
                  "landscape.natural.terrain",
                  "poi",
                  "poi.attraction",
                  "poi.business",
                  "poi.government",
                  "poi.medical",
                  "poi.park",
                  "poi.place_of_worship",
                  "poi.school",
                  "poi.sports_complex",
                  "road",
                  "road.arterial",
                  "road.highway",
                  "road.highway.controlled_access",
                  "road.local",
                  "transit",
                  "transit.line",
                  "transit.station",
                  "transit.station.airport",
                  "transit.station.bus",
                  "transit.station.rail",
                  "water"
                ],
                "description": "Selects the feature, or group of features, to which a styler should be applied."
              },
              "stylers": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "color": {
                      "type": "string",
                      "maxLength": 100,
                      "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                    },
                    "gamma": {
                      "type": "number",
                      "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                    },
                    "hue": {
                      "type": "string",
                      "maxLength": 100,
                      "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                    },
                    "invert_lightness": {
                      "type": "boolean",
                      "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                    },
                    "lightness": {
                      "type": "number",
                      "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                    },
                    "saturation": {
                      "type": "number",
                      "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                    },
                    "visibility": {
                      "type": "string",
                      "enum": [
                        "on",
                        "off",
                        "simplified"
                      ],
                      "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                    },
                    "weight": {
                      "type": "number",
                      "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                    }
                  },
                  "maxProperties": 1,
                  "additionalProperties": false,
                  "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array."
                }
              }
            },
            "required": [
              "stylers"
            ]
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "HtmlComponent": {
      "type": "object",
      "properties": {
        "sourceType": {
          "type": "string",
          "default": ""
        },
        "url": {
          "type": "string",
          "default": ""
        },
        "title": {
          "type": "string"
        },
        "freezeFrame": {
          "type": "boolean",
          "default": false
        },
        "allowFullScreen": {
          "type": "boolean",
          "default": false
        },
        "componentConsentPolicy": {
          "type": "string",
          "default": "essential",
          "enum": [
            "essential",
            "functional",
            "analytics",
            "advertising",
            "dataToThirdParty"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "DisqusComments": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "disqusId": {
          "type": "string",
          "default": ""
        }
      }
    },
    "ItunesButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "downloadUrl": {
          "type": "string",
          "default": "",
          "description": "Insert band URL"
        }
      }
    },
    "LinkableFlashComponent": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "title": {
          "type": "string"
        },
        "uri": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "height": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "width": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "placeHolderImage": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        }
      }
    },
    "LinkableButton": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "direction": {
          "$ref": "Direction",
          "description": "direction of the component"
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "SiteButtonA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "LoginButton": {
      "type": "object",
      "properties": {
        "language": {
          "type": "string",
          "default": ""
        }
      },
      "isTopLevelDataNode": true
    },
    "TinyMenu": {
      "type": "object",
      "properties": {
        "loginSocialBarRef": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "LoginSocialBar"
          ]
        },
        "menuRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldCollect": false,
          "shouldValidate": false,
          "referencedMap": "#",
          "refTypes": [
            "CustomMenu"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "LoginSocialBar": {
      "type": "object",
      "properties": {
        "menuItemsRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "CustomMenuDataRef"
          ]
        },
        "iconItemsRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "CustomMenuDataRef"
          ]
        },
        "language": {
          "type": "string",
          "default": "en",
          "maxLength": 10
        },
        "loggedInMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText",
            "memberInitials"
          ],
          "default": "avatarAndText"
        },
        "loggedOutMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText"
          ]
        },
        "loggedInAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedOutAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ],
          "default": "profileImage"
        },
        "loggedInCustomAvatar": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "loggedOutCustomAvatar": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "loggedOutText": {
          "type": "string",
          "default": "Log In",
          "maxLength": 50
        },
        "showLoggedInText": {
          "type": "boolean",
          "default": true
        },
        "loggedInTextState": {
          "type": "string",
          "enum": [
            "memberName",
            "custom"
          ]
        },
        "loggedInText": {
          "type": "string",
          "default": "Hello",
          "maxLength": 50
        },
        "customLoggedInText": {
          "type": "string",
          "maxLength": 50
        },
        "logOutText": {
          "type": "string",
          "default": "Log Out",
          "maxLength": 50
        }
      },
      "isTopLevelDataNode": true
    },
    "PagesGroupData": {
      "type": "object",
      "properties": {
        "appId": {
          "type": [
            "number",
            "null"
          ]
        },
        "appDefinitionId": {
          "type": "string"
        },
        "groupName": {
          "type": "string"
        },
        "pages": {
          "type": "array",
          "items": {
            "type": "string",
            "pseudoType": [
              "weakRef"
            ],
            "shouldCollect": false,
            "shouldValidate": true,
            "referencedMap": "#",
            "refTypes": [
              "Page",
              "AppPage"
            ]
          },
          "default": []
        }
      },
      "isTopLevelDataNode": true
    },
    "PagesGroupCollection": {
      "type": "object",
      "isPermanentDataNode": true,
      "properties": {
        "groups": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "PagesGroupData"
          ],
          "default": []
        }
      },
      "isTopLevelDataNode": true
    },
    "PayPalButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "merchantID": {
          "type": "string",
          "default": "",
          "description": "some amazing description"
        }
      }
    },
    "PermaLink": {
      "type": "object",
      "required": [
        "appType"
      ],
      "properties": {
        "appType": {
          "enum": [
            "ListsApps",
            "ThirdPartyApps"
          ]
        },
        "dataItemRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "default": ""
        },
        "mutableSeoTitle": {
          "type": "string"
        },
        "correctPermaLinkRef": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      },
      "isPermanentDataNode": true,
      "isTopLevelDataNode": true
    },
    "PinterestFollow": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "urlChoice": {
          "type": "string",
          "default": "pinterest/",
          "description": ""
        },
        "label": {
          "type": "string",
          "default": "Pinterest",
          "description": ""
        }
      }
    },
    "SelectableList": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "$ref": "Direction",
              "description": "direction of the component"
            },
            "labelDirection": {
              "$ref": "Direction",
              "description": "direction of the label"
            },
            "inputDirection": {
              "$ref": "Direction",
              "description": "direction of the input"
            },
            "dropdownDirection": {
              "$ref": "Direction",
              "description": "direction of the dropdown"
            },
            "errorDirection": {
              "$ref": "Direction",
              "description": "direction of the error"
            },
            "options": {
              "type": [
                "null",
                "array"
              ],
              "pseudoType": [
                "refList"
              ],
              "refTypes": [
                "SelectOption"
              ],
              "description": "a list of SelectOption data items",
              "default": []
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "placeholder": {
              "type": "object",
              "properties": {
                "value": {
                  "type": "string",
                  "default": "-1",
                  "description": "the value of the placeholder option",
                  "maxLength": 400
                },
                "text": {
                  "type": "string",
                  "default": "",
                  "description": "the text of the placeholder option",
                  "maxLength": 400
                }
              }
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SelectOption": {
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "text": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "selectedText": {
          "type": "string",
          "maxLength": 400
        },
        "disabled": {
          "type": "boolean"
        },
        "description": {
          "type": "string",
          "maxLength": 100
        }
      },
      "isTopLevelDataNode": true
    },
    "RadioButton": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "label": {
              "type": "string",
              "default": "",
              "maxLength": 400
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RadioGroup": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "optionsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "defaultValue": {
              "type": [
                "null",
                "string"
              ]
            },
            "options": {
              "type": [
                "null",
                "array"
              ],
              "pseudoType": [
                "refList"
              ],
              "refTypes": [
                "RadioButton"
              ],
              "description": "a list of RadioButton data items",
              "default": []
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 400
            },
            "placeholder": {
              "type": "object",
              "properties": {
                "value": {
                  "type": "string",
                  "default": "-1",
                  "description": "the value of the placeholder option",
                  "maxLength": 400
                },
                "text": {
                  "type": "string",
                  "default": "",
                  "description": "the text of the placeholder option",
                  "maxLength": 400
                }
              }
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "CheckboxGroup": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "optionsDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "options": {
              "type": [
                "null",
                "array"
              ],
              "pseudoType": [
                "refList"
              ],
              "refTypes": [
                "CheckboxInput"
              ],
              "description": "a list of CheckboxInput data items",
              "default": []
            },
            "label": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "maxLength": 4000
            }
          }
        },
        {
          "$ref": "BaseInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "FileUploader": {
      "type": "object",
      "properties": {
        "buttonLabel": {
          "type": "string",
          "default": "Upload File",
          "maxLength": 500
        },
        "placeholderLabel": {
          "type": "string",
          "default": "Max File Size 15MG",
          "maxLength": 500
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonLabelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "filesDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "iconPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ],
          "description": "Flex direction"
        }
      },
      "isTopLevelDataNode": true
    },
    "UploadName": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": true
    },
    "SiteButtonA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "pressed": {
          "type": "boolean"
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "menu",
            "dialog",
            "listbox",
            "tree",
            "grid"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        }
      }
    },
    "SiteButton": {
      "type": "object",
      "properties": {
        "linkType": {
          "$ref": "LinkType"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        }
      },
      "isTopLevelDataNode": true
    },
    "SoundCloudWidget": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "url": {
          "type": "string",
          "default": ""
        },
        "showArtWork": {
          "type": "boolean",
          "default": true
        },
        "autoPlay": {
          "type": "boolean",
          "default": false
        },
        "embedSource": {
          "type": "string",
          "default": ""
        }
      }
    },
    "StyledTextA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        }
      }
    },
    "StyledText": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 120000,
          "default": "<p class='font_7'></p>",
          "not": {
            "pattern": "<script"
          }
        },
        "stylesMapId": {
          "type": "string"
        },
        "linkList": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "PageLink",
            "ExternalLink",
            "EmailLink",
            "AnchorLink",
            "DocumentLink",
            "PhoneLink",
            "DynamicPageLink",
            "TextLink",
            "LoginToWixLink",
            "WhatsAppLink",
            "AddressLink",
            "TpaPageLink"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "StyledTextA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        }
      },
      "isTopLevelDataNode": false
    },
    "SvgShape": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "alt": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "VectorImage": {
      "type": "object",
      "properties": {
        "link": {
          "$ref": "LinkReference",
          "description": "Reference to a link associated with the vector image."
        },
        "alt": {
          "type": "string",
          "description": "Alternative text for the vector image (for accessibility purposes).",
          "default": ""
        },
        "decorative": {
          "type": "boolean"
        },
        "title": {
          "type": "string",
          "maxLength": 100,
          "description": "Title or caption for the vector image."
        },
        "svgId": {
          "type": "string",
          "maxLength": 100,
          "description": "Identifier for the SVG image."
        }
      },
      "isTopLevelDataNode": true
    },
    "Video": {
      "type": "object",
      "properties": {
        "videoId": {
          "type": "string"
        },
        "userId": {
          "type": "string"
        },
        "posterImage": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ],
          "default": "YOUTUBE"
        }
      },
      "isTopLevelDataNode": true
    },
    "VKShareButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "style": {
          "type": "string",
          "enum": [
            "Button",
            "ButtonWithoutCounter",
            "Link",
            "LinkWithoutIcon",
            "Icon"
          ],
          "default": "Button",
          "description": "the layout of the button"
        },
        "text": {
          "type": "string",
          "default": "Share",
          "description": "the text of the Button"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "$ref": "UrlFormat"
        }
      }
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object",
          "additionalProperties": true
        },
        "spriteOffset": {
          "type": "object",
          "additionalProperties": true
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "TPAWidget": {
      "type": "object",
      "properties": {
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "some amazing description"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "TPAData"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TPAData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "content": {
          "type": "string",
          "default": "",
          "description": "storage for app data",
          "maxLength": 4000
        }
      }
    },
    "TPAGlobalData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "isPermanentDataNode": true,
      "properties": {
        "content": {
          "type": "string",
          "default": "",
          "description": "storage for app data"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Definition ID"
        }
      }
    },
    "TPA": {
      "type": "object",
      "properties": {
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "referenceId": {
          "type": "string"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "widget id"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TPASection": {
      "type": "object",
      "properties": {
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "TPAData"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TPAMultiSection": {
      "type": "object",
      "properties": {
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "hidden tpaSection part of multi section app"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "TPAData"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "RssButton": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "image": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "link": {
          "$ref": "LinkReference"
        },
        "type": {
          "type": "string"
        }
      }
    },
    "AppPart": {
      "type": "object",
      "properties": {
        "appInnerID": {
          "type": [
            "string",
            "number"
          ]
        },
        "appLogicParams": {
          "type": "object",
          "default": {},
          "additionalProperties": true
        },
        "appLogicCustomizations": {
          "type": "array",
          "items": {
            "$ref": "AppPartCustomization"
          },
          "default": []
        },
        "appPartName": {
          "type": "string"
        },
        "viewName": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "AppPage": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "appPageId": {
              "type": "string",
              "default": ""
            },
            "appInnerID": {
              "type": [
                "string",
                "number"
              ],
              "default": ""
            },
            "appPageType": {
              "type": "string"
            },
            "repeaterPage": {
              "type": "boolean",
              "default": false
            }
          }
        },
        {
          "$ref": "Page"
        }
      ],
      "isTopLevelDataNode": true
    },
    "AppBuilderComponent": {
      "type": "object",
      "properties": {
        "appInnerID": {
          "type": [
            "string",
            "null"
          ]
        },
        "appPartName": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "BoxSlideShow": {
      "type": "object",
      "properties": {
        "direction": {
          "$ref": "Direction",
          "description": "direction of the component"
        }
      },
      "isTopLevelDataNode": true
    },
    "BoxSlideShowSlide": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "StripContainerSlideShow": {
      "type": "object",
      "properties": {
        "direction": {
          "$ref": "Direction",
          "description": "direction of the component"
        }
      },
      "isTopLevelDataNode": true
    },
    "StripContainerSlideShowSlide": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "background": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "VerticalAnchorsMenu": {
      "type": "object",
      "properties": {
        "pageTopLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Page Top"
        },
        "pageBottomLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Page Bottom"
        },
        "hiddenAnchorIds": {
          "type": [
            "null",
            "object"
          ],
          "default": {}
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "bulletPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ],
          "description": "Flex direction"
        }
      },
      "isTopLevelDataNode": true
    },
    "WFacebookComment": {
      "type": "object",
      "properties": {
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "$ref": "UrlFormat"
        }
      },
      "isTopLevelDataNode": true
    },
    "WFacebookLike": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "$ref": "UrlFormat"
        }
      }
    },
    "AppController": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "applicationId": {
          "type": "string",
          "maxLength": 100
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "default": ""
        },
        "controllerType": {
          "type": "string",
          "maxLength": 100
        },
        "settings": {
          "type": "string",
          "maxLength": 6000,
          "pseudoType": [
            "stringifyObject"
          ]
        },
        "externalId": {
          "type": "string",
          "maxLength": 100
        }
      },
      "required": [
        "applicationId",
        "controllerType"
      ]
    },
    "RepeaterA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "none",
            "radiogroup",
            "list",
            "group"
          ]
        }
      }
    },
    "Repeater": {
      "type": "object",
      "properties": {
        "direction": {
          "$ref": "Direction",
          "description": "direction of the component"
        },
        "items": {
          "type": "array",
          "default": [],
          "items": {
            "type": "string"
          },
          "description": "Unique identifiers for items of the repeater"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "RepeaterA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "RepeatedData": {
      "type": "object",
      "description": "data used for the serialization of a component inside a repeater component",
      "properties": {
        "original": {
          "type": "object",
          "additionalProperties": true,
          "description": "the original data item of a component inside a repeater according to the specific component schema"
        },
        "overrides": {
          "type": "object",
          "additionalProperties": true,
          "description": "a map from itemId in a repeater to its data item according to the specific component schema"
        }
      },
      "isTopLevelDataNode": true
    },
    "ImageButtonWithText": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 100
        },
        "icon": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "predefinedClass": {
          "type": "string",
          "maxLength": 20
        }
      },
      "isTopLevelDataNode": true
    },
    "Icon": {
      "type": "object",
      "properties": {
        "url": {
          "type": "string"
        },
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "title": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "WidgetRef": {
      "type": "object",
      "properties": {
        "appDefinitionId": {
          "type": "string"
        },
        "widgetId": {
          "type": "string"
        },
        "variationId": {
          "type": [
            "string",
            "null"
          ]
        },
        "name": {
          "type": "string",
          "maxLength": 100
        }
      },
      "isTopLevelDataNode": true
    },
    "InternalRef": {
      "type": "object",
      "properties": {
        "rootCompId": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": false,
          "referencedMap": "DESKTOP"
        },
        "pageId": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "InternalBlocksRef": {
      "type": "object",
      "properties": {
        "rootCompId": {
          "type": "string"
        },
        "pageId": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "LightboxA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "LightboxContainer": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "LightboxA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "ContainerA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "none",
            "status",
            "alert",
            "nav",
            "list",
            "listitem",
            "tablist",
            "tab",
            "tabpanel",
            "menubar",
            "presentation",
            "heading"
          ]
        },
        "roledescription": {
          "type": "string",
          "maxLength": 100
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ],
          "maxLength": 10
        },
        "hidden": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string",
          "enum": [
            "all",
            "additions",
            "text",
            "removals"
          ]
        }
      }
    },
    "ContainerData": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ContainerA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "MediaBoxData": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ContainerA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "SlotsPlaceholderData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "interfaces": {
          "type": "array",
          "items": {
            "type": "string"
          },
          "maxItems": 20
        }
      },
      "required": [
        "interfaces"
      ]
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK",
      "isTopLevelDataNode": false
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash",
      "isTopLevelDataNode": false
    },
    "MultiStateBoxDataA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "MultiStateBoxData": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "defaultStateId": {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "weakRef"
              ],
              "refTypes": [
                "Component",
                "Container",
                "RefComponent",
                "RepeaterContainer"
              ],
              "shouldValidate": false,
              "shouldCollect": false,
              "referencedMap": "components",
              "default": "FIRST_STATE"
            },
            "selectedStateId": {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "weakRef"
              ],
              "refTypes": [
                "Component",
                "Container",
                "RefComponent",
                "RepeaterContainer"
              ],
              "shouldValidate": false,
              "shouldCollect": false,
              "referencedMap": "components"
            },
            "a11y": {
              "type": [
                "null",
                "string"
              ],
              "pseudoType": [
                "ref"
              ],
              "refTypes": [
                "MultiStateBoxDataA11y"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "AppsInstallState": {
      "type": "object",
      "properties": {
        "stateMap": {
          "type": "object",
          "properties": {},
          "default": {},
          "additionalProperties": {
            "type": "object",
            "properties": {
              "status": {
                "type": "string",
                "enum": [
                  "INSTALLED",
                  "REMOVED"
                ],
                "default": "INSTALLED"
              },
              "version": {
                "type": [
                  "string",
                  "null"
                ],
                "minLength": 1,
                "maxLength": 20
              },
              "codeReferenceId": {
                "type": [
                  "string",
                  "null"
                ],
                "minLength": 1,
                "maxLength": 40
              },
              "overrideCodeReferenceId": {
                "type": [
                  "string",
                  "null"
                ],
                "minLength": 1,
                "maxLength": 40
              }
            },
            "required": [
              "status"
            ]
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "StateBoxA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "StateBox": {
      "type": "object",
      "properties": {
        "a11y": {
          "referencedMap": "#",
          "shouldCollect": true,
          "shouldValidate": true,
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "StateBoxA11y"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "StateBoxStateA11y": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": {
          "referencedMap": "#",
          "shouldCollect": true,
          "shouldValidate": true,
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "StateBoxStateA11y"
          ]
        }
      }
    },
    "Builder.MenuItem": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "items": {
          "type": [
            "array",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldCollect": true,
          "shouldValidate": true,
          "isRefOwner": true,
          "referencedMap": "#",
          "refTypes": [
            "Builder.MenuItem"
          ]
        },
        "container": {
          "type": "string"
        },
        "label": {
          "type": "string"
        },
        "isVisible": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "Builder.MenuItems": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "items": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "Builder.MenuItem"
          ]
        }
      }
    },
    "Builder.Image": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "uri": {
          "type": "string",
          "maxLength": 1000,
          "description": "Identifier or URL for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Human-readable filename to use for the image."
        },
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "crop": {
          "type": "object",
          "properties": {
            "width": {
              "type": "number",
              "minimum": 0
            },
            "height": {
              "type": "number",
              "minimum": 0
            },
            "x": {
              "type": "number",
              "minimum": 0
            },
            "y": {
              "type": "number",
              "minimum": 0
            }
          },
          "required": [
            "width",
            "height",
            "x",
            "y"
          ]
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.Video": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "uri": {
          "type": "string",
          "description": "Unique identifier for the video media",
          "maxLength": 1000
        },
        "sources": {
          "type": "array",
          "description": "Available video sources in different qualities",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string",
                "enum": [
                  "1080p",
                  "720p",
                  "480p",
                  "360p"
                ],
                "description": "Quality level of the video source"
              },
              "width": {
                "type": "number",
                "description": "Width of the video in pixels"
              },
              "height": {
                "type": "number",
                "description": "Height of the video in pixels"
              },
              "types": {
                "type": "array",
                "description": "Available format types and their URIs for this quality",
                "items": {
                  "type": "object",
                  "properties": {
                    "format": {
                      "type": "string",
                      "enum": [
                        "mp4",
                        "mp4-luminance"
                      ],
                      "description": "Video format type"
                    },
                    "uri": {
                      "type": "string",
                      "description": "URI to access the video file"
                    }
                  },
                  "required": [
                    "format",
                    "uri"
                  ]
                }
              }
            },
            "required": [
              "quality",
              "width",
              "height",
              "types"
            ]
          }
        },
        "adaptiveSources": {
          "type": "array",
          "description": "Sources for adaptive streaming formats",
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ],
                "description": "Adaptive streaming format"
              },
              "uri": {
                "type": "string",
                "description": "URI to access the stream manifest"
              }
            },
            "required": [
              "format",
              "uri"
            ]
          }
        },
        "hasAudio": {
          "type": "boolean",
          "description": "Whether the video contains an audio track"
        },
        "fps": {
          "type": "number",
          "description": "Frames per second of the video"
        },
        "poster": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "description": "Poster image for the video",
          "refTypes": [
            "Builder.Image"
          ]
        },
        "duration": {
          "type": "number",
          "description": "Duration of the video in seconds"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.VectorArt": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "uri": {
          "type": "string"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.RichText": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 120000
        },
        "linkList": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "PageLink",
            "ExternalLink",
            "EmailLink",
            "AnchorLink",
            "DocumentLink",
            "PhoneLink",
            "DynamicPageLink",
            "TextLink",
            "LoginToWixLink",
            "WhatsAppLink",
            "AddressLink",
            "TpaPageLink"
          ]
        }
      }
    },
    "mobui.MobuiButton": {
      "properties": {
        "contentType": {
          "default": "Text",
          "enum": [
            "Text",
            "Icon",
            "Text and icon"
          ],
          "type": "string"
        },
        "label": {
          "default": "Button",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "$ref": "SVGReference"
        },
        "iconPosition": {
          "default": "Left",
          "enum": [
            "Left",
            "Right"
          ],
          "type": "string"
        },
        "buttonType": {
          "default": "Full",
          "enum": [
            "Full",
            "Outline",
            "Link"
          ],
          "type": "string"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiDatePicker": {
      "properties": {
        "label": {
          "default": "Select Date",
          "maxLength": 120,
          "type": "string"
        },
        "initialText": {
          "default": "today's date",
          "enum": [
            "today's date",
            "placeholder"
          ],
          "type": "string"
        },
        "placeholder": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "$ref": "SVGReference"
        },
        "fieldType": {
          "default": "form",
          "enum": [
            "form",
            "settings",
            "filter"
          ],
          "type": "string"
        },
        "pickerType": {
          "default": "calendar",
          "enum": [
            "wheel",
            "calendar"
          ],
          "type": "string"
        },
        "pickerTitle": {
          "default": "Select Date",
          "maxLength": 120,
          "type": "string"
        },
        "showPastDates": {
          "default": true,
          "type": "boolean"
        },
        "showFutureDates": {
          "default": true,
          "type": "boolean"
        },
        "wheelMode": {
          "default": "DD/MM/YY",
          "enum": [
            "DD/MM/YY",
            "MM/YY"
          ],
          "type": "string"
        },
        "firstDay": {
          "default": "Monday",
          "enum": [
            "Sunday",
            "Monday"
          ],
          "type": "string"
        },
        "disabledDaysOfWeek": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "enabledDateRanges": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "MobuiDateRangeType"
          ]
        },
        "disabledDateRanges": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "MobuiDateRangeType"
          ]
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "requiredErrorMessage": {
          "default": "This field is required",
          "maxLength": 1200,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "disabledDates": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "minDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "maxDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "timeZone": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "defaultItemSchemaType": {
      "properties": {
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "MobuiDateRangeType": {
      "properties": {
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "startDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "endDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiImage": {
      "properties": {
        "src": {
          "$ref": "ImageReference"
        },
        "isExternalSource": {
          "default": false,
          "type": "boolean"
        },
        "resizeMode": {
          "default": "cover",
          "enum": [
            "cover",
            "contain",
            "stretch",
            "repeat",
            "center"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiPicker": {
      "properties": {
        "fieldType": {
          "default": "form",
          "enum": [
            "form",
            "filter",
            "settings"
          ],
          "type": "string"
        },
        "label": {
          "default": "Label",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Select an option",
          "maxLength": 120,
          "type": "string"
        },
        "pickerType": {
          "default": "fullScreen",
          "enum": [
            "fullScreen",
            "dialog"
          ],
          "type": "string"
        },
        "optionsDialogTitle": {
          "default": "Select an Option",
          "maxLength": 120,
          "type": "string"
        },
        "optionsDialogSubtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "hasItemSubtitle": {
          "default": false,
          "type": "boolean"
        },
        "isMultiselect": {
          "default": false,
          "type": "boolean"
        },
        "selectionLimit": {
          "default": 3,
          "type": "number",
          "multipleOf": 1
        },
        "hasSearchBar": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "requiredErrorMessage": {
          "default": "Please fill out this field",
          "maxLength": 120,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "validateOnBlur": {
          "default": false,
          "type": "boolean"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "MobuiPickerItemType"
          ]
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "MobuiPickerItemType": {
      "properties": {
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "subtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isSelected": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiSwitch": {
      "properties": {
        "value": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiText": {
      "properties": {
        "text": {
          "default": "Add Title",
          "maxLength": 1200,
          "type": "string"
        },
        "selectable": {
          "default": true,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiTextInput": {
      "properties": {
        "inputType": {
          "default": "text",
          "enum": [
            "text",
            "password",
            "phone",
            "email",
            "url",
            "number"
          ],
          "type": "string"
        },
        "label": {
          "default": "Label",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "initialValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "hasCharLimit": {
          "default": false,
          "type": "boolean"
        },
        "maxInputLength": {
          "default": 300,
          "maximum": 120000,
          "type": "number",
          "multipleOf": 1
        },
        "prefixValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "suffixValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "requiredErrorMessage": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validatorErrorMessageValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validatorType": {
          "default": "none",
          "enum": [
            "none",
            "number",
            "email",
            "url",
            "required"
          ],
          "type": "string"
        },
        "textContentType": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "autoComplete": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "validateOnBlur": {
          "default": true,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiVideoPlayer": {
      "properties": {
        "title": {
          "default": "I am a Title",
          "maxLength": 120,
          "type": "string"
        },
        "src": {
          "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
          "maxLength": 1200,
          "type": "string"
        },
        "poster": {
          "$ref": "ImageReference"
        },
        "isPlaying": {
          "default": false,
          "type": "boolean"
        },
        "muteOnStart": {
          "default": false,
          "type": "boolean"
        },
        "playInLoop": {
          "default": false,
          "type": "boolean"
        },
        "enableFullScreen": {
          "default": true,
          "type": "boolean"
        },
        "enableCasting": {
          "default": false,
          "type": "boolean"
        },
        "showVideoSettings": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiMultiStateBoxData": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "defaultStateId": {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "weakRef"
              ],
              "refTypes": [
                "Component",
                "Container",
                "RefComponent",
                "RepeaterContainer"
              ],
              "shouldValidate": false,
              "shouldCollect": false,
              "referencedMap": "components",
              "default": null
            },
            "selectedStateId": {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "weakRef"
              ],
              "refTypes": [
                "Component",
                "Container",
                "RefComponent",
                "RepeaterContainer"
              ],
              "shouldValidate": false,
              "shouldCollect": false,
              "referencedMap": "components",
              "default": null
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "wixui.ExternalComponent": {
      "properties": {
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "compProps": {
          "default": "{}",
          "maxLength": 120000,
          "type": "string"
        },
        "isTrusted": {
          "default": false,
          "type": "boolean"
        },
        "importKey": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.HamburgerOverlay": {
      "properties": {
        "showBackgroundOverlay": {
          "default": true,
          "type": "boolean"
        },
        "tapOutsideToClose": {
          "default": true,
          "type": "boolean"
        },
        "isMenuContainerFullscreen": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.Logo": {
      "properties": {
        "isLoadingData": {
          "default": true,
          "type": "boolean"
        },
        "logoId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "alt": {
          "default": "Logo",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "preset": {
          "default": "original",
          "maxLength": 120,
          "type": "string"
        },
        "hasBackground": {
          "default": true,
          "type": "boolean"
        },
        "brandId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "backgroundColor": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "logoUrl": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.LottieEmbed": {
      "properties": {
        "animationUrl": {
          "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
          "maxLength": 1200,
          "type": "string"
        },
        "speed": {
          "default": 1,
          "minimum": 0,
          "type": "number"
        },
        "loop": {
          "default": true,
          "type": "boolean"
        },
        "autoplay": {
          "default": true,
          "type": "boolean"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isDecorative": {
          "default": false,
          "type": "boolean"
        },
        "showPlaybackControl": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.ProductSpecification": {
      "properties": {
        "items": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.RangeSlider": {
      "properties": {
        "label": {
          "default": "Set a range value",
          "maxLength": 120,
          "type": "string"
        },
        "sliderType": {
          "default": "Continuous",
          "enum": [
            "Continuous",
            "Stepped"
          ],
          "type": "string"
        },
        "stepType": {
          "default": "Number",
          "enum": [
            "Number",
            "Value"
          ],
          "type": "string"
        },
        "step": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "direction": {
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ],
          "type": "string"
        },
        "rootDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "labelDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "sliderDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "min": {
          "default": 0,
          "type": "number"
        },
        "max": {
          "default": 100,
          "type": "number"
        },
        "prefix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "suffix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "minValue": {
          "default": 0,
          "type": "number"
        },
        "maxValue": {
          "default": 0,
          "type": "number"
        },
        "thumbShape": {
          "default": "Circle",
          "enum": [
            "Circle",
            "Square",
            "Rectangle",
            "Bar"
          ],
          "type": "string"
        },
        "marksTickShape": {
          "default": "Lines",
          "enum": [
            "Lines",
            "Dots"
          ],
          "type": "string"
        },
        "thumbSize": {
          "default": 24,
          "type": "number",
          "multipleOf": 1
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "accessibleName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.Rive": {
      "properties": {
        "animationFileUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "thumbnailFileUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "artboard": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "stateMachine": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "fit": {
          "default": "cover",
          "maxLength": 120,
          "type": "string"
        },
        "alignment": {
          "default": "center",
          "maxLength": 120,
          "type": "string"
        },
        "isAutoPlayOn": {
          "default": true,
          "type": "boolean"
        },
        "isTouchScrollEnabled": {
          "default": true,
          "type": "boolean"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "fileName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isDecorative": {
          "default": true,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.ShareButtons": {
      "properties": {
        "buttons": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "IShareButton"
          ]
        },
        "pageToShare": {
          "default": "home",
          "maxLength": 1200,
          "type": "string"
        },
        "shareUrl": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "direction": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "IShareButton": {
      "properties": {
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "platformId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "illustration": {
          "$ref": "SVGReference"
        },
        "isHidden": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.SingleTab": {
      "properties": {
        "tabId": {
          "maxLength": 120,
          "type": "string"
        },
        "label": {
          "default": "Tab",
          "maxLength": 120,
          "type": "string"
        },
        "isParentStretched": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "tabId"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "AccordionContainerData": {
      "type": "object",
      "properties": {
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "allOf": [
              {
                "properties": {
                  "id": {
                    "type": "string"
                  },
                  "label": {
                    "type": "string"
                  }
                }
              }
            ]
          },
          "default": []
        }
      },
      "isTopLevelDataNode": true
    },
    "AccordionItemData": {
      "type": "object",
      "properties": {
        "isParentStretched": {
          "type": "boolean",
          "default": false
        }
      },
      "isTopLevelDataNode": true
    },
    "AddressInput": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "locale": {
          "type": "string",
          "maxLength": 100
        },
        "googleMapsApiKey": {
          "type": "string",
          "maxLength": 400
        },
        "filter": {
          "type": "object",
          "properties": {
            "country": {
              "type": "string",
              "maxLength": 10
            }
          }
        },
        "sorting": {
          "type": "object",
          "properties": {
            "location": {
              "type": "object",
              "properties": {
                "lat": {
                  "type": "number"
                },
                "lng": {
                  "type": "number"
                }
              }
            },
            "radius": {
              "type": "number",
              "default": 100
            },
            "formatted": {
              "type": "string",
              "maxLength": 10
            }
          }
        },
        "placeholder": {
          "type": "string",
          "description": "The value of the placeholder if chosen",
          "maxLength": 1000
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "BoltComponentData": {
      "type": "object",
      "anyOf": [
        {
          "properties": {}
        }
      ],
      "isTopLevelDataNode": true
    },
    "BreadcrumbsData": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "svgId": {
              "type": "string",
              "maxLength": 100
            }
          }
        },
        {
          "$ref": "CustomMenuDataRef"
        }
      ],
      "isTopLevelDataNode": true
    },
    "Captcha": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "captchaType": {
          "type": "string",
          "enum": [
            "image",
            "audio"
          ],
          "default": "image",
          "description": "When set changes the type of the challenge (image or audio)"
        }
      }
    },
    "CollapsibleTextData": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "default": "",
          "maxLength": 120000
        },
        "readMoreText": {
          "type": "string",
          "default": "Read More",
          "maxLength": 1200
        },
        "readLessText": {
          "type": "string",
          "default": "Read Less",
          "maxLength": 1200
        },
        "link": {
          "$ref": "LinkReference"
        },
        "linkText": {
          "type": "string",
          "default": "Read More",
          "maxLength": 1200
        },
        "textDescription": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "tag": {
          "type": "string",
          "default": "p",
          "maxLength": 31
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      },
      "isTopLevelDataNode": true
    },
    "ComboBoxInputData": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "dropdownDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "errorDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        },
        {
          "$ref": "SelectableList"
        }
      ],
      "isTopLevelDataNode": true
    },
    "CustomElement": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "tagName": {
          "type": "string",
          "default": "wix-default-custom-element"
        },
        "url": {
          "type": "string",
          "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
        },
        "hostedInCorvid": {
          "type": "boolean",
          "default": false
        },
        "initialAttributes": {
          "type": "string",
          "default": "{}",
          "maxLength": 4096
        },
        "shouldReload": {
          "type": "boolean",
          "description": "if iframe should be reloaded on initialAttributes change"
        },
        "scriptType": {
          "type": "string",
          "enum": [
            "none",
            "module"
          ],
          "default": "none"
        },
        "appDefinitionId": {
          "type": "string",
          "maxLength": 36
        },
        "widgetId": {
          "type": "string",
          "maxLength": 36
        }
      }
    },
    "wixui.FastGallery": {
      "properties": {
        "items": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "Image"
          ]
        },
        "itemClickAction": {
          "default": "ACTION",
          "enum": [
            "ACTION",
            "LINK",
            "NOTHING"
          ],
          "type": "string"
        },
        "downloadProtection": {
          "default": true,
          "type": "boolean"
        },
        "wixSDKItems": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "wixui.HamburgerMenuContainer": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": true
    },
    "wixui.HamburgerMenuRoot": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": true
    },
    "ImageX": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "image": {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "alt": {
              "type": "string",
              "default": ""
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "height": {
              "type": "number",
              "default": 200
            },
            "width": {
              "type": "number",
              "default": 200
            },
            "decorative": {
              "type": "boolean"
            }
          }
        },
        "link": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "scopedData": {
          "description": "ImageX data per breakpoint",
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "breakpoint": {
                "type": "string"
              },
              "crop": {
                "$ref": "Crop"
              },
              "focalPoint": {
                "$ref": "FocalPoint"
              },
              "displayMode": {
                "type": "string",
                "enum": [
                  "fill",
                  "fit",
                  "fitWidth"
                ],
                "default": "fill"
              },
              "scrollEffect": {
                "type": "string",
                "enum": [
                  "parallax",
                  "fixed",
                  "zoomIn",
                  "fadeIn",
                  "none"
                ]
              },
              "clickAction": {
                "type": "string",
                "enum": [
                  "none",
                  "goToLink"
                ]
              }
            }
          }
        },
        "mask": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "x": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "y": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "width": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "svgId": {
              "type": "string"
            },
            "flip": {
              "type": "string",
              "enum": [
                "x",
                "y",
                "xy",
                "none"
              ]
            },
            "rotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "mode": {
              "type": "string",
              "enum": [
                "alpha",
                "luminance"
              ]
            }
          }
        },
        "parallaxSpeed": {
          "type": "number"
        },
        "parallaxDirection": {
          "type": "string",
          "enum": [
            "normal",
            "reverse"
          ]
        },
        "hasAnimation": {
          "type": "boolean"
        }
      }
    },
    "Crop": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      },
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "isTopLevelDataNode": false
    },
    "FocalPoint": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      },
      "required": [
        "x",
        "y"
      ],
      "isTopLevelDataNode": false
    },
    "LanguageSelector": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "wixui.MegaMenuContainerItem": {
      "properties": {
        "type": {
          "default": "wixui.MegaMenuContainerItem",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "MenuData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "itemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "submenuDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "submenuItemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "submenuSubItemDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "navAriaLabel": {
              "type": "string",
              "maxLength": 1000
            }
          }
        },
        {
          "$ref": "CustomMenuDataRef"
        }
      ]
    },
    "wixui.MenuList": {
      "properties": {
        "menus": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "MusicPlayerData": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "coverDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "audioRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "audioUrl": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 256
        },
        "playListId": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 255
        },
        "playlist": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "artistName": {
                "type": "string",
                "maxLength": 255,
                "default": "Unknown Artist"
              },
              "trackName": {
                "type": "string",
                "maxLength": 255,
                "default": "Unknown Track"
              },
              "url": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 2500
              },
              "cover": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 2500
              },
              "durationFormatted": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 16
              }
            }
          },
          "default": []
        },
        "coverRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "coverUrl": {
          "type": [
            "string",
            "null"
          ]
        },
        "artistName": {
          "type": "string",
          "default": "Unknown Artist",
          "maxLength": 255
        },
        "trackName": {
          "type": "string",
          "default": "Unknown Track",
          "maxLength": 255
        },
        "description": {
          "type": "string",
          "default": "",
          "maxLength": 1000
        }
      }
    },
    "WixAudio": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "uri": {
          "type": "string",
          "default": ""
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "duration": {
          "type": "number"
        }
      }
    },
    "Pagination": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "totalPages": {
          "type": "number",
          "description": "The total number of pages displayed by the component"
        },
        "currentPage": {
          "type": "number",
          "default": 1,
          "description": "The the page number marked as current"
        },
        "nextText": {
          "type": "string",
          "default": "Next",
          "maxLength": 400,
          "description": "Text to appear in NEXT button"
        },
        "previousText": {
          "type": "string",
          "default": "Previous",
          "maxLength": 400,
          "description": "Text to appear in PREVIOUS button"
        },
        "firstText": {
          "type": "string",
          "default": "First",
          "maxLength": 400,
          "description": "Text to appear in FIRST button"
        },
        "lastText": {
          "type": "string",
          "default": "Last",
          "maxLength": 400,
          "description": "Text to appear in LAST button"
        },
        "nextAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the NEXT button"
        },
        "previousAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the PREVIOUS button"
        },
        "firstAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the FIRST button"
        },
        "lastAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the LAST button"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "PaginationA11y"
          ]
        }
      }
    },
    "PaginationA11y": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ProgressBar": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "value": {
          "type": "number",
          "description": "Current progress value"
        },
        "targetValue": {
          "type": "number",
          "default": 100,
          "description": "Progress target value to be defined as complete"
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "barDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "RatingsDisplay": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "ratingsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "rating": {
          "type": "number",
          "description": "The rating displayed by the component",
          "minimum": 1,
          "maximum": 5
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "numRatings": {
          "type": "number",
          "description": "The amount of ratings the rating is based on",
          "minimum": 0
        },
        "reviewsCountLabel": {
          "type": "string",
          "default": "Reviews",
          "maxLength": 400,
          "description": "Text that describes the numRatings value"
        },
        "noReviewsPlaceholder": {
          "type": "string",
          "default": "Be the first to rate this item",
          "maxLength": 1000,
          "description": "Placeholder text when there aren't any reviews"
        }
      }
    },
    "RatingsInput": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "value": {
          "type": [
            "number",
            "null"
          ],
          "description": "The rating value currently selected",
          "minimum": 0,
          "maximum": 5
        },
        "titleText": {
          "type": "string",
          "description": "the title before a value is selected",
          "maxLength": 300
        },
        "svgId": {
          "type": "string",
          "description": "the id of the svg that illustrates the rating",
          "maxLength": 100
        },
        "labels": {
          "type": "object",
          "description": "contains the labels for the different values. maps 1-5 as keys to strings",
          "default": {
            "1": "Bad",
            "2": "Fine",
            "3": "OK",
            "4": "Good",
            "5": "Great"
          },
          "additionalProperties": {
            "type": [
              "string",
              "number"
            ]
          }
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "wixui.RichContentViewer": {
      "properties": {
        "content": {
          "type": "object"
        },
        "trimEnabled": {
          "type": "boolean",
          "default": false
        },
        "trimMode": {
          "type": "string",
          "default": "paragraph",
          "maxLength": 100
        },
        "trimLengthParagraph": {
          "type": "number",
          "default": 3
        },
        "trimLengthWord": {
          "type": "number",
          "default": 10
        },
        "trimExclude": {
          "type": "string",
          "default": "plugins",
          "maxLength": 100
        },
        "trimEllipsisEnabled": {
          "type": "boolean",
          "default": true
        },
        "trimEllipsisExpandText": {
          "type": "string",
          "default": "Show More",
          "maxLength": 1200
        },
        "trimEllipsisCollapseText": {
          "type": "string",
          "default": "Show Less",
          "maxLength": 1200
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "RichTextBox": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "maxLength": {
              "type": [
                "number",
                "null"
              ],
              "description": "maximum number of characters allowed"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SearchBox": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "placeholder": {
          "type": "string",
          "default": "Search...",
          "maxLength": 255
        },
        "suggestionsEnabled": {
          "type": "boolean",
          "default": true,
          "description": "Determines whether the suggestions disabled or not"
        },
        "clearButtonText": {
          "type": "string",
          "default": "Clear",
          "maxLength": 255
        },
        "displaySettingsToggles": {
          "type": "boolean",
          "default": true,
          "description": "Determines whether the settings toggles are displayed or not"
        }
      }
    },
    "Section": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "SectionA11y"
          ]
        }
      }
    },
    "SectionA11y": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "alert",
            "status"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        }
      }
    },
    "wixui.SelectableContainer": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": true
    },
    "wixui.SelectableContainerInput": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": true
    },
    "SelectionTagsList": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "options": {
          "description": "Array of items which behave like checkboxes and look similar to buttons",
          "type": [
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": []
        },
        "value": {
          "description": "Array with the values of the selected options",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "SelectionTag": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "value": {
          "type": "string",
          "maxLength": 400
        },
        "label": {
          "type": "string",
          "maxLength": 400
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "rel": {
          "type": "string",
          "enum": [
            "nofollow"
          ]
        }
      }
    },
    "SignatureInput": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "titleText": {
          "type": "string",
          "description": "The title of the field",
          "maxLength": 400
        },
        "clearButtonText": {
          "type": "string",
          "description": "The undo signature text",
          "minLength": 1,
          "maxLength": 400
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "radioButtonsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "SiteButtonData": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        },
        {
          "$ref": "LinkableButton"
        }
      ],
      "isTopLevelDataNode": true
    },
    "Slider": {
      "type": "object",
      "properties": {
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "trackDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "tooltipDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "min": {
          "type": "number",
          "default": 0,
          "description": "Minimum value"
        },
        "max": {
          "type": "number",
          "default": 100,
          "description": "Maximum value"
        },
        "value": {
          "type": "number",
          "default": 50,
          "description": "Current value"
        },
        "step": {
          "type": "number",
          "default": 0,
          "description": "Step value"
        },
        "stepType": {
          "type": "string",
          "default": "value",
          "enum": [
            "value",
            "count"
          ],
          "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
        },
        "disabled": {
          "type": "boolean",
          "default": false,
          "description": "Determines whether the slider is disabled or not"
        },
        "readOnly": {
          "type": "boolean",
          "default": false,
          "description": "Determines whether the slider is read-only or not"
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "description": "Label text",
          "maxLength": 1200
        }
      },
      "isTopLevelDataNode": true
    },
    "wixui.Slideshow": {
      "properties": {
        "type": {
          "default": "wixui.Slideshow",
          "maxLength": 120,
          "type": "string"
        },
        "direction": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "SocialAuth": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": true
    },
    "StylableButton": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON",
          "maxLength": 1200
        },
        "svgId": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "isIconAnimated": {
          "type": "boolean"
        },
        "animatedIcon": {
          "type": "object",
          "properties": {
            "svgIdAnimationSelected": {
              "type": "string",
              "maxLength": 100
            },
            "customAnimatedIcon": {
              "type": [
                "object"
              ],
              "properties": {
                "svgIdAnimationStart": {
                  "type": "string",
                  "maxLength": 100
                },
                "svgIdAnimationEnd": {
                  "type": "string",
                  "maxLength": 100
                },
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                }
              }
            },
            "animationDuration": {
              "type": "number"
            }
          }
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "StylableButtonA11y"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "StylableButtonA11y": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "pressed": {
          "type": "boolean"
        },
        "expanded": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "dialog",
            "menu"
          ]
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        }
      }
    },
    "Submenu": {
      "properties": {
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "itemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "subItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      },
      "required": [
        "direction"
      ],
      "isTopLevelDataNode": true
    },
    "SvgImage": {
      "type": "object",
      "properties": {
        "decorative": {
          "type": "boolean"
        },
        "alt": {
          "type": "string",
          "description": "Alternative text for the vector image (for accessibility purposes).",
          "maxLength": 120
        },
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "stretch"
          ],
          "description": "should the shape maintain it's aspect ratio or stretch",
          "default": "fit"
        },
        "svgId": {
          "type": "string",
          "maxLength": 100,
          "description": "Identifier for the SVG image."
        },
        "link": {
          "$ref": "LinkReference",
          "description": "Reference to a link associated with the vector image."
        }
      },
      "required": [
        "svgId"
      ],
      "isTopLevelDataNode": true
    },
    "wixui.Tabs": {
      "type": "object",
      "properties": {
        "tabIds": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 120
          }
        },
        "defaultTabId": {
          "type": "string",
          "default": "",
          "maxLength": 120
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "TabsA11y"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      },
      "isTopLevelDataNode": true
    },
    "TabsA11y": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "TextEffectsSharedData": {
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 500
        },
        "link": {
          "$ref": "LinkReference"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "default": "div"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction",
          "default": "inherit"
        },
        "patternScope": {
          "type": "string",
          "enum": [
            "none",
            "character",
            "word"
          ],
          "default": "none"
        }
      },
      "isTopLevelDataNode": true
    },
    "TextMarqueeData": {
      "type": "object",
      "properties": {
        "movementDirection": {
          "type": "string",
          "description": "direction the text is moving to",
          "default": "rtl",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "speed": {
          "type": "number",
          "description": "speed of the animation in pixels per second"
        },
        "pauseOnHover": {
          "type": "boolean",
          "description": "pause animation on hover"
        },
        "textDirection": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "headingLevel": {
          "type": "number",
          "maximum": 6,
          "minimum": 0,
          "description": "Heading level to wrap the component (deprecated)"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "description": "Semantic tag name to wrap the component"
        },
        "svgId": {
          "type": "string"
        },
        "items": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "TextMarqueeItem"
          ],
          "default": [],
          "description": "array of marquee items"
        }
      },
      "required": [
        "items",
        "speed"
      ],
      "isTopLevelDataNode": true
    },
    "TextMarqueeItem": {
      "type": "object",
      "description": "TextMarquee Item",
      "properties": {
        "link": {
          "$ref": "LinkReference"
        },
        "text": {
          "type": "string",
          "maxLength": 500
        }
      },
      "required": [
        "text"
      ],
      "isTopLevelDataNode": true
    },
    "TextFxData": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "text": {
          "type": "string",
          "maxLength": 450
        },
        "headingLevel": {
          "type": "number",
          "minimum": 0,
          "maximum": 6,
          "description": "Heading level to wrap the component (deprecated)"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "description": "Semantic tag name to wrap the component"
        }
      }
    },
    "TextOnPathData": {
      "type": "object",
      "properties": {
        "isDecorative": {
          "type": "boolean"
        },
        "text": {
          "type": "string",
          "description": "text",
          "maxLength": 500
        },
        "path": {
          "type": "string",
          "description": "path"
        },
        "pathLength": {
          "type": "number",
          "description": "Path length"
        },
        "viewBox": {
          "type": "string",
          "description": "View box"
        },
        "speed": {
          "type": "number",
          "description": "Speed",
          "default": 3
        },
        "movementDirection": {
          "type": "string",
          "description": "Direction the text is moving to",
          "default": "forward",
          "enum": [
            "forward",
            "reverse"
          ]
        },
        "pauseOnHover": {
          "type": "boolean",
          "description": "Pause animation on hover"
        },
        "direction": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div"
          ],
          "description": "Semantic tag name to wrap the component"
        },
        "fillMode": {
          "type": "string",
          "enum": [
            "normal",
            "repeat",
            "justify"
          ],
          "default": "normal",
          "description": "How the text should be rendered on the path"
        },
        "link": {
          "$ref": "LinkReference",
          "description": "Reference to a link associated with the vector image."
        },
        "startOffset": {
          "type": "number",
          "description": "Starting point of the text on the path",
          "minimum": 0,
          "maximum": 100
        },
        "fontSize": {
          "type": "number",
          "description": "Font size as a number in percent",
          "minimum": 0,
          "maximum": 100
        },
        "pathStrokeWidth": {
          "type": "number",
          "description": "Width of the path stroke in em units",
          "minimum": 0,
          "maximum": 3
        }
      },
      "isTopLevelDataNode": true
    },
    "TextParticlesData": {
      "type": "object",
      "properties": {
        "text": {
          "default": "TextParticles",
          "maxLength": 500,
          "type": "string"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction",
          "default": "inherit"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "default": "div"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "isDecorative": {
          "type": "boolean"
        }
      },
      "isTopLevelDataNode": true
    },
    "TimePickerData": {
      "isTopLevelDataNode": true,
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "labelDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "inputDirection": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            },
            "placeholder": {
              "type": "string",
              "description": "The value of the placeholder if chosen",
              "maxLength": 1000
            },
            "step": {
              "type": "number",
              "minimum": 1,
              "maximum": 60,
              "default": 1,
              "description": "Increment step in minutes"
            },
            "label": {
              "type": "string",
              "maxLength": 1000
            },
            "margin": {
              "type": "number",
              "minimum": 1,
              "maximum": 30,
              "description": "Time picker layout label margin"
            },
            "disabledTimes": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "startTime": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "endTime": {
                    "type": "string",
                    "maxLength": 100
                  }
                },
                "additionalProperties": false,
                "required": [
                  "startTime",
                  "endTime"
                ]
              },
              "default": [],
              "maxItems": 5,
              "description": "array of disabled times"
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ]
    },
    "ToggleSwitch": {
      "isTopLevelDataNode": true,
      "type": "object",
      "allOf": [
        {
          "properties": {
            "checked": {
              "type": "boolean",
              "description": "The checked status of the input"
            },
            "direction": {
              "type": [
                "string"
              ],
              "enum": [
                "ltr",
                "rtl",
                "inherit"
              ],
              "description": "direction"
            }
          }
        },
        {
          "$ref": "BaseTextInput"
        }
      ]
    },
    "UnsupportedComponentData": {
      "type": "object",
      "properties": {
        "migratedFrom": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": true
    },
    "VideoPlayer": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "videoType": {
          "type": "string",
          "enum": [
            "dailymotion",
            "facebook",
            "file",
            "twitch",
            "vimeo",
            "youtube"
          ],
          "default": "file"
        },
        "videoRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "videoUrl": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 256
        },
        "posterUrl": {
          "type": [
            "string",
            "null"
          ]
        },
        "videoTitle": {
          "type": "string",
          "default": "",
          "maxLength": 255
        },
        "description": {
          "type": "string",
          "default": "",
          "maxLength": 1000,
          "description": "Video Description"
        },
        "logoRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        }
      }
    },
    "dsgnsys.ControlTypes": {
      "properties": {
        "shortString": {
          "default": "ShortString",
          "maxLength": 120,
          "type": "string"
        },
        "longString": {
          "default": "LongString",
          "maxLength": 1200,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "dropdown": {
          "default": "Options 1",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ],
          "type": "string"
        },
        "radioButtons": {
          "default": "Options 1",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ],
          "type": "string"
        },
        "toggleSwitch": {
          "default": false,
          "type": "boolean"
        },
        "thumbnails": {
          "$ref": "SVGReference"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "slider": {
          "default": 1,
          "minimum": 0,
          "maximum": 2,
          "type": "number",
          "multipleOf": 1
        },
        "numericInput": {
          "default": 0,
          "type": "number"
        },
        "colorPickerInput": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "selectedFont": {
          "default": "arial",
          "maxLength": 1200,
          "format": "font-family",
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardButton": {
      "properties": {
        "label": {
          "default": "Save",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Light",
            "Destructive",
            "Premium",
            "Premium light",
            "Dark",
            "Transparent"
          ],
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixIcon": {
          "$ref": "SVGReference"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixIcon": {
          "$ref": "SVGReference"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "priority": {
          "default": "Primary",
          "enum": [
            "Primary",
            "Secondary"
          ],
          "type": "string"
        }
      },
      "required": [
        "label"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardHeading": {
      "properties": {
        "text": {
          "default": "Add Page title H1",
          "maxLength": 1200,
          "type": "string"
        },
        "size": {
          "default": "Page title H1",
          "enum": [
            "Page title H1",
            "Modal title H2",
            "Card title H3",
            "Section title H4",
            "Card section title H5",
            "Caption H6"
          ],
          "type": "string"
        },
        "invertColor": {
          "default": false,
          "type": "boolean"
        },
        "textAlignment": {
          "default": "Left",
          "enum": [
            "Left",
            "Center",
            "Right"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardIconButton": {
      "properties": {
        "icon": {
          "$ref": "SVGReference"
        },
        "tooltip": {
          "default": "More Actions",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Transparent"
          ],
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "priority": {
          "default": "Secondary",
          "enum": [
            "Primary",
            "Secondary"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardInfoIcon": {
      "properties": {
        "tooltip": {
          "default": "This message explains the purpose of a feature.",
          "maxLength": 1200,
          "type": "string"
        },
        "addLink": {
          "default": false,
          "type": "boolean"
        },
        "tooltipLinkText": {
          "default": "Learn more",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipLink": {
          "$ref": "LinkReference"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardInput": {
      "properties": {
        "label": {
          "default": "Event name",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Enter your event name...",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "$ref": "SVGReference"
        },
        "prefixValue": {
          "default": "Units",
          "maxLength": 120,
          "type": "string"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "suffixIcon": {
          "$ref": "SVGReference"
        },
        "suffixValue": {
          "default": ".com",
          "maxLength": 120,
          "type": "string"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "setMaxLength": {
          "default": false,
          "type": "boolean"
        },
        "maxLength": {
          "default": 20,
          "type": "number",
          "multipleOf": 1
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "border": {
          "default": "Default",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ],
          "type": "string"
        },
        "labelPosition": {
          "default": "Top",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardNumberInput": {
      "properties": {
        "label": {
          "default": "Number of tickets",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Enter a number...",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": 25,
          "type": "number",
          "multipleOf": 1
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "$ref": "SVGReference"
        },
        "prefixValue": {
          "default": "Units",
          "maxLength": 120,
          "type": "string"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "suffixIcon": {
          "$ref": "SVGReference"
        },
        "suffixValue": {
          "default": "%",
          "maxLength": 120,
          "type": "string"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "minAndMaxValues": {
          "default": false,
          "type": "boolean"
        },
        "min": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "max": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepSize": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "border": {
          "default": "Default",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ],
          "type": "string"
        },
        "labelPlacement": {
          "default": "Top",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardText": {
      "properties": {
        "text": {
          "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
          "maxLength": 1200,
          "type": "string"
        },
        "preset": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Standard secondary",
            "Light",
            "Light secondary",
            "Success",
            "Destructive",
            "Primary",
            "Premium",
            "Disabled"
          ],
          "type": "string"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "Thin",
          "enum": [
            "Bold",
            "Normal",
            "Thin"
          ],
          "type": "string"
        },
        "textAlignment": {
          "default": "Left",
          "enum": [
            "Left",
            "Center",
            "Right"
          ],
          "type": "string"
        },
        "overflow": {
          "default": "Wrap",
          "enum": [
            "Wrap",
            "Ellipsis"
          ],
          "type": "string"
        },
        "maxLines": {
          "default": 1,
          "minimum": 1,
          "type": "number",
          "multipleOf": 1
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardTextButton": {
      "properties": {
        "label": {
          "default": "View All",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Dark",
            "Destructive"
          ],
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixIcon": {
          "$ref": "SVGReference"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixIcon": {
          "$ref": "SVGReference"
        },
        "underline": {
          "default": "Never",
          "enum": [
            "Never",
            "On hover",
            "Always"
          ],
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "Regular",
          "enum": [
            "Regular",
            "Medium"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.DashboardToggleSwitch": {
      "properties": {
        "label": {
          "default": "Set a reminder",
          "maxLength": 120,
          "type": "string"
        },
        "checked": {
          "default": true,
          "type": "boolean"
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Success",
            "Destructive"
          ],
          "type": "string"
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Large",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "labelPosition": {
          "default": "Right",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.SettingsPanelContainer": {
      "properties": {
        "theme": {
          "default": "classic",
          "enum": [
            "classic",
            "responsive"
          ],
          "type": "string"
        },
        "debug": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuAccordion": {
      "properties": {
        "label": {
          "default": "Label Example",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "openByDefault": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuBackButton": {
      "properties": {
        "label": {
          "default": "Back",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuButton": {
      "properties": {
        "fieldTitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "label": {
          "default": "Button",
          "maxLength": 120,
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "standard secondary",
            "premium",
            "premium secondary",
            "alert",
            "alert secondary",
            "inverted"
          ],
          "type": "string"
        },
        "size": {
          "default": "medium",
          "enum": [
            "small",
            "medium",
            "large"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "$ref": "SVGReference"
        },
        "suffixIcon": {
          "$ref": "SVGReference"
        },
        "fullWidth": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuCheckboxGroup": {
      "properties": {
        "fieldTitle": {
          "default": "Multiple Choices",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuColorPicker": {
      "properties": {
        "label": {
          "default": "Opacity & Color",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "opacity": {
          "default": 100,
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "showPercentage": {
          "default": true,
          "type": "boolean"
        },
        "opacitySliderEnabled": {
          "default": true,
          "type": "boolean"
        },
        "color": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuColorSelector": {
      "properties": {
        "label": {
          "default": "Color Selector",
          "maxLength": 120,
          "type": "string"
        },
        "color": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuColumnControllerControl": {
      "properties": {
        "fieldTitle": {
          "default": "Column controller",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "enableReorder": {
          "default": true,
          "type": "boolean"
        },
        "minimumValue": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "dividerType": {
          "default": "none",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        },
        "columns": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuDatePicker": {
      "properties": {
        "label": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Choose a Date",
          "maxLength": 120,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuDrillDown": {
      "properties": {
        "label": {
          "default": "Label Title",
          "maxLength": 120,
          "type": "string"
        },
        "description": {
          "default": "This is a description text",
          "maxLength": 1200,
          "type": "string"
        },
        "iconType": {
          "default": "None",
          "enum": [
            "None",
            "Info",
            "Alert"
          ],
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuDropdown": {
      "properties": {
        "fieldTitle": {
          "default": "Dropdown",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Choose an option",
          "maxLength": 120,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuEmptyState": {
      "properties": {
        "label": {
          "default": "Link to Lightbox",
          "maxLength": 120,
          "type": "string"
        },
        "description": {
          "default": "Create your own lightboxes and link to them for any place in your site.",
          "maxLength": 1200,
          "type": "string"
        },
        "textButtonLabel": {
          "default": "Start Creating",
          "maxLength": 120,
          "type": "string"
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "illustration": {
          "$ref": "SVGReference"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "properties": {
        "label": {
          "default": "Pick Font and Color",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "font": {
          "default": "arial",
          "maxLength": 1200,
          "format": "font-family",
          "type": "string"
        },
        "color": {
          "default": "#FFC233",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuHorizontalTabs": {
      "properties": {
        "tabsStyle": {
          "default": "Folder",
          "enum": [
            "Folder",
            "Arrowed",
            "Arrowed Without a Line"
          ],
          "type": "string"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "maxVisibleTabs": {
          "default": 3,
          "minimum": 1,
          "maximum": 10,
          "type": "number",
          "multipleOf": 1
        },
        "tabsToScroll": {
          "default": 3,
          "minimum": 1,
          "maximum": 10,
          "type": "number",
          "multipleOf": 1
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuLeftTextButton": {
      "properties": {
        "text": {
          "default": "Text Button",
          "maxLength": 120,
          "type": "string"
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "size": {
          "default": "medium",
          "enum": [
            "tiny",
            "small",
            "medium"
          ],
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "premium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "normal",
          "enum": [
            "thin",
            "normal"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "$ref": "SVGReference"
        },
        "suffixIcon": {
          "$ref": "SVGReference"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuMultilineTextInput": {
      "properties": {
        "label": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 120000,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Write text here...",
          "maxLength": 1200,
          "type": "string"
        },
        "maxLength": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "closeOnEnterKeyPress": {
          "default": false,
          "type": "boolean"
        },
        "autoFocus": {
          "default": false,
          "type": "boolean"
        },
        "selectTextOnFocus": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "usePatternValidation": {
          "default": false,
          "type": "boolean"
        },
        "regexPattern": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "validationMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuNotificationBanner": {
      "properties": {
        "label": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "premium",
            "alert",
            "success"
          ],
          "type": "string"
        },
        "linkText": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "linkUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "iconTooltipText": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "multiline": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuNumericInput": {
      "properties": {
        "title": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": 0,
          "type": "number"
        },
        "unitSuffix": {
          "default": "None",
          "enum": [
            "None",
            "Pixels",
            "Percentage",
            "Degrees"
          ],
          "type": "string"
        },
        "numberOfFractions": {
          "default": 2,
          "minimum": 0,
          "maximum": 2,
          "type": "number",
          "multipleOf": 1
        },
        "steps": {
          "default": 1,
          "minimum": 1,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepControls": {
          "default": false,
          "type": "boolean"
        },
        "minValue": {
          "default": 0,
          "type": "number"
        },
        "maxValue": {
          "default": 100,
          "type": "number"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "properties": {
        "fieldTitle": {
          "default": "Radio Buttons",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuRichText": {
      "properties": {
        "richTextContent": {
          "default": "Your placeholder text goes here. Write, style and link it.",
          "maxLength": 120000,
          "type": "string"
        },
        "richTextLabel": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "$ref": "LinkReference"
        },
        "richTextLink": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "alignTextToCenter": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuSectionDivider": {
      "properties": {
        "sectionTitle": {
          "default": "Section Divider",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuSlider": {
      "properties": {
        "fieldTitle": {
          "default": "Slider",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "unitOfMeasurement": {
          "default": "number",
          "enum": [
            "number",
            "percentage",
            "pixels",
            "angle"
          ],
          "type": "string"
        },
        "defaultSelectedValue": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "minimumValue": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "maximumValue": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepValue": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "showNumericInput": {
          "default": true,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuTextInput": {
      "properties": {
        "fieldTitle": {
          "default": "Text Input",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "defaultText": {
          "default": "Write it here...",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Placeholder text",
          "maxLength": 120,
          "type": "string"
        },
        "prefix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "autofocus": {
          "default": false,
          "type": "boolean"
        },
        "selectedOnFocus": {
          "default": true,
          "type": "boolean"
        },
        "charactersLimit": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "usePatternValidation": {
          "default": false,
          "type": "boolean"
        },
        "regexPattern": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "errorMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuThumbnails": {
      "properties": {
        "fieldTitle": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "setNumberOfColumns": {
          "default": 3,
          "minimum": 1,
          "maximum": 5,
          "type": "number",
          "multipleOf": 1
        },
        "showEmptyThumbnail": {
          "default": false,
          "type": "boolean"
        },
        "thumbnailHeight": {
          "default": "Fixed ratio (1:1)",
          "enum": [
            "Fixed ratio (1:1)",
            "Fluid"
          ],
          "type": "string"
        },
        "displayLabels": {
          "default": true,
          "type": "boolean"
        },
        "options": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "ThumbnailItemData"
          ]
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [
        "options"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "ThumbnailItemData": {
      "properties": {
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "illustration": {
          "$ref": "SVGReference"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WbuToggleSwitch": {
      "properties": {
        "label": {
          "default": "Toggle Switch",
          "maxLength": 120,
          "type": "string"
        },
        "toggleSwitch": {
          "default": true,
          "type": "boolean"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WutAvatar": {
      "properties": {
        "firstName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "lastName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "src": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WutAvatarGroup": {
      "properties": {
        "maxAvatars": {
          "default": 5,
          "minimum": 1,
          "type": "number",
          "multipleOf": 1
        },
        "showHiddenAvatarCount": {
          "default": true,
          "type": "boolean"
        },
        "avatars": {
          "default": [],
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "defaultItemSchemaType"
          ]
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WutBadge": {
      "properties": {
        "text": {
          "default": "My Badge",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "$ref": "SVGReference"
        },
        "composition": {
          "default": "TextAndIcon",
          "enum": [
            "TextAndIcon",
            "Text",
            "Icon",
            "None"
          ],
          "type": "string"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "dsgnsys.WutRadioButton": {
      "properties": {
        "radioGroupName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "checked": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "value"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    }
  },
  "design.json": {
    "MediaContainerDesignData": {
      "type": "object",
      "properties": {
        "charas": {
          "type": [
            "string",
            "null"
          ]
        },
        "background": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "BackgroundMedia"
          ]
        },
        "dataChangeBehaviors": {
          "$ref": "dataChangeBehaviors"
        },
        "cssStyle": {
          "$ref": "cssStyle"
        },
        "themeMappings": {
          "type": "object",
          "additionalProperties": {
            "type": "string"
          }
        },
        "mediaRef": {
          "refTypes": [
            "Image",
            "WixVideo"
          ]
        },
        "posterImageRef": {
          "refTypes": [
            "Image"
          ]
        },
        "imageOverlay": {
          "refTypes": [
            "Image"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "MediaContainerWithDividers": {
      "type": "object",
      "properties": {
        "background": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "BackgroundMedia"
          ]
        },
        "dividerTop": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ShapeDivider"
          ]
        },
        "dividerBottom": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ShapeDivider"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "ShapeDivider": {
      "type": "object",
      "properties": {
        "svgId": {
          "type": "string"
        },
        "color": {
          "type": "string",
          "format": "color"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "padding": {
          "$ref": "UnitLengthPercentage"
        },
        "height": {
          "$ref": "UnitLengthPercentage"
        },
        "offsetX": {
          "$ref": "UnitLengthPercentage"
        },
        "flip": {
          "type": "boolean"
        },
        "invert": {
          "type": "boolean"
        },
        "keepAspectRatio": {
          "type": "boolean"
        },
        "shouldRepeat": {
          "type": "boolean"
        },
        "repeatCount": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "layersEffect": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "LayersEffect"
            }
          ]
        },
        "presetId": {
          "type": "string",
          "maxLength": 20
        }
      },
      "required": [
        "svgId"
      ],
      "isTopLevelDataNode": true
    },
    "MediaPlayerDesignData": {
      "type": "object",
      "properties": {
        "charas": {
          "type": [
            "string",
            "null"
          ]
        },
        "background": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "BackgroundMedia"
          ]
        },
        "cssStyle": {
          "$ref": "cssStyle"
        },
        "themeMappings": {
          "type": "object",
          "additionalProperties": {
            "type": "string"
          }
        },
        "posterImageRef": {
          "refTypes": [
            "Image"
          ]
        },
        "mediaRef": {
          "refTypes": [
            "WixVideo"
          ]
        },
        "imageOverlay": {
          "refTypes": [
            "Image"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextFxDesign": {
      "type": "object",
      "properties": {
        "autoScale": {
          "type": "boolean",
          "default": true,
          "description": "true - scale the text dynamically by layout, false - no scaling (text size by font size)"
        },
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ],
          "default": "middle"
        },
        "family": {
          "type": "string",
          "maxLength": 150
        },
        "size": {
          "type": "number",
          "minimum": 6,
          "maximum": 999
        },
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ],
          "default": "normal"
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ],
          "default": "normal"
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ],
          "default": "none"
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ],
          "default": "none"
        },
        "letterSpacing": {
          "$ref": "UnitLengthPercentage"
        },
        "lineHeight": {
          "type": "number",
          "minimum": 0,
          "maximum": 7,
          "default": 1
        },
        "outlineColor": {
          "type": "string",
          "maxLength": 40,
          "format": "color"
        },
        "outlineOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "outlineWidth": {
          "type": "number",
          "minimum": 0
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "Shadow"
            }
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "TextFxMask": {
      "type": "object",
      "allOf": [
        {
          "$ref": "TextFxDesign"
        },
        {
          "properties": {
            "media": {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "ref"
              ],
              "refTypes": [
                "BackgroundMedia"
              ]
            },
            "mediaRotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "mediaFlip": {
              "enum": [
                "none",
                "horizontal",
                "vertical",
                "both"
              ],
              "default": "none"
            },
            "viewBox": {
              "type": [
                "string",
                "null"
              ],
              "minimum": 7,
              "maximum": 200
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "TextFxPath": {
      "type": "object",
      "allOf": [
        {
          "$ref": "TextFxDesign"
        },
        {
          "properties": {
            "path": {
              "type": "string",
              "maxLength": 1024
            },
            "keepAspectRatio": {
              "type": "boolean"
            },
            "keepFontSize": {
              "type": "boolean"
            },
            "inside": {
              "type": "boolean"
            },
            "verticalAlign": {
              "enum": [
                "top",
                "middle",
                "bottom"
              ],
              "default": "bottom"
            },
            "verticalOffset": {
              "type": "number"
            },
            "horizontalOffset": {
              "type": "number"
            },
            "spread": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "textColor": {
              "type": "string",
              "maxLength": 40,
              "format": "color"
            },
            "textOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "fillColor": {
              "type": "string",
              "maxLength": 40,
              "format": "color"
            },
            "fillOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "strokeColor": {
              "type": "string",
              "maxLength": 40,
              "format": "color"
            },
            "strokeOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "strokeWidth": {
              "type": "number",
              "minimum": 0
            },
            "viewBox": {
              "type": [
                "string",
                "null"
              ],
              "minimum": 7,
              "maximum": 200
            },
            "presetId": {
              "type": "string",
              "maxLength": 20
            }
          }
        }
      ],
      "isTopLevelDataNode": true
    },
    "css-keyword": {
      "type": "boolean",
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-percentage": {
      "type": "object",
      "properties": {
        "value": {
          "type": "number"
        },
        "unit": {
          "enum": [
            "%"
          ]
        }
      },
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-absolute-length-unit": {
      "enum": [
        "px",
        "cm",
        "mm",
        "q",
        "in",
        "pt",
        "pc"
      ],
      "isTopLevelDataNode": false
    },
    "css-relative-length-unit": {
      "enum": [
        "em",
        "ex",
        "ch",
        "rem",
        "vw",
        "vh",
        "vmin",
        "vmax"
      ],
      "isTopLevelDataNode": false
    },
    "css-length": {
      "type": "object",
      "properties": {
        "unit": {
          "type": "string",
          "oneOf": [
            {
              "$ref": "css-absolute-length-unit"
            },
            {
              "$ref": "css-relative-length-unit"
            }
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "required": [
        "unit",
        "value"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-length-or-percentage": {
      "type": "object",
      "oneOf": [
        {
          "$ref": "css-length"
        },
        {
          "$ref": "css-percentage"
        }
      ],
      "isTopLevelDataNode": false
    },
    "css-byte": {
      "type": "number",
      "default": 0,
      "multipleOf": 1,
      "minimum": 0,
      "maximum": 255,
      "isTopLevelDataNode": false
    },
    "css-color": {
      "type": "object",
      "properties": {
        "red": {
          "$ref": "css-byte"
        },
        "green": {
          "$ref": "css-byte"
        },
        "blue": {
          "$ref": "css-byte"
        },
        "alpha": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "required": [
        "red",
        "green",
        "blue",
        "alpha"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-box-shadow": {
      "type": "array",
      "items": {
        "properties": {
          "inset": {
            "$ref": "css-keyword"
          },
          "offsetX": {
            "$ref": "css-length"
          },
          "offsetY": {
            "$ref": "css-length"
          },
          "blurRadius": {
            "$ref": "css-length"
          },
          "spreadRadius": {
            "$ref": "css-length"
          },
          "color": {
            "$ref": "css-color"
          }
        },
        "required": [
          "inset",
          "offsetX",
          "offsetY",
          "blurRadius",
          "spreadRadius",
          "color"
        ],
        "additionalProperties": false
      },
      "minItems": 1,
      "isTopLevelDataNode": false
    },
    "css-border-radius": {
      "type": "object",
      "properties": {
        "topLeft": {
          "$ref": "css-length-or-percentage"
        },
        "topRight": {
          "$ref": "css-length-or-percentage"
        },
        "bottomLeft": {
          "$ref": "css-length-or-percentage"
        },
        "bottomRight": {
          "$ref": "css-length-or-percentage"
        }
      },
      "required": [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-br-width": {
      "type": "object",
      "oneOf": [
        {
          "$ref": "css-length"
        }
      ],
      "isTopLevelDataNode": false
    },
    "css-border-width": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "css-br-width"
        },
        "right": {
          "$ref": "css-br-width"
        },
        "bottom": {
          "$ref": "css-br-width"
        },
        "left": {
          "$ref": "css-br-width"
        }
      },
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-br-style": {
      "enum": [
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ],
      "isTopLevelDataNode": false
    },
    "css-border-style": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "css-br-style"
        },
        "right": {
          "$ref": "css-br-style"
        },
        "bottom": {
          "$ref": "css-br-style"
        },
        "left": {
          "$ref": "css-br-style"
        }
      },
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-border-color": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "css-color"
        },
        "right": {
          "$ref": "css-color"
        },
        "bottom": {
          "$ref": "css-color"
        },
        "left": {
          "$ref": "css-color"
        }
      },
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "css-border": {
      "type": "object",
      "properties": {
        "width": {
          "$ref": "css-border-width"
        },
        "style": {
          "$ref": "css-border-style"
        },
        "color": {
          "$ref": "css-border-color"
        }
      },
      "required": [
        "width",
        "style",
        "color"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "cssBorder": {
      "$ref": "css-border",
      "isTopLevelDataNode": false
    },
    "cssBorderRadius": {
      "$ref": "css-border-radius",
      "isTopLevelDataNode": false
    },
    "cssBoxShadow": {
      "$ref": "css-box-shadow",
      "isTopLevelDataNode": false
    },
    "cssStyle": {
      "type": "object",
      "properties": {
        "cssBorder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "cssBorder"
            }
          ]
        },
        "cssBoxShadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "cssBoxShadow"
            }
          ]
        },
        "cssBorderRadius": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "cssBorderRadius"
            }
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "LayersEffect": {
      "type": "object",
      "properties": {
        "size": {
          "type": "number",
          "minimum": 1,
          "maximum": 10
        },
        "y": {
          "$ref": "UnitLengthPercentage"
        },
        "x": {
          "$ref": "UnitLengthPercentage"
        },
        "pin": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "required": [
        "size"
      ]
    },
    "dataChangeBehaviors": {
      "type": [
        "array",
        "null"
      ],
      "items": {
        "type": "object",
        "properties": {
          "trigger": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "part": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "params": {
            "type": "object"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "BackgroundMedia": {
      "type": "object",
      "properties": {
        "mediaRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image",
            "WixVideo"
          ]
        },
        "mediaTransforms": {
          "$ref": "BackgroundTransforms"
        },
        "overlayTransforms": {
          "$ref": "BackgroundTransforms"
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "format": "color"
            }
          ]
        },
        "colorOpacity": {
          "type": "number"
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ],
          "default": "WixVideo"
        },
        "imageOverlay": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "colorOverlay": {
          "type": "string",
          "format": "color"
        },
        "colorOverlayOpacity": {
          "type": "number"
        },
        "overlayBlending": {
          "$ref": "overlayBlending"
        },
        "filterEffect": {
          "$ref": "filterEffect"
        },
        "colorLayers": {
          "$ref": "ColorLayers"
        }
      },
      "isTopLevelDataNode": true
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ],
      "isTopLevelDataNode": false
    },
    "Shadow": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "spreadRadius": {
          "type": "number"
        },
        "blurRadius": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "color": {
          "type": "string",
          "description": "Hex or RGB color"
        }
      },
      "isTopLevelDataNode": false
    },
    "filterEffect": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "effectType": {
          "type": "string",
          "enum": [
            "none",
            "normal",
            "ink",
            "kennedy",
            "feathered",
            "blur",
            "whistler",
            "3d",
            "blueray",
            "lighten",
            "darken",
            "pinkrinse",
            "redrum",
            "greenwash",
            "yellowstreak",
            "neonsky",
            "seaweed",
            "soledad",
            "sangria",
            "malibu",
            "candyfloss",
            "elmo",
            "unicorn",
            "kerouac",
            "koolaid",
            "hydra",
            "pixie",
            "nightrain",
            "bauhaus",
            "neptune",
            "orca",
            "manhattan",
            "goldie",
            "flamingo",
            "faded",
            "gotham",
            "hulk",
            "midnight",
            "lucille",
            "organic",
            "grayscale",
            "tvDuotone",
            "tvMonotoneDark",
            "tvMonotoneLight",
            "tvHue"
          ]
        },
        "brightness": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "saturation": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "hue": {
          "type": "number",
          "minimum": -180,
          "maximum": 180
        },
        "duotoneDark": {
          "type": "string"
        },
        "duotoneLight": {
          "type": "string"
        },
        "invert": {
          "type": "boolean",
          "default": false
        },
        "isCustom": {
          "type": "boolean"
        }
      },
      "isTopLevelDataNode": false
    },
    "overlayBlending": {
      "type": "object",
      "properties": {
        "color": {
          "type": "string"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "saturate": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "blendMode": {
          "$ref": "BlendMode"
        }
      },
      "isTopLevelDataNode": false
    },
    "BackgroundTransforms": {
      "type": "object",
      "properties": {
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "isTopLevelDataNode": false
    },
    "ImageMask": {
      "type": "object",
      "description": "CSS mask using an image",
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "y": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "width": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "svgId": {
          "type": "string"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "description": "Defines whether the mask is flipped on the v or h axis"
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "mode": {
          "type": "string",
          "enum": [
            "alpha",
            "luminance"
          ],
          "default": "alpha"
        }
      },
      "isTopLevelDataNode": false
    },
    "WixVideo": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            }
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            }
          }
        },
        "posterImageRef": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Image"
          ]
        },
        "duration": {
          "type": "number"
        },
        "loop": {
          "type": "boolean"
        },
        "autoplay": {
          "type": "boolean"
        },
        "playbackSpeed": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": {
          "type": "boolean",
          "description": "deprecated, moved to properties"
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "opacity": {
          "type": "number"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          }
        },
        "mediaFeatures": {
          "description": "Annotate which features does this video have, for example 'media is a video with alpha'",
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "array",
              "items": {
                "type": "string",
                "enum": [
                  "alpha",
                  "360"
                ]
              }
            }
          ]
        },
        "mask": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "ImageMask"
            }
          ]
        },
        "focalPoint": {
          "$ref": "FocalPoint"
        }
      },
      "isTopLevelDataNode": true
    },
    "Video": {
      "type": "object",
      "properties": {
        "videoId": {
          "type": "string"
        },
        "userId": {
          "type": "string"
        },
        "posterImage": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ]
        },
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ],
          "default": "YOUTUBE"
        }
      },
      "isTopLevelDataNode": true
    },
    "Image": {
      "$ref": "Common_Image",
      "isTopLevelDataNode": true
    },
    "MediaControlsDesignData": {
      "type": "object",
      "properties": {
        "iconsDefaultDesign": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "description": "VectorImageDesignData reference to design all icons",
          "refTypes": [
            "VectorImageDesignData"
          ]
        },
        "icons": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "description": "ControlIconDesignData references",
          "refTypes": [
            "ControlIconDesignData"
          ]
        },
        "iconDesign": {
          "refTypes": [
            "VectorImageDesignData"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "ControlIconDesignData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 50
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "iconDesign": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "description": "VectorImageDesignData reference to override the default design",
          "refTypes": [
            "VectorImageDesignData"
          ]
        }
      }
    },
    "VectorImageDesignData": {
      "type": "object",
      "properties": {
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "$ref": "Shadow"
            }
          ]
        },
        "shapeStyle": {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "strokeWidth": {
              "type": "number"
            },
            "fill": {
              "type": "string"
            },
            "fillOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "stroke": {
              "type": "string"
            },
            "strokeOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "enableStroke": {
              "type": "boolean"
            }
          }
        },
        "overrideColors": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "color1": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color2": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color3": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color4": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color5": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color6": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color7": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color8": {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              }
            }
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "GradientMesh": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientMesh"
          ]
        },
        "gradients": {
          "type": "array",
          "items": {
            "type": "object",
            "oneOf": [
              {
                "$ref": "GradientLinear"
              },
              {
                "$ref": "GradientCircle"
              },
              {
                "$ref": "GradientEllipse"
              },
              {
                "$ref": "GradientConic"
              }
            ]
          }
        }
      },
      "isTopLevelDataNode": false
    }
  },
  "discussions.json": {
    "Discussions": {
      "isTopLevelDataNode": true,
      "type": "object",
      "required": [
        "discussions"
      ],
      "properties": {
        "discussions": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 100
          },
          "default": []
        }
      }
    }
  },
  "editorsettings.json": {
    "EditorSettings": {
      "type": "object",
      "properties": {
        "dockingBehavior": {
          "type": "string",
          "enum": [
            "heuristic",
            "keep"
          ]
        },
        "layoutIntent": {
          "type": "string",
          "enum": [
            "SuperGrid",
            "CssGrid",
            "Mesh"
          ]
        },
        "sizingBehavior": {
          "type": "string",
          "enum": [
            "preset",
            "advanced"
          ]
        },
        "aspectRatioLock": {
          "type": "boolean"
        },
        "disableAutoDOMOrder": {
          "type": "boolean"
        },
        "domOrderStrategy": {
          "type": "string",
          "enum": [
            "N-shape",
            "Z-shape"
          ]
        },
        "thumbnailId": {
          "type": "string"
        },
        "progressStatus": {
          "type": "string",
          "enum": [
            "UNKNOWN",
            "TO_DO",
            "IN_PROGRESS",
            "ITERATE",
            "DONE"
          ]
        },
        "linkedComponents": {
          "type": "object",
          "patternProperties": {
            "^comp-": {
              "type": "string",
              "pseudoType": [
                "weakRef"
              ],
              "referencedMap": "components",
              "refTypes": [],
              "shouldCollect": false,
              "shouldValidate": false,
              "isTopLevelDataNode": false
            }
          }
        }
      },
      "isTopLevelDataNode": true
    }
  },
  "effects.json": {
    "KeyframeEffectList": {
      "description": "Ref List of Keyframe Effects",
      "type": "object",
      "isPermanentDataNode": true,
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "KeyframeEffect"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#"
        }
      }
    },
    "KeyframeEffect": {
      "description": "An Effect that is a list of custom Keyframe animations",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "keyframes": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "Keyframe"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#"
        }
      }
    },
    "Keyframe": {
      "description": "A single animation keyframe, manipulating opacity, clipPath or transform",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "offset": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
        },
        "effectStyle": {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1,
              "multipleOf": 0.01
            },
            "clipPath": {
              "type": "object",
              "properties": {
                "clipType": {
                  "type": "string",
                  "enum": [
                    "inset",
                    "circle",
                    "ellipse",
                    "polygon",
                    "path"
                  ]
                },
                "value": {
                  "type": "string",
                  "maxLength": 1000
                }
              },
              "required": [
                "clipType",
                "value"
              ]
            }
          }
        },
        "transform": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "transformations_data"
        }
      }
    },
    "EffectsList": {
      "description": "Ref List of different types of Animation Effects",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "TimeAnimation",
            "ScrubAnimation",
            "CanvasAnimation"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#"
        }
      }
    },
    "CanvasAnimation": {
      "description": "A canvas-based animation",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "CanvasAnimationOptions",
            "TimeAnimationOptions",
            "ScrubAnimationOptions"
          ]
        }
      },
      "required": [
        "name",
        "value"
      ]
    },
    "CanvasAnimationOptions": {
      "description": "Properties of canvas-based animations",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "namedEffect": {
          "type": [
            "null",
            "string"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "Kaleidoscope",
            "RGBSplit",
            "RGBOrb",
            "SlitScan",
            "NoisyTrack",
            "Smear",
            "Ripples"
          ]
        }
      }
    },
    "TimeAnimationOptions": {
      "description": "Properties of a time-based animation: duration, delay, end-delay, replay type and all Base Animation Properties",
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "duration": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 0
            },
            "delay": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 0
            },
            "endDelay": {
              "type": "number",
              "minimum": 0,
              "multipleOf": 1
            },
            "allowReplay": {
              "type": "string",
              "enum": [
                "perPageView",
                "always",
                "never"
              ],
              "default": "perPageView"
            }
          }
        },
        {
          "$ref": "AnimationCommonOptions"
        }
      ]
    },
    "TimeAnimation": {
      "description": "A time-based animation",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TimeAnimationOptions"
          ]
        }
      },
      "required": [
        "name",
        "value"
      ]
    },
    "ScrubAnimationOptions": {
      "description": "Common options for a Scrub Animation: duration, start offset, end offset and all Common Animation Options",
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "duration": {
              "$ref": "UnitLengthPercentage"
            },
            "startOffset": {
              "$ref": "RangeOffset"
            },
            "endOffset": {
              "$ref": "RangeOffset"
            },
            "centeredToTarget": {
              "type": "boolean"
            },
            "playbackRate": {
              "type": "number",
              "description": "Adds a lerp effect to animations",
              "minimum": 0,
              "maximum": 1
            },
            "transitionDuration": {
              "type": "number",
              "minimum": 0
            },
            "transitionDelay": {
              "type": "number",
              "minimum": 0
            },
            "transitionEasing": {
              "$ref": "Easing"
            }
          }
        },
        {
          "$ref": "AnimationCommonOptions"
        }
      ]
    },
    "ScrubAnimation": {
      "description": "A Scrub Animation",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "ScrubAnimationOptions"
          ]
        }
      },
      "required": [
        "name",
        "value"
      ]
    },
    "AnimationCommonOptions": {
      "description": "Common options for all animations: named effect, keyframe effect, easing, iterations, alternate, fill, reversed",
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "keyframeEffect": {
          "type": [
            "string",
            "null"
          ],
          "shouldCollect": false,
          "shouldValidate": true,
          "pseudoType": [
            "weakRef"
          ],
          "referencedMap": "#",
          "refTypes": [
            "KeyframeEffect"
          ]
        },
        "namedEffect": {
          "type": [
            "null",
            "string"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "pseudoType": [
            "ref"
          ],
          "refTypes": [
            "ArcIn",
            "DropIn",
            "ExpandIn",
            "FadeIn",
            "FlipIn",
            "FloatIn",
            "FlyIn",
            "FoldIn",
            "RevealIn",
            "SlideIn",
            "SpinIn",
            "TurnIn",
            "BounceIn",
            "GlideIn",
            "GlitchIn",
            "TiltIn",
            "ShapeIn",
            "ShuttersIn",
            "WinkIn",
            "GrowIn",
            "BlurIn",
            "PunchIn",
            "CurveIn",
            "CircleIn",
            "Breathe",
            "Blink",
            "Pulse",
            "Spin",
            "Poke",
            "Flash",
            "Swing",
            "Flip",
            "Rubber",
            "Fold",
            "Jello",
            "Wiggle",
            "Bounce",
            "DVD",
            "Cross",
            "ArcScroll",
            "BlurScroll",
            "FadeScroll",
            "FlipScroll",
            "GrowScroll",
            "MoveScroll",
            "PanScroll",
            "ParallaxScroll",
            "RevealScroll",
            "ShapeScroll",
            "ShrinkScroll",
            "ShuttersScroll",
            "SkewPanScroll",
            "SlideScroll",
            "Spin3dScroll",
            "StretchScroll",
            "SpinScroll",
            "TiltScroll",
            "TurnScroll",
            "TrackMouse",
            "Tilt3DMouse",
            "SwivelMouse",
            "BlobMouse",
            "ScaleMouse",
            "Track3DMouse",
            "AiryMouse",
            "BlurMouse",
            "SkewMouse",
            "BgCloseUp",
            "BgFade",
            "BgFadeBack",
            "BgFake3D",
            "BgPan",
            "BgParallax",
            "BgPullBack",
            "BgReveal",
            "BgRotate",
            "BgSkew",
            "BgZoom",
            "ImageParallax"
          ]
        },
        "customEffect": {
          "type": "object",
          "isTopLevelDataNode": false,
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": {
                    "type": "number",
                    "default": 0
                  },
                  "max": {
                    "type": "number",
                    "default": 1
                  },
                  "step": {
                    "type": "number"
                  }
                },
                "required": [
                  "name",
                  "min",
                  "max"
                ]
              },
              "maxItems": 10,
              "minItems": 1
            }
          },
          "required": [
            "ranges"
          ]
        },
        "easing": {
          "$ref": "Easing"
        },
        "iterations": {
          "type": "number",
          "minimum": 0,
          "default": 1
        },
        "alternate": {
          "type": "boolean"
        },
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": {
          "type": "boolean"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "keyframeEffect"
          ]
        },
        {
          "type": "object",
          "required": [
            "namedEffect"
          ]
        },
        {
          "type": "object",
          "not": {
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "keyframeEffect"
                ]
              },
              {
                "type": "object",
                "required": [
                  "namedEffect"
                ]
              }
            ]
          }
        }
      ]
    },
    "RangeOffset": {
      "description": "Scrub animation range and offset",
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "name": {
          "type": "string",
          "enum": [
            "entry",
            "exit",
            "contain",
            "cover"
          ]
        },
        "offset": {
          "$ref": "UnitLengthPercentage"
        }
      }
    },
    "Easing": {
      "description": "Easing function names",
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "linear",
        "ease",
        "easeIn",
        "easeOut",
        "easeInOut",
        "sineIn",
        "sineOut",
        "sineInOut",
        "quadIn",
        "quadOut",
        "quadInOut",
        "cubicIn",
        "cubicOut",
        "cubicInOut",
        "quartIn",
        "quartOut",
        "quartInOut",
        "quintIn",
        "quintOut",
        "quintInOut",
        "expoIn",
        "expoOut",
        "expoInOut",
        "circIn",
        "circOut",
        "circInOut",
        "backIn",
        "backOut",
        "backInOut",
        "hardBackOut"
      ]
    },
    "EffectPower": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "soft",
        "medium",
        "hard"
      ]
    },
    "EffectScrollRange": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "in",
        "out",
        "continuous"
      ]
    },
    "EffectScaleDirection": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "up",
        "down"
      ]
    },
    "EffectFourDirections": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "left",
        "right",
        "top",
        "bottom"
      ]
    },
    "EffectFourCorners": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
      ]
    },
    "EffectEightDirections": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right"
      ]
    },
    "EffectNineDirections": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right",
        "center"
      ]
    },
    "EffectAxes": {
      "isTopLevelDataNode": false,
      "type": "string",
      "enum": [
        "horizontal",
        "vertical",
        "both"
      ]
    },
    "ArcIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "required": [
        "direction"
      ]
    },
    "CurveIn": {
      "description": "Previous version of ArcIn",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "DropIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "initialScale": {
          "type": "number",
          "minimum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale"
          ]
        }
      ]
    },
    "ExpandIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "$ref": "EffectNineDirections"
        },
        "initialScale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale",
            "direction"
          ]
        }
      ]
    },
    "FadeIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "FlipIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "initialRotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialRotate",
            "direction"
          ]
        }
      ]
    },
    "FloatIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourDirections"
        }
      },
      "required": [
        "direction"
      ]
    },
    "ShuttersIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "shutters": {
          "type": "number",
          "minimum": 2
        },
        "staggered": {
          "type": "boolean"
        }
      },
      "required": [
        "direction",
        "shutters"
      ]
    },
    "FoldIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "initialRotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialRotate",
            "direction"
          ]
        }
      ]
    },
    "SlideIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "initialTranslate": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialTranslate",
            "direction"
          ]
        }
      ]
    },
    "SpinIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "spins": {
          "type": "number",
          "minimum": 0.25
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        },
        "power": {
          "$ref": "EffectPower"
        },
        "initialScale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction",
            "spins"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale",
            "direction",
            "spins"
          ]
        }
      ]
    },
    "BounceIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "anyOf": [
            {
              "$ref": "EffectFourDirections"
            },
            {
              "type": "string",
              "enum": [
                "center"
              ]
            }
          ]
        },
        "power": {
          "$ref": "EffectPower"
        },
        "distanceFactor": {
          "type": "number",
          "minimum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "distanceFactor",
            "direction"
          ]
        }
      ]
    },
    "PunchIn": {
      "description": "Previous version of BounceIn",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "anyOf": [
            {
              "$ref": "EffectFourCorners"
            },
            {
              "type": "string",
              "enum": [
                "center"
              ]
            }
          ]
        },
        "power": {
          "$ref": "EffectPower"
        }
      }
    },
    "GlideIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "startFromOffScreen": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "required": [
        "direction",
        "distance"
      ]
    },
    "GlitchIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "startFromOffScreen": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "required": [
        "direction",
        "distance"
      ]
    },
    "TurnIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourCorners"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "required": [
        "direction"
      ]
    },
    "CircleIn": {
      "description": "Previous version of TurnIn",
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "WinkIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "TiltIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "ShapeIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "shape": {
          "type": "string",
          "enum": [
            "ellipse",
            "circle",
            "rectangle",
            "diamond",
            "window"
          ]
        },
        "direction": {
          "$ref": "EffectNineDirections"
        }
      },
      "required": [
        "shape",
        "direction"
      ]
    },
    "GrowIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "initialScale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "distance",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale",
            "distance",
            "direction"
          ]
        }
      ]
    },
    "FlyIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectEightDirections"
        }
      },
      "required": [
        "direction"
      ]
    },
    "RevealIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourDirections"
        }
      },
      "required": [
        "direction"
      ]
    },
    "BlurIn": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "blur": {
          "type": "number",
          "minimum": 0
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "blur"
          ]
        }
      ]
    },
    "Breathe": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal",
            "center"
          ]
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        }
      },
      "required": [
        "direction",
        "distance"
      ]
    },
    "Blink": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "scale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "distance",
            "scale"
          ]
        }
      ]
    },
    "Pulse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Spin": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "Poke": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity",
            "direction"
          ]
        }
      ]
    },
    "Flash": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "Swing": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "swing": {
          "type": "number"
        },
        "direction": {
          "$ref": "EffectFourDirections"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "swing"
          ]
        }
      ]
    },
    "Flip": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "Rubber": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Fold": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "angle": {
          "type": "number"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "angle",
            "direction"
          ]
        }
      ]
    },
    "Jello": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Wiggle": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Bounce": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Cross": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "direction": {
          "$ref": "EffectEightDirections"
        }
      },
      "required": [
        "direction"
      ]
    },
    "DVD": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "power": {
          "$ref": "EffectPower"
        }
      },
      "required": [
        "power"
      ]
    },
    "ArcScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "BlurScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "blur": {
          "type": "number",
          "minimum": 0
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "blur"
          ]
        }
      ]
    },
    "FadeScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    },
    "FlipScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "rotate": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "rotate"
          ]
        }
      ]
    },
    "GrowScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        },
        "direction": {
          "$ref": "EffectNineDirections"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "MoveScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "angle"
          ]
        },
        {
          "type": "object",
          "required": [
            "distance",
            "angle"
          ]
        }
      ]
    },
    "PanScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "startFromOffScreen": {
          "type": "boolean"
        }
      },
      "required": [
        "direction",
        "distance",
        "startFromOffScreen"
      ]
    },
    "ParallaxScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "speed": {
          "type": "number"
        }
      },
      "required": [
        "speed"
      ]
    },
    "RevealScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "direction": {
          "$ref": "EffectFourDirections"
        }
      },
      "required": [
        "direction"
      ]
    },
    "ShapeScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "shape": {
          "type": "string",
          "enum": [
            "ellipse",
            "circle",
            "rectangle",
            "diamond",
            "window"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "shape"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity",
            "shape"
          ]
        }
      ]
    },
    "ShrinkScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        },
        "direction": {
          "$ref": "EffectNineDirections"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "ShuttersScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "shutters": {
          "type": "number",
          "minimum": 2
        },
        "direction": {
          "$ref": "EffectFourDirections"
        },
        "staggered": {
          "type": "boolean"
        }
      },
      "required": [
        "shutters",
        "direction"
      ]
    },
    "SkewPanScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "skew": {
          "type": "number"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "skew"
          ]
        }
      ]
    },
    "SlideScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "direction": {
          "$ref": "EffectFourDirections"
        }
      },
      "required": [
        "direction"
      ]
    },
    "Spin3dScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "rotate": {
          "type": "number"
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "rotate"
          ]
        }
      ]
    },
    "SpinScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "spins": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        },
        "power": {
          "$ref": "EffectPower"
        },
        "scale": {
          "type": "number",
          "minimum": 0
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "spins",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "spins",
            "scale"
          ]
        }
      ]
    },
    "StretchScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "stretch": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "stretch"
          ]
        }
      ]
    },
    "TiltScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "required": [
        "direction"
      ]
    },
    "TurnScroll": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "$ref": "EffectScrollRange"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "spin": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "spin",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "spin",
            "scale"
          ]
        }
      ]
    },
    "TrackMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "axis": {
          "$ref": "EffectAxes"
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      }
    },
    "Tilt3DMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        },
        "perspective": {
          "type": "number",
          "minimum": 0
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle",
            "perspective"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "SwivelMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        },
        "perspective": {
          "type": "number",
          "minimum": 0
        },
        "inverted": {
          "type": "boolean"
        },
        "pivotAxis": {
          "type": "string",
          "enum": [
            "center-vertical",
            "center-horizontal",
            "top",
            "bottom",
            "left",
            "right"
          ]
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle",
            "perspective"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "BlobMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "ScaleMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "axis": {
          "$ref": "EffectAxes"
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        },
        "scaleDirection": {
          "$ref": "EffectScaleDirection"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "scaleDirection"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "Track3DMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "perspective": {
          "type": "number",
          "minimum": 0
        },
        "axis": {
          "$ref": "EffectAxes"
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle",
            "perspective"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "AiryMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "axis": {
          "$ref": "EffectAxes"
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "BlurMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "blur": {
          "type": "number",
          "minimum": 1
        },
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "angle",
            "scale"
          ]
        }
      ]
    },
    "SkewMouse": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "distance": {
          "$ref": "UnitLengthPercentage"
        },
        "axis": {
          "$ref": "EffectAxes"
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "$ref": "EffectPower"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "BgCloseUp": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "scale": {
          "type": "number"
        }
      }
    },
    "BgFade": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "required": [
        "range"
      ]
    },
    "BgFadeBack": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "scale": {
          "type": "number"
        }
      }
    },
    "BgFake3D": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "zoom": {
          "type": "number"
        },
        "stretch": {
          "type": "number"
        }
      }
    },
    "BgPan": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "speed": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "BgParallax": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "speed": {
          "type": "number"
        }
      }
    },
    "BgPullBack": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "scale": {
          "type": "number"
        }
      }
    },
    "BgReveal": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "BgRotate": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "angle": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      }
    },
    "BgSkew": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "angle": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      }
    },
    "BgZoom": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "zoom": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "ImageParallax": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "speed": {
          "type": "number"
        },
        "inverted": {
          "type": "boolean"
        }
      }
    },
    "Kaleidoscope": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "segments": {
          "type": "number"
        },
        "rotation": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        }
      }
    },
    "RGBSplit": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "splitType": {
          "type": "string",
          "enum": [
            "all",
            "red-cyan",
            "green-magenta",
            "blue-yellow"
          ]
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "intensity": {
          "type": "number"
        },
        "frequency": {
          "type": "number"
        },
        "octaves": {
          "type": "number",
          "minimum": 1
        },
        "speed": {
          "type": "number"
        },
        "radius": {
          "type": "number"
        }
      }
    },
    "RGBOrb": {
      "$ref": "RGBSplit",
      "isTopLevelDataNode": true
    },
    "SlitScan": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "speed": {
          "type": "number"
        },
        "intensity": {
          "type": "number"
        },
        "frequency": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "x",
            "y"
          ]
        }
      }
    },
    "NoisyTrack": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "radius": {
          "type": "number"
        },
        "spread": {
          "type": "number"
        }
      }
    },
    "Smear": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "radius": {
          "type": "number"
        },
        "intensity": {
          "type": "number"
        },
        "duration": {
          "type": "number",
          "minimum": 1
        },
        "decayPower": {
          "type": "number"
        }
      }
    },
    "Ripples": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "frequency": {
          "type": "number"
        },
        "octaves": {
          "type": "number",
          "minimum": 1
        },
        "aspectRatio": {
          "type": "number"
        },
        "intensity": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        }
      }
    }
  },
  "fixerVersions.json": {
    "FixerVersions": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "viewer_fixer": {
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": {
                "type": "number"
              }
            },
            {
              "type": "string",
              "maxLength": 400
            }
          ]
        },
        "migration_fixer": {
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": {
                "type": "number"
              }
            },
            {
              "type": "string",
              "maxLength": 400
            }
          ]
        },
        "ds_fixer": {
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": {
                "type": "number"
              }
            },
            {
              "type": "string",
              "maxLength": 400
            }
          ]
        }
      }
    }
  },
  "grouping.json": {
    "GroupRelation": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "groupId": {
          "type": "string"
        }
      }
    }
  },
  "innerElements.json": {
    "InnerElementQueries": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "dataQuery": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "document_data",
          "isTopLevelDataNode": false
        },
        "innerElementsQuery": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "isRefOwner": true,
          "referencedMap": "innerElements",
          "isTopLevelDataNode": false
        },
        "presetsQuery": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "isRefOwner": true,
          "referencedMap": "presets",
          "isTopLevelDataNode": false,
          "isRelationalSplit": true
        },
        "slotsQuery": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "ref"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "isRefOwner": true,
          "referencedMap": "slots",
          "isTopLevelDataNode": false
        },
        "styleId": {
          "type": [
            "string",
            "null"
          ],
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": false,
          "shouldCollect": true,
          "referencedMap": "theme_data",
          "isTopLevelDataNode": false,
          "isRelationalSplit": true
        }
      }
    },
    "InnerElement": {
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "type": "object",
          "properties": {
            "referredType": {
              "type": "string"
            }
          },
          "required": [
            "referredType"
          ]
        },
        {
          "type": "object",
          "$ref": "InnerElementQueries"
        }
      ]
    }
  },
  "intent.json": {
    "Intent": {
      "isTopLevelDataNode": true,
      "type": "object",
      "required": [
        "intent"
      ],
      "properties": {
        "intent": {
          "type": "string",
          "maxLength": 30
        }
      }
    }
  },
  "layout.json": {
    "KeywordSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "auto",
            "maxContent",
            "minContent",
            "unset",
            "fit"
          ]
        }
      },
      "required": [
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "Calculation": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "Calc"
          ]
        },
        "value": {
          "type": "string"
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "CalculationFormula": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "CalcFormula"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "formula": {
              "type": "string",
              "description": "A valid css calc formula, with constants formatted like ${constName}"
            },
            "values": {
              "type": "object",
              "properties": {},
              "additionalProperties": {
                "type": "object",
                "anyOf": [
                  {
                    "$ref": "UnitSize"
                  },
                  {
                    "$ref": "SystemVariableSize"
                  },
                  {
                    "$ref": "NumberSize"
                  }
                ]
              },
              "minProperties": 1
            }
          },
          "required": [
            "formula",
            "values"
          ]
        }
      },
      "required": [
        "value",
        "type"
      ],
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "AspectRatioSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "aspectRatio"
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "required": [
        "value",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "SystemVariableSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "SystemVariable"
          ]
        },
        "value": {
          "enum": [
            "siteWidth",
            "topBannerHeight"
          ]
        }
      },
      "required": [
        "type",
        "value"
      ],
      "isTopLevelDataNode": false
    },
    "NumberSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "Number"
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "required": [
        "type",
        "value"
      ],
      "isTopLevelDataNode": false
    },
    "LayoutSize": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "UnitSize"
        },
        {
          "$ref": "Calculation"
        },
        {
          "$ref": "CalculationFormula"
        },
        {
          "$ref": "SystemVariableSize"
        },
        {
          "$ref": "KeywordSize"
        }
      ],
      "isTopLevelDataNode": false
    },
    "SpxStopper": {
      "type": "object",
      "properties": {
        "min": {
          "$ref": "LayoutSize"
        },
        "max": {
          "$ref": "LayoutSize"
        }
      }
    },
    "StretchWithSoftMargins": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "StretchWithSoftMargins"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "margins": {
              "type": "object",
              "properties": {
                "left": {
                  "$ref": "LayoutSize"
                },
                "right": {
                  "$ref": "LayoutSize"
                }
              }
            }
          }
        }
      },
      "required": [
        "type",
        "value"
      ],
      "isTopLevelDataNode": false
    },
    "Height": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "AspectRatioSize"
        },
        {
          "$ref": "LayoutSize"
        }
      ],
      "isTopLevelDataNode": false
    },
    "MinMaxSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "default": "MinMaxSize"
        },
        "min": {
          "$ref": "LayoutSize"
        },
        "max": {
          "$ref": "LayoutSize"
        }
      },
      "required": [
        "min",
        "max",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "GridTrackSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "$ref": "LayoutSize"
        },
        "max": {
          "$ref": "LayoutSize"
        },
        "value": {
          "type": [
            "string",
            "number",
            "array"
          ],
          "items": {
            "$ref": "BaseGridTrackSize"
          }
        },
        "length": {
          "type": "string",
          "anyOf": [
            {
              "type": "number",
              "$ref": "NumberThatCanConnectToAVariable"
            },
            {
              "type": "string",
              "$ref": "KeywordLength"
            }
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "BaseGridTrackSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "$ref": "LayoutSize"
        },
        "max": {
          "$ref": "LayoutSize"
        },
        "value": {
          "type": [
            "string",
            "number"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "KeywordLength": {
      "enum": [
        "auto-fill",
        "auto-fit"
      ],
      "isTopLevelDataNode": false
    },
    "ItemsAlignment": {
      "type": "string",
      "enum": [
        "start",
        "end",
        "center",
        "stretch",
        "content"
      ],
      "isTopLevelDataNode": false
    },
    "ContainerLayoutIntent": {
      "type": "object",
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "Alignment": {
      "type": "string",
      "enum": [
        "auto",
        "stretch",
        "start",
        "center",
        "end"
      ],
      "isTopLevelDataNode": false
    },
    "Direction": {
      "enum": [
        "rtl",
        "ltr"
      ]
    },
    "Margins": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "LayoutSize"
        },
        "bottom": {
          "$ref": "LayoutSize"
        },
        "left": {
          "$ref": "LayoutSize"
        },
        "right": {
          "$ref": "LayoutSize"
        }
      },
      "isTopLevelDataNode": false
    },
    "Padding": {
      "type": "object",
      "properties": {
        "top": {
          "$ref": "LayoutSize"
        },
        "bottom": {
          "$ref": "LayoutSize"
        },
        "left": {
          "$ref": "LayoutSize"
        },
        "right": {
          "$ref": "LayoutSize"
        }
      },
      "isTopLevelDataNode": false
    },
    "FlexDirection": {
      "enum": [
        "row",
        "rowReverse",
        "column",
        "columnReverse"
      ],
      "isTopLevelDataNode": false
    },
    "FlexWrap": {
      "enum": [
        "nowrap",
        "wrap"
      ],
      "isTopLevelDataNode": false
    },
    "Overflow": {
      "enum": [
        "auto",
        "scroll",
        "hidden",
        "visible",
        "clip"
      ],
      "isTopLevelDataNode": false
    },
    "Contain": {
      "enum": [
        "none",
        "paint"
      ],
      "isTopLevelDataNode": false
    },
    "AutoFlow": {
      "enum": [
        "row",
        "column",
        "dense",
        "row dense",
        "column dense"
      ],
      "isTopLevelDataNode": false
    },
    "JustifyContent": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ],
      "isTopLevelDataNode": false
    },
    "AlignContent": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ],
      "isTopLevelDataNode": false
    },
    "GridArea": {
      "type": "object",
      "properties": {
        "rowStart": {
          "$ref": "NumberThatCanConnectToAVariable"
        },
        "columnStart": {
          "$ref": "NumberThatCanConnectToAVariable"
        },
        "rowEnd": {
          "$ref": "NumberThatCanConnectToAVariable"
        },
        "columnEnd": {
          "$ref": "NumberThatCanConnectToAVariable"
        }
      },
      "required": [
        "rowStart",
        "rowEnd",
        "columnStart",
        "columnEnd"
      ],
      "isTopLevelDataNode": false
    },
    "LayoutData": {
      "type": "object",
      "properties": {
        "componentLayouts": {
          "type": [
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": []
        },
        "itemLayouts": {
          "type": [
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": []
        },
        "containerLayouts": {
          "type": [
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": []
        }
      },
      "isTopLevelDataNode": false
    },
    "SingleLayoutData": {
      "type": "object",
      "properties": {
        "componentLayout": {
          "type": "object",
          "default": {},
          "anyOf": [
            {
              "$ref": "ComponentLayout"
            },
            {
              "$ref": "ClassicComponentLayout"
            }
          ]
        },
        "itemLayout": {
          "type": "object",
          "default": {},
          "anyOf": [
            {
              "$ref": "GridItemLayout"
            },
            {
              "$ref": "FixedItemLayout"
            },
            {
              "$ref": "FlexItemLayout"
            },
            {
              "$ref": "OrganizerItemLayout"
            },
            {
              "$ref": "StackItemLayout"
            },
            {
              "$ref": "MultiColumnsItemLayout"
            },
            {
              "$ref": "MeshItemLayout"
            },
            {
              "$ref": "FixedPositionItemLayout"
            },
            {
              "$ref": "BackgroundLayerItemLayout"
            },
            {
              "$ref": "MasterPageItemLayout"
            }
          ]
        },
        "containerLayout": {
          "type": "object",
          "default": {},
          "anyOf": [
            {
              "$ref": "GridContainerLayout"
            },
            {
              "$ref": "FlexContainerLayout"
            },
            {
              "$ref": "OrganizerContainerLayout"
            },
            {
              "$ref": "StackContainerLayout"
            },
            {
              "$ref": "MultiColumnsContainerLayout"
            },
            {
              "$ref": "MeshContainerLayout"
            }
          ]
        },
        "spx": {
          "$ref": "SPXReferenceDefinition"
        }
      },
      "isTopLevelDataNode": true,
      "required": [
        "itemLayout",
        "componentLayout",
        "containerLayout"
      ]
    },
    "ScrollSnapType": {
      "enum": [
        "mandatory",
        "proximity",
        "none"
      ],
      "isTopLevelDataNode": false
    },
    "ScrollSnapDirection": {
      "enum": [
        "x",
        "y"
      ],
      "isTopLevelDataNode": false
    },
    "ScrollBehavior": {
      "enum": [
        "auto",
        "smooth"
      ],
      "isTopLevelDataNode": false
    },
    "ScrollSnapAlignType": {
      "enum": [
        "center",
        "end",
        "start",
        "none"
      ],
      "isTopLevelDataNode": false
    },
    "ScrollSnapData": {
      "type": "object",
      "properties": {
        "scrollSnapType": {
          "$ref": "ScrollSnapType"
        },
        "scrollSnapDirection": {
          "$ref": "ScrollSnapDirection"
        }
      },
      "isTopLevelDataNode": false
    },
    "ContentMaxWidth": {
      "type": "object",
      "properties": {
        "maxWidth": {
          "$ref": "UnitSize"
        },
        "align": {
          "type": "string",
          "enum": [
            "center",
            "right",
            "left"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "GridContainerLayout": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "rows": {
          "type": "array",
          "items": {
            "$ref": "GridTrackSize"
          }
        },
        "columns": {
          "type": "array",
          "items": {
            "$ref": "GridTrackSize"
          }
        },
        "rowGap": {
          "$ref": "LayoutSize"
        },
        "columnGap": {
          "$ref": "LayoutSize"
        },
        "autoRows": {
          "type": "array",
          "items": {
            "$ref": "GridTrackSize"
          }
        },
        "autoColumns": {
          "type": "array",
          "items": {
            "$ref": "GridTrackSize"
          }
        },
        "autoFlow": {
          "$ref": "AutoFlow"
        },
        "overflowY": {
          "$ref": "Overflow"
        },
        "overflowX": {
          "$ref": "Overflow"
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "$ref": "Padding"
        },
        "scrollSnap": {
          "$ref": "ScrollSnapData"
        },
        "scrollBehavior": {
          "$ref": "ScrollBehavior"
        },
        "contentMaxWidth": {
          "$ref": "ContentMaxWidth"
        },
        "type": {
          "type": "string",
          "enum": [
            "GridContainerLayout"
          ]
        },
        "contain": {
          "$ref": "Contain"
        },
        "spxStopper": {
          "$ref": "SpxStopper"
        }
      },
      "required": [
        "rows",
        "columns"
      ]
    },
    "ComponentLayout": {
      "allOf": [
        {
          "$ref": "BaseComponentLayout"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "ComponentLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "ClassicComponentLayout": {
      "allOf": [
        {
          "$ref": "BaseComponentLayout"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "ClassicComponentLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "BaseComponentLayout": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ],
          "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
        },
        "width": {
          "type": "object",
          "oneOf": [
            {
              "$ref": "LayoutSize"
            },
            {
              "$ref": "StretchWithSoftMargins"
            }
          ]
        },
        "height": {
          "$ref": "Height"
        },
        "minWidth": {
          "$ref": "LayoutSize"
        },
        "minHeight": {
          "$ref": "LayoutSize"
        },
        "maxWidth": {
          "$ref": "LayoutSize"
        },
        "maxHeight": {
          "$ref": "LayoutSize"
        },
        "margins": {
          "$ref": "Margins"
        },
        "direction": {
          "$ref": "Direction"
        },
        "rotationInDegrees": {
          "type": "number"
        },
        "fixed": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        }
      }
    },
    "GridItemLayout": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "gridArea": {
              "$ref": "GridArea"
            },
            "alignSelf": {
              "$ref": "ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "GridItemLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "FixedItemLayout": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "alignSelf": {
              "$ref": "ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "FixedItemLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "BackgroundLayerItemLayout": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "alignSelf": {
              "$ref": "ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "ItemsAlignment"
            },
            "type": {
              "type": "string",
              "enum": [
                "BackgroundLayerItemLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "FixedPositionItemLayout": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FixedPositionItemLayout"
              ]
            }
          }
        }
      ]
    },
    "MasterPageItemLayout": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "isFixed": {
              "type": "boolean"
            },
            "type": {
              "type": "string",
              "enum": [
                "MasterPageItemLayout"
              ]
            }
          }
        }
      ]
    },
    "FlexContainerLayoutBase": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "direction": {
              "$ref": "FlexDirection"
            },
            "wrap": {
              "$ref": "FlexWrap"
            },
            "alignItems": {
              "$ref": "ItemsAlignment"
            },
            "justifyContent": {
              "$ref": "JustifyContent"
            },
            "alignContent": {
              "$ref": "AlignContent"
            },
            "overflowY": {
              "$ref": "Overflow"
            },
            "overflowX": {
              "$ref": "Overflow"
            },
            "hideScrollbar": {
              "type": "boolean"
            },
            "padding": {
              "$ref": "Padding"
            },
            "scrollSnap": {
              "$ref": "ScrollSnapData"
            },
            "scrollBehaviour": {
              "$ref": "ScrollBehavior"
            },
            "contentMaxWidth": {
              "$ref": "ContentMaxWidth"
            },
            "spxStopper": {
              "$ref": "SpxStopper"
            },
            "rowGap": {
              "$ref": "LayoutSize"
            },
            "columnGap": {
              "$ref": "LayoutSize"
            },
            "contain": {
              "$ref": "Contain"
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "FlexContainerLayout": {
      "allOf": [
        {
          "$ref": "FlexContainerLayoutBase"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FlexContainerLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "FlexItemLayoutBase": {
      "allOf": [
        {
          "$ref": "BaseItemLayout"
        },
        {
          "type": "object",
          "properties": {
            "order": {
              "type": "number"
            },
            "alignSelf": {
              "$ref": "ItemsAlignment"
            },
            "justifySelf": {
              "$ref": "ItemsAlignment"
            },
            "basis": {
              "$ref": "LayoutSize"
            },
            "grow": {
              "type": "number"
            },
            "shrink": {
              "type": "number"
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "FlexItemLayout": {
      "allOf": [
        {
          "$ref": "FlexItemLayoutBase"
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "FlexItemLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "OrganizerContainerLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "ContainerLayoutIntent"
        },
        {
          "$ref": "FlexContainerLayoutBase"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "OrganizerContainerLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "MultiColumnsContainerLayout": {
      "type": "object",
      "properties": {
        "alignContent": {
          "$ref": "Alignment"
        },
        "columnCount": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "padding": {
          "$ref": "Padding"
        },
        "rowGap": {
          "$ref": "LayoutSize"
        },
        "columnGap": {
          "$ref": "LayoutSize"
        },
        "spxStopper": {
          "$ref": "SpxStopper"
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsContainerLayout"
          ]
        }
      },
      "required": [
        "columnCount",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "MultiColumnsItemLayout": {
      "type": "object",
      "properties": {
        "margins": {
          "$ref": "Margins"
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsItemLayout"
          ]
        }
      },
      "required": [
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "OrganizerItemLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "FlexItemLayoutBase"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "OrganizerItemLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "StackContainerLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "FlexContainerLayoutBase"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "StackContainerLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "StackItemLayout": {
      "type": "object",
      "allOf": [
        {
          "$ref": "FlexItemLayoutBase"
        },
        {
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "StackItemLayout"
              ]
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "LayoutDataItem": {
      "type": "object",
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "BaseItemLayout": {
      "allOf": [
        {
          "$ref": "LayoutDataItem"
        },
        {
          "type": "object",
          "properties": {
            "scrollSnapAlign": {
              "$ref": "ScrollSnapAlignType"
            },
            "pinnedToContainer": {
              "type": "boolean"
            },
            "margins": {
              "$ref": "Margins"
            },
            "position": {
              "$ref": "PositionType"
            },
            "isInFront": {
              "type": "boolean"
            },
            "top": {
              "$ref": "LayoutSize"
            },
            "bottom": {
              "$ref": "LayoutSize"
            },
            "left": {
              "$ref": "LayoutSize"
            },
            "right": {
              "$ref": "LayoutSize"
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "PositionType": {
      "enum": [
        "sticky",
        "stickyToHeader",
        "absolute",
        "relative"
      ]
    },
    "WedgeItem": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "distance": {
          "$ref": "LayoutSize"
        },
        "startsAtRow": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        }
      },
      "required": [
        "distance",
        "startsAtRow"
      ]
    },
    "MeshGridArea": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "rowStart": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "rowEnd": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 2
        }
      },
      "required": [
        "rowStart",
        "rowEnd"
      ]
    },
    "ItemMeshData": {
      "type": "object",
      "properties": {
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "rotationInDegrees": {
          "type": "number"
        }
      },
      "required": [
        "width",
        "height",
        "x",
        "y"
      ]
    },
    "MeshItemLayout": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "justifySelf": {
          "$ref": "ItemsAlignment"
        },
        "margins": {
          "$ref": "Margins"
        },
        "meshData": {
          "$ref": "ItemMeshData"
        },
        "type": {
          "type": "string",
          "enum": [
            "MeshItemLayout"
          ]
        },
        "isAbsolutePosition": {
          "type": "boolean"
        }
      },
      "required": [
        "meshData",
        "type"
      ]
    },
    "ContainerMeshData": {
      "type": "object",
      "properties": {
        "contentHeight": {
          "oneOf": [
            {
              "type": "number"
            },
            {
              "type": "string",
              "enum": [
                "auto"
              ]
            }
          ]
        }
      },
      "required": [
        "contentHeight"
      ]
    },
    "ContentArea": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "alignment": {
          "$ref": "ItemsAlignment"
        },
        "width": {
          "$ref": "LayoutSize"
        },
        "ratio": {
          "type": "number"
        }
      },
      "required": [
        "alignment",
        "width"
      ]
    },
    "MeshContainerLayout": {
      "type": "object",
      "isTopLevelDataNode": false,
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MeshContainerLayout"
          ]
        },
        "meshData": {
          "$ref": "ContainerMeshData"
        },
        "contentArea": {
          "$ref": "ContentArea"
        }
      }
    }
  },
  "layoutSettings.json": {
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "autoResponsivenessSettings": {
          "type": "object",
          "properties": {
            "mode": {
              "enum": [
                "adaptive"
              ]
            },
            "lastGroupingsHash": {
              "type": "string"
            },
            "lastMobileAlgoVersion": {
              "type": "string"
            }
          }
        },
        "type": {
          "enum": [
            "LayoutSettings"
          ]
        }
      },
      "isTopLevelDataNode": true
    }
  },
  "manifest.json": {
    "Manifest": {
      "isTopLevelDataNode": true,
      "type": "object",
      "properties": {
        "gfpp": {
          "$ref": "GfppConfig"
        },
        "behavior": {
          "$ref": "ComponentStageBehavior"
        },
        "displayName": {
          "$ref": "TranslatableString"
        },
        "connections": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "*": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "gfpp": {
                  "$ref": "GfppConfig"
                }
              }
            }
          }
        }
      }
    },
    "ComponentStageBehavior": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "duplicatable": {
          "type": "boolean"
        },
        "resizable": {
          "type": "boolean"
        },
        "preventHide": {
          "type": "boolean"
        },
        "dataEditOptions": {
          "type": "string",
          "maxLength": 50
        },
        "closed": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "selectable": {
              "type": "boolean"
            },
            "hideFromHierarchy": {
              "type": "boolean"
            }
          }
        }
      }
    },
    "GfppConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "desktop": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "mainAction1": {
              "$ref": "MainActionConfig"
            },
            "mainAction2": {
              "$ref": "MainActionConfig"
            },
            "iconButtons": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "settings": {
                  "$ref": "IconButtonConfig"
                },
                "add": {
                  "$ref": "IconButtonConfig"
                },
                "design": {
                  "$ref": "IconButtonConfig"
                },
                "crop": {
                  "$ref": "GfppIconButtonConfig"
                },
                "filters": {
                  "$ref": "GfppIconButtonConfig"
                },
                "animation": {
                  "$ref": "GfppIconButtonConfig"
                },
                "link": {
                  "$ref": "GfppIconButtonConfig"
                },
                "stretch": {
                  "$ref": "GfppIconButtonConfig"
                },
                "layout": {
                  "$ref": "IconButtonConfig"
                },
                "upgrade": {
                  "type": "object",
                  "anyOf": [
                    {
                      "$ref": "IconButtonConfig"
                    },
                    {
                      "$ref": "GfppUpgradeConfig"
                    }
                  ]
                },
                "connect": {
                  "$ref": "GfppIconButtonConfig"
                },
                "pinMode": {
                  "$ref": "GfppIconButtonConfig"
                },
                "customConnect": {
                  "$ref": "GfppIconActionConfig"
                },
                "focalPoint": {
                  "$ref": "GfppIconButtonConfig"
                },
                "presets": {
                  "$ref": "GfppIconButtonConfig"
                }
              }
            },
            "helpId": {
              "type": "string",
              "maxLength": 50
            }
          }
        }
      }
    },
    "MainActionConfig": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "GfppMainActionDefinition"
        },
        {
          "$ref": "GfppMainActionButtonConfig"
        }
      ]
    },
    "GfppMainActionButtonConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT",
            "DEFAULT1",
            "DEFAULT2"
          ]
        }
      }
    },
    "GfppMainActionDefinition": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior",
        "label"
      ],
      "oneOf": [
        {
          "required": [
            "actionId"
          ]
        },
        {
          "required": [
            "actionType"
          ]
        }
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        },
        "label": {
          "$ref": "TranslatableString"
        },
        "actionType": {
          "enum": [
            "settings",
            "layout",
            "design",
            "manage",
            "background"
          ]
        }
      }
    },
    "IconButtonConfig": {
      "type": "object",
      "anyOf": [
        {
          "$ref": "GfppIconActionConfig"
        },
        {
          "$ref": "GfppIconButtonConfig"
        }
      ]
    },
    "GfppIconButtonConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT"
          ]
        }
      }
    },
    "GfppIconActionConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior",
        "actionId"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        }
      }
    },
    "GfppUpgradeConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "SITE_UPGRADE"
          ]
        }
      }
    },
    "TranslatableString": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "value",
        "shouldTranslate"
      ],
      "properties": {
        "value": {
          "type": "string",
          "maxLength": 100
        },
        "shouldTranslate": {
          "type": "boolean"
        }
      }
    }
  },
  "measurements.json": {
    "MeasurementsData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MeasurementsData"
          ]
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "viewportSize": {
          "type": "number",
          "minimum": 0
        },
        "isFixedPosition": {
          "type": "boolean"
        }
      },
      "required": [
        "type",
        "width",
        "height",
        "x",
        "y",
        "viewportSize"
      ]
    }
  },
  "migration.json": {
    "migration": {
      "isTopLevelDataNode": true,
      "type": "object",
      "required": [
        "migrationStatus",
        "migrationSource"
      ],
      "properties": {
        "migrationStatus": {
          "type": "string",
          "maxLength": 50
        },
        "migrationSource": {
          "enum": [
            "classic",
            "figma",
            "site-description-file",
            "editor-x",
            "editor-x-force-migration",
            "site-generation"
          ]
        },
        "migrationRevision": {
          "type": "string",
          "maxLength": 50
        }
      }
    }
  },
  "mobileHints.json": {
    "MobileHints": {
      "type": "object",
      "properties": {
        "author": {
          "enum": [
            "studio",
            "duplicate"
          ],
          "description": "Data source"
        },
        "isLocked": {
          "type": "boolean",
          "description": "Skip element because user locked this element"
        },
        "hidden": {
          "type": "boolean",
          "description": "Should hide component on mobile"
        },
        "offsetX": {
          "type": "number",
          "description": "Horizontal distance from the corner of the previous sibling"
        },
        "offsetY": {
          "type": "number",
          "description": "Vertical distance from the corner of the previous sibling"
        },
        "offsetOrigin": {
          "enum": [
            "leftTop",
            "rightTop",
            "leftBottom"
          ],
          "description": "The corner of the previous sibling that the offsets are applied to"
        },
        "originalCompId": {
          "type": "string",
          "description": "Id of source component"
        },
        "recommendedScale": {
          "type": "number",
          "description": "Recommended component scale on mobile"
        },
        "recommendedWidth": {
          "type": "number",
          "description": "Recommended component width on mobile"
        },
        "recommendedHeight": {
          "type": "number",
          "description": "Recommended component height on mobile"
        },
        "orderIndex": {
          "type": "number",
          "description": "Recommended index of component in parent container"
        },
        "modifiedByUser": {
          "type": "boolean",
          "description": "Indicate is component was changed by user on mobile"
        },
        "shouldBeForceConverted": {
          "type": "boolean",
          "description": "Indicate that component need to be force converted to mobile"
        }
      },
      "isTopLevelDataNode": true
    }
  },
  "naming.json": {
    "naming": {
      "isTopLevelDataNode": true,
      "type": "object",
      "required": [
        "name"
      ],
      "properties": {
        "name": {
          "type": "string"
        }
      }
    }
  },
  "notifications.json": {
    "Notifications": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "anyOf": [
              {
                "$ref": "SectionsFixer"
              },
              {
                "$ref": "PinToSticky"
              }
            ]
          }
        }
      }
    },
    "SectionsFixer": {
      "type": "object",
      "properties": {
        "fixedPages": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 50
          }
        },
        "type": {
          "type": "string",
          "enum": [
            "SectionsFixer"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "PinToSticky": {
      "type": "object",
      "properties": {
        "sticky": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0,
          "default": 0
        },
        "pinned": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "masterVertical": {
          "type": "number",
          "minimum": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "PinToSticky"
          ]
        }
      },
      "required": [],
      "isTopLevelDataNode": false
    }
  },
  "pageSections.json": {
    "pageSections": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "isSectionsEnabled": {
          "type": "boolean"
        },
        "isMigratedFromAdi": {
          "type": "boolean",
          "default": false
        },
        "preserveEditorFontsOrder": {
          "type": "boolean",
          "default": false
        },
        "migrationVersion": {
          "type": "string",
          "maxLength": 20
        },
        "migrationSkipCount": {
          "type": "number"
        },
        "sections": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string"
              },
              "contentRole": {
                "type": "string"
              },
              "children": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            }
          }
        }
      }
    }
  },
  "patterns.json": {
    "Pattern": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "items": {
          "type": [
            "array",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#",
          "refTypes": [
            "NthChild"
          ],
          "default": []
        }
      },
      "required": [
        "items"
      ]
    },
    "NthChild": {
      "type": "object",
      "properties": {
        "repeat": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0,
          "default": 0
        },
        "offset": {
          "type": "number",
          "multipleOf": 1
        },
        "variant": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": false,
          "referencedMap": "variants_data",
          "refTypes": [
            "RepeaterPattern"
          ]
        }
      },
      "required": [
        "offset",
        "variant"
      ],
      "isTopLevelDataNode": true
    }
  },
  "presets.json": {
    "PresetData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "layout": {
          "type": "string",
          "maxLength": 100
        },
        "style": {
          "type": "string",
          "maxLength": 100
        }
      },
      "required": [
        "layout",
        "style"
      ]
    }
  },
  "props.json": {
    "FontsEnum": {
      "langsKey": "System.font",
      "type": "string",
      "default": "arial",
      "enum": [
        "lucidaSansConsole",
        "palatinoLinotype",
        "americantypwrteritcw01--731025",
        "anton",
        "arial",
        "arialBlack",
        "avenida-w01",
        "basic",
        "caudex",
        "clarendon-w01-medium-692107",
        "comicSansMS",
        "cookie",
        "coquette-w00-light",
        "courierNew",
        "din-next-w01-light",
        "droid-serif-w01-regular",
        "eb garamond",
        "enriqueta",
        "forum",
        "georgia",
        "helvetica-w01-roman",
        "helvetica-w01-bold",
        "helvetica-w01-light",
        "impact",
        "jockey one",
        "jura",
        "kelly slab",
        "lobster",
        "lucidaConsole",
        "marck script",
        "monoton",
        "noticia text",
        "open sans",
        "open sans condensed",
        "palatino linotype",
        "patrick hand",
        "play",
        "reklamescriptw00-medium",
        "sacramento",
        "sarina",
        "signika",
        "soho-w01-thin-condensed",
        "tahoma",
        "timesNewRoman",
        "verdana",
        "bodoni-w01-poster",
        "ｍｓ ゴシック",
        "ｍｓ 明朝",
        "ｍｓ ｐゴシック",
        "ｍｓ ｐ明朝",
        "meiryo",
        "メイリオ",
        "bm-hanna",
        "돋움",
        "fbbluegothicl",
        "fbchamblue",
        "fbgreen",
        "fbneogothic",
        "fbplum",
        "굴림",
        "맑은 고딕",
        "nanumgothic-regular",
        "ahmedltw20-outlineregul",
        "amiri",
        "arabictypesettingw23-re",
        "arian-lt-w20-regular",
        "arian-lt-w20-light",
        "coheadlinew23-arabicbol",
        "dinnextltw23-ultralight",
        "droid-naskh",
        "janna-lt-w20-regular",
        "kufi-lt-w20-regular",
        "midan-w20",
        "helveticaneueltw20-ligh",
        "tanseekmodernw20-light",
        "adler-w26-regular",
        "alef-regular",
        "almoni-dl-aaa-700",
        "almoni-dl-aaa-300",
        "almoni-dl-aaa-400",
        "asimon-aaa-400",
        "atlas-aaa-500",
        "chips-w26-normal",
        "frank-ruhl-w26-regular",
        "gulash-w26-regular",
        "haim-arukeem-w26-medium",
        "miriam-w26-medium",
        "mixtape-aaa-400",
        "museum-aaa-400",
        "nekudot-w26-bold",
        "omes-aaa-400",
        "opensanshebrewcondensed-regular",
        "shabazi-w26-bold",
        "amatic sc",
        "braggadocio-w01",
        "chelsea market",
        "corben",
        "fredericka the great",
        "geotica-w01-four-open",
        "helvetica neue",
        "helvetica neue italic",
        "helvetica neue medium",
        "helvetica neue thin",
        "itc-arecibo-w01-regular",
        "josefin slab",
        "lucida sans unicode",
        "marzo-w00-regular",
        "mr de haviland",
        "museo-w01-700",
        "museo-slab-w01-100",
        "niconne",
        "nimbus-sans-tw01con",
        "overlock",
        "pacifica-w00-condensed",
        "raleway",
        "rosewood-w01-regular",
        "snellroundhandw01-scrip",
        "spinnaker",
        "stencil-w01-bold"
      ],
      "isTopLevelDataNode": false
    },
    "DefaultProperties": {
      "type": "object",
      "properties": {
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      },
      "isTopLevelDataNode": true
    },
    "FlipProperties": {
      "type": "object",
      "properties": {
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ],
          "default": "none",
          "description": "Defines a flip axis for the content"
        }
      },
      "isTopLevelDataNode": false
    },
    "VideoBackgroundProperties": {
      "type": "object",
      "properties": {
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      },
      "isTopLevelDataNode": false
    },
    "CardsLayoutProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right",
                "justify"
              ],
              "default": "left"
            },
            "gap": {
              "type": "object",
              "properties": {
                "vertical": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0,
                  "description": "sets the vertical gap (in px) between items of a repeater"
                },
                "horizontal": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100,
                  "default": 0,
                  "description": "sets the horizontal gap (in px) between items of a repeater"
                }
              },
              "default": {}
            },
            "direction": {
              "enum": [
                "rtl",
                "ltr"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VerticalLayoutProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "gap": {
              "type": "number",
              "default": 10,
              "description": "sets the gap (in px) between items of a vertical repeater"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "DisableableProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "isDisabled": {
              "type": "boolean",
              "description": "disables the component"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ClassicSectionProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "mediaBackgroundPadding": {
              "type": [
                "object",
                "null"
              ],
              "maxProperties": 1,
              "properties": {
                "top": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": 0,
                  "description": "value of the mediaBackgroundPadding"
                },
                "bottom": {
                  "type": [
                    "number",
                    "null"
                  ],
                  "minimum": 0,
                  "description": "value of the mediaBackgroundPadding"
                }
              }
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StripColumnsContainerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "columnsMargin": {
              "type": "number",
              "default": 15
            },
            "frameMargin": {
              "type": "number",
              "default": 15
            },
            "fullWidth": {
              "type": "boolean",
              "default": true
            },
            "fullHeight": {
              "type": "boolean",
              "default": false
            },
            "rowMargin": {
              "type": "number",
              "default": 15
            },
            "siteMargin": {
              "type": "number",
              "default": 30
            },
            "horizontalPaddingOnMobile": {
              "type": "number"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ColumnProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "background": {
              "type": [
                "string",
                "null"
              ],
              "pseudoType": [
                "ref"
              ]
            },
            "alignment": {
              "type": "number",
              "default": 50,
              "minimum": 0,
              "maximum": 100,
              "description": "The alignment of the content relative to the whole column, represented as percentage (e.g. 0 for left, 50 for center and 100 for right)"
            },
            "mediaBackgroundPadding": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "maxProperties": 1,
                  "properties": {
                    "top": {
                      "oneOf": [
                        {
                          "type": "null"
                        },
                        {
                          "type": "number",
                          "default": 18,
                          "minimum": 0,
                          "description": "value of the mediaBackgroundPadding"
                        }
                      ]
                    },
                    "bottom": {
                      "oneOf": [
                        {
                          "type": "null"
                        },
                        {
                          "type": "number",
                          "default": 18,
                          "minimum": 0,
                          "description": "value of the mediaBackgroundPadding"
                        }
                      ]
                    }
                  }
                }
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "InputProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "label": {
              "type": "string",
              "description": "input label"
            },
            "required": {
              "type": "boolean",
              "description": "is the input field required to have a value"
            },
            "autoFocus": {
              "type": "boolean",
              "description": "should the field be focused when loading the page"
            },
            "readOnly": {
              "type": "boolean",
              "description": "is the field readonly"
            },
            "tabIndex": {
              "type": "number",
              "description": "the tab index in the form"
            },
            "inputHeight": {
              "type": [
                "number",
                "null"
              ],
              "description": "Height of input",
              "minimum": 25
            },
            "inputHeightMobile": {
              "type": [
                "number",
                "null"
              ],
              "description": "Height of input",
              "minimum": 25
            },
            "labelMargin": {
              "type": "number",
              "default": 14,
              "description": "Margin between label to input",
              "minimum": 0,
              "maximum": 100
            },
            "labelPadding": {
              "type": "number",
              "default": 0,
              "description": "Padding of label",
              "minimum": 0,
              "maximum": 100
            },
            "labelMobileFontSize": {
              "type": "number"
            },
            "inputMobileFontSize": {
              "type": "number"
            }
          }
        },
        {
          "$ref": "DisableableProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "InputElementsErrorProperties": {
      "type": "object",
      "properties": {
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "isTopLevelDataNode": false
    },
    "QuickActionBarProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "colorScheme": {
              "type": "string",
              "enum": [
                "black",
                "grey",
                "brand"
              ],
              "default": "brand"
            },
            "invertColors": {
              "type": "boolean",
              "default": true
            },
            "hideText": {
              "type": "boolean",
              "default": true
            },
            "alignment": {
              "type": "string",
              "enum": [
                "right",
                "left"
              ],
              "default": "right"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PhotoProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "imageSize": {
              "type": "string",
              "enum": [
                "small",
                "medium",
                "large"
              ],
              "default": "medium",
              "description": "size of the image in runtime"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "FacebookLikeBoxProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "transparentBg": {
              "type": "boolean",
              "default": false,
              "description": "Sets a transparent background for the like box"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "ImageButtonProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "transition": {
              "type": "string",
              "enum": [
                "none",
                "fade"
              ],
              "default": "fade"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MultiSelectionProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "placeholder": {
              "type": "string",
              "default": "Enter text here...",
              "description": "The placeholder for the input skinpart",
              "maxLength": 4000
            },
            "newItemText": {
              "type": "string",
              "default": "(New)",
              "description": "The text that will appear on a new item in the dropdown"
            },
            "selectionOnly": {
              "type": "boolean",
              "default": false,
              "description": "Restricts component to selection only"
            },
            "maxTextLength": {
              "type": "number",
              "default": 30,
              "description": "The max text length for the input skinpart"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MultiSelectionItemProperties": {
      "$ref": "DefaultProperties",
      "isTopLevelDataNode": true
    },
    "NumericStepperProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "minValue": {
              "type": "number",
              "default": 0,
              "description": "Min value for input"
            },
            "maxValue": {
              "type": "number",
              "default": 999,
              "description": "Max value for input"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PinterestPinItProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "size": {
              "type": "string",
              "enum": [
                "small",
                "large"
              ],
              "default": "small"
            },
            "color": {
              "type": "string",
              "enum": [
                "gray",
                "red",
                "white"
              ],
              "default": "gray"
            },
            "counterPosition": {
              "type": "string",
              "enum": [
                "none",
                "above",
                "beside"
              ],
              "default": "none"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "SingleAudioPlayerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "volume": {
              "type": "number",
              "default": 50,
              "description": "Volume"
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": "Autoplay MP3"
            },
            "loop": {
              "type": "boolean",
              "default": false,
              "description": "Loop MP3"
            },
            "showArtist": {
              "type": "boolean",
              "default": true,
              "description": "Display Artist"
            },
            "showTrack": {
              "type": "boolean",
              "default": true,
              "description": "Display Track"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SkypeCallButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "imageSize": {
              "type": "string",
              "enum": [
                "small",
                "medium",
                "large"
              ],
              "default": "medium"
            },
            "imageColor": {
              "type": "string",
              "enum": [
                "blue",
                "white"
              ],
              "default": "blue"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "SpotifyFollowProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "size": {
              "type": "string",
              "enum": [
                "small",
                "large"
              ],
              "default": "large"
            },
            "theme": {
              "type": "string",
              "enum": [
                "light",
                "dark"
              ],
              "default": "light"
            },
            "showFollowersCount": {
              "type": "boolean",
              "default": true
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "SpotifyPlayerProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "size": {
              "type": "string",
              "enum": [
                "compact",
                "large"
              ],
              "default": "compact",
              "description": "Size of the player"
            },
            "color": {
              "type": "string",
              "enum": [
                "black",
                "white"
              ],
              "default": "black",
              "description": "Theme of the player"
            },
            "style": {
              "type": "string",
              "enum": [
                "list",
                "coverart"
              ],
              "default": "list",
              "description": "Style of the player"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "SubscribeFormProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "hiddenFirstNameField": {
              "type": "boolean",
              "default": false
            },
            "hiddenLastNameField": {
              "type": "boolean",
              "default": false
            },
            "hiddenEmailField": {
              "type": "boolean",
              "default": true
            },
            "hiddenPhoneField": {
              "type": "boolean",
              "default": false
            },
            "requiredFirstNameField": {
              "type": "boolean",
              "default": false
            },
            "requiredLastNameField": {
              "type": "boolean",
              "default": false
            },
            "requiredEmailField": {
              "type": "boolean",
              "default": true
            },
            "requiredPhoneField": {
              "type": "boolean",
              "default": false
            },
            "useCookie": {
              "type": "boolean",
              "default": true
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VerticalMenuProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "itemsAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left",
              "description": "alignment of the menu items"
            },
            "subMenuOpenSide": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "right",
              "description": "Opening direction of sub-menus"
            },
            "originalHeight": {
              "type": "number",
              "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
            },
            "menuItemHeight": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "number"
                }
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "YouTubeSubscribeButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "layout": {
              "type": "string",
              "enum": [
                "default",
                "full"
              ],
              "default": "full",
              "description": "the layout of the youtube subscribe button"
            },
            "theme": {
              "type": "string",
              "enum": [
                "light",
                "dark"
              ],
              "default": "light",
              "description": "the theme of the youtube subscribe button"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "BgImageStripProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "bgUrl": {
              "type": [
                "string",
                "null"
              ],
              "default": "",
              "description": "Set image background"
            },
            "bgSize": {
              "type": "string",
              "enum": [
                "auto",
                "cover",
                "contain"
              ],
              "default": "auto",
              "description": "Set background mode"
            },
            "bgRepeat": {
              "type": "string",
              "enum": [
                "no-repeat",
                "repeat-x",
                "repeat-y",
                "repeat"
              ],
              "default": "repeat",
              "description": "Set background tile direction"
            },
            "bgPosition": {
              "type": "string",
              "enum": [
                "top left",
                "top center",
                "top right",
                "center left",
                "center",
                "center right",
                "bottom left",
                "bottom center",
                "bottom right"
              ],
              "default": "center",
              "description": "Set background position"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "BgImageStripUnifiedProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "fittingType": {
              "type": "string",
              "enum": [
                "fill",
                "fit",
                "actual_size",
                "tile",
                "fit_and_tile",
                "tile_horizontal",
                "tile_vertical",
                "legacy_strip_tile",
                "legacy_strip_tile_horizontal",
                "legacy_strip_tile_vertical",
                "legacy_strip_original_size",
                "legacy_strip_fill",
                "legacy_strip_fit",
                "legacy_strip_fit_and_tile"
              ],
              "default": "fill",
              "description": "Set image fitting type"
            },
            "alignType": {
              "type": "string",
              "enum": [
                "top_left",
                "top",
                "top_right",
                "left",
                "center",
                "right",
                "bottom_left",
                "bottom",
                "bottom_right"
              ],
              "default": "center",
              "description": "Set image alignment"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "FileUploaderProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "buttonAlignment": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr",
              "description": "alignment of the label to the button"
            },
            "filesAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left",
              "description": "alignment of the file name to the component"
            },
            "showPlaceholder": {
              "type": "boolean",
              "default": true,
              "description": "should show placeholder"
            },
            "filesType": {
              "type": "string",
              "enum": [
                "Image",
                "Document",
                "Video",
                "Audio",
                "Archive",
                "Gallery"
              ],
              "default": "Image",
              "description": "the file type allowed for upload by the component"
            },
            "filesSizeLimit": {
              "type": "number",
              "default": 15,
              "minimum": 1,
              "maximum": 15,
              "description": "the maximum file size allowed to upload by the component"
            },
            "numFilesLimit": {
              "type": "number",
              "default": 1,
              "minimum": 1,
              "maximum": 50,
              "description": "the maximum number of files allowed to be uploaded by the component"
            },
            "showFileName": {
              "type": "boolean"
            },
            "textBelowButtonMobileFontSize": {
              "type": "number"
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "UploadNameProperties": {
      "type": "object",
      "$ref": "DefaultProperties",
      "isTopLevelDataNode": true
    },
    "ButtonProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "align": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "center",
              "description": "alignment of the menu"
            },
            "margin": {
              "type": "number",
              "default": 0,
              "description": "text left and right margins"
            }
          }
        },
        {
          "$ref": "DisableableProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "LoginSocialBarProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "buttonsDirection": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ],
              "description": "alignment of the buttons"
            },
            "iconSize": {
              "type": "number",
              "default": 26,
              "description": "size of the buttons' icons"
            },
            "loggedOutIconSize": {
              "type": "number",
              "description": "size of the loggedOut buttons' icons"
            },
            "dropDownTextAlignment": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "description": "alignment of the text in the dropdown menu"
            },
            "buttonsAlignment": {
              "type": "string",
              "default": "right",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "description": "alignment of the bar of the component itself"
            },
            "arrowShape": {
              "type": "string",
              "default": "line",
              "enum": [
                "none",
                "line",
                "full"
              ],
              "description": "arrow shape of login bar"
            },
            "arrowSize": {
              "type": "number",
              "default": 14,
              "description": "arrow size of login bar"
            },
            "showBellIcon": {
              "type": "boolean",
              "default": true,
              "description": "should show bell icon"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ComboBoxInputProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "textAlignment": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "string",
                  "default": "center",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "description": "the direction of the text",
                  "maxLength": 100
                }
              ]
            },
            "textPadding": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "number",
                  "default": 18,
                  "minimum": 0,
                  "maximum": 100,
                  "description": "the value of the textPadding"
                }
              ]
            },
            "placeholder": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "properties": {
                    "value": {
                      "type": "string",
                      "default": "-1",
                      "description": "the value of the placeholder option",
                      "maxLength": 400
                    },
                    "text": {
                      "type": "string",
                      "default": "",
                      "description": "the text of the placeholder option",
                      "maxLength": 400
                    }
                  }
                }
              ],
              "description": "the placeholder option in case nothing is selected"
            },
            "size": {
              "type": [
                "null",
                "number"
              ],
              "description": "Amount of options to display"
            },
            "designableList": {
              "type": "boolean",
              "default": true,
              "description": "is the list designable"
            },
            "dropdownItemsSpacing": {
              "type": "number",
              "default": 16,
              "minimum": 0,
              "maximum": 100,
              "description": "the value of the dropdownItemsSpacing"
            },
            "autocomplete": {
              "type": "boolean",
              "description": "is the autocomplete enabled"
            }
          }
        },
        {
          "$ref": "InputProperties"
        },
        {
          "$ref": "InputElementsErrorProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RadioButtonProperties": {
      "type": "object",
      "allOf": [
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RadioGroupProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "left",
              "description": "alignment of the text"
            },
            "layout": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ],
              "default": "vertical",
              "description": "the layout of the radio buttons child components"
            },
            "buttonsMargin": {
              "type": "number",
              "default": 24,
              "description": "Margin between each button item",
              "minimum": 0,
              "maximum": 100
            },
            "spacing": {
              "type": "number",
              "default": 12,
              "description": "Spacing between radio icon and text",
              "minimum": 0,
              "maximum": 100
            },
            "buttonSize": {
              "type": "number",
              "default": 18,
              "description": "radio button size size",
              "minimum": 6,
              "maximum": 100
            },
            "labelMargin": {
              "type": "number",
              "default": 24,
              "description": "Margin between label to buttons",
              "minimum": 0,
              "maximum": 100
            }
          }
        },
        {
          "$ref": "InputProperties"
        },
        {
          "$ref": "InputElementsErrorProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "CheckboxGroupProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "left",
              "description": "alignment of the text"
            },
            "layout": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ],
              "default": "vertical",
              "description": "the layout of the checkboxes components"
            },
            "buttonsMargin": {
              "type": "number",
              "default": 24,
              "description": "Margin between each button item",
              "minimum": 0,
              "maximum": 100
            },
            "spacing": {
              "type": "number",
              "default": 12,
              "description": "Spacing between checkbox and text",
              "minimum": 0,
              "maximum": 100
            },
            "buttonSize": {
              "type": "number",
              "default": 18,
              "description": "checkbox size",
              "minimum": 6,
              "maximum": 100
            },
            "labelMargin": {
              "type": "number",
              "default": 24,
              "description": "Margin between label to checkbox",
              "minimum": 0,
              "maximum": 100
            }
          }
        },
        {
          "$ref": "InputProperties"
        },
        {
          "$ref": "InputElementsErrorProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ContactFormProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "hidden_emailFieldLabel": {
              "type": "boolean",
              "default": true
            },
            "hidden_nameFieldLabel": {
              "type": "boolean",
              "default": true
            },
            "hidden_phoneFieldLabel": {
              "type": "boolean",
              "default": false
            },
            "hidden_addressFieldLabel": {
              "type": "boolean",
              "default": false
            },
            "hidden_subjectFieldLabel": {
              "type": "boolean",
              "default": true
            },
            "hidden_messageFieldLabel": {
              "type": "boolean",
              "default": true
            },
            "required_emailFieldLabel": {
              "type": "boolean",
              "default": true
            },
            "required_nameFieldLabel": {
              "type": "boolean",
              "default": true
            },
            "required_phoneFieldLabel": {
              "type": "boolean",
              "default": false
            },
            "required_addressFieldLabel": {
              "type": "boolean",
              "default": false
            },
            "required_subjectFieldLabel": {
              "type": "boolean",
              "default": false
            },
            "required_messageFieldLabel": {
              "type": "boolean",
              "default": false
            },
            "useCookie": {
              "type": "boolean",
              "default": true
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "DocumentMediaProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showTitle": {
              "type": "boolean",
              "default": true,
              "description": "Toggle Document Title Display"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "EbayItemsBySellerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "headerImage": {
              "enum": [
                "0",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11"
              ],
              "default": "0",
              "description": "The widget's header"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "FiveGridLineProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "fullScreenModeOn": {
              "type": "boolean",
              "default": false,
              "description": "Toggle full screen mode"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "FlashComponentProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "displayMode": {
              "type": "string",
              "enum": [
                "original",
                "fit",
                "stretch"
              ],
              "default": "original",
              "description": "displayMode of the movie"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "GalleryExpandProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "expandEnabled": {
              "type": "boolean",
              "default": true
            },
            "goToLinkText": {
              "type": [
                "null",
                "string"
              ],
              "default": "Go to link"
            },
            "galleryImageOnClickAction": {
              "type": "string",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ],
              "default": "zoomMode"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "GoogleMapProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showZoom": {
              "type": "boolean",
              "default": true,
              "description": "show zoom control"
            },
            "fullscreenControl": {
              "type": "boolean",
              "default": true,
              "description": "show fullscreen control"
            },
            "showPosition": {
              "type": "boolean",
              "default": true,
              "description": "show position control"
            },
            "showStreetView": {
              "type": "boolean",
              "default": true,
              "description": "show Street View control"
            },
            "showMapType": {
              "type": "boolean",
              "default": true,
              "description": "show map type control"
            },
            "zoom": {
              "type": "number",
              "default": 14,
              "description": "default map zoom level",
              "minimum": 0,
              "maximum": 20
            },
            "mapDragging": {
              "type": "boolean",
              "default": true,
              "description": "show map type control"
            },
            "showDirectionsLink": {
              "type": "boolean",
              "default": true,
              "description": "show directions link in infoWindow"
            },
            "mapType": {
              "type": "string",
              "enum": [
                "ROADMAP",
                "TERRAIN",
                "SATELLITE",
                "HYBRID"
              ],
              "default": "ROADMAP",
              "description": "show zoom control"
            },
            "language": {
              "type": "string",
              "enum": [
                "userLang",
                "cs",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "hi",
                "it",
                "ja",
                "ko",
                "nl",
                "no",
                "pl",
                "pt",
                "ru",
                "sv",
                "zh",
                "th",
                "uk",
                "tr"
              ],
              "default": "en",
              "description": "Possible languages taken from https://developers.google.com/maps/faq?hl=en#languagesupport"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "HorizontalMenuProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignButtons": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "center",
              "description": "alignment of the menu buttons"
            },
            "alignText": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "center",
              "description": "alignment of the menu buttons' text"
            },
            "sameWidthButtons": {
              "type": "boolean",
              "default": false,
              "description": "Keep buttons the same size"
            },
            "moreButtonLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "More",
              "description": "Label to use for 'more button'"
            },
            "moreItemHeight": {
              "type": "number",
              "default": 15,
              "description": "height of items in the more menu"
            },
            "stretchButtonsToMenuWidth": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "rtl": {
              "type": "boolean",
              "default": false,
              "description": "should display menu in RTL mode"
            },
            "autoTextDirection": {
              "$ref": "urn:dm:schemas:common.json#/NullableBool"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ImpressProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "textMode": {
              "langsPrefix": "System",
              "type": "string",
              "default": "titleAndDescription",
              "enum": [
                "titleAndDescription",
                "titleOnly",
                "descriptionOnly",
                "noText"
              ]
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "autoplayInterval": {
              "type": "number",
              "default": 5,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "showPagination": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "galleryImageOnClickAction": {
              "langsPrefix": "System",
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "cropAndFitStage": {
              "langsPrefix": "System",
              "type": "string",
              "default": "crop",
              "enum": [
                "crop",
                "fit"
              ]
            },
            "transition": {
              "type": "string",
              "default": "random",
              "enum": [
                "none",
                "1",
                "2",
                "3",
                "4",
                "5",
                "random"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MasonryProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "galleryImageOnClickAction": {
              "langsPrefix": "System",
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "numCols": {
              "type": "number",
              "default": 3,
              "description": "Number of columns",
              "minimum": 1,
              "maximum": 10
            },
            "margin": {
              "type": "number",
              "default": 25,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 100
            },
            "textMode": {
              "langsPrefix": "System",
              "type": "string",
              "default": "titleAndDescription",
              "enum": [
                "titleAndDescription",
                "titleOnly",
                "descriptionOnly",
                "noText"
              ]
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "boxShadowIsOn": {
              "type": "boolean",
              "default": true
            },
            "boxShadow": {
              "type": "string",
              "default": "0 1px 3px 0 rgba(0,0,0,0.33)"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StripShowcaseProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "galleryImageOnClickAction": {
              "langsKey": "System.centerImageClick",
              "type": "string",
              "default": "disabled",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "cropAndFitStage": {
              "langsPrefix": "System",
              "type": "string",
              "default": "fit",
              "enum": [
                "crop",
                "fit"
              ]
            },
            "imageScale": {
              "type": "string",
              "default": "4:3",
              "enum": [
                "16:9",
                "4:3",
                "1:1",
                "3:4",
                "9:16"
              ]
            },
            "imageMargin": {
              "type": "number",
              "default": 5,
              "description": "Margin between thumbnails",
              "minimum": 0,
              "maximum": 100
            },
            "showThumbnails": {
              "type": "boolean",
              "default": true
            },
            "thumbsScale": {
              "type": "string",
              "default": "4:3",
              "enum": [
                "16:9",
                "4:3",
                "1:1",
                "3:4",
                "9:16"
              ]
            },
            "thumbsMargin": {
              "type": "number",
              "default": 5,
              "description": "Margin between thumbnails",
              "minimum": 0,
              "maximum": 100
            },
            "autoplay": {
              "type": "boolean",
              "default": false
            },
            "autoplayInterval": {
              "type": "number",
              "default": 5,
              "minimum": 0,
              "maximum": 30
            },
            "arrowMode": {
              "type": "boolean",
              "default": false
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StripSlideshowProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "textMode": {
              "langsPrefix": "System",
              "type": "string",
              "default": "titleAndDescription",
              "enum": [
                "titleAndDescription",
                "titleOnly",
                "descriptionOnly",
                "noText"
              ]
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "autoplayInterval": {
              "type": "number",
              "default": 5,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "showPlaybackControl": {
              "type": "boolean"
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            },
            "transition": {
              "langsPrefix": "System",
              "type": "string",
              "default": "scroll",
              "enum": [
                "none",
                "crossFade",
                "slide",
                "scroll",
                "zoom",
                "random"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ThumbnailsProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "cropAndFitStage": {
              "langsPrefix": "System",
              "type": "string",
              "default": "crop",
              "enum": [
                "crop",
                "fit"
              ]
            },
            "componentScale": {
              "type": "string",
              "default": "4:3",
              "enum": [
                "16:9",
                "4:3",
                "1:1"
              ]
            },
            "margin": {
              "type": "number",
              "default": 5,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 100
            },
            "textMode": {
              "langsPrefix": "System",
              "type": "string",
              "default": "titleAndDescription",
              "enum": [
                "titleAndDescription",
                "titleOnly",
                "descriptionOnly",
                "noText"
              ]
            },
            "arrowMode": {
              "type": "boolean",
              "default": true
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "autoplayInterval": {
              "type": "number",
              "default": 5,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            },
            "transition": {
              "langsPrefix": "System",
              "type": "string",
              "default": "crossFade",
              "enum": [
                "none",
                "crossFade",
                "slide",
                "scroll",
                "zoom",
                "random"
              ]
            },
            "thumbnailsGravity": {
              "langsKey": "System.gravity",
              "type": "string",
              "default": "bottom",
              "enum": [
                "top",
                "bottom",
                "left",
                "right"
              ]
            },
            "galleryImageOnClickAction": {
              "langsPrefix": "System",
              "type": "string",
              "default": "disabled",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "AccordionProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "descFont": {
              "$ref": "FontsEnum"
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "textMode": {
              "langsKey": "System.textMode",
              "type": "string",
              "default": "titleOnly",
              "enum": [
                "titleOnly",
                "noText"
              ]
            },
            "galleryImageOnClickAction": {
              "langsPrefix": "System",
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "borderWidth": {
              "type": "number",
              "default": 0,
              "description": "Borer width between images",
              "minimum": 0,
              "maximum": 30
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "CollageProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "alignText": {
              "type": "string",
              "default": "center",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "textMode": {
              "langsKey": "System.textMode",
              "type": "string",
              "default": "titleOnly",
              "enum": [
                "titleAndDescription",
                "titleOnly",
                "noText"
              ]
            },
            "galleryImageOnClickAction": {
              "langsPrefix": "System",
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "minImageSize": {
              "type": "number",
              "default": 1,
              "description": "minimum image size",
              "minimum": 1,
              "maximum": 10
            },
            "maxImageSize": {
              "type": "number",
              "default": 3,
              "description": "maximum image size",
              "minimum": 1,
              "maximum": 10
            },
            "avergeImageSize": {
              "type": "number",
              "default": 1,
              "description": "averge image size",
              "minimum": 1,
              "maximum": 10
            },
            "margin": {
              "type": "number",
              "default": 5,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 30
            },
            "fitToScreenWidth": {
              "type": "boolean",
              "default": false,
              "description": "fit component width to screen"
            },
            "showNavButtons": {
              "type": "boolean",
              "default": true,
              "description": "show navigation buttons"
            },
            "numOfCells": {
              "type": "number",
              "default": 5,
              "description": "number of grid cells",
              "minimum": 2,
              "maximum": 10
            },
            "orientation": {
              "langsKey": "System.orientation",
              "type": "string",
              "default": "vertical",
              "enum": [
                "vertical",
                "horizontal"
              ]
            },
            "layoutSeed": {
              "type": "number",
              "default": 50,
              "description": "seed for layout calculation",
              "minimum": 1,
              "maximum": 100
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "FreestyleProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "galleryImageOnClickAction": {
              "langsPrefix": "System",
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "layoutSeed": {
              "type": "number",
              "default": 50,
              "description": "seed for layout calculation",
              "minimum": 1,
              "maximum": 100
            },
            "cropAndFitStage": {
              "langsPrefix": "System",
              "type": "string",
              "default": "fit",
              "enum": [
                "crop",
                "fit"
              ]
            },
            "imageDecoration": {
              "langsPrefix": "System",
              "type": "string",
              "default": "none",
              "enum": [
                "none",
                "polaroid",
                "scotchTape",
                "vintageFrame",
                "random"
              ]
            },
            "borderWidth": {
              "type": "number",
              "default": 3,
              "description": "image border width",
              "minimum": 0,
              "maximum": 15
            },
            "orientation": {
              "type": "string",
              "default": "horizontal",
              "enum": [
                "vertical",
                "horizontal"
              ]
            },
            "applyRotationInLayout": {
              "type": "boolean",
              "default": true
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ItunesButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "language": {
              "type": "string",
              "enum": [
                "userLang",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "it",
                "ja",
                "ko",
                "nl",
                "no",
                "pl",
                "pt",
                "ru",
                "sv",
                "tr"
              ],
              "default": "en",
              "description": "Language of the button"
            },
            "openIn": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_blank",
              "description": "Where the link will be opened"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "LayoutProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "x": {
              "type": "number",
              "default": 0,
              "description": "x position"
            },
            "y": {
              "type": "number",
              "default": 0,
              "description": "y position"
            },
            "w": {
              "type": "number",
              "default": 100,
              "description": "width"
            },
            "h": {
              "type": "number",
              "default": 100,
              "description": "height"
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "description": "list of anchors"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "LinkBarProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "gallery": {
              "type": [
                "null",
                "string"
              ],
              "default": "clipart",
              "description": "gallery type (photos, icons, backgrounds, etc..)"
            },
            "iconSize": {
              "type": "number",
              "default": 30,
              "description": "Icon Size",
              "minimum": 16,
              "maximum": 128
            },
            "spacing": {
              "type": "number",
              "default": 5,
              "description": "Spacing",
              "minimum": 1,
              "maximum": 50
            },
            "bgScale": {
              "type": "number",
              "default": 1,
              "description": "Background scale",
              "minimum": 0,
              "maximum": 2
            },
            "orientation": {
              "type": "string",
              "enum": [
                "HORIZ",
                "VERT"
              ],
              "default": "HORIZ",
              "description": "Orientation"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MatrixGalleryProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "imageMode": {
              "type": "string",
              "enum": [
                "clipImage",
                "flexibleWidthFixed"
              ],
              "default": "clipImage"
            },
            "itemHeight": {
              "type": [
                "null",
                "number"
              ],
              "description": "height of specific item"
            },
            "numCols": {
              "type": "number",
              "default": 3,
              "description": "Number of columns",
              "minimum": 1,
              "maximum": 10
            },
            "maxRows": {
              "type": "number",
              "default": 3,
              "description": "Maximum number of rows",
              "minimum": 1,
              "maximum": 10
            },
            "incRows": {
              "type": "number",
              "default": 2,
              "description": "Row number increase",
              "minimum": 1,
              "maximum": 10
            },
            "margin": {
              "type": "number",
              "default": 15,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 250
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "showMoreLabel": {
              "type": [
                "null",
                "string"
              ],
              "default": "Show More",
              "description": "Show More"
            },
            "expandEnabled": {
              "type": "boolean",
              "default": true
            },
            "goToLinkText": {
              "type": [
                "null",
                "string"
              ],
              "default": "Go to link"
            },
            "galleryImageOnClickAction": {
              "type": "string",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ],
              "default": "zoomMode"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "NumberInputProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "minValue": {
              "type": "number",
              "default": 0,
              "description": "minimum allowed value"
            },
            "maxValue": {
              "type": "number",
              "default": 999,
              "description": "maximum allowed value"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PageGroupProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "transition": {
              "type": "string",
              "enum": [
                "none",
                "swipeHorizontalFullScreen",
                "swipeVerticalFullScreen",
                "crossfade",
                "outIn",
                "slide"
              ],
              "default": "swipeHorizontalFullScreen",
              "description": "page transition"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PaginatedGridGalleryProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "imageMode": {
              "type": "string",
              "enum": [
                "clipImage"
              ],
              "default": "clipImage"
            },
            "numCols": {
              "type": "number",
              "default": 3,
              "description": "Number of columns",
              "minimum": 1,
              "maximum": 10
            },
            "maxRows": {
              "type": "number",
              "default": 3,
              "description": "Maximum number of rows",
              "minimum": 1,
              "maximum": 10
            },
            "margin": {
              "type": "number",
              "default": 0,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 250
            },
            "transition": {
              "type": "string",
              "default": "seq_crossFade_All",
              "enum": [
                "none",
                "seq_crossFade_All",
                "seq_shrink_All",
                "swipe_horiz_All",
                "swipe_vert_All",
                "seq_random"
              ]
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            },
            "autoplayInterval": {
              "type": "number",
              "default": 3,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "showAutoplay": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "showNavigation": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "showCounter": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "expandEnabled": {
              "type": "boolean",
              "default": true
            },
            "goToLinkText": {
              "type": [
                "null",
                "string"
              ],
              "default": "Go to link"
            },
            "galleryImageOnClickAction": {
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PayPalButtonProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "buttonType": {
              "type": "string",
              "enum": [
                "buy",
                "donate"
              ],
              "default": "buy",
              "description": "buy or donate button"
            },
            "itemName": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "description": "some amazing description"
            },
            "itemID": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "description": "some amazing description"
            },
            "organizationName": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "description": "some amazing description"
            },
            "organizationID": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "description": "some amazing description"
            },
            "amount": {
              "type": [
                "null",
                "string"
              ],
              "default": "",
              "description": "some amazing description"
            },
            "currencyCode": {
              "type": "string",
              "default": "USD",
              "description": "Currency Code"
            },
            "target": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ],
              "default": "_blank",
              "description": "Currency Code"
            },
            "showCreditCards": {
              "type": "boolean",
              "default": true,
              "description": "Show credit card symbols"
            },
            "smallButton": {
              "type": "boolean",
              "default": false,
              "description": "use small button"
            },
            "language": {
              "type": "string",
              "enum": [
                "userLang",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "it",
                "ja",
                "nl",
                "no",
                "pl",
                "pt",
                "ru",
                "sv",
                "tr"
              ],
              "default": "en",
              "description": "https://developer.paypal.com/docs/classic/api/locale_codes/"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SiteSegmentContainerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "fixedPosition": {
              "type": "boolean",
              "default": false,
              "description": "fixed positioning for components that inherit from SiteSegmentContainers"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SliderGalleryProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "imageMode": {
              "type": "string",
              "default": "clipImage",
              "enum": [
                "clipImage",
                "flexibleWidth"
              ]
            },
            "margin": {
              "type": "number",
              "default": 15,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 250
            },
            "maxSpeed": {
              "type": "number",
              "default": 5,
              "minimum": 1,
              "maximum": 30,
              "description": "Speed"
            },
            "aspectRatio": {
              "type": "number",
              "minimum": 0.1,
              "maximum": 3,
              "default": 1,
              "description": ""
            },
            "aspectRatioPreset": {
              "type": "string",
              "enum": [
                "16:9",
                "4:3",
                "1:1",
                "3:4",
                "9:16"
              ],
              "default": "4:3"
            },
            "loop": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "showCounter": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "expandEnabled": {
              "type": "boolean",
              "default": true
            },
            "goToLinkText": {
              "type": [
                "null",
                "string"
              ],
              "default": "Go to link"
            },
            "galleryImageOnClickAction": {
              "type": "string",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ],
              "default": "zoomMode"
            },
            "autoplayInterval": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "transDuration": {
              "$ref": "urn:dm:schemas:common.json#/NullableInt"
            },
            "showAutoplay": {
              "$ref": "urn:dm:schemas:common.json#/NullableBool"
            },
            "autoplay": {
              "$ref": "urn:dm:schemas:common.json#/NullableBool"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SlideShowGalleryProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "imageMode": {
              "type": "string",
              "enum": [
                "clipImage",
                "flexibleHeight",
                "flexibleWidthFixed"
              ],
              "default": "clipImage"
            },
            "transition": {
              "type": "string",
              "enum": [
                "none",
                "swipeVertical",
                "swipeHorizontal",
                "crossfade",
                "outIn"
              ],
              "default": "swipeHorizontal",
              "description": "Transition between items of the gallery"
            },
            "autoplayInterval": {
              "type": "number",
              "default": 5,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            },
            "bidirectional": {
              "type": "boolean",
              "default": true,
              "description": "Decides whether the transition direction reflects Prev/Next"
            },
            "reverse": {
              "type": "boolean",
              "default": false,
              "description": "If bidirectional, inverts the direction of transitions"
            },
            "showAutoplay": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "showNavigation": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "showCounter": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "expandEnabled": {
              "type": "boolean",
              "default": true
            },
            "goToLinkText": {
              "type": [
                "null",
                "string"
              ],
              "default": "Go to link"
            },
            "galleryImageOnClickAction": {
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right"
              ]
            },
            "showSocial": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "showExpand": {
              "type": [
                "boolean",
                "null"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SvgShapeProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "maintainAspectRatio": {
              "type": "boolean",
              "default": true,
              "description": "should the shape maintain it's aspect ratio or stretch"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VectorImageProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "displayMode": {
              "type": "string",
              "enum": [
                "legacyFit",
                "fit",
                "stretch"
              ],
              "description": "should the shape maintain it's aspect ratio or stretch, 'legacy-fit' is for converted SvgShape"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "FlipProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TableComponentProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "minHeight": {
              "type": "number",
              "default": -1,
              "description": "minimum allowed value"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TinyMenuProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ExpandableMenuProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "itemsAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left",
              "description": "alignment of the menu items"
            },
            "subMenuOpenSide": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "right",
              "description": "Opening direction of sub-menus"
            },
            "originalHeight": {
              "type": "number",
              "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
            },
            "menuItemHeight": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "number"
                }
              ]
            },
            "menuArrowDirection": {
              "enum": [
                "left",
                "center",
                "right"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TwitterFeedProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "numOfTweets": {
              "type": "number",
              "default": 5,
              "description": "Number of tweets in feed"
            },
            "subject": {
              "type": [
                "null",
                "string"
              ],
              "default": "What's being said about...",
              "description": "subject line"
            },
            "title": {
              "type": [
                "null",
                "string"
              ],
              "default": "Me...",
              "description": "title line"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VideoProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": "video autoplay on load"
            },
            "loop": {
              "type": "boolean",
              "default": false,
              "description": "play video in a loop"
            },
            "showinfo": {
              "type": "boolean",
              "default": false,
              "description": "show video title and author"
            },
            "lightTheme": {
              "type": "boolean",
              "default": false,
              "description": "show video with light theme"
            },
            "showControls": {
              "type": "string",
              "enum": [
                "always_show",
                "always_hide",
                "temp_show"
              ],
              "default": "always_show",
              "description": "show / hide controls"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VKShareProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "rightAngles": {
              "type": "boolean",
              "default": false,
              "description": "Button Right angles"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "WFacebookCommentProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "numPosts": {
              "type": "number",
              "default": 2,
              "minimum": 0,
              "maximum": 10,
              "description": "the number of posts display by default"
            },
            "width": {
              "type": "number",
              "default": 555,
              "description": "the width of the plugin, in pixels"
            },
            "colorScheme": {
              "type": "string",
              "enum": [
                "light",
                "dark"
              ],
              "default": "light",
              "description": "the color scheme of the plugin"
            },
            "canBeShownOnAllPagesBug": {
              "type": "boolean",
              "default": false,
              "description": "The component was added after the bug who-145 fix, and will be shown on all pages"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "DisqusCommentsProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "disqusId": {
              "type": "string",
              "description": "User id in disqus"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "WFacebookLikeProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "layout": {
              "type": "string",
              "enum": [
                "standard",
                "button_count",
                "box_count"
              ],
              "default": "standard",
              "description": "the layout of the button"
            },
            "send": {
              "type": "boolean",
              "default": false,
              "description": "enable/disable the send button"
            },
            "show_faces": {
              "type": "boolean",
              "default": false,
              "description": "show the faces of your friends that liked this item"
            },
            "width": {
              "type": [
                "null",
                "string",
                "number"
              ],
              "default": "225",
              "description": "the width of the Like button"
            },
            "action": {
              "type": "string",
              "enum": [
                "like",
                "recommend"
              ],
              "default": "like",
              "description": " the verb to display on the button. Options: *like*, *recommend*"
            },
            "font": {
              "type": "string",
              "enum": [
                "helvetica",
                "arial",
                "lucida grande",
                "segoe ui",
                "tahoma",
                "trebuchet ms",
                "verdana"
              ],
              "default": "helvetica",
              "description": "the font to display in the button"
            },
            "colorScheme": {
              "type": "string",
              "enum": [
                "light",
                "dark"
              ],
              "default": "dark",
              "description": "the color scheme for the like button"
            },
            "language": {
              "type": "string",
              "enum": [
                "userLang",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "it",
                "ja",
                "kr",
                "nl",
                "no",
                "pl",
                "pt",
                "ru",
                "sv",
                "tr"
              ],
              "default": "en"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "WGooglePlusOneProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "size": {
              "type": "string",
              "enum": [
                "small",
                "medium",
                "standard",
                "tall"
              ],
              "default": "standard",
              "description": "The button size to render"
            },
            "annotation": {
              "type": "string",
              "enum": [
                "none",
                "bubble",
                "inline"
              ],
              "default": "inline",
              "description": "The annotation to display next to the button."
            },
            "width": {
              "type": [
                "null",
                "number"
              ],
              "description": "If annotation is set to *inline*, the width in pixels to use for the button and its inline annotation. If omitted, a button and its inline annotation use 450px."
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "WPhotoProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "displayMode": {
              "type": "string",
              "enum": [
                "fit",
                "fill",
                "full",
                "stretch",
                "fitWidth",
                "fitWidthStrict",
                "fitHeightStrict"
              ],
              "default": "fill",
              "description": "displayMode of the photo"
            },
            "autoFill": {
              "type": "boolean",
              "default": false,
              "description": "Should the photo should enable auto crop in the editor"
            },
            "onClickBehavior": {
              "type": "string",
              "enum": [
                "disabled",
                "goToLink",
                "zoomMode",
                "zoomAndPanMode"
              ],
              "default": "goToLink",
              "description": "goToLink"
            },
            "effectName": {
              "type": [
                "string",
                "null"
              ],
              "description": "An effect to apply on the image",
              "default": "none"
            },
            "filterEffect": {
              "type": [
                "object",
                "null"
              ],
              "properties": {
                "effectType": {
                  "type": "string"
                },
                "brightness": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "contrast": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "saturation": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 10
                },
                "hue": {
                  "type": "number",
                  "minimum": -180,
                  "maximum": 180
                },
                "duotoneDark": {
                  "type": "string"
                },
                "duotoneLight": {
                  "type": "string"
                },
                "invert": {
                  "type": "boolean",
                  "default": false
                },
                "isCustom": {
                  "type": "boolean"
                }
              },
              "description": "An effect to apply on the image"
            },
            "overrideCrop": {
              "description": "Overriding the image crop for Mobile view",
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "minProperties": 4,
                  "allOf": [
                    {
                      "properties": {
                        "x": {
                          "type": "number",
                          "minimum": 0
                        },
                        "y": {
                          "type": "number",
                          "minimum": 0
                        },
                        "width": {
                          "type": "number",
                          "minimum": 0
                        },
                        "height": {
                          "type": "number",
                          "minimum": 0
                        },
                        "svgId": {
                          "type": "string",
                          "description": "Defines an svg uri for a mask inside the crop boundaries"
                        },
                        "rotate": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 360,
                          "description": "Defines a rotation angle for the mask"
                        }
                      }
                    },
                    {
                      "$ref": "FlipProperties"
                    }
                  ]
                }
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "WRichTextProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "packed": {
              "type": "boolean",
              "default": false,
              "description": "Is the text component packed"
            },
            "brightness": {
              "type": "number",
              "default": 1
            },
            "overrideAlignment": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center",
                    "justify"
                  ]
                }
              ]
            },
            "overrideColor": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "string"
                }
              ]
            },
            "minHeight": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "number"
                }
              ]
            },
            "minWidth": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "number"
                }
              ]
            },
            "verticalText": {
              "type": "boolean",
              "default": false,
              "description": "Vertical oriented text flag"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RefComponentProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "minHeight": {
              "type": "number"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "WTwitterFollowProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "showCount": {
              "type": "boolean",
              "default": true,
              "description": "Followers count display"
            },
            "showScreenName": {
              "type": "boolean",
              "default": true,
              "description": "Show screen name"
            },
            "textColor": {
              "type": [
                "string",
                "null"
              ],
              "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
              "description": "HEX color code for the text color"
            },
            "linkColor": {
              "type": [
                "string",
                "null"
              ],
              "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
              "description": "HEX color code for the Username link color"
            },
            "width": {
              "type": "number",
              "default": 100,
              "description": "width of the Follow Button"
            },
            "dataLang": {
              "type": "string",
              "enum": [
                "userLang",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "hi",
                "it",
                "ja",
                "ko",
                "nl",
                "no",
                "pl",
                "pt",
                "ru",
                "sv",
                "tr"
              ],
              "default": "en",
              "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "WTwitterTweetProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "dataCount": {
              "type": "string",
              "enum": [
                "none",
                "horizontal",
                "vertical"
              ],
              "default": "horizontal",
              "description": "Count box position"
            },
            "dataLang": {
              "type": "string",
              "enum": [
                "userLang",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "hi",
                "it",
                "ja",
                "ko",
                "nl",
                "no",
                "pl",
                "pt",
                "ru",
                "sv",
                "tr"
              ],
              "default": "en",
              "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "HoverBoxProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "mobileDisplayedModeId": {
              "type": [
                "string",
                "null"
              ],
              "description": "The mode to activate when in mobile view"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TPAGluedProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "placement": {
              "type": [
                "null",
                "string"
              ],
              "default": "BOTTOM_RIGHT",
              "description": "widget placement"
            },
            "verticalMargin": {
              "type": [
                "null",
                "string",
                "number"
              ],
              "default": "",
              "description": "widget vertical margin"
            },
            "horizontalMargin": {
              "type": [
                "null",
                "string",
                "number"
              ],
              "default": "",
              "description": "widget horizontal margin"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "HoneycombProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "font": {
              "$ref": "FontsEnum"
            },
            "alignText": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "center",
                "right"
              ]
            },
            "textMode": {
              "langsKey": "System.textMode",
              "type": "string",
              "default": "titleAndDescription",
              "enum": [
                "titleAndDescription",
                "titleOnly",
                "descriptionOnly",
                "noText"
              ]
            },
            "galleryImageOnClickAction": {
              "type": "string",
              "default": "zoomMode",
              "enum": [
                "disabled",
                "zoomMode",
                "goToLink"
              ]
            },
            "margin": {
              "type": "number",
              "default": 1,
              "description": "Margin around each item",
              "minimum": 0,
              "maximum": 30
            },
            "numOfColumns": {
              "type": "number",
              "default": 4,
              "description": "number of columns",
              "minimum": 2,
              "maximum": 10
            },
            "numOfHoles": {
              "type": "number",
              "default": 2,
              "description": "number of holes in the honeycomb",
              "minimum": 2,
              "maximum": 8
            },
            "layoutSeed": {
              "type": "number",
              "default": 50,
              "description": "seed for layout calculation",
              "minimum": 1,
              "maximum": 100
            },
            "rolloverAnimation": {
              "type": "string",
              "default": "colorOnly",
              "enum": [
                "colorOnly",
                "glow",
                "bounce"
              ]
            },
            "imageShape": {
              "type": "string",
              "default": "hexagon",
              "enum": [
                "hexagon",
                "square",
                "triangle"
              ]
            },
            "imageScale": {
              "type": "string",
              "default": "x1",
              "enum": [
                "x1",
                "x2",
                "x3"
              ]
            },
            "expandEnabled": {
              "$ref": "urn:dm:schemas:common.json#/NullableBool"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "AppPartProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": "string",
              "default": "ltr",
              "enum": [
                "ltr",
                "rtl"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RssButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "transition": {
              "type": "string",
              "enum": [
                "none",
                "fade",
                "float",
                "expand",
                "spin",
                "fly",
                "turn",
                "reveal",
                "slide",
                "puff",
                "flip",
                "fold",
                "arc"
              ],
              "default": "fade"
            },
            "type": {
              "type": "string"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "BoxSlideShowProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "transition": {
              "type": "string",
              "enum": [
                "NoTransition",
                "SlideVertical",
                "SlideHorizontal",
                "CrossFade",
                "OutIn"
              ],
              "default": "SlideHorizontal",
              "description": "Transition between items of the gallery"
            },
            "autoPlay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "autoPlayInterval": {
              "type": "number",
              "default": 3,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "showPlaybackControl": {
              "type": "boolean"
            },
            "direction": {
              "type": "string",
              "default": "RTL",
              "enum": [
                "LTR",
                "RTL"
              ]
            },
            "pauseAutoPlayOnMouseOver": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            },
            "shouldHideOverflowContent": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "flexibleBoxHeight": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "showNavigationButton": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "navigationButtonSize": {
              "type": "number",
              "minimum": 8,
              "maximum": 72,
              "default": 21,
              "description": "Size of the navigation arrow buttons"
            },
            "navigationButtonMargin": {
              "type": "number",
              "minimum": -72,
              "maximum": 72,
              "default": 0,
              "description": "Margin from the sides of the navigation arrow buttons"
            },
            "showNavigationDots": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "navigationDotsAlignment": {
              "type": "string",
              "default": "center",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "description": "Alignment of the navigation dots"
            },
            "navigationDotsSize": {
              "type": "number",
              "minimum": 6,
              "maximum": 24,
              "default": 6,
              "description": "Size of the navigation dots"
            },
            "navigationDotsMargin": {
              "type": "number",
              "minimum": -50,
              "maximum": 50,
              "default": 0,
              "description": "Margin from the sides of the navigation dots"
            },
            "navigationDotsGap": {
              "type": "number",
              "minimum": 0,
              "maximum": 24,
              "default": 0,
              "description": "Gap size (spacing) of the navigation dots"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "BoxSlideShowSlideProperties": {
      "type": "object",
      "allOf": [
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StateBoxProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "transition": {
              "type": "string",
              "enum": [
                "NoTransition",
                "SlideVertical",
                "SlideHorizontal",
                "CrossFade",
                "OutIn"
              ],
              "default": "NoTransition",
              "description": "Transition between states"
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StateBoxStateProperties": {
      "type": "object",
      "allOf": [
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StateBoxFormStateProperties": {
      "type": "object",
      "allOf": [
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StripContainerSlideShowProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "transition": {
              "type": "string",
              "enum": [
                "NoTransition",
                "SlideVertical",
                "SlideHorizontal",
                "CrossFade",
                "OutIn"
              ],
              "default": "SlideHorizontal",
              "description": "Transition between items of the gallery"
            },
            "autoPlay": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "showPlaybackControl": {
              "type": "boolean"
            },
            "autoPlayInterval": {
              "type": "number",
              "default": 2,
              "minimum": 0,
              "maximum": 30,
              "description": "Autplay interval"
            },
            "direction": {
              "type": "string",
              "default": "RTL",
              "enum": [
                "LTR",
                "RTL"
              ]
            },
            "pauseAutoPlayOnMouseOver": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "transDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 1,
              "description": "Duration of the transition in sec"
            },
            "shouldHideOverflowContent": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "flexibleBoxHeight": {
              "type": "boolean",
              "default": false,
              "description": ""
            },
            "showNavigationButton": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "navigationButtonSize": {
              "type": "number",
              "minimum": 8,
              "maximum": 72,
              "default": 21,
              "description": "Size of the navigation arrow buttons"
            },
            "navigationButtonMargin": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 0,
              "description": "Margin from the sides of the navigation arrow buttons"
            },
            "showNavigationDots": {
              "type": "boolean",
              "default": true,
              "description": ""
            },
            "navigationDotsAlignment": {
              "type": "string",
              "default": "center",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "description": "Alignment of the navigation dots"
            },
            "navigationDotsSize": {
              "type": "number",
              "minimum": 6,
              "maximum": 24,
              "default": 6,
              "description": "Size of the navigation dots"
            },
            "navigationDotsMargin": {
              "type": "number",
              "minimum": -50,
              "maximum": 50,
              "default": 0,
              "description": "Margin from the sides of the navigation dots"
            },
            "navigationDotsGap": {
              "type": "number",
              "minimum": 0,
              "maximum": 24,
              "default": 0,
              "description": "Gap size (spacing) of the navigation dots"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StripContainerSlideShowSlideProperties": {
      "type": "object",
      "allOf": [
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VerticalAnchorsMenuProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "itemsAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left",
              "description": "alignment of the menu items"
            },
            "orientation": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "right",
              "description": "menu orientation"
            },
            "autoColor": {
              "type": "boolean",
              "default": false,
              "description": "does the menu color change automatically according to the background brightness"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TextInputProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "textAlignment": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center"
                  ],
                  "maxLength": 100
                }
              ],
              "default": "left",
              "description": "the direction of the text"
            },
            "textPadding": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              ],
              "default": 14,
              "description": "the value of the textPadding"
            },
            "placeholder": {
              "type": [
                "string",
                "null"
              ],
              "maxLength": 4000,
              "description": "the placeholder option in case nothing is selected",
              "default": "Add your name"
            },
            "defaultTextType": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "string",
                  "enum": [
                    "none",
                    "initialText",
                    "placeholderText",
                    "placeholderAndInitialText"
                  ],
                  "maxLength": 100
                }
              ],
              "default": "placeholderText",
              "description": "the type of the default text for the input"
            },
            "autoComplete": {
              "type": "boolean",
              "description": "can the field be auto completed by the browser"
            }
          }
        },
        {
          "$ref": "InputProperties"
        },
        {
          "$ref": "InputElementsErrorProperties"
        }
      ]
    },
    "TextAreaInputProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "textAlignment": {
              "type": "string",
              "default": "center",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "description": "the direction of the text",
              "maxLength": 100
            },
            "textPadding": {
              "type": "number",
              "default": 18,
              "minimum": 0,
              "maximum": 100,
              "description": "the value of the textPadding"
            },
            "placeholder": {
              "type": "string",
              "maxLength": 4000,
              "description": "the placeholder option in case nothing is selected"
            },
            "defaultTextType": {
              "type": "string",
              "default": "none",
              "enum": [
                "none",
                "initialText",
                "placeholderText",
                "placeholderAndInitialText"
              ],
              "description": "the type of the default text for the input",
              "maxLength": 100
            }
          }
        },
        {
          "$ref": "InputProperties"
        },
        {
          "$ref": "InputElementsErrorProperties"
        }
      ]
    },
    "CheckboxProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "left",
              "description": "alignment of the text"
            },
            "buttonSize": {
              "type": "number",
              "default": 18,
              "description": "checkbox size",
              "minimum": 12,
              "maximum": 100
            },
            "spacing": {
              "type": "number",
              "default": 12,
              "description": "Spacing between checkbox and label",
              "minimum": 0,
              "maximum": 100
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "DatePickerProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "textAlignment": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "description": "the direction of the text"
            },
            "textPadding": {
              "type": "number",
              "default": 18,
              "description": "the value of the text padding"
            },
            "placeholder": {
              "type": "string",
              "default": "",
              "maxLength": 200,
              "description": "placeholder text for date in input field"
            },
            "dateFormat": {
              "type": "string",
              "default": "MM/DD/YYYY",
              "enum": [
                "MM/DD/YYYY",
                "DD/MM/YYYY",
                "YYYY/MM/DD",
                "YYYY/M/D"
              ],
              "description": "date format for selected date presentation inside the date input field"
            },
            "defaultTextType": {
              "type": "string",
              "default": "none",
              "enum": [
                "none",
                "today",
                "placeholder"
              ],
              "description": "the type of the default text for the date input"
            },
            "dayToStart": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "string",
                  "enum": [
                    "Sunday",
                    "Monday"
                  ],
                  "description": "the day which the week starts on"
                }
              ]
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ]
    },
    "GridProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "columns": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "id": {
                    "type": "string"
                  },
                  "dataPath": {
                    "type": "string"
                  },
                  "linkPath": {
                    "type": "string"
                  },
                  "label": {
                    "type": "string"
                  },
                  "width": {
                    "type": "number",
                    "default": 100
                  },
                  "visible": {
                    "type": "boolean",
                    "default": true
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "number",
                      "string",
                      "date",
                      "image",
                      "bool",
                      "richText"
                    ]
                  },
                  "imageAltPath": {
                    "type": "string"
                  }
                }
              }
            },
            "showHeader": {
              "type": "boolean"
            },
            "headerHeight": {
              "type": "number"
            },
            "rowHeight": {
              "type": "number"
            },
            "allowUserSorting": {
              "type": "boolean"
            },
            "allowUserFiltering": {
              "type": "boolean"
            },
            "allowUserEditing": {
              "type": "boolean"
            },
            "heightLayout": {
              "type": "string",
              "enum": [
                "manual",
                "auto"
              ]
            },
            "pagination": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "pagination",
                    "virtual"
                  ]
                },
                "rowsPerPage": {
                  "type": "number",
                  "multipleOf": 1
                },
                "manualHeightProps": {
                  "type": "object",
                  "properties": {
                    "rowsPerPage": {
                      "type": "number",
                      "multipleOf": 1
                    },
                    "gridHeight": {
                      "type": "number",
                      "multipleOf": 1
                    },
                    "type": {
                      "type": "string",
                      "enum": [
                        "normal",
                        "pagination",
                        "virtual"
                      ]
                    }
                  }
                },
                "style": {
                  "type": "string",
                  "enum": [
                    "text",
                    "number",
                    "simple"
                  ],
                  "default": "text"
                },
                "alignment": {
                  "type": "string",
                  "enum": [
                    "left",
                    "center",
                    "right",
                    "spread"
                  ],
                  "default": "right"
                }
              }
            },
            "userSelectionType": {
              "type": "string",
              "enum": [
                "none",
                "cell",
                "row"
              ],
              "default": "none"
            },
            "dateFormat": {
              "type": "string"
            },
            "sorting": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "colId": {
                    "type": "string"
                  },
                  "sort": {
                    "type": "string",
                    "default": "none",
                    "enum": [
                      "asc",
                      "desc",
                      "none"
                    ]
                  }
                }
              }
            },
            "linkTarget": {
              "type": "string",
              "enum": [
                "_self",
                "_blank"
              ]
            },
            "columnLayout": {
              "type": "string",
              "enum": [
                "equal",
                "fitContent",
                "manual"
              ]
            },
            "horizontalAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "PagePropertiesForDevice": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "minHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "minimum page size"
        },
        "popup": {
          "type": "object",
          "properties": {
            "closeOnOverlayClick": {
              "type": "boolean",
              "default": true
            }
          }
        }
      }
    },
    "PageProperties": {
      "type": "object",
      "allOf": [
        {
          "type": "object",
          "properties": {
            "desktop": {
              "$ref": "PagePropertiesForDevice"
            },
            "mobile": {
              "$ref": "PagePropertiesForDevice"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PopupContainerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "horizontalAlignment": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "center",
              "description": ""
            },
            "verticalAlignment": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "center"
              ],
              "default": "top",
              "description": ""
            },
            "alignmentType": {
              "type": "string",
              "enum": [
                "nineGrid",
                "fullHeight",
                "fullWidth"
              ],
              "default": "nineGrid",
              "description": ""
            },
            "horizontalOffset": {
              "type": "number",
              "default": 0,
              "description": ""
            },
            "verticalOffset": {
              "type": "number",
              "default": 0,
              "description": ""
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        },
        {
          "$ref": "VideoBackgroundProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MediaPlayerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "autoplay": {
              "type": "boolean",
              "default": false
            },
            "playerInteraction": {
              "type": "object",
              "description": "The way the player itself interacts with user input",
              "default": {},
              "properties": {
                "click": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "play",
                    "toggle"
                  ],
                  "default": "toggle"
                },
                "rollIn": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "play",
                    "pause"
                  ],
                  "default": "none"
                },
                "rollOut": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "play",
                    "pause"
                  ],
                  "default": "none"
                },
                "allowReplay": {
                  "type": "boolean",
                  "default": true
                }
              }
            },
            "playerAudioInteraction": {
              "type": "object",
              "description": "The way the player itself interacts with user input",
              "default": {},
              "properties": {
                "rollIn": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "mute",
                    "unmute"
                  ],
                  "default": "none"
                },
                "rollOut": {
                  "type": [
                    "string",
                    "null"
                  ],
                  "enum": [
                    "none",
                    "mute",
                    "unmute"
                  ],
                  "default": "none"
                }
              }
            },
            "animatePoster": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "fade"
              ],
              "default": "none"
            },
            "mute": {
              "type": "boolean",
              "description": "mute on load",
              "default": false
            },
            "disableAudio": {
              "type": "boolean",
              "description": "don't allow audio in player",
              "default": false
            },
            "loop": {
              "type": "boolean",
              "default": false
            },
            "overrideMask": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "$ref": "ImageMask"
                }
              ]
            }
          }
        },
        {
          "$ref": "VideoBackgroundProperties"
        },
        {
          "$ref": "FlipProperties"
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MediaControlsProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showStoryboard": {
              "type": "string",
              "enum": [
                "videoAndTime",
                "time",
                "none"
              ],
              "default": "videoAndTime",
              "description": "The options of displaying video preview when hovering on the progress bar"
            },
            "playerId": {
              "type": "string",
              "default": ""
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MediaOverlayControlsProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "playerId": {
              "type": "string",
              "default": ""
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "LanguageSelectorProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "displayMode": {
              "type": "string",
              "default": "dropdown",
              "enum": [
                "horizontal",
                "dropdown"
              ],
              "description": "the direction of the language labels"
            },
            "iconType": {
              "type": "string",
              "default": "circle",
              "enum": [
                "none",
                "circle",
                "square",
                "rounded"
              ],
              "description": "language selector flag shape"
            },
            "iconSize": {
              "type": [
                "null",
                "number"
              ],
              "description": "language selector icon size"
            },
            "hasArrow": {
              "type": "boolean"
            },
            "itemFormat": {
              "type": "string",
              "default": "shortName",
              "enum": [
                "shortName",
                "fullName",
                "iconOnly",
                "fullLocalizedName"
              ],
              "description": "language selector labels type"
            },
            "alignTabs": {
              "type": "string",
              "default": "center",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "description": "language selector tabs alignment"
            },
            "languagesOrder": {
              "type": "array",
              "default": [],
              "items": {
                "type": "string",
                "maxLength": 50
              },
              "description": "Override for the order of the languages in the selection"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MediaBoxProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "allowOverflowContent": {
              "type": "boolean",
              "default": false,
              "description": ""
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PopoverProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "position": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "left",
                "right"
              ],
              "default": "top"
            },
            "alignment": {
              "type": "string",
              "enum": [
                "start",
                "center",
                "end"
              ],
              "default": "center"
            },
            "horizontalOffset": {
              "type": "number",
              "default": 0
            },
            "verticalOffset": {
              "type": "number",
              "default": 0
            },
            "closeMethod": {
              "type": "string",
              "enum": [
                "mouseOut",
                "outerClick",
                "manual"
              ],
              "default": "mouseOut"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "mobui.MobuiPickerProperties": {
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "required": {
              "default": false,
              "type": "boolean"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "MobuiPickerItemType": {
      "properties": {
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "subtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isSelected": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "mobui.MobuiTextInputProperties": {
      "required": [],
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "hasInitialValue": {
              "default": true,
              "type": "boolean"
            },
            "multiline": {
              "default": false,
              "type": "boolean"
            },
            "readOnly": {
              "default": false,
              "type": "boolean"
            },
            "hasPrefix": {
              "default": false,
              "type": "boolean"
            },
            "hasSuffix": {
              "default": false,
              "type": "boolean"
            },
            "required": {
              "default": false,
              "type": "boolean"
            },
            "autoCorrect": {
              "default": false,
              "type": "boolean"
            },
            "hasAutoComplete": {
              "default": false,
              "type": "boolean"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ]
    },
    "AccordionContainerProperties": {
      "type": "object",
      "properties": {
        "defaultOpened": {
          "type": "string",
          "enum": [
            "close_all",
            "open_first",
            "open_all"
          ],
          "default": "close_all"
        },
        "multiple": {
          "type": "boolean",
          "default": false
        },
        "animated": {
          "type": "boolean",
          "default": false
        },
        "animationTime": {
          "type": "number",
          "minimum": 0,
          "default": 0.25
        },
        "icon": {
          "type": "string",
          "enum": [
            "arrow",
            "plus"
          ],
          "default": "arrow"
        }
      },
      "isTopLevelDataNode": true
    },
    "AccordionItemProperties": {
      "properties": {
        "isParentFullWidth": {
          "type": "boolean"
        }
      },
      "type": "object",
      "isTopLevelDataNode": true
    },
    "AddressInputProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left"
            },
            "iconVisible": {
              "type": "boolean",
              "default": false
            },
            "dividerVisible": {
              "type": "boolean",
              "default": false
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "BoltComponentProperties": {
      "type": "object",
      "anyOf": [
        {
          "properties": {}
        }
      ],
      "isTopLevelDataNode": false
    },
    "BreadcrumbsProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "separator": {
              "type": "string",
              "enum": [
                "greater-than",
                "slash"
              ],
              "default": "slash",
              "description": "Defines type of separator between breadcrumbs items"
            },
            "shouldWrap": {
              "type": "boolean",
              "default": true,
              "description": "Defines flex wrapping of items"
            },
            "direction": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr",
              "description": "Direction of breadcrumbs items"
            },
            "alignment": {
              "type": "string",
              "enum": [
                "flex-start",
                "center",
                "flex-end"
              ],
              "default": "flex-start",
              "description": "Alignment of breadcrumbs items"
            },
            "showHomePage": {
              "type": "boolean",
              "default": true,
              "description": "Should show home item"
            },
            "showHomePageAsIcon": {
              "type": "boolean",
              "default": false,
              "description": "Breadcrumbs will show HOME item as icon"
            },
            "showCurrentPage": {
              "type": "boolean",
              "default": true,
              "description": "Should show current page in breadcrumbs"
            },
            "showOnlyPreviousPageOnMobile": {
              "type": "boolean",
              "default": false,
              "description": "Show only previous page in mobile breadcrumbs"
            },
            "horizontalMargin": {
              "type": "number",
              "default": 0
            },
            "verticalMargin": {
              "type": "number",
              "default": 0
            },
            "isCollapsedByDefault": {
              "type": "boolean",
              "default": true
            },
            "itemsBeforeCollapse": {
              "type": "number",
              "default": 1
            },
            "itemsAfterCollapse": {
              "type": "number",
              "default": 1
            },
            "align": {
              "type": "string",
              "enum": [
                "start",
                "center",
                "end"
              ],
              "description": "Alignment of breadcrumbs items updated to new approach"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "CaptchaProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "theme": {
              "type": "string",
              "enum": [
                "light",
                "dark"
              ],
              "default": "light",
              "description": "When set changes the theme of the captcha (dark or light)"
            },
            "size": {
              "type": "string",
              "enum": [
                "normal",
                "compact"
              ],
              "default": "normal",
              "description": "When set changes the size of the captcha (normal or compact)"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "CollapsibleTextProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "ellipsis": {
              "type": "boolean",
              "default": true
            },
            "showExpandControl": {
              "type": "boolean",
              "default": false
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "align": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "left"
            },
            "alignButton": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "left"
            },
            "maxLines": {
              "type": "number",
              "default": 3
            },
            "wrappingStyle": {
              "type": "string",
              "enum": [
                "single-line",
                "multi-line"
              ],
              "default": "multi-line"
            },
            "expandControlSpacing": {
              "type": "number",
              "default": 10
            },
            "expandMode": {
              "type": "string",
              "enum": [
                "button",
                "link"
              ],
              "default": "link"
            },
            "isExpanded": {
              "type": "boolean",
              "default": false
            },
            "lastUserDefinedWidth": {
              "type": "number",
              "default": 300
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "HamburgerCloseButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "StylableButtonProperties"
        }
      ]
    },
    "HamburgerMenuContainerProperties": {
      "type": "object",
      "properties": {
        "fullWidth": {
          "type": "boolean",
          "default": false
        }
      },
      "isTopLevelDataNode": true
    },
    "HamburgerOpenButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "StylableButtonProperties"
        }
      ]
    },
    "LineShareButtonProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "buttonType": {
              "type": "string",
              "default": "button",
              "enum": [
                "button",
                "classicWithButton",
                "classicBig",
                "classicMedium",
                "classicSmall",
                "bubbleBig",
                "bubbleMedium",
                "bubbleSmall"
              ]
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "MusicPlayerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "layout": {
              "type": "string",
              "enum": [
                "classic",
                "icon"
              ],
              "default": "classic"
            },
            "source": {
              "type": "string",
              "enum": [
                "uploads",
                "url",
                "wixMusic"
              ],
              "default": "uploads"
            },
            "showCover": {
              "type": "boolean",
              "default": true
            },
            "showArtistName": {
              "type": "boolean",
              "default": true
            },
            "showTrackName": {
              "type": "boolean",
              "default": true
            },
            "showProgressBar": {
              "type": "boolean",
              "default": true
            },
            "showTimeStamp": {
              "type": "boolean",
              "default": true
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": "Autoplay audio"
            },
            "loop": {
              "type": "boolean",
              "default": false,
              "description": "Play audio on loop"
            },
            "showPlaylist": {
              "type": "boolean",
              "default": true,
              "description": "Show Tracklist"
            },
            "playlistTracksInfo": {
              "type": "string",
              "enum": [
                "trackName",
                "trackNameAndArtistName"
              ],
              "default": "trackName",
              "description": "Show track name or track name w/ artist name"
            },
            "playlistTracksAction": {
              "type": "string",
              "enum": [
                "onActive",
                "onAll"
              ],
              "default": "onActive",
              "description": "Show track actions on active track or all tracks"
            },
            "playlistTrackSpacing": {
              "type": "number",
              "minimum": 0,
              "maximum": 30,
              "description": "How much vertical space must be between each track in playlist",
              "default": 0
            },
            "iconId": {
              "type": "string",
              "default": "icon0",
              "description": "Design IconLayout id"
            },
            "consentToShareAlbum": {
              "type": "boolean",
              "default": false,
              "description": "Agreement to share album"
            },
            "consentToShareTracks": {
              "type": "boolean",
              "default": false,
              "description": "Agreement to share tracks"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "PaginationProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showFirstLastNavButtons": {
              "type": "boolean",
              "default": false
            },
            "showFirstPage": {
              "type": "boolean",
              "default": false
            },
            "showLastPage": {
              "type": "boolean",
              "default": false
            },
            "showInputModeTotalPages": {
              "type": "boolean",
              "default": true
            },
            "paginationMode": {
              "type": "string",
              "enum": [
                "pages",
                "input",
                "arrows"
              ],
              "default": "pages"
            },
            "navigationType": {
              "type": "string",
              "enum": [
                "arrows",
                "text"
              ],
              "default": "arrows"
            },
            "paginationDirection": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "spread",
                "right"
              ],
              "default": "center"
            },
            "showPageNumbersBar": {
              "type": "boolean",
              "default": true
            }
          }
        },
        {
          "$ref": "DisableableProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ProGalleryProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "options": {
              "type": "object",
              "properties": {
                "controllers_optionsMap_behaviourParams_item_video_volume": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_layoutParams_info_allowTitleAndDescription": {
                  "type": "string",
                  "default": ""
                },
                "layoutParams_structure_galleryLayout": {
                  "type": "number",
                  "default": 0
                },
                "layoutParams_structure_scrollDirection": {
                  "type": "string",
                  "default": "VERTICAL"
                },
                "layoutParams_structure_layoutOrientation": {
                  "type": "string",
                  "default": "VERTICAL"
                },
                "behaviourParams_gallery_layoutDirection": {
                  "type": "string",
                  "default": "LEFT_TO_RIGHT"
                },
                "layoutParams_structure_itemSpacing": {
                  "type": "number",
                  "default": 10
                },
                "layoutParams_structure_numberOfGridRows": {
                  "type": "number",
                  "default": 1
                },
                "layoutParams_structure_numberOfColumns": {
                  "type": "number",
                  "default": 3
                },
                "layoutParams_groups_density": {
                  "type": "number",
                  "default": 0.8
                },
                "layoutParams_targetItemSize_value": {
                  "type": "number",
                  "default": 48
                },
                "layoutParams_crop_method": {
                  "type": "string",
                  "default": "FILL"
                },
                "layoutParams_crop_ratios": {
                  "type": "number",
                  "default": 1
                },
                "layoutParams_structure_responsiveMode": {
                  "type": "string",
                  "default": "FIT_TO_SCREEN"
                },
                "layoutParams_thumbnails_alignment": {
                  "type": "string",
                  "default": "BOTTOM"
                },
                "layoutParams_thumbnails_size": {
                  "type": "number",
                  "default": 120
                },
                "layoutParams_thumbnails_spacing": {
                  "type": "number",
                  "default": 4
                },
                "controllers_layoutParams_thumbnails_marginToGallery": {
                  "type": "number",
                  "default": 4
                },
                "behaviourParams_gallery_vertical_loadMore_enable": {
                  "type": "boolean",
                  "default": false
                },
                "behaviourParams_gallery_vertical_loadMore_text": {
                  "type": "string",
                  "default": "Load More"
                },
                "behaviourParams_gallery_horizontal_navigationDuration": {
                  "type": "number",
                  "default": 800
                },
                "behaviourParams_gallery_horizontal_loop": {
                  "type": "boolean",
                  "default": false
                },
                "behaviourParams_gallery_horizontal_autoSlide_interval": {
                  "type": "number",
                  "default": 4
                },
                "behaviourParams_gallery_horizontal_autoSlide_speed": {
                  "type": "number",
                  "default": 50
                },
                "behaviourParams_gallery_horizontal_autoSlide_pauseOnHover": {
                  "type": "boolean",
                  "default": true
                },
                "behaviourParams_gallery_blockContextMenu": {
                  "type": "boolean",
                  "default": true
                },
                "layoutParams_navigationArrows_enable": {
                  "type": "boolean",
                  "default": true
                },
                "layoutParams_navigationArrows_size": {
                  "type": "number",
                  "default": 23
                },
                "layoutParams_navigationArrows_position": {
                  "type": "string",
                  "default": "ON_GALLERY"
                },
                "layoutParams_navigationArrows_container_type": {
                  "type": "string",
                  "default": "NONE"
                },
                "layoutParams_navigationArrows_mouseCursorContainerMaxWidth": {
                  "type": "string",
                  "default": "100"
                },
                "layoutParams_navigationArrows_verticalAlignment": {
                  "type": "string",
                  "default": "ITEM_CENTER"
                },
                "controllers_behaviourParams_item_overlay_hoverAnimationBehavior": {
                  "type": "string",
                  "default": "APPEARS"
                },
                "behaviourParams_item_content_hoverAnimation": {
                  "type": "string",
                  "default": "NO_EFFECT"
                },
                "behaviourParams_item_content_loader": {
                  "type": "string",
                  "default": "MAIN_COLOR"
                },
                "behaviourParams_item_content_placementAnimation": {
                  "type": "string",
                  "default": "NO_EFFECT"
                },
                "behaviourParams_gallery_scrollAnimation": {
                  "type": "string",
                  "default": "NO_EFFECT"
                },
                "behaviourParams_gallery_horizontal_slideAnimation": {
                  "type": "string",
                  "default": "SCROLL"
                },
                "behaviourParams_item_video_enablePlayButton": {
                  "type": "boolean",
                  "default": true
                },
                "behaviourParams_item_video_playTrigger": {
                  "type": "string",
                  "default": "HOVER"
                },
                "behaviourParams_item_video_speed": {
                  "type": "number",
                  "default": 1
                },
                "behaviourParams_item_video_volume": {
                  "type": "number",
                  "default": 0
                },
                "behaviourParams_item_video_loop": {
                  "type": "boolean",
                  "default": true
                },
                "behaviourParams_item_clickAction": {
                  "type": "string",
                  "default": "NOTHING"
                },
                "behaviourParams_item_content_magnificationValue": {
                  "type": "number",
                  "default": 2
                },
                "layoutParams_navigationArrows_padding": {
                  "type": "number",
                  "default": 23
                },
                "behaviourParams_gallery_vertical_loadMore_amount": {
                  "type": "string",
                  "default": "ALL"
                },
                "behaviourParams_gallery_horizontal_autoSlide_behaviour": {
                  "type": "string",
                  "default": "OFF"
                },
                "behaviourParams_gallery_horizontal_slideTransition": {
                  "type": "string",
                  "default": "cubic-bezier(0.46,0.1,0.25,1)"
                },
                "controllers_layoutParams_external_info_placement": {
                  "type": "string",
                  "default": "BELOW"
                },
                "controllers_layoutParams_external_info_CustomButtonHorizontalAlignment": {
                  "type": "string",
                  "default": "CENTER"
                },
                "controllers_layoutParams_internal_info_CustomButtonHorizontalAlignment": {
                  "type": "string",
                  "default": "CENTER"
                },
                "controllers_layoutParams_internal_info_CustomButtonCustomButtonText": {
                  "type": "string",
                  "default": "Click here"
                },
                "controllers_layoutParams_external_info_CustomButtonCustomButtonText": {
                  "type": "string",
                  "default": "Click here"
                },
                "controllers_layoutParams_external_info_SocialButtonsHorizontalAlignment": {
                  "type": "string",
                  "default": "LEFT"
                },
                "controllers_layoutParams_internal_info_SocialButtonsHorizontalAlignment": {
                  "type": "string",
                  "default": "LEFT"
                },
                "layoutParams_info_placement": {
                  "type": "string",
                  "default": "OVERLAY"
                },
                "controllers_layoutParams_info_allowTitle": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_layoutParams_info_allowDescription": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_layoutParams_info_verticalPadding": {
                  "type": "number",
                  "default": 0
                },
                "controllers_layoutParams_info_horizontalPadding": {
                  "type": "number",
                  "default": 0
                },
                "controllers_layoutParams_infoElementOptions_external_enabled": {
                  "type": "string",
                  "default": ""
                },
                "controllers_layoutParams_infoElementOptions_internal_enabled": {
                  "type": "string",
                  "default": ""
                },
                "controllers_experimental_useNewInfo": {
                  "type": "string",
                  "default": ""
                },
                "controllers_layoutParams_infoElementOptions_external_order": {
                  "type": "string",
                  "default": "top,Title,Description,CustomButton,middle,bottom,Social"
                },
                "controllers_layoutParams_infoElementOptions_internal_order": {
                  "type": "string",
                  "default": "top,Title,Description,CustomButton,middle,bottom,Social"
                },
                "controllers_layoutParams_info_verticalAlignment": {
                  "type": "string",
                  "default": "CENTER"
                },
                "controllers_layoutParams_info_horizontalAlignment": {
                  "type": "string",
                  "default": "CENTER"
                },
                "controllers_layoutParams_structure_imageWidth_method": {
                  "type": "string",
                  "default": "FIXED"
                },
                "controllers_layoutParams_structure_numberOfDisplayedItems": {
                  "type": "number",
                  "default": 3
                },
                "layoutParams_info_sizeUnits": {
                  "type": "string",
                  "default": "PIXEL"
                },
                "layoutParams_info_height": {
                  "type": "number",
                  "default": 200
                },
                "controllers_layoutParams_info_width_pixel": {
                  "type": "number",
                  "default": 200
                },
                "controllers_layoutParams_info_width_percent": {
                  "type": "number",
                  "default": 50
                },
                "behaviourParams_item_overlay_hoveringBehaviour": {
                  "type": "string",
                  "default": "NEVER_SHOW"
                },
                "controllers_behaviourParams_item_overlay_overlayType": {
                  "type": "string",
                  "default": "FULL"
                },
                "behaviourParams_item_overlay_sizeUnits": {
                  "type": "string",
                  "default": "PERCENT"
                },
                "controllers_behaviourParams_item_overlay_size_percent": {
                  "type": "number",
                  "default": 100
                },
                "controllers_behaviourParams_item_overlay_size_pixel": {
                  "type": "number",
                  "default": 100
                },
                "behaviourParams_item_overlay_position": {
                  "type": "string",
                  "default": "BOTTOM"
                },
                "behaviourParams_item_overlay_padding": {
                  "type": "number",
                  "default": 0
                },
                "behaviourParams_item_secondaryMedia_enableHoverTrigger": {
                  "type": "boolean",
                  "default": false
                },
                "behaviourParams_item_overlay_hoverAnimation": {
                  "type": "string",
                  "default": "NO_EFFECT"
                },
                "controllers_layoutParams_structure_galleryRatio_method": {
                  "type": "string",
                  "default": "MANUAL"
                },
                "controllers_layoutParams_structure_galleryRatio_value": {
                  "type": "number",
                  "default": 1
                },
                "controllers_fullscreen_allowTitleExpand": {
                  "type": "boolean",
                  "default": true
                },
                "controllers_behaviourParams_item_overlay_enabled": {
                  "type": "boolean",
                  "default": true
                },
                "controllers_layoutParams_info_newInfo_external_enabled": {
                  "type": "boolean",
                  "default": true
                },
                "controllers_fullscreen_allowDescriptionExpand": {
                  "type": "boolean",
                  "default": true
                },
                "controllers_fullscreen_allowLinkExpand": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_fullscreen_expandInfoPosition": {
                  "type": "string",
                  "default": "SIDE"
                },
                "controllers_fullscreen_showInfoExpandButton": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_fullscreen_whenToShowInfo": {
                  "type": "string",
                  "default": "ALWAYS"
                },
                "controllers_fullscreen_allowFullscreenExpand": {
                  "type": "boolean",
                  "default": true
                },
                "controllers_fullscreen_fullscreenLoop": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_fullscreen_allowFullscreenMagnifyImage": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_fullscreen_fullscreenMagnificationLevel": {
                  "type": "number",
                  "default": 2
                },
                "controllers_fullscreen_fullscreenMagnificationPercent": {
                  "type": "number",
                  "default": 200
                },
                "controllers_fullscreen_backgroundBlurFilter": {
                  "type": "number",
                  "default": 1
                },
                "controllers_fullscreen_backgroundGrayscaleFilter": {
                  "type": "boolean",
                  "default": false
                },
                "controllers_showManageMedia": {
                  "type": "boolean",
                  "default": false
                },
                "variant_count": {
                  "type": "number",
                  "default": 0
                }
              }
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ProgressBarProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RangeSliderProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "align": {
              "type": "string",
              "enum": [
                "start",
                "center",
                "end"
              ],
              "description": "Alignment of range slider"
            }
          }
        },
        {
          "$ref": "DisableableProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RatingsDisplayProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showReviewsCount": {
              "type": "boolean",
              "default": true
            },
            "showRating": {
              "type": "boolean",
              "default": true
            },
            "noReviewsMode": {
              "type": "string",
              "enum": [
                "nothing",
                "emptyIcons",
                "placeholderText"
              ],
              "default": "emptyIcons"
            },
            "ratingPosition": {
              "type": "string",
              "enum": [
                "before",
                "after"
              ],
              "default": "before"
            },
            "shapeSize": {
              "type": "number",
              "minimum": 15,
              "maximum": 100,
              "default": 24
            },
            "shapeSpacing": {
              "type": "number",
              "minimum": 1,
              "maximum": 50,
              "default": 5
            },
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "default": "left"
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            },
            "renderSeo": {
              "type": "boolean",
              "default": true
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RatingsInputProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showTitle": {
              "type": "boolean",
              "default": true
            },
            "showLabels": {
              "type": "boolean",
              "default": true
            },
            "labelPosition": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "side"
              ],
              "default": "top"
            },
            "a11yLabelPosition": {
              "type": "string",
              "enum": [
                "top",
                "bottom",
                "side"
              ],
              "default": "side"
            },
            "labelAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "center"
            },
            "a11yLabelAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "center"
            },
            "shapeSize": {
              "type": "number",
              "minimum": 15,
              "maximum": 100,
              "default": 24
            },
            "shapeSpacing": {
              "type": "number",
              "minimum": 1,
              "maximum": 50,
              "default": 5
            },
            "direction": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "RichTextBoxProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "textAlignment": {
              "type": "string",
              "default": "left",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "description": "the text alignment",
              "maxLength": 100
            },
            "textPadding": {
              "type": "number",
              "default": 18,
              "minimum": 0,
              "maximum": 100,
              "description": "the value of the textPadding"
            },
            "toolbarPosition": {
              "type": "string",
              "default": "top",
              "enum": [
                "top",
                "bottom",
                "inline"
              ],
              "description": "the location of the toolbar",
              "maxLength": 20
            },
            "placeholder": {
              "type": "string",
              "description": "the placeholder",
              "default": "",
              "maxLength": 4000
            },
            "defaultTextType": {
              "type": "string",
              "default": "placeholderText",
              "enum": [
                "none",
                "initialText",
                "placeholderText",
                "placeholderAndInitialText"
              ],
              "description": "the type of the default text for the input",
              "maxLength": 100
            },
            "allowLinks": {
              "type": "boolean",
              "description": "Are links allowed"
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SearchBoxProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "layout": {
              "type": "string",
              "enum": [
                "icon",
                "button",
                "icon-only",
                "expandable"
              ],
              "default": "icon"
            },
            "iconAlignment": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "left"
            },
            "textAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center"
              ],
              "default": "left"
            },
            "textSpacing": {
              "type": "number",
              "default": 12,
              "description": "Setting the spacing from the side the text is aligned to",
              "minimum": 0,
              "maximum": 50
            },
            "iconSpacing": {
              "type": "number",
              "default": 12,
              "description": "In icon layout affects the side to which the icon is aligend to, for button layout affects both - left and right sides",
              "minimum": 0,
              "maximum": 50
            },
            "trendingItemsEnabled": {
              "type": "boolean",
              "default": true,
              "description": "Controls trending items visibility."
            },
            "isExpandable": {
              "type": "boolean",
              "default": false,
              "description": "Is component able to expand/collapse"
            },
            "expandedDirection": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "left",
              "description": "Which direction the component should expand to"
            },
            "expandedWidth": {
              "type": "number",
              "default": 100,
              "description": "What's the expanded component width",
              "minimum": 0,
              "maximum": 1000
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SearchButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "StylableButtonProperties"
        }
      ]
    },
    "SelectionTagsListProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr",
              "description": "Direction of tags"
            },
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left",
              "description": "Alignment of tags"
            },
            "hasAutoHeight": {
              "type": "boolean",
              "description": "used in mapper to avoid adding min-height property"
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SignatureInputProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "direction": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ]
            },
            "required": {
              "type": "boolean"
            },
            "titlePaddingStart": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "titleMarginBottom": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "labelMobileFontSize": {
              "type": "number"
            },
            "inputMobileFontSize": {
              "type": "number"
            }
          }
        },
        {
          "$ref": "DisableableProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SingleTabProperties": {
      "properties": {
        "isParentFullWidth": {
          "type": "boolean"
        }
      },
      "type": "object",
      "isTopLevelDataNode": true
    },
    "SliderProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "trackSize": {
              "type": "number",
              "default": 25
            },
            "orientation": {
              "type": "string",
              "enum": [
                "horizontal",
                "vertical"
              ],
              "default": "horizontal"
            },
            "thumbShape": {
              "type": "string",
              "enum": [
                "circle",
                "square",
                "rectangle",
                "bar"
              ],
              "default": "circle"
            },
            "thumbSize": {
              "type": "number",
              "minimum": 18,
              "maximum": 100,
              "description": "Size of the slider thumb"
            },
            "tickMarksShape": {
              "type": "string",
              "enum": [
                "none",
                "line",
                "dot"
              ],
              "default": "line"
            },
            "tooltipVisibility": {
              "type": "string",
              "enum": [
                "none",
                "hover",
                "always"
              ],
              "default": "hover"
            },
            "tooltipPosition": {
              "type": "string",
              "enum": [
                "normal",
                "across"
              ],
              "default": "normal"
            },
            "tooltipPrefix": {
              "type": "string",
              "maxLength": 30
            },
            "tooltipSuffix": {
              "type": "string",
              "maxLength": 30
            },
            "tickMarksPosition": {
              "type": "string",
              "enum": [
                "normal",
                "middle",
                "across"
              ],
              "default": "normal"
            },
            "dir": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ],
              "default": "ltr"
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "SlideshowProperties": {
      "properties": {
        "isHidden": {
          "type": "boolean"
        },
        "isCollapsed": {
          "type": "boolean"
        },
        "type": {
          "default": "SlideshowProperties",
          "maxLength": 120,
          "type": "string"
        },
        "isPlaying": {
          "default": true,
          "type": "boolean"
        },
        "slideDuration": {
          "default": 5,
          "minimum": 1,
          "maximum": 30,
          "type": "number"
        },
        "pauseOnHover": {
          "default": true,
          "type": "boolean"
        },
        "showPlaybackControl": {
          "default": false,
          "type": "boolean"
        },
        "loop": {
          "default": true,
          "type": "boolean"
        },
        "previewItemId": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      },
      "required": [
        "isHidden",
        "isCollapsed"
      ],
      "type": "object",
      "isTopLevelDataNode": true
    },
    "SlideshowButtonProperties": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "properties": {
            "action": {
              "type": "string",
              "enum": [
                "prev",
                "next"
              ],
              "default": "next"
            }
          }
        },
        {
          "$ref": "StylableButtonProperties"
        }
      ]
    },
    "SocialAuthProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "isSmallIcons": {
              "type": "boolean",
              "default": true
            },
            "isSocialLoginGoogleEnabled": {
              "type": "boolean",
              "default": true
            },
            "isSocialLoginFacebookEnabled": {
              "type": "boolean",
              "default": true
            },
            "mode": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "signup",
                "login"
              ]
            },
            "formType": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "default",
                "custom",
                "corvid"
              ],
              "default": "corvid"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StylableButtonProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "iconCollapsed": {
              "type": "boolean",
              "default": false
            },
            "isMaxContent": {
              "type": "boolean",
              "default": false
            },
            "isWrapText": {
              "type": "boolean",
              "default": false
            }
          }
        },
        {
          "$ref": "DisableableProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "StylableHorizontalMenuProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "menuMode": {
              "type": "string",
              "enum": [
                "wrap",
                "scroll"
              ],
              "default": "wrap"
            },
            "submenuMode": {
              "type": "string",
              "enum": [
                "columnMenu",
                "columnStretched",
                "flyout"
              ],
              "description": "Submenu view modes",
              "default": "columnMenu"
            },
            "slotMap": {
              "type": "object"
            },
            "isContainerStretched": {
              "type": "boolean",
              "default": true
            },
            "submenuOrder": {
              "type": "string",
              "enum": [
                "vertical",
                "horizontal"
              ],
              "description": "Submenu items order",
              "default": "vertical"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TabsProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "itemSpacing": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 0
            },
            "itemRowSpacing": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 0
            },
            "containerSpacing": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 0
            },
            "tabWidth": {
              "type": "number",
              "minimum": 10,
              "maximum": 500
            },
            "stretchTabsToMenuWidth": {
              "type": "boolean",
              "default": false
            },
            "fitTabsToTextWidth": {
              "type": "boolean",
              "default": false
            },
            "itemsOrientation": {
              "type": "string",
              "enum": [
                "horizontal",
                "vertical"
              ],
              "default": "horizontal"
            },
            "itemsAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left"
            },
            "contentAlignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left"
            },
            "itemsLogicalAlign": {
              "type": "string",
              "enum": [
                "start",
                "center",
                "end"
              ],
              "default": "start"
            },
            "contentLogicalAlign": {
              "type": "string",
              "enum": [
                "start",
                "center",
                "end"
              ],
              "default": "start"
            },
            "horizontalTabPadding": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 20
            },
            "verticalTabPadding": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 20
            },
            "menuMode": {
              "type": "string",
              "enum": [
                "wrap",
                "scroll"
              ],
              "default": "scroll"
            },
            "itemsDirection": {
              "type": "string",
              "enum": [
                "rtl",
                "ltr"
              ],
              "default": "ltr"
            },
            "tabEnterAnimationName": {
              "type": "string",
              "enum": [
                "none",
                "fadeIn",
                "floatFromTop",
                "floatFromBottom"
              ],
              "default": "none",
              "description": "The animation that will be played when a tab is entered"
            },
            "tabExitAnimationName": {
              "type": "string",
              "enum": [
                "none",
                "fadeOut"
              ],
              "default": "none",
              "description": "The animation that will be played when a tab is exited"
            },
            "animationDuration": {
              "type": "number",
              "minimum": 0,
              "maximum": 5,
              "default": 0.3,
              "description": "Duration of the transition in sec"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "TimePickerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right"
              ],
              "default": "left"
            },
            "useAmPmFormat": {
              "type": "boolean",
              "default": false,
              "description": "Should the display format be 12 hours (or 24)"
            },
            "controller": {
              "type": "string",
              "enum": [
                "text",
                "stepper",
                "dropdown"
              ],
              "default": "text",
              "description": "The display of the time picker"
            },
            "initialTime": {
              "type": "string",
              "enum": [
                "none",
                "current",
                "value",
                "placeholder"
              ],
              "default": "current",
              "description": "What the time picker should display on load"
            },
            "margin": {
              "type": "number",
              "multipleOf": 1,
              "description": ""
            },
            "disabledTimes": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "startTime": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "endTime": {
                    "type": "string",
                    "maxLength": 100
                  }
                },
                "additionalProperties": false,
                "required": [
                  "startTime",
                  "endTime"
                ]
              },
              "default": [],
              "maxItems": 5,
              "description": "array of disabled times"
            },
            "enabledTimes": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "startTime": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "endTime": {
                    "type": "string",
                    "maxLength": 100
                  }
                },
                "additionalProperties": false,
                "required": [
                  "startTime",
                  "endTime"
                ]
              },
              "default": [],
              "maxItems": 5,
              "description": "array of enabled times"
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "ToggleSwitchProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "displayKnobIcons": {
              "type": "boolean"
            },
            "trackHeight": {
              "type": "number",
              "default": 100
            },
            "knobSize": {
              "type": "number",
              "default": 90
            },
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "right"
              ],
              "default": "left"
            },
            "switchHeight": {
              "type": "number",
              "default": 24
            }
          }
        },
        {
          "$ref": "InputProperties"
        }
      ],
      "isTopLevelDataNode": true
    },
    "VideoPlayerProperties": {
      "type": "object",
      "allOf": [
        {
          "properties": {
            "showVideoTitle": {
              "type": "boolean",
              "default": true
            },
            "autoplay": {
              "type": "boolean",
              "default": false,
              "description": "Autoplay video"
            },
            "loop": {
              "type": "boolean",
              "default": false,
              "description": "Play video on loop"
            },
            "share": {
              "type": "boolean",
              "default": true,
              "description": "Allow to share video"
            },
            "controlsVisibility": {
              "type": "string",
              "enum": [
                "hover",
                "never"
              ],
              "default": "hover"
            },
            "animatePoster": {
              "type": "string",
              "enum": [
                "fade",
                "none"
              ],
              "default": "none",
              "description": "Animate video poster"
            }
          }
        },
        {
          "$ref": "DefaultProperties"
        }
      ],
      "isTopLevelDataNode": true
    }
  },
  "reactions.json": {
    "Reactions": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": [
            "array",
            "null"
          ],
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "refTypes": [
            "ToggleState",
            "RemoveState",
            "AddState",
            "RemoveAllStates",
            "ScrollForward",
            "ScrollBackward",
            "Play",
            "Scrub",
            "TogglePlay"
          ]
        }
      },
      "required": [
        "values"
      ]
    },
    "BaseStateReaction": {
      "type": "object",
      "properties": {
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": false,
          "referencedMap": "variants_data",
          "refTypes": [
            "State"
          ]
        }
      },
      "required": [
        "state"
      ],
      "isTopLevelDataNode": false
    },
    "ToggleState": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "BaseStateReaction"
        }
      ]
    },
    "RemoveState": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "BaseStateReaction"
        }
      ]
    },
    "AddState": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "BaseStateReaction"
        }
      ]
    },
    "RemoveAllStates": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "ScrollForward": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "ScrollBackward": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {}
    },
    "Play": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "effect": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": false,
          "referencedMap": "effects",
          "refTypes": [
            "TimeAnimation"
          ]
        },
        "once": {
          "type": "boolean"
        }
      },
      "required": [
        "effect"
      ]
    },
    "TogglePlay": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "effect": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": false,
          "referencedMap": "effects",
          "refTypes": [
            "TimeAnimation"
          ]
        }
      },
      "required": [
        "effect"
      ]
    },
    "Scrub": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "effect": {
          "type": "string",
          "pseudoType": [
            "weakRef"
          ],
          "shouldValidate": true,
          "shouldCollect": false,
          "referencedMap": "effects",
          "refTypes": [
            "ScrubAnimation"
          ]
        }
      },
      "required": [
        "effect"
      ]
    }
  },
  "slots.json": {
    "PlaceholderSlot": {
      "type": "object",
      "properties": {
        "slots": {
          "type": "object",
          "properties": {
            "slot": {
              "$ref": "SlotRef"
            }
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "DynamicSlots": {
      "type": "object",
      "properties": {
        "slots": {
          "type": "object",
          "properties": {},
          "additionalProperties": {
            "$ref": "SlotRef"
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "SlotRef": {
      "type": "string",
      "pseudoType": [
        "weakRef"
      ],
      "referencedMap": "components",
      "refTypes": [],
      "shouldCollect": false,
      "shouldValidate": false,
      "isTopLevelDataNode": false
    }
  },
  "source.json": {
    "Source": {
      "type": "object",
      "properties": {
        "original": {
          "$ref": "SourceEnumType"
        },
        "current": {
          "$ref": "SourceEnumType"
        },
        "changed": {
          "type": "boolean",
          "default": false
        },
        "ai_semantics": {
          "type": "string",
          "maxLength": 4000,
          "description": "experimental field to add context for AI. This field is only for use within a POC for AI and may be removed. It should not be relied on in production"
        }
      },
      "isTopLevelDataNode": true
    },
    "SourceEnumType": {
      "type": "string",
      "enum": [
        "template",
        "preset",
        "user",
        "application",
        "translation",
        "caas",
        "ai"
      ]
    }
  },
  "states.json": {
    "States": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": "array",
          "items": {
            "type": "string",
            "pseudoType": [
              "weakRef"
            ],
            "shouldValidate": true,
            "shouldCollect": true,
            "dontSerialize": true,
            "referencedMap": "variants_data",
            "refTypes": [
              "State"
            ]
          },
          "default": []
        }
      },
      "required": [
        "values"
      ]
    }
  },
  "structure.json": {
    "DesignQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "design_data",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "DataQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "document_data",
      "isTopLevelDataNode": false
    },
    "PropertyQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "component_properties",
      "isTopLevelDataNode": false
    },
    "VariantsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "variants_data",
      "isTopLevelDataNode": false,
      "refTypes": [
        "VariantsList"
      ]
    },
    "StyleId": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": false,
      "shouldCollect": true,
      "referencedMap": "theme_data",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "MobileHintsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "mobile_hints",
      "isTopLevelDataNode": false
    },
    "BehaviorQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "behaviors_data",
      "isTopLevelDataNode": false
    },
    "ConnectionQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "connections_data",
      "isTopLevelDataNode": false
    },
    "ControllersQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "controllers",
      "isTopLevelDataNode": false
    },
    "LayoutQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "layout_data",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "AnchorQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "anchors_data",
      "isTopLevelDataNode": false
    },
    "BreakpointVariantsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "variants_data",
      "isTopLevelDataNode": false
    },
    "TransformationQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "transformations_data",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "TransitionQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "transitions_data",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "type": [
                      "string",
                      "null"
                    ],
                    "pseudoType": [
                      "weakRef"
                    ],
                    "shouldValidate": true,
                    "isRefOwner": false,
                    "shouldCollect": true,
                    "referencedMap": "document_data",
                    "refTypes": [
                      "PagesGroupData"
                    ]
                  }
                }
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "required": [
              "modeId",
              "type"
            ]
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "$ref": "LayoutObjectForComponents"
              },
              "designQuery": {
                "$ref": "DesignQuery"
              },
              "propertyQuery": {
                "$ref": "PropertyQuery"
              },
              "styleId": {
                "$ref": "StyleId"
              }
            },
            "required": [
              "modeIds"
            ]
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "isTopLevelDataNode": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "AnchorDefinition"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "isTopLevelDataNode": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "$ref": "DockingUnitSize"
        },
        "right": {
          "$ref": "DockingUnitSize"
        },
        "top": {
          "$ref": "DockingUnitSize"
        },
        "bottom": {
          "$ref": "DockingUnitSize"
        },
        "hCenter": {
          "$ref": "DockingUnitSize"
        },
        "vCenter": {
          "$ref": "DockingUnitSize"
        }
      },
      "isTopLevelDataNode": false
    },
    "BaseComponentObject": {
      "type": "object",
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          }
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "$ref": "Parent"
        }
      },
      "required": [
        "id",
        "type"
      ],
      "isTopLevelDataNode": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "isTopLevelDataNode": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "$ref": "ShouldReallyBeAnIntAtSomePoint"
        },
        "y": {
          "$ref": "ShouldReallyBeAnIntAtSomePoint"
        },
        "width": {
          "$ref": "ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "height": {
          "$ref": "ShouldReallyBeAnIntAtSomePoint",
          "minimum": 0
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "$ref": "DockingDefinition"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "$ref": "AnchorDefinition"
          }
        }
      },
      "isTopLevelDataNode": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "type": [
        "null",
        "array"
      ],
      "uniqueItems": true,
      "pseudoType": [
        "refList"
      ],
      "refTypes": [
        "Component",
        "Container",
        "RefComponent",
        "RepeaterContainer"
      ],
      "isTopLevelDataNode": false
    },
    "Component": {
      "type": "object",
      "allOf": [
        {
          "$ref": "BaseComponentObject"
        },
        {
          "$ref": "ComponentQueries"
        },
        {
          "type": "object",
          "properties": {
            "componentType": {
              "type": "string"
            },
            "skin": {
              "type": "string"
            },
            "modes": {
              "$ref": "ModesDefinition"
            }
          },
          "required": [
            "componentType"
          ]
        }
      ],
      "isTopLevelDataNode": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "$ref": "DataQuery"
        },
        "propertyQuery": {
          "$ref": "PropertyQuery"
        },
        "designQuery": {
          "$ref": "DesignQuery"
        },
        "mobileHintsQuery": {
          "$ref": "MobileHintsQuery"
        },
        "behaviorQuery": {
          "$ref": "BehaviorQuery"
        },
        "connectionQuery": {
          "$ref": "ConnectionQuery"
        },
        "controllersQuery": {
          "$ref": "ControllersQuery"
        },
        "layoutQuery": {
          "$ref": "LayoutQuery"
        },
        "anchorQuery": {
          "$ref": "AnchorQuery"
        },
        "breakpointVariantsQuery": {
          "$ref": "BreakpointVariantsQuery"
        },
        "transformationQuery": {
          "$ref": "TransformationQuery"
        },
        "transitionQuery": {
          "$ref": "TransitionQuery"
        },
        "variantsQuery": {
          "$ref": "VariantsQuery"
        },
        "styleId": {
          "$ref": "StyleId"
        },
        "layout": {
          "$ref": "LayoutObjectForComponents"
        },
        "classnamesQuery": {
          "$ref": "ClassnamesQuery"
        },
        "contentRoleQuery": {
          "$ref": "ContentRoleQuery"
        },
        "cursorQuery": {
          "$ref": "CursorQuery"
        },
        "discussionsQuery": {
          "$ref": "DiscussionsQuery"
        },
        "editorsettingsQuery": {
          "$ref": "EditorsettingsQuery"
        },
        "effectsQuery": {
          "$ref": "EffectsQuery"
        },
        "groupingQuery": {
          "$ref": "GroupingQuery"
        },
        "innerElementsQuery": {
          "$ref": "InnerElementsQuery"
        },
        "intentQuery": {
          "$ref": "IntentQuery"
        },
        "layoutSettingsQuery": {
          "$ref": "LayoutSettingsQuery"
        },
        "manifestQuery": {
          "$ref": "ManifestQuery"
        },
        "measurementsQuery": {
          "$ref": "MeasurementsQuery"
        },
        "migrationQuery": {
          "$ref": "MigrationQuery"
        },
        "namingQuery": {
          "$ref": "NamingQuery"
        },
        "notificationsQuery": {
          "$ref": "NotificationsQuery"
        },
        "pageSectionsQuery": {
          "$ref": "PageSectionsQuery"
        },
        "presetsQuery": {
          "$ref": "PresetsQuery"
        },
        "reactionsQuery": {
          "$ref": "ReactionsQuery"
        },
        "slotsQuery": {
          "$ref": "SlotsQuery"
        },
        "sourceQuery": {
          "$ref": "SourceQuery"
        },
        "statesQuery": {
          "$ref": "StatesQuery"
        },
        "triggersQuery": {
          "$ref": "TriggersQuery"
        },
        "variablesQuery": {
          "$ref": "VariablesQuery"
        }
      },
      "isTopLevelDataNode": false
    },
    "RefComponent": {
      "type": "object",
      "allOf": [
        {
          "$ref": "Component"
        },
        {
          "properties": {
            "components": {
              "$ref": "ComponentsList"
            }
          }
        }
      ],
      "isTopLevelDataNode": false
    },
    "RepeaterContainer": {
      "type": "object",
      "allOf": [
        {
          "$ref": "Container"
        },
        {
          "$ref": "RepeaterQueries"
        }
      ],
      "isTopLevelDataNode": false
    },
    "RepeaterVariantsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "referencedMap": "variants_data",
      "isTopLevelDataNode": false,
      "refTypes": [
        "RepeaterPatternList"
      ]
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "$ref": "RepeaterVariantsQuery"
        },
        "patternsQuery": {
          "$ref": "PatternsQuery"
        }
      },
      "isTopLevelDataNode": false
    },
    "Container": {
      "type": "object",
      "allOf": [
        {
          "$ref": "Component"
        },
        {
          "properties": {
            "components": {
              "$ref": "ComponentsList"
            }
          },
          "required": [
            "components"
          ]
        }
      ],
      "isTopLevelDataNode": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "$ref": "FixerVersionsQuery"
        }
      },
      "isTopLevelDataNode": false
    },
    "Page": {
      "type": "object",
      "allOf": [
        {
          "$ref": "Container"
        },
        {
          "$ref": "PageQueries"
        }
      ],
      "isTopLevelDataNode": false
    },
    "DocumentProperties": {
      "type": "object",
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "$ref": "PartialLayoutObjectForMasterPage"
        },
        "componentProperties": {
          "type": "object",
          "properties": {}
        },
        "themeData": {
          "type": "object",
          "properties": {}
        },
        "variantsQuery": {
          "$ref": "VariantsQuery"
        },
        "fixerVersionsQuery": {
          "$ref": "FixerVersionsQuery"
        },
        "themeConfigQuery": {
          "$ref": "ThemeConfigQuery"
        }
      },
      "required": [
        "documentType",
        "components"
      ],
      "isTopLevelDataNode": false
    },
    "Document": {
      "type": "object",
      "allOf": [
        {
          "$ref": "Container"
        },
        {
          "$ref": "DocumentProperties"
        }
      ],
      "isTopLevelDataNode": false
    },
    "Parent": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "weakRef"
      ],
      "shouldValidate": true,
      "shouldCollect": false,
      "referencedMap": "#",
      "isTopLevelDataNode": false
    },
    "ClassnamesQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "classnames",
      "isTopLevelDataNode": false
    },
    "ContentRoleQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "contentRole",
      "isTopLevelDataNode": false
    },
    "CursorQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "cursor",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "DiscussionsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "discussions",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "EditorsettingsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "editorsettings",
      "isTopLevelDataNode": false
    },
    "EffectsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "effects",
      "isTopLevelDataNode": false
    },
    "FixerVersionsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "fixerVersions",
      "isTopLevelDataNode": false
    },
    "GroupingQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "grouping",
      "isTopLevelDataNode": false
    },
    "InnerElementsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "innerElements",
      "isTopLevelDataNode": false
    },
    "IntentQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "intent",
      "isTopLevelDataNode": false
    },
    "LayoutSettingsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "layoutSettings",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "ManifestQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "manifest",
      "isTopLevelDataNode": false
    },
    "MeasurementsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "measurements",
      "isTopLevelDataNode": false
    },
    "MigrationQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "migration",
      "isTopLevelDataNode": false
    },
    "NamingQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "naming",
      "isTopLevelDataNode": false
    },
    "NotificationsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "notifications",
      "isTopLevelDataNode": false
    },
    "PageSectionsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "pageSections",
      "isTopLevelDataNode": false
    },
    "PatternsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "patterns",
      "isTopLevelDataNode": false
    },
    "PresetsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "presets",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "ReactionsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "reactions",
      "isTopLevelDataNode": false,
      "isRelationalSplit": true
    },
    "SlotsQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "slots",
      "isTopLevelDataNode": false
    },
    "SourceQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "source",
      "isTopLevelDataNode": false
    },
    "StatesQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "states",
      "isTopLevelDataNode": false
    },
    "ThemeConfigQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "themeConfig",
      "isTopLevelDataNode": false
    },
    "TriggersQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "triggers",
      "isTopLevelDataNode": false
    },
    "VariablesQuery": {
      "type": [
        "string",
        "null"
      ],
      "pseudoType": [
        "ref"
      ],
      "shouldValidate": true,
      "shouldCollect": true,
      "isRefOwner": true,
      "referencedMap": "variables",
      "isTopLevelDataNode": false
    }
  },
  "style.json": {
    "WFlatTheme": {
      "type": "object",
      "isPermanentDataNode": true,
      "properties": {
        "THEME_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "BG_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "CONTACT_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "NETWORKS_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "PAGES_DIRECTORY": {
          "type": "string",
          "format": "themeUrl",
          "default": "base"
        },
        "WEB_THEME_DIRECTORY": {
          "type": "string",
          "format": "webThemeUrl",
          "default": "base"
        },
        "BASE_THEME_DIRECTORY": {
          "type": "string",
          "format": "webThemeUrl",
          "default": "base"
        },
        "siteBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "color": {
          "type": "array",
          "items": {
            "type": [
              "null",
              "string"
            ],
            "format": "color"
          },
          "default": [
            "#000000",
            "#000000",
            "#FFFFFF",
            "#FF0000",
            "#00FF00",
            "#0000FF",
            "#333333",
            "#666666",
            "#999999",
            "#AAAAAA",
            "#DCDCDC",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF"
          ]
        },
        "font": {
          "type": "array",
          "items": {
            "type": [
              "null",
              "string"
            ],
            "format": "font"
          },
          "default": [
            "normal normal normal 24px/1.2em Arial {color_5}",
            "normal normal bold 16px/1.1em Arial {color_5}",
            "italic normal bold 18px/1.1em Lobster {color_5}",
            "normal normal bold 22px/1.1em Arial {color_5}",
            "normal normal bold 20px/1.1em Arial {color_5}",
            "normal normal normal 18px/1.3em Arial {color_5}",
            "normal normal normal 16px/1.2em Arial {color_6}",
            "normal normal normal 14px/1.3em Arial {color_6}",
            "normal normal normal 12px/1.3em Arial {color_6}",
            "normal normal normal 10px/1.3em Arial {color_6}",
            "normal normal normal 8px/1.3em Arial {color_6}"
          ]
        },
        "textTheme": {
          "type": "array",
          "items": {
            "$ref": "TextTheme"
          },
          "default": [
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "24px",
              "fontFamily": "Arial",
              "lineHeight": "1.2em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "16px",
              "fontFamily": "Arial",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "italic",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "18px",
              "fontFamily": "Lobster",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "22px",
              "fontFamily": "Arial",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "20px",
              "fontFamily": "Arial",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "18px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "16px",
              "fontFamily": "Arial",
              "lineHeight": "1.2em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "14px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "12px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "10px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "8px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            }
          ]
        },
        "theme": {
          "$ref": "OverridableTheme"
        },
        "fontDisplay": {
          "type": "string",
          "enum": [
            "auto",
            "block",
            "swap",
            "fallback",
            "optional"
          ],
          "description": "font-display css property. The default is 'block' in the viewer rendering"
        },
        "border": {
          "type": "array",
          "items": {
            "type": [
              "null",
              "string"
            ],
            "format": "border"
          },
          "default": [
            "0.15em solid [color_0]",
            "0.15em solid [color_0]",
            "0.15em solid [color_0]"
          ]
        },
        "padding1": {
          "type": "string",
          "format": "padding",
          "default": "0 0 0 0"
        },
        "padding2": {
          "type": "string",
          "format": "padding",
          "default": "0.0em 0.5em 0.0em 0.5em"
        },
        "padding3": {
          "type": "string",
          "format": "padding",
          "default": "1.0em 0.0em 1.0em 0.0em"
        },
        "iconSize": {
          "format": "cssMeasure",
          "default": "3.2"
        },
        "bulletSize": {
          "format": "cssMeasure",
          "default": "1.5"
        },
        "headerSpacing": {
          "format": "cssMeasure",
          "default": "0em"
        },
        "componentSpacing": {
          "format": "cssMeasure",
          "default": "0.45em"
        },
        "itemSpacing": {
          "format": "cssMeasure",
          "default": "0.75em"
        },
        "thumbSpacing": {
          "format": "cssMeasure",
          "default": "0.23em"
        },
        "iconSpacing": {
          "format": "cssMeasure",
          "default": "0.75em"
        },
        "mobileBg": {
          "type": "string",
          "default": "[siteBg]"
        },
        "themePresets": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "mobileBg": {
              "type": "boolean"
            }
          }
        }
      },
      "isTopLevelDataNode": true
    },
    "OverridableTheme": {
      "type": "object",
      "properties": {
        "spx": {
          "$ref": "SPXReferenceDefinition"
        }
      },
      "isTopLevelDataNode": false
    },
    "TextTheme": {
      "type": "object",
      "allOf": [
        {
          "$ref": "TextThemeWithDefaults"
        },
        {
          "type": "object",
          "required": [
            "fontStyle",
            "fontWeight",
            "fontVariant",
            "fontSize",
            "lineHeight",
            "fontFamily"
          ]
        }
      ],
      "isTopLevelDataNode": false
    },
    "FontStyle": {
      "type": "string",
      "enum": [
        "normal",
        "italic"
      ]
    },
    "FontSize": {
      "type": "string",
      "format": "cssMeasureWithUnit"
    },
    "FontWeight": {
      "type": "string",
      "enum": [
        "normal",
        "bold",
        "bolder",
        "lighter",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900"
      ]
    },
    "FontVariant": {
      "type": "string",
      "enum": [
        "normal",
        "small-caps",
        "inherit"
      ]
    },
    "FontFamily": {
      "type": "string",
      "format": "font-family"
    },
    "TextColor": {
      "type": "string",
      "format": "color"
    },
    "LineHeight": {
      "type": "string",
      "format": "cssMeasureWithUnit"
    },
    "LetterSpacing": {
      "type": "string",
      "format": "cssMeasureWithUnit"
    },
    "PartialTextTheme": {
      "type": "object",
      "properties": {
        "fontStyle": {
          "$ref": "FontStyle"
        },
        "fontWeight": {
          "$ref": "FontWeight"
        },
        "fontVariant": {
          "$ref": "FontVariant"
        },
        "fontSize": {
          "$ref": "FontSize"
        },
        "maxFontSize": {
          "$ref": "FontSize"
        },
        "minFontSize": {
          "$ref": "FontSize"
        },
        "scale_maxFontSize": {
          "$ref": "FontSize"
        },
        "scale_minFontSize": {
          "$ref": "FontSize"
        },
        "fontFamily": {
          "$ref": "FontFamily"
        },
        "color": {
          "$ref": "TextColor"
        },
        "lineHeight": {
          "$ref": "LineHeight"
        },
        "letterSpacing": {
          "$ref": "LetterSpacing"
        }
      },
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "TextThemeWithDefaults": {
      "type": "object",
      "properties": {
        "fontStyle": {
          "$ref": "FontStyle",
          "default": "normal"
        },
        "fontWeight": {
          "$ref": "FontWeight",
          "default": "normal"
        },
        "fontVariant": {
          "$ref": "FontVariant",
          "default": "normal"
        },
        "fontSize": {
          "$ref": "FontSize",
          "default": "60px"
        },
        "minFontSize": {
          "$ref": "FontSize"
        },
        "maxFontSize": {
          "$ref": "FontSize"
        },
        "scale_maxFontSize": {
          "$ref": "FontSize"
        },
        "scale_minFontSize": {
          "$ref": "FontSize"
        },
        "fontFamily": {
          "$ref": "FontFamily",
          "default": "proxima-n-w01-reg"
        },
        "color": {
          "$ref": "TextColor",
          "default": "{color_15}"
        },
        "lineHeight": {
          "$ref": "LineHeight",
          "default": "normal"
        },
        "letterSpacing": {
          "$ref": "LetterSpacing",
          "default": "normal"
        }
      },
      "additionalProperties": false,
      "isTopLevelDataNode": false
    },
    "TopLevelStyle": {
      "type": "object",
      "isTopLevelDataNode": true,
      "isPermanentDataNode": true,
      "allOf": [
        {
          "$ref": "StyleObjectDefinition"
        }
      ]
    },
    "ComponentStyle": {
      "type": "object",
      "isTopLevelDataNode": true,
      "allOf": [
        {
          "$ref": "StyleObjectDefinition"
        },
        {
          "properties": {
            "styleType": {
              "type": "string",
              "enum": [
                "custom"
              ],
              "description": "style type for custom styles",
              "default": "custom"
            },
            "spx": {
              "$ref": "SPXReferenceDefinition"
            },
            "themeOverrides": {
              "$ref": "OverridableTheme"
            }
          }
        }
      ]
    },
    "GlobalStylesCollection": {
      "type": "object",
      "isTopLevelDataNode": true,
      "isPermanentDataNode": true,
      "properties": {
        "styles": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#"
        }
      }
    },
    "GlobalStyle": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "name": {
          "type": "string",
          "maxLength": 100
        },
        "styleType": {
          "type": "string",
          "maxLength": 200
        },
        "value": {
          "type": "string",
          "pseudoType": [
            "ref"
          ],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#",
          "isRelationalSplit": true
        },
        "innerElementStyles": {
          "type": "object",
          "additionalProperties": {
            "type": "array",
            "items": {
              "type": "array",
              "minItems": 1,
              "maxItems": 20,
              "items": {
                "type": "string"
              }
            },
            "maxItems": 20
          }
        }
      },
      "required": [
        "styleType"
      ]
    },
    "StyleObjectDefinition": {
      "type": "object",
      "properties": {
        "skin": {
          "type": "string"
        },
        "style": {
          "type": "object",
          "properties": {
            "properties": {
              "type": "object",
              "default": {},
              "additionalProperties": true
            },
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "$ref": "ColorLayers"
                }
              }
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              },
              "default": {}
            },
            "groups": {
              "type": "object",
              "additionalProperties": true
            },
            "propertiesOverride": {
              "type": "object",
              "properties": {},
              "additionalProperties": {
                "$ref": "PartialTextTheme"
              }
            }
          }
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ],
          "description": "type of the style, defaults to custom",
          "default": "custom"
        },
        "pageId": {
          "type": "string",
          "description": "for custom styles - id of the page where the component is"
        },
        "compId": {
          "type": "string",
          "description": "for custom styles - id of the component that has the custom style"
        },
        "componentClassName": {
          "type": "string",
          "description": "class name of the component type this style applies to"
        }
      },
      "isTopLevelDataNode": false
    }
  },
  "themeConfig.json": {
    "themeConfig": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "colorMapping": {
          "patternProperties": {
            "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
              "type": "string",
              "pattern": "^$|^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$|__empty__"
            }
          }
        },
        "colorNaming": {
          "patternProperties": {
            "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "order": {
                  "type": "number",
                  "default": 0
                },
                "hidden": {
                  "type": "boolean"
                }
              }
            }
          }
        },
        "fontNaming": {
          "patternProperties": {
            "^font_([0-9]|10)$": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "order": {
                  "type": "number",
                  "default": 0
                },
                "hidden": {
                  "type": "boolean"
                }
              }
            }
          }
        }
      }
    }
  },
  "transformations.json": {
    "TransformData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "scale": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            }
          }
        },
        "rotate": {
          "type": "number"
        },
        "translate": {
          "type": "object",
          "properties": {
            "x": {
              "$ref": "UnitSize"
            },
            "y": {
              "$ref": "UnitSize"
            }
          }
        },
        "skew": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            }
          }
        },
        "origin": {
          "type": "object",
          "properties": {
            "x": {
              "$ref": "UnitSize"
            },
            "y": {
              "$ref": "UnitSize"
            }
          }
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "hidden": {
          "type": "boolean"
        },
        "zLayer": {
          "type": "string",
          "enum": [
            "BELOW_PINNED",
            "ABOVE_PINNED",
            "ABOVE_ALL_COMPS"
          ]
        }
      }
    }
  },
  "transitions.json": {
    "TransitionData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "timing-function": {
          "oneOf": [
            {
              "type": "string",
              "enum": [
                "ease",
                "linear",
                "ease-in",
                "ease-out",
                "ease-in-out"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "cubic-bezier"
                  ],
                  "description": "cubic bazier timing function"
                },
                "params": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "number"
                  }
                }
              },
              "required": [
                "type",
                "params"
              ]
            }
          ],
          "description": "the placeholder option in case nothing is selected"
        },
        "duration": {
          "type": "number",
          "default": 0
        },
        "delay": {
          "type": "number",
          "default": 0
        },
        "viewPortThreshold": {
          "type": "number",
          "exclusiveMinimum": 0,
          "maximum": 1
        },
        "isLegacyCrossFade": {
          "type": "boolean"
        }
      },
      "required": [
        "timing-function"
      ]
    }
  },
  "triggers.json": {
    "Triggers": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": "array",
          "items": {
            "type": "string",
            "pseudoType": [
              "weakRef"
            ],
            "shouldValidate": true,
            "shouldCollect": true,
            "dontSerialize": true,
            "referencedMap": "variants_data",
            "refTypes": [
              "Trigger"
            ]
          },
          "default": []
        }
      },
      "required": [
        "values"
      ]
    }
  },
  "variables.json": {
    "VariablesList": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "variables": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "shouldCollect": true,
          "shouldValidate": true,
          "referencedMap": "#",
          "refTypes": [
            "UnitSizeVar",
            "NumberVar",
            "ItemsAlignmentVar",
            "JustifyContentVar",
            "PositionTypeVar",
            "LayoutSizeVar",
            "HeightVar",
            "KeywordLengthVar",
            "NumVar",
            "LengthVar",
            "AngleVar",
            "ColorVar",
            "PercentageVar",
            "BorderEdgeStyleVar",
            "BorderEdgeWidthVar",
            "BorderWidthVar",
            "BorderStyleVar",
            "BorderColorVar",
            "BorderVar",
            "BorderCornerRadiusVar",
            "BorderRadiusVar",
            "FontVar",
            "FontSizeVar",
            "FontStretchVar",
            "FontStyleVar",
            "FontVariantVar",
            "FontWeightVar",
            "FontFamilyVar",
            "LineHeightVar",
            "LetterSpacingVar",
            "TextAlignVar",
            "TextTransformVar",
            "TextShadowVar",
            "TextDecorationVar",
            "TextDecorationLineVar",
            "TextDecorationStyleVar",
            "TextDecorationThicknessVar",
            "TextIndentVar",
            "PaddingVar",
            "PaddingEdgeVar",
            "MarginVar",
            "MarginEdgeVar",
            "BoxShadowVar",
            "OpacityVar",
            "CssJustifyContentVar",
            "BackgroundVar",
            "WritingModeVar",
            "DisplayVar",
            "FilterVar",
            "GapVar"
          ],
          "default": []
        }
      },
      "required": [
        "variables"
      ]
    },
    "UnitSizeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "UnitSizeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "UnitSizeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "UnitSize"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "NumberVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "NumberValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "NumberValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "NumberThatCanConnectToAVariable"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "ItemsAlignmentVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "ItemsAlignmentValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "ItemsAlignmentValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "ItemsAlignment"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "JustifyContentVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "JustifyContentValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "JustifyContentValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "JustifyContent"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "PositionTypeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "PositionTypeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "PositionTypeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "PositionType"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "LayoutSizeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "LayoutSizeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "LayoutSizeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "LayoutSize"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "HeightVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "HeightValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "HeightValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "Height"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "KeywordLengthVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "KeywordLengthValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "KeywordLengthValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "KeywordLength"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "NumVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "NumValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "NumValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "LengthVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "LengthValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "LengthValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "AngleVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "AngleValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "AngleValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Angle"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "ColorVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "ColorValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "ColorValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "PercentageVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "PercentageValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "PercentageValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderEdgeStyleVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderEdgeStyleValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderEdgeStyleValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopStyle"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderEdgeWidthVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderEdgeWidthValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderEdgeWidthValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopWidth"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderWidthVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderWidthValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderWidthValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderWidth"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderStyleVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderStyleValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderStyleValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderStyle"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderColorVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderColorValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderColorValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderColor"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Border"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderCornerRadiusVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderCornerRadiusValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderCornerRadiusValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderTopLeftRadius"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BorderRadiusVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BorderRadiusValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BorderRadiusValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BorderRadius"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Font"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontSizeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontSizeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontSizeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontSize"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontStretchVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontStretchValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontStretchValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontStretch"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontStyleVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontStyleValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontStyleValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontStyle"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontVariantVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontVariantValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontVariantValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontVariant"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontWeightVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontWeightValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontWeightValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontWeight"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FontFamilyVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FontFamilyValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FontFamilyValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.FontFamily"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "LineHeightVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "LineHeightValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "LineHeightValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LineHeight"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "LetterSpacingVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "LetterSpacingValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "LetterSpacingValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LetterSpacing"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextAlignVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextAlignValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextAlignValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextAlign"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextTransformVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextTransformValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextTransformValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextTransform"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextShadowVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextShadowValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextShadowValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextShadow"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextDecorationVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextDecorationValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextDecorationValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecoration"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextDecorationLineVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextDecorationLineValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextDecorationLineValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationLine"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextDecorationStyleVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextDecorationStyleValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextDecorationStyleValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationStyle"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextDecorationThicknessVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextDecorationThicknessValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextDecorationThicknessValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextDecorationThickness"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "TextIndentVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "TextIndentValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "TextIndentValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.TextIndent"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "PaddingVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "PaddingValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "PaddingValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Padding"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "PaddingEdgeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "PaddingEdgeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "PaddingEdgeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PaddingTop"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "MarginVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "MarginValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "MarginValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Margin"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "MarginEdgeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "MarginEdgeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "MarginEdgeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.MarginTop"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BoxShadowVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BoxShadowValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BoxShadowValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BoxShadow"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "OpacityVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "OpacityValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "OpacityValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Opacity"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "CssJustifyContentVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "CssJustifyContentValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "CssJustifyContentValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.JustifyContent"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "BackgroundVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "BackgroundValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "BackgroundValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Background"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "WritingModeVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "WritingModeValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "WritingModeValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.WritingMode"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "DisplayVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "DisplayValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "DisplayValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Display"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "FilterVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "FilterValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "FilterValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Filter"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    },
    "GapVar": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "cssVarName": {
          "type": "string"
        },
        "value": {
          "type": "string",
          "isRelationalSplit": true,
          "shouldCollect": true,
          "shouldValidate": true,
          "pseudoType": [
            "ref"
          ],
          "referencedMap": "#",
          "refTypes": [
            "GapValue"
          ]
        }
      },
      "isTopLevelDataNode": true
    },
    "GapValue": {
      "type": "object",
      "properties": {
        "value": {
          "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Gap"
        }
      },
      "required": [
        "value"
      ],
      "isTopLevelDataNode": true
    }
  },
  "variants.json": {
    "Hover": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "Mobile": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "State": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        },
        "name": {
          "type": "string",
          "default": "state"
        }
      },
      "required": [
        "componentId",
        "name"
      ]
    },
    "Selected": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "Trigger": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        },
        "trigger": {
          "type": "string"
        },
        "params": {
          "type": "object",
          "additionalProperties": true
        }
      },
      "discriminator": {
        "propertyName": "trigger"
      },
      "oneOf": [
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "viewport-enter",
                "viewport-leave"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "threshold": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "margin": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "$ref": "MinimalUnitSize"
                    },
                    "bottom": {
                      "$ref": "MinimalUnitSize"
                    },
                    "left": {
                      "$ref": "MinimalUnitSize"
                    },
                    "right": {
                      "$ref": "MinimalUnitSize"
                    }
                  }
                }
              }
            }
          },
          "additionalProperties": true
        },
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "animation-start",
                "animation-end"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "effect": {
                  "type": "string",
                  "pseudoType": [
                    "ref"
                  ],
                  "refTypes": [
                    "TimeAnimation"
                  ],
                  "shouldValidate": true,
                  "shouldCollect": false,
                  "referencedMap": "effects"
                }
              },
              "required": [
                "effect"
              ],
              "additionalProperties": false
            }
          },
          "additionalProperties": true,
          "required": [
            "params"
          ]
        },
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "pointer-move"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "hitArea": {
                  "type": "string",
                  "default": "self",
                  "enum": [
                    "self",
                    "root"
                  ]
                }
              },
              "required": [
                "hitArea"
              ]
            }
          },
          "additionalProperties": true
        },
        {
          "properties": {
            "trigger": {
              "type": "string",
              "default": "click",
              "enum": [
                "click",
                "tap",
                "mouse-in",
                "mouse-out",
                "hover",
                "view-progress",
                "scroll-progress",
                "page-visible"
              ]
            },
            "params": {
              "type": "object",
              "additionalProperties": false
            }
          },
          "additionalProperties": true
        }
      ],
      "required": [
        "componentId",
        "trigger"
      ]
    },
    "Preset": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "RepeaterPattern": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        },
        "tag": {
          "type": "string"
        }
      },
      "required": [
        "componentId",
        "tag"
      ]
    },
    "RepeaterPatternList": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        },
        "values": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#",
          "refTypes": [
            "RepeaterPattern"
          ]
        }
      },
      "required": [
        "componentId",
        "values"
      ]
    },
    "VariantsList": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "componentId": {
          "type": "string"
        },
        "values": {
          "type": "array",
          "pseudoType": [
            "refList"
          ],
          "default": [],
          "shouldValidate": true,
          "shouldCollect": true,
          "referencedMap": "#"
        }
      },
      "required": [
        "componentId",
        "values"
      ]
    },
    "BreakpointsData": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "values": {
          "type": [
            "null",
            "array"
          ],
          "pseudoType": [
            "refList"
          ],
          "refTypes": [
            "BreakpointRange"
          ]
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "values"
      ]
    },
    "BreakpointRange": {
      "type": "object",
      "isTopLevelDataNode": true,
      "properties": {
        "min": {
          "$ref": "urn:dm:schemas:common.json#/JavaInt"
        },
        "max": {
          "$ref": "urn:dm:schemas:common.json#/JavaInt"
        },
        "canvasSize": {
          "type": "number",
          "multipleOf": 1
        }
      }
    }
  }
}
